webpackJsonp([16],{

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _domainRegex = __webpack_require__(758);

var domainRegex = _interopRequireWildcard(_domainRegex);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  email: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
  phone: /^\(\d{3}\)\s\d{3}-\d{4}$/,
  uid: /^[a-z][a-z0-9-_]{2,47}$/,
  dob: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
  zip: /^\d{5}$/,
  state: /^[A-Z]{2}$/,
  city: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  domain: domainRegex.default(),
  name: /^[a-zA-Z\s]+$/,
  firstAndLast: /^[a-zA-Z]+ [a-zA-Z]+$/,
  all: /\.*/
};

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1158:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1180:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1181:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1182:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1183:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1187:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 552,
	"./af.js": 552,
	"./ar": 559,
	"./ar-dz": 553,
	"./ar-dz.js": 553,
	"./ar-kw": 554,
	"./ar-kw.js": 554,
	"./ar-ly": 555,
	"./ar-ly.js": 555,
	"./ar-ma": 556,
	"./ar-ma.js": 556,
	"./ar-sa": 557,
	"./ar-sa.js": 557,
	"./ar-tn": 558,
	"./ar-tn.js": 558,
	"./ar.js": 559,
	"./az": 560,
	"./az.js": 560,
	"./be": 561,
	"./be.js": 561,
	"./bg": 562,
	"./bg.js": 562,
	"./bm": 563,
	"./bm.js": 563,
	"./bn": 565,
	"./bn-bd": 564,
	"./bn-bd.js": 564,
	"./bn.js": 565,
	"./bo": 566,
	"./bo.js": 566,
	"./br": 567,
	"./br.js": 567,
	"./bs": 568,
	"./bs.js": 568,
	"./ca": 569,
	"./ca.js": 569,
	"./cs": 570,
	"./cs.js": 570,
	"./cv": 571,
	"./cv.js": 571,
	"./cy": 572,
	"./cy.js": 572,
	"./da": 573,
	"./da.js": 573,
	"./de": 576,
	"./de-at": 574,
	"./de-at.js": 574,
	"./de-ch": 575,
	"./de-ch.js": 575,
	"./de.js": 576,
	"./dv": 577,
	"./dv.js": 577,
	"./el": 578,
	"./el.js": 578,
	"./en-au": 579,
	"./en-au.js": 579,
	"./en-ca": 580,
	"./en-ca.js": 580,
	"./en-gb": 581,
	"./en-gb.js": 581,
	"./en-ie": 582,
	"./en-ie.js": 582,
	"./en-il": 583,
	"./en-il.js": 583,
	"./en-in": 584,
	"./en-in.js": 584,
	"./en-nz": 585,
	"./en-nz.js": 585,
	"./en-sg": 586,
	"./en-sg.js": 586,
	"./eo": 587,
	"./eo.js": 587,
	"./es": 591,
	"./es-do": 588,
	"./es-do.js": 588,
	"./es-mx": 589,
	"./es-mx.js": 589,
	"./es-us": 590,
	"./es-us.js": 590,
	"./es.js": 591,
	"./et": 592,
	"./et.js": 592,
	"./eu": 593,
	"./eu.js": 593,
	"./fa": 594,
	"./fa.js": 594,
	"./fi": 595,
	"./fi.js": 595,
	"./fil": 596,
	"./fil.js": 596,
	"./fo": 597,
	"./fo.js": 597,
	"./fr": 600,
	"./fr-ca": 598,
	"./fr-ca.js": 598,
	"./fr-ch": 599,
	"./fr-ch.js": 599,
	"./fr.js": 600,
	"./fy": 601,
	"./fy.js": 601,
	"./ga": 602,
	"./ga.js": 602,
	"./gd": 603,
	"./gd.js": 603,
	"./gl": 604,
	"./gl.js": 604,
	"./gom-deva": 605,
	"./gom-deva.js": 605,
	"./gom-latn": 606,
	"./gom-latn.js": 606,
	"./gu": 607,
	"./gu.js": 607,
	"./he": 608,
	"./he.js": 608,
	"./hi": 609,
	"./hi.js": 609,
	"./hr": 610,
	"./hr.js": 610,
	"./hu": 611,
	"./hu.js": 611,
	"./hy-am": 612,
	"./hy-am.js": 612,
	"./id": 613,
	"./id.js": 613,
	"./is": 614,
	"./is.js": 614,
	"./it": 616,
	"./it-ch": 615,
	"./it-ch.js": 615,
	"./it.js": 616,
	"./ja": 617,
	"./ja.js": 617,
	"./jv": 618,
	"./jv.js": 618,
	"./ka": 619,
	"./ka.js": 619,
	"./kk": 620,
	"./kk.js": 620,
	"./km": 621,
	"./km.js": 621,
	"./kn": 622,
	"./kn.js": 622,
	"./ko": 623,
	"./ko.js": 623,
	"./ku": 624,
	"./ku.js": 624,
	"./ky": 625,
	"./ky.js": 625,
	"./lb": 626,
	"./lb.js": 626,
	"./lo": 627,
	"./lo.js": 627,
	"./lt": 628,
	"./lt.js": 628,
	"./lv": 629,
	"./lv.js": 629,
	"./me": 630,
	"./me.js": 630,
	"./mi": 631,
	"./mi.js": 631,
	"./mk": 632,
	"./mk.js": 632,
	"./ml": 633,
	"./ml.js": 633,
	"./mn": 634,
	"./mn.js": 634,
	"./mr": 635,
	"./mr.js": 635,
	"./ms": 637,
	"./ms-my": 636,
	"./ms-my.js": 636,
	"./ms.js": 637,
	"./mt": 638,
	"./mt.js": 638,
	"./my": 639,
	"./my.js": 639,
	"./nb": 640,
	"./nb.js": 640,
	"./ne": 641,
	"./ne.js": 641,
	"./nl": 643,
	"./nl-be": 642,
	"./nl-be.js": 642,
	"./nl.js": 643,
	"./nn": 644,
	"./nn.js": 644,
	"./oc-lnc": 645,
	"./oc-lnc.js": 645,
	"./pa-in": 646,
	"./pa-in.js": 646,
	"./pl": 647,
	"./pl.js": 647,
	"./pt": 649,
	"./pt-br": 648,
	"./pt-br.js": 648,
	"./pt.js": 649,
	"./ro": 650,
	"./ro.js": 650,
	"./ru": 651,
	"./ru.js": 651,
	"./sd": 652,
	"./sd.js": 652,
	"./se": 653,
	"./se.js": 653,
	"./si": 654,
	"./si.js": 654,
	"./sk": 655,
	"./sk.js": 655,
	"./sl": 656,
	"./sl.js": 656,
	"./sq": 657,
	"./sq.js": 657,
	"./sr": 659,
	"./sr-cyrl": 658,
	"./sr-cyrl.js": 658,
	"./sr.js": 659,
	"./ss": 660,
	"./ss.js": 660,
	"./sv": 661,
	"./sv.js": 661,
	"./sw": 662,
	"./sw.js": 662,
	"./ta": 663,
	"./ta.js": 663,
	"./te": 664,
	"./te.js": 664,
	"./tet": 665,
	"./tet.js": 665,
	"./tg": 666,
	"./tg.js": 666,
	"./th": 667,
	"./th.js": 667,
	"./tk": 668,
	"./tk.js": 668,
	"./tl-ph": 669,
	"./tl-ph.js": 669,
	"./tlh": 670,
	"./tlh.js": 670,
	"./tr": 671,
	"./tr.js": 671,
	"./tzl": 672,
	"./tzl.js": 672,
	"./tzm": 674,
	"./tzm-latn": 673,
	"./tzm-latn.js": 673,
	"./tzm.js": 674,
	"./ug-cn": 675,
	"./ug-cn.js": 675,
	"./uk": 676,
	"./uk.js": 676,
	"./ur": 677,
	"./ur.js": 677,
	"./uz": 679,
	"./uz-latn": 678,
	"./uz-latn.js": 678,
	"./uz.js": 679,
	"./vi": 680,
	"./vi.js": 680,
	"./x-pseudo": 681,
	"./x-pseudo.js": 681,
	"./yo": 682,
	"./yo.js": 682,
	"./zh-cn": 683,
	"./zh-cn.js": 683,
	"./zh-hk": 684,
	"./zh-hk.js": 684,
	"./zh-mo": 685,
	"./zh-mo.js": 685,
	"./zh-tw": 686,
	"./zh-tw.js": 686
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1187;

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.674f50d.eot";

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1162)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1320),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-454a5836",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1313),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1168)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1329),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f4e7727",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1154)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1307),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0dd5a009",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(801),
  /* template */
  __webpack_require__(1312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(802),
  /* template */
  __webpack_require__(1333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1283:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1180)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(806),
  /* template */
  __webpack_require__(1347),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c795f642",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1284:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(1321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(815),
  /* template */
  __webpack_require__(1335),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1181)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1348),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-daa54c52",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1169)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1330),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66f165cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1184)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1351),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ec0c6ec2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1334),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1159)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1315),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35908d68",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1183)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1350),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e529c4d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1325),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1157)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1311),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24f81818",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1161)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1319),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cc434e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1173)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1337),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-88437a7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1345),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1182)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1349),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e0f1254e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1153)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1306),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c4f9ea8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1302),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03667643",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1300:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1167)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1328),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1302:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "agree-finish"
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Agree and Finish")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('label', [_vm._v("E-sign disclosure")]), _vm._v(" "), _c('div', [_vm._v("\n       BY CREATING AN ELECTRONIC ACCOUNT AT OUR SITES, OR BY SUBMITTING AN ONLINE ORDER FOR SERVICES OR PRODUCTS, YOU AGREE THAT AN ELECTRONIC FACSIMILE OF YOUR SIGNATURE OR ELECTRONICALLY SIGNED AGREEMENT\n       (e.g., through your checking a box, typing your name, or otherwise) CARRIES THE FULL LEGAL WEIGHT OF A WRITTEN SIGNATURE. IF YOU WOULD RATHER PROVIDE YOUR CONSENT IN NON-ELECTRONIC FORM, PLEASE EMAIL YOUR REQUEST TO sales@xmission.com,\n       SUBJECT: Written Agreement. YOU CAN ALSO REQUEST A PRINTED COPY OF YOUR ELECTRONIC CONSENT THROUGH WRITTEN REQUEST TO  sales@xmission.com, SUBJECT: Agreement Copy.\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "mt-4 mb-5",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.setCurrentTime.apply(null, arguments)
      }
    }
  }, [_c('label', {
    staticClass: "radio-head"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.agreed
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.setCurrentTime.apply(null, arguments)
      }
    }
  }), _c('span', [_vm._v("I agree to the above terms and conditions")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pre-scrollable legal-goo mb-3"
  }, [_c('div', {
    staticClass: "entry-content"
  }, [_c('h4', [_vm._v("XMission's General Terms and Conditions")]), _vm._v(" "), _c('p', [_vm._v("\n             These General Terms and Conditions govern Your use of XMission’s website and the XMission network. By accessing or using XMission’s website or network in any way, You expressly acknowledge and agree to be bound by these Terms and Conditions. It is Your exclusive obligation to review these Terms and Conditions carefully. Please do so. If You do not agree to be bound by all provisions, please exit the website promptly.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n             These Terms and Conditions are also part of XMission Master Services Agreement (“MSA”) and are incorporated therein by reference. Capitalized terms have the same meaning given to them in the MSA. A copy of XMission’s MSA can be viewed here "), _c('a', {
    attrs: {
      "href": "https://xmission.com/legal/terms/msa/",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("https://xmission.com/legal/terms/msa/")]), _vm._v(".\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("1. "), _c('u', [_vm._v("STATEMENT OF INTENT")])]), _vm._v(" "), _c('p', [_vm._v("XMission's primary objection is the protection of its network, customers, and employees. Accordingly, XMission reserves the right to take whatever measures it deems necessary to secure its network, customer, and employees against abuse. This includes, but is not limited to: scanning for open mail relays, virus filtering, and spam mitigation, as examples. XMission further reserves the right to take whatever actions it deems appropriate to enforce its terms and conditions including, but not limited to, account suspension or termination.")]), _vm._v(" "), _c('p', [_vm._v("XMission reserves the right to change its terms and conditions at any time without prior notice to you. Your continued use of XMission’s Services constitutes Your consent to be bound by the latest terms and conditions. The latest terms and conditions will always be posted online at "), _c('a', {
    attrs: {
      "href": "https://xmission.com/legal/terms"
    }
  }, [_vm._v("https://xmission.com/legal/terms")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("XMission reserves the right to refuse service to anyone at any time for any reason. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("2. "), _c('u', [_vm._v("WAIVER OF WARRANTY AND LIMITATION OF LIABILITY")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("2.1")]), _vm._v("UNLESS OTHERWISE STATED IN THE SERVICE ADDENDA: (A) YOUR USE OF THE SERVICES IS AT YOUR SOLE RISK, AND THE SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS ONLY, AND XMISSION EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, WARRANTIES AS TO SERVICES PROVIDED, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT; (B) WITHOUT LIMITING THE FOREGOING, XMISSION MAKES NO WARRANTY THAT THE SERVICES WILL MEET YOUR REQUIREMENTS OR EXPECTATIONS, OR BE UNINTERRUPTED, TIMELY, SECURE, ERROR-FREE, OR VIRUS OR MALWARE FREE; (C) STATED BANDWIDTH(S) APPLY ONLY TO THE CUSTOMER-TO-XMISSION ROUTER PORT ATTACHMENT, NO GUARANTEE OF END-TO-END BANDWIDTH ON THE INTERNET IS MADE; AND (D) ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED FROM THROUGH THE USE OF THE SERVICES IS ACCESSED AT YOUR OWN RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEMS AND/OR MOBILE DEVICE THAT RESULTS FROM THE USE OF ANY SUCH MATERIAL.")]), _vm._v(" "), _c('p', [_vm._v("YOUR EXCLUSIVE REMEDY AND XMISSION’S ENTIRE LIABILITY, IF ANY, FOR ANY CLAIMS ARISING OUT OF THE AGREEMENT AND/OR YOUR USE OF THE SERVICES, SHALL BE LIMITED TO THE AMOUNT YOU PAID XMISSION FOR THE SERVICES FOR THE PRECEDING SIX-MONTH PERIOD.  ")]), _vm._v(" "), _c('p', [_vm._v("IN NO EVENT SHALL XMISSION, OR ANY OF ITS DIRECTORS, OFFICERS, EMPLOYEES, AFFILIATES, AGENTS, CONTRACTORS, SUPPLIERS, OR SERVICE PROVIDERS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY SPECIAL, PUNITIVE, INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER, INCLUDING, WITHOUT LIMITATION, THOSE RESULTING FROM BODILY HARM, PERSONAL INJURY, LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT XMISSION HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND ON ANY THEORY OF LIABILITY, ARISING OUT OF OR IN CONNECTION WITH THE USE OF THE SERVICES, OR INABILITY TO USE THE SERVICES.  ")]), _vm._v(" "), _c('p', [_vm._v("ANY LEGAL ACTION ARISING OUT OF ANY ALLEGED FAILURE, MALFUNCTION OR DEFECTS IN XMISSION’S SERVICES OR HARDWARE SHALL BE BROUGHT WITHIN A PERIOD OF ONE (1) YEAR OF THE OCCURRENCE OR IS DEEMED WAIVED. ")]), _vm._v(" "), _c('p', [_vm._v("IF YOU ARE DISSATISFIED WITH THE TERMS OF THE AGREEMENT OR THE SERVICES, YOUR SOLE REMEDY AND EXPRESS OBLIGATION IS TO STOP USING THE SERVICES. IN THE EVENT YOU FAIL TO STOP USING THE SERVICES AND CLAIMS SOME INJURY AS THE RESULT, YOU AGREE TO INDEMNIFY AND HOLD XMISSION HARMLESS FROM ANY AND ALL LOSSES OR DAMAGE, INCLUDING ATTORNEYS’ FEES INCURRED BY XMISSION IN DEFENSE OF ANY ACTION INITIATED BY YOU OR A THIRD PARTY. ")]), _vm._v(" "), _c('p', [_vm._v("SOME JURISDICTIONS PROHIBIT THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("3. "), _c('u', [_vm._v("INTELLECTUAL PROPERTY ")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("3.1")]), _vm._v("For purposes of these Agreement, “Content and Material” is defined as any information, communications, software, published works, photos, video, graphics, music, sounds, code, or other material that can be viewed or heard by users while using XMission’s website, network or services, and which was created by XMission. All of the Content and Material is subject to United States and international copyright, trade dress, trademark and/or other intellectual property laws with all rights thereto held by XMission. Use of any Content and Material without prior written authorization by XMission is strictly prohibited and may subject You to liability. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("3.2")]), _vm._v("If You know of, or suspect, copyright or trademark infringement or other unauthorized or improper use of XMission’s property by others, including but not limited to uses for commercial purposes, please notify XMission ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("3.3")]), _c('u', [_vm._v("Digital Millennium Copyright Act")]), _vm._v(". XMission has not taken and will not take content or material from You or any third party unless it has been assigned to XMission pursuant to law. However, if You are a copyright holder and have a good faith belief that any content or materials posted on this Website infringes Your copyright, please send to XMission Your notification of claimed infringement requesting the material to be removed or blocked to the following:")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 pl-5 d-inline-block"
  }, [_vm._v("\n             XMission, L.C. "), _c('br'), _vm._v("\n             51 East 400 South, Suite 000 "), _c('br'), _vm._v("\n             Salt Lake City, UT 84111-2753 "), _c('br'), _vm._v("\n             Phone: 801.539.0852 "), _c('br'), _vm._v("\n             Legal Response Email: legal@xmission.com "), _c('br')])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("\n             Your notice must contain the following: (a) Reasonably sufficient details about the nature of the copyrighted work in question, or, in the case of multiple alleged infringements, a representative list of such works, including title(s), author(s), any U.S. Copyright Registration number(s), URL(s) etc.; (b) Reasonably sufficient details to enable us to identify and locate the material that is allegedly infringing the copyright holder’s work(s) (for example, file name or URL of the page(s) that contain(s) the material); (c) Your contact information so that we can make contact with You (including for example, your address, telephone number, and email address); (d) A statement that You have a good faith belief that the use of the material identified above in “b” is not authorized by the copyright owner, its agent, or the law; (e) A statement, under penalty of perjury, that the information in the notification is accurate and that You are authorized to act on behalf of the copyright owner; and (f) Your signature. Prior to sending us notice, You may wish to consult a lawyer to determine Your rights and legal obligations under applicable laws. Nothing here or anywhere on this Website is intended as a substitute for qualified legal advice. You also acknowledge and agree that upon receipt of a notice of a claim of copyright infringement, we may temporarily or permanently remove the identified materials from the Website without liability to you or any other party.\n             ")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("4. "), _c('u', [_vm._v("COMMUNICATIONS DECENCY ACT.")])]), _vm._v(" "), _c('p', [_vm._v("XMission does not control or monitor the content users of the Service. XMission invokes Section 230 of the Communications Decency Act (47 U.S.C. § 230) (hereinafter “CDA”) and Utah Code 76-9-203. XMission advises You that parental control protections (such as computer hardware, software, or filtering services) are commercially available that may assist You in limiting access to material that is harmful to minors. Pursuant to the CDA, XMission takes no responsibility and assumes no liability for any content You may view while utilizing XMission’s website, the Services, or the XMission network. XMission has no obligation to, monitor, edit, or remove content that may be unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or in violation of any third-party’s intellectual property rights. XMission also maintains a separate policy under Utah Code 76-10-1231 which can be found here, "), _c('a', {
    attrs: {
      "href": "https://wiki.xmission.com/Content_Filtering"
    }
  }, [_vm._v("https://wiki.xmission.com/Content_Filtering")]), _vm._v(", which is incorporated by reference herein.  ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("5. "), _c('u', [_vm._v("MAINTENANCE ")])]), _vm._v(" "), _c('p', [_vm._v("All scheduled systems maintenance will be performed during approved maintenance window times. Scheduled maintenance does not qualify as outages, and does not qualify for credit. Maintenance will be listed here: "), _c('a', {
    attrs: {
      "href": "https://status.xmission.com/"
    }
  }, [_vm._v("https://status.xmission.com/")]), _vm._v(". Critical systems refers to: electrical infrastructure, core routers/switches, and core servers (e.g., mail, web hosting, etc.) ")]), _vm._v(" "), _c('p', [_vm._v("Approved maintenance window times:  ")]), _vm._v(" "), _c('p', [_vm._v("For critical systems: between midnight-6am on Sat/Sun/Mon mornings;  ")]), _vm._v(" "), _c('p', [_vm._v("For non-critical systems: outside of business hours, preferably between 10pm-7am. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("6. "), _c('u', [_vm._v("INDEMNITY")])]), _vm._v(" "), _c('p', [_vm._v("You agree to defend, indemnify, and hold XMission (and its directors, officers, employees, affiliates, agents, contractors, suppliers, service providers or licensors) harmless to the fullest extent permitted in law or equity from all liabilities, demands, claims, and expenses, including attorneys’ fees that may arise from Your use or misuse of XMission’s website, the Services, Your breach of the Agreement, and/or Your violation of any law or the rights of a third party. XMission will provide notice to You of any such demand, claim, suit, or proceeding. XMission reserves the right, at its own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by You, in which event You will cooperate with XMission in asserting any available defenses. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("7. "), _c('u', [_vm._v("ARBITRATION AND CLASS ACTION WAIVER")])]), _vm._v(" "), _c('p', [_vm._v("For purposes of the Dispute Resolution Policy, a “Dispute” is defined as any controversy, claim, dispute, or difference arising between You and XMission out of or relating to the Agreement, the Services, and Your transacting business with XMission in any way. ")]), _vm._v(" "), _c('p', [_vm._v("Any Dispute shall be resolved solely and exclusively by arbitration to be held in Salt Lake County, Utah with a single disinterested arbitrator and pursuant to Utah law. This means that neither You nor XMission can sue in court before a judge or jury, individually or as a class member. Instead, an independent arbitrator will decide the dispute with limited discovery rights, and limited rights to appeal. Except as may be required to enforce an arbitration decision, You and XMission expressly waive any right to file any legal action in any other state or federal court or before any other tribunal, and any right to a trial by jury. Each party to such arbitration shall be responsible for its own attorneys’ fees and costs regardless of the outcome of the arbitration.  ")]), _vm._v(" "), _c('p', [_vm._v("You may opt-out of this Arbitration Clause and Class Action Waiver by sending written notice within 30 days of your first transaction with XMission. All notices must be sent pursuant to the Contact Us section below. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("8. "), _c('u', [_vm._v("EMAIL AND SPAM")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("8.1")]), _vm._v(" Spam Mitigation.")]), _vm._v(" "), _c('p', [_vm._v("The receipt of unsolicited or unlawful commercial electronic mail messages, otherwise known as spam (“Spam”), adversely affects the use and enjoyment of email services, as well as XMission’s business and its ability to provide email services to customers. Accordingly, You agree that XMission may take action on Your behalf to mitigate Spam and You grant to XMission the authority and right to opt-out and/or unsubscribe from receiving any and all Spam emails, sent by any party to Your email address(es), as determined by XMission. You also grant and hereby assign to XMission the authority and right to take any other action, including legal action, to stop the mailing and/or receipt of Spam emails to Your email address(es), and seek all available legal remedies against responsible parties, including monetary damages. You understand that through this assignment of claims, You forgo Your personal right and interest to assert legal claims arising under state or federal law, including potential claims for monetary relief, resulting from Your receipt of Spam emails. State law claims may arise under State consumer law. As examples, the Utah Consumer Sales Practices Act, which allows for the recovery of monetary damages for certain consumer transactions and may apply to certain Spam practices. XMission’s Spam mitigation effort may require the preservation and disclosure of Your emails, as well as information contained in the emails, such as, Your name and email address. In most cases, the parties to whom the disclosure is made are already in possession of this information which they used to send You the Spam (i.e., Spam emailers, their attorneys, etc.), but disclosure may also be made to attorneys, law enforcement, the court and court personnel. XMission will make every effort to obfuscate any personally identifying information included in the Spam emails or ensure that any information is protected by a protective order. If You do not wish to have Your email address(es) included in the Spam mitigation effort, or do not desire to assign Your right to claims to XMission, it is Your responsibility to contact XMission at fightspam@xmission.com and opt-out. You may request information from XMission regarding any action taken by XMission described above, which information will not be unreasonably withheld.  ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("8.2")]), _vm._v(" Zero Tolerance.")]), _vm._v(" "), _c('p', [_vm._v("To both aid in the fight against Spam, and to keep XMission's mailservers off Internet blacklists, XMission has zero tolerance in regards to Your sending unsolicited (email/fax/pages/news) messages, or bulk messages (i.e., more than ten (10) messages containing substantially similar content in less than one minute). If XMission receives complaints about Your spamming, Your account will be canceled unless You can prove the recipient requested bulk email from You. You may also face legal action and confess to liquidated damages in the amount of $50 per incident (i.e., one email message constituting one incident) and $100 per hour per employee whose time was used to address the issue. While bulk email is the primary concern, XMission’s Spam policy applies to all other forms of bulk communications. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("8.3")]), _vm._v(" HIPAA")]), _vm._v(" "), _c('p', [_vm._v("XMission's email service is not HIPAA compliant. HIPAA compliance will require additional add-on features.  ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("9. "), _c('u', [_vm._v(" PRIVACY ")])]), _vm._v(" "), _c('p', [_vm._v("The XMission Privacy Policy sets forth XMission's privacy practices with regard to the collection and use of personal information. The XMission Privacy Policy is incorporated herein by this reference. You are required to carefully read the XMission Privacy Policy prior to transacting any business with XMission as part of this Agreement.  ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("10. "), _c('u', [_vm._v(" VOICE SERVICE.  ")])]), _vm._v(" "), _c('p', [_vm._v("The terms and conditions outlined in the XMission Voice Service Addendum accessible at "), _c('a', {
    attrs: {
      "href": "https://xmission.com/legal/terms/voip",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("https://xmission.com/legal/terms/voip")]), _vm._v(", are hereby incorporated by reference and constitute a part of these General Terms and Conditions. The parties agree to be bound thereby. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("11. "), _c('u', [_vm._v(" EQUIPMENT AND SOFTWARE ")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("11.1")]), _vm._v("\n             Physical Equipment and/or Software products that are not provided by XMission are Your responsibility. XMission will not be responsible for the installation of and/or service on equipment and/or software not provided by XMission. You are responsible for the use and compatibility of hardware and software not provided by XMission. In the event You use hardware and/or software that does impair your use of the Services, You shall nonetheless be liable for regular payment to XMission. Upon notice from XMission that the hardware and/or software not provided by XMission is causing, or in the sole opinion of XMission, is likely to cause hazard, interference or service obstruction, You shall eliminate the hazard, interference or service obstruction immediately. You will, if necessary, pay XMission to troubleshoot problems caused by such equipment and/or software not provided by XMission. XMission will not be responsible if any changes in hardware, software or services cause equipment not provided by XMission to become obsolete, require modification or alteration, or in any other way affect the total performance of Services. In the case of user-owned hardware and/or software connected to the XMission network, the user is solely responsible for any and all service to that equipment. XMission, at its option, may supply technical services in the form of consulting and/or service to XMission for a fee. XMission has the right to refuse any such technical services at its sole option. On leased telephone lines, no matter who the leasing party is, XMission must have free and open access to such lines.\n          ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("11.2")]), _vm._v("\n             Physical Equipment and/or Software products provided by XMission are Your responsibility while in Your possession. You agree to maintain such Equipment and/or Software products in working condition, free from damage outside of normal wear and tear. You agree to grant access to XMission to service, update, or replace any such hardware in XMission’s discretion. Further, You agree that any failure to timely pay for the hardware/software or otherwise breach Your responsibilities pertaining thereto, may result in XMission’s repossession of the hardware and/or software. Some services involve leased equipment paid during the terms of service. Other equipment is provided as part of the services. Regardless of lease status at the time of termination of services, if XMission provided it equipment is not returned within one week of termination, XMission reserves the right to charge a monthly lease fee based on the fair market value of the equipment amortized over a twelve (12) month period with 10% interest (“Lease Fee”). The Lease Fee will vary from product to product, and will be identified on monthly invoices. The Lease Fee will continue until the first of the following to occur: (a) You return the equipment in clean, working condition, with no more than ordinary wear and tear. However, XMission reserves the right to reject the return of any damaged equipment after inspection; (b) twelve (12) months, after which you are free to keep the equipment.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("12. "), _c('u', [_vm._v(" GENERAL TERMS OF SERVICE")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.1")]), _vm._v(" XMission will exercise no control whatsoever over the content of any information passing through it. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.2")]), _vm._v(" You are responsible for maintaining secure, unique account passwords and to update them regularly. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.3")]), _vm._v(" You will not use the Services: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code; (h) to collect or track the personal identification information of others; (i) to Spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of this XMission’s network, or any related network, website, or other websites, or the Internet.  ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.4")]), _vm._v(" You may not: (a) resell or make commercial use of the Services or XMission network, or any of its content. You may not modify, adapt, translate or convert into another form any portion of the Services, XMission’s website, or the XMission network; (b) copy, reproduce, download, display, perform, transfer, transmit or publish any portion of the Services, XMission’s website, or the XMission network by any means or in any form; (c) access the Services, XMission’s website, or XMission network from any jurisdiction where doing so would be illegal.  ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.5")]), _vm._v(" You will comply with all laws pertaining to privacy, data collection and protection, intellectual property, contract, and other applicable laws, including but not limited to those laws in the jurisdiction in which you reside or from which you use the Services. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.6")]), _vm._v(" Any and all information You obtain through XMission’s data network services (public and or private) is at Your own risk. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.7")]), _vm._v(" Any and all access to other networks via XMission must be in compliance with all policies and rules of those networks. This applies to any other network that XMission attaches to. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.8")]), _vm._v(" You shall provide all necessary preparations required to comply with XMission’s installation, maintenance and operational specifications. You will be responsible for all costs of relocation of service once installed by XMission and/or its vendors, and will provide XMission and its suppliers of communication service and equipment, reasonable access to your premises to perform any acts required by the Agreement. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.9")]), _vm._v(" XMission bills for all services in advance. Non-contracted accounts are suspended 14 days after their due date if payment is not made. Invoices are sent by email unless the customer requests postal billing, which is billed at $1.50 per invoice. XMission notifies clients an account is due on three separate occasions: with the original invoice (typically 14 days before the account comes due), the day the account is due, and the day before the account will be suspended. XMission accepts all forms of payment including cash, checks, ACH transfers, and most credit cards (e.g., Mastercard, Visa, American Express, Discover). XMission will assess a $20 fee on all returned checks and credit card invoices. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("12.10")]), _vm._v(" Non-contracted accounts are terminated when a customer notifies us they wish to cancel their service. If a customer doesn’t pay for service the account will be suspended 14 days after the due date and then terminated 7 days later.  The customer is responsible for the period of time billed while the account remains active so we suggest you cancel your service to avoid such charges. Any customer terminated account is subject to a refund for the balance due minus a $10 processing fee. This fee will be credited one time to clients who later return to XMission. Accounts canceled by XMission for policy violations are NOT subject to refund and penalty fees may apply. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("13. "), _c('u', [_vm._v(" GENERAL PROVISIONS ")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("13.1")]), _vm._v(" "), _c('b', [_vm._v("Transferability")]), _vm._v(". You may not sell, assign or transfer Services without the prior written consent of XMission. XMission may, at any time, sell, assign or transfer any customer Agreements and any customer accounts to a third party provider with no notice. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("13.2")]), _vm._v(" "), _c('b', [_vm._v("Waiver")]), _vm._v(". Any failure by XMission to enforce or exercise any provision of the Agreement or related rights shall not constitute a waiver of that right or provision. XMission’s rights and remedies under the Agreement are cumulative, and the exercise of a right or recovery of a remedy shall not limit or prevent XMission’s exercise of another right or recover another remedy allowed under the Agreement, at law or in equity. ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("13.3")]), _vm._v(" "), _c('b', [_vm._v("Modification")]), _vm._v(". THESE TERMS AND CONDITIONS CANNOT BE MODIFIED EXCEPT BY WRITTEN AMENDMENT BY THE PARTIES. NO AGENT, EMPLOYEE OR REPRESENTATIVE OF XMISSION HAS THE AUTHORITY TO BIND THE PARTIES TO ANY REPRESENTATION OR WARRANTY UNLESS SUCH IS SPECIFICALLY INCLUDED IN THESE TERMS AND CONDITIONS, THE MSA, OR THE SERVICE ADDENDA.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "ml-5 mr-3 d-inline-block"
  }, [_vm._v("13.4")]), _vm._v(" "), _c('b', [_vm._v("Force Majeure")]), _vm._v(". In addition to any excuse provided by applicable law, XMission shall be excused from liability for its failure to honor any obligations arising from any event beyond XMission’s reasonable control, whether or not foreseeable by either party, including but not limited to: labor disturbance, war, fire, accident, adverse weather, governmental act or regulation, epidemic, pandemic, and any other causes or events beyond XMission’s reasonable control, whether or not similar to those which are enumerated above. ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 mb-3"
  }, [_vm._v("14. "), _c('u', [_vm._v(" CONTACT US  ")])]), _vm._v("\n          XMission, L.C. "), _c('br'), _vm._v("\n          51 East 400 South, Suite 000 "), _c('br'), _vm._v("\n          Salt Lake City, UT 84111-2753 "), _c('br'), _vm._v("\n          Phone: 801.539.0852 "), _c('br'), _c('br'), _vm._v("\n          Toll-Free: 877.964.7746 "), _c('br'), _vm._v("\n          Legal: legal@xmission.com "), _c('br'), _vm._v("\n          Sales: sales@xmission.com "), _c('br'), _vm._v("\n          Billing: billing@xmission.com "), _c('br'), _vm._v("\n          Support: support@xmission.com\n       ")])])
}]}

/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v("Payment method")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "pmt-cc"
    }
  }, [_c('input', {
    staticClass: "pmt-type",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.account_type === _vm.credit_card
    },
    on: {
      "input": function($event) {
        return _vm.setAccountType(_vm.credit_card)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Credit card")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "pmt-ach"
    }
  }, [_c('input', {
    staticClass: "pmt-type",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.account_type === _vm.ach
    },
    on: {
      "input": function($event) {
        return _vm.setAccountType(_vm.ach)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Bank / ACH")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1304:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "addr-search"
    }
  }, [_c('xm-input', {
    ref: "search",
    attrs: {
      "name": "uid"
    },
    on: {
      "blur": function($event) {
        return _vm.hideSuggestions(200)
      }
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "suggestion-menu"
  }, [(_vm.showDropdown) ? _c('ul', {
    ref: "dropdown",
    attrs: {
      "id": "search-dropdown"
    }
  }, _vm._l((_vm.suggestions), function(item) {
    return _c('li', {
      key: item.addr_id,
      staticClass: "suggestion",
      on: {
        "click": function($event) {
          _vm.choice = item
        }
      }
    }, [_vm._v(_vm._s(item.formatted))])
  }), 0) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1305:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('serviceable-address-search', {
    on: {
      "input": _vm.setPotentialServiceableAddressData,
      "form-state": _vm.setAddressPotentiallyServiceable
    }
  }), _vm._v(" "), (_vm.addressPotentiallyServiceable) ? _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('customer-details-rc')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "customer-details-rc"
    }
  }, [_c('customer-details', {
    attrs: {
      "service": _vm.serviceDetails.connectivity
    },
    on: {
      "input": _vm.setCustomerData,
      "form-state": _vm.setCustomerDetailsValid,
      "contact-added": _vm.resetBeforeAddressForm
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('speed-select-rc')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerDetailsValid),
      expression: "customerDetailsValid"
    }],
    attrs: {
      "id": "speed-select-rc"
    }
  }, [_c('speed-select', {
    attrs: {
      "service-details": _vm.serviceDetails
    },
    on: {
      "input": _vm.setSpeedData,
      "form-state": _vm.setSpeedDetailsValid
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('xwi-service-rc')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedValid),
      expression: "speedValid"
    }],
    attrs: {
      "id": "xwi-service-rc"
    }
  }, [_c('xwi-service', {
    attrs: {
      "service": _vm.serviceDetails.router
    },
    on: {
      "input": _vm.setRouterData,
      "form-state": _vm.setRouterValid
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('connectivity-service-rc')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routerValid),
      expression: "routerValid"
    }],
    attrs: {
      "id": "connectivity-service-rc"
    }
  }, [(['utopia', 'yellowstone_fiber', 'bountiful_fiber'].includes(_vm.provider.name)) ? _c('div', [_c('utopia-residential', {
    attrs: {
      "service": _vm.serviceDetails.connectivity
    },
    on: {
      "input": _vm.setUtopiaDetails,
      "form-state": _vm.setConnectivityValid
    }
  })], 1) : (['lehi_fiber'].includes(_vm.provider.name)) ? _c('div', [_c('strata-residential', {
    attrs: {
      "service": _vm.serviceDetails.connectivity
    },
    on: {
      "input": _vm.setStrataData,
      "form-state": _vm.setConnectivityValid
    }
  })], 1) : (['southern_ute'].includes(_vm.provider.name)) ? _c('div', [_c('bonfire-residential', {
    attrs: {
      "service": _vm.serviceDetails.connectivity
    },
    on: {
      "input": _vm.setSouthernUteData,
      "form-state": _vm.setConnectivityValid
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('voice-service-rc')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needsVoiceOption),
      expression: "needsVoiceOption"
    }],
    attrs: {
      "id": "voice-service-rc"
    }
  }, [_c('br'), _vm._v(" "), _c('voice-service', {
    attrs: {
      "service": _vm.serviceDetails.voice
    },
    on: {
      "input": _vm.setVoiceData
    }
  })], 1)]), _vm._v(" "), _c('br')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "us-states"
    }
  }, [_c('b-input-group', {
    attrs: {
      "id": "state-abbrev-input-group"
    }
  }, [_c('b-input-group-prepend', [_c('b-dropdown', {
    attrs: {
      "text": _vm.choice.abbr || 'Abbreviation',
      "no-flip": "",
      "boundary": "state-abbrev-input-group"
    }
  }, [_c('div', {
    attrs: {
      "form-class": "abbrDropdown bd-links"
    }
  }, _vm._l((_vm.states.states), function(state) {
    return _c('b-dropdown-item', {
      key: state['abbr'],
      on: {
        "click": function($event) {
          _vm.choice = state;
        }
      }
    }, [_vm._v(_vm._s(state['abbr']))])
  }), 1)])], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "required": "",
      "id": "state-abbrev-input"
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), _vm._v(" "), (_vm.showDropdown) ? _c('ul', {
    ref: "dropdown",
    attrs: {
      "id": "input-dropdown"
    }
  }, _vm._l((_vm.suggestions), function(item) {
    return _c('li', {
      staticClass: "suggestion",
      on: {
        "click": function($event) {
          _vm.choice = item
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1307:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "copyright"
  }, [_vm._v("©"), _c('span', {
    attrs: {
      "id": "xmyear"
    }
  }, [_vm._v(_vm._s(_vm.currentYear))]), _vm._v(" XMission")]), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-switch",
    attrs: {
      "id": "modeBox"
    }
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "modeSwitch"
    },
    on: {
      "click": _vm.darkmodeToggle
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "modeSwitch",
      "id": "modeSwitchLabel"
    }
  }, [_vm._v("Dark mode")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "footerLinks"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Services")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/utopia"
    }
  }, [_vm._v("UTOPIA Fiber")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/cloud_hosting"
    }
  }, [_vm._v("Managed Hosting")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/web_hosting"
    }
  }, [_vm._v("Shared Hosting")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/colocation"
    }
  }, [_vm._v("Colocation")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/email_collaboration"
    }
  }, [_vm._v("Email")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/business_phone"
    }
  }, [_vm._v("Phone / VoIP")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Credentials")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/green/"
    }
  }, [_vm._v("100% Green Powered"), _c('br')]), _c('a', {
    attrs: {
      "href": "/soc2/"
    }
  }, [_vm._v("SOC 2")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/pci/"
    }
  }, [_vm._v("PCI DSS"), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.bbb.org/utah/business-reviews/internet-services/xmission-in-salt-lake-city-ut-2001636"
    }
  }, [_vm._v("BBB Accredited")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/privacy-pledge/"
    }
  }, [_vm._v("Privacy Pledge")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/environment/"
    }
  }, [_vm._v("Energy Star Certified")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', [_vm._v("Social")]), _vm._v(" "), _c('i', {
    staticClass: "bi bi-bluesky"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://bsky.app/profile/xmission.com"
    }
  }, [_vm._v("@xmission")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-bluesky"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://bsky.app/profile/status.xmission.com"
    }
  }, [_vm._v("@xmissionstatus")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-facebook"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/pages/XMission/6155383019"
    }
  }, [_vm._v("facebook")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-instagram"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/xmission/"
    }
  }, [_vm._v("instagram")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-linkedin"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/company/33375?trk=NUS_CMPY_TWIT"
    }
  }, [_vm._v("linkedin")]), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "bi bi-star-fill"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/reviews"
    }
  }, [_vm._v("Review us")])])])
}]}

/***/ }),

/***/ 1308:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.hasDarkTheme ? 'darkMode' : ''],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('top-navbar'), _vm._v(" "), (_vm.isSignup) ? _c('notifications', {
    staticClass: "ssu-alert-container"
  }) : _vm._e(), _vm._v(" "), (_vm.isSignup) ? _c('signup', {
    staticClass: "signup"
  }) : _vm._e(), _vm._v(" "), (_vm.subNavbarVisible) ? _c('bottom-navbar') : _vm._e(), _vm._v(" "), (!_vm.isSignup) ? _c('div', {
    staticClass: "container app",
    class: _vm.visibilityClass
  }, [_c('notifications'), _vm._v(" "), _c('notices'), _vm._v(" "), _c('refresh-password-modal'), _vm._v(" "), _c('router-view')], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isSignup) ? _c('foot') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1309:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-validator', {
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('username-suggest', {
    ref: "uid",
    attrs: {
      "value": _vm.form_data.uid,
      "fname": _vm.fname,
      "lname": _vm.lname,
      "required": ""
    },
    on: {
      "input": _vm.updateUid,
      "form-state": function($event) {
        return _vm.updateUidValid($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('password-form', {
    attrs: {
      "suggestions-in-modal": true,
      "isNewPassword": false,
      "hide-password-notifications": true
    },
    on: {
      "input": _vm.updatePassword,
      "form-state": _vm.updatePasswordValid
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1310:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', _vm._g(_vm._b({
    attrs: {
      "visible": _vm.value,
      "body-class": "position-static"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      },
      "hide": _vm.closeModalNotifications
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('modal-notifications'), _vm._v(" "), _c('text-overlay', {
          attrs: {
            "show": _vm.saving || _vm.deleting,
            "no-wrap": "",
            "text": _vm.saving ? _vm.savingText : _vm.deletingText,
            "rounded": ""
          }
        }), _vm._v(" "), _vm._t("default", null, null, scope)]
      }
    }, _vm._l((Object.keys(_vm.$scopedSlots).filter(function (x) { return !(['default', 'modal-footer'].includes(x)); })), function(slot) {
      return {
        key: slot,
        fn: function(scope) {
          return [_vm._t(slot, null, null, scope)]
        }
      }
    }), {
      key: "modal-footer",
      fn: function(ref) {
        var ok = ref.ok;
        var cancel = ref.cancel;

        return [(_vm.deleteMethod !== null) ? _c('delete-button', {
          staticClass: "mr-auto",
          attrs: {
            "disabled": _vm.deleteDisabled
          },
          on: {
            "confirmed": function($event) {
              _vm.deleteClicked().then(function () { return ok(); })
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "outline-secondary",
            "disabled": _vm.cancelDisabled
          },
          on: {
            "click": function($event) {
              _vm.cancelClicked().then(function () { return cancel(); })
            }
          }
        }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('b-button', {
          class: _vm.saveDisabled ? 'save-disabled' : '',
          attrs: {
            "variant": "primary",
            "disabled": _vm.saveDisabled
          },
          on: {
            "click": function($event) {
              _vm.saveClicked().then(function () { return ok(); }, function () {})
            }
          }
        }, [_vm._v(_vm._s(_vm.saveText))])]
      }
    }], null, true)
  }, 'b-modal', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),

/***/ 1311:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1",
    attrs: {
      "id": "heard-about-xm"
    }
  }, [_c('h3', {
    staticClass: "mt-4"
  }, [_vm._v("How did you hear about XMission?")]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-top"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('label', {
    staticClass: "mr-sm-2 sr-only",
    attrs: {
      "for": "hdyh-select"
    }
  }, [_vm._v("Preference")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribution),
      expression: "attribution"
    }],
    staticClass: "custom-select mr-sm-2",
    attrs: {
      "id": "hdyh-select"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.attribution = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.attribution_types), function(attribution_type) {
    return _c('option', {
      key: attribution_type.id,
      domProps: {
        "value": attribution_type.id
      }
    }, [_vm._v(" " + _vm._s(attribution_type.label))])
  }), 0)]), _vm._v(" "), (_vm.isOtherAttribution) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.other_text),
      expression: "other_text"
    }],
    staticClass: "ml-2",
    attrs: {
      "id": "hdyh-other",
      "type": "text",
      "placeholder": "please specify"
    },
    domProps: {
      "value": (_vm.other_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.other_text = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNullAttribution) ? _c('button', {
    staticClass: "btn btn-outline-secondary ml-2",
    attrs: {
      "id": "hdyh-skip"
    },
    on: {
      "click": _vm.skipClicked
    }
  }, [_vm._v("skip")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1312:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "id": _vm.id,
      "title": _vm.title,
      "hide-footer": ""
    },
    on: {
      "show": _vm.getPayaUrl
    },
    model: {
      value: (_vm.inputVal),
      callback: function($$v) {
        _vm.inputVal = $$v
      },
      expression: "inputVal"
    }
  }, [_c('paya-payment-account', {
    on: {
      "card-added": _vm.cardAdded
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1313:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dropdown', {
    attrs: {
      "disabled": _vm.disabled,
      "dropup": _vm.dropup,
      "text": _vm.buttonText,
      "variant": _vm.buttonType,
      "right": _vm.right,
      "size": _vm.size
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.$emit('confirmed')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmText))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1314:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alertBox"
  }, _vm._l((_vm.reverseModalNotifications), function(notification, index) {
    return _c('notification', {
      key: index,
      attrs: {
        "notification": notification,
        "position": index
      },
      on: {
        "close": function($event) {
          return _vm.closeNotification(index)
        }
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 1315:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "equipment-option"
    }
  }, [_c('h4', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.isTenG ? '10Gbps connections include XWi' : 'Add premium home WiFi'))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [(!_vm.activeRouterAvailable) ? _c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xwi-oos"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(0)]) : _c('label', {
    staticClass: "mb-3",
    on: {
      "click": function($event) {
        return _vm.setNeedsRouter(true)
      }
    }
  }, [_c('input', {
    class: _vm.isTenGRouter ? 'xwi-xtndrs' : '',
    attrs: {
      "type": "radio",
      "name": _vm.isTenG ? 'xtndrs' : 'xwi',
      "id": "xwi-radio"
    },
    domProps: {
      "checked": _vm.isTenG
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xwi"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v(" ")]), _vm._v(" "), _c('table', [_c('tr', [_c('td', [_c('img', {
    class: _vm.isTenGRouter ? '' : 'd-none d-md-block',
    style: (_vm.isTenGRouter ? 'margin:0 -30px 0 10px' : 'margin-right:-30px'),
    attrs: {
      "src": _vm.routerImageLink,
      "height": "200"
    }
  })]), _vm._v(" "), _c('td', {
    class: _vm.isTenGRouter ? 'pr-3 pl-3 pb-3 w-100' : 'pr-3 pl-3 w-100'
  }, [(_vm.grossMonthlyRateReady) ? _c('div', {
    attrs: {
      "id": "get-xwi-headline"
    }
  }, [_c('strong', {
    staticClass: "mb-1"
  }, [_vm._v("Total home Internet solution")]), _vm._v(" "), (!_vm.isTenG) ? _c('center', [_c('b', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.grossMonthlyRate))]), _vm._v("/mo")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.isTenGRouter ? 'w-100' : '',
    attrs: {
      "id": "xwi-benys"
    }
  }, [_c('b', [_vm._v("Control your home WiFi with ease")]), _vm._v(" "), (!_vm.isTenGRouter) ? _c('ul', [_c('li', [_vm._v("XWi 1Gbps WAN WiFi 6 Router (4x1Gbps LAN) and app")]), _vm._v(" "), _c('li', [_vm._v("Remote XMission support for hassle-free maintenance")]), _vm._v(" "), _c('li', [_vm._v("Up to 250 devices with 2,500 sq ft coverage")]), _vm._v(" "), _c('li', [_vm._v("Powerful parental controls and protection from malware and viruses")])]) : _c('ul', [_c('li', [_vm._v("XWi Premium WiFi 6e router and app")]), _vm._v(" "), _c('li', [_vm._v("Remote XMission support for hassle-free maintenance")]), _vm._v(" "), _c('li', [_vm._v("Powerful parental controls and protection from malware and viruses")]), _vm._v(" "), _c('li', [_vm._v("Up to 250 devices with 2,500 sq ft coverage")])]), _vm._v(" "), (_vm.isTenGRouter) ? _c('a', {
    staticClass: "btn btn-info btn-sm float-right",
    attrs: {
      "href": "https://xmission.com/xwi",
      "target": "_blank"
    }
  }, [_vm._v("Learn more")]) : _vm._e()]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })])])])])])]), _vm._v(" "), (!_vm.isTenG) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', {
    staticClass: "mb-3",
    on: {
      "click": function($event) {
        return _vm.setNeedsRouter(false)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "xwi",
      "id": "none-radio"
    }
  }), _vm._v(" "), _vm._m(1)])]) : _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', {
    on: {
      "click": function($event) {
        return _vm.setNeedsRouter(false)
      }
    }
  }, [_c('input', {
    staticClass: "xwi-xtndrs",
    attrs: {
      "type": "radio",
      "name": "xtndrs",
      "id": "none-radio"
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), (_vm.isTenG) ? _c('button', {
    staticClass: "btn btn-outline-dark",
    on: {
      "click": function($event) {
        _vm.ten_g_button_clicked = true
      }
    }
  }, [_vm._v("OK, proceed")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('mesh-extender')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routerSelected && _vm.needsRouter && _vm.activeRouterAvailable),
      expression: "routerSelected && needsRouter && activeRouterAvailable"
    }],
    staticClass: "mt-3",
    attrs: {
      "id": "mesh-extender"
    }
  }, [_c('h4', {
    staticClass: "mt-2"
  }, [_vm._v("Extend your WiFi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [(!_vm.meshesAvailable) ? _c('div', {
    staticClass: "mb-3 w-100"
  }, [_c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xtndr-oos"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_c('img', {
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-logo-black.png",
      "alt": "xwi"
    }
  }), _vm._v(" Mesh Extender")]), _vm._v(" "), _c('table', [_c('tr', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('img', {
    staticClass: "mt-4",
    staticStyle: {
      "filter": "grayscale(100%)",
      "opacity": "0.5"
    },
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-mesh-extender.png",
      "width": "140"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "pr-3 pl-3 w-100"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("Temporarily Out of Stock")]), _vm._v("\n                    New mesh extenders arriving soon. "), _c('br'), _vm._v("Please\n                    "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "tel:8015390852"
    }
  }, [_c('b', [_vm._v("call (801) 539-0852")])]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "https://chat.xmission.com",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("chat")])]), _vm._v(" for exact date.\n                    "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })])])])])]) : _c('label', {
    staticClass: "mb-3 w-100"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "xtndr",
      "id": "xtndr-radio"
    },
    domProps: {
      "checked": _vm.meshExtendersSelected && _vm.isMeshLease
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    attrs: {
      "id": "get-xtndr"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_c('img', {
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-logo-black.png",
      "alt": "xwi"
    }
  }), _vm._v(" Mesh Extender")]), _vm._v(" "), _c('table', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('img', {
    staticClass: "mt-4",
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-mesh-extender.png",
      "width": "140"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "pr-3 pl-3 w-100"
  }, [_c('div', [_c('b', [_vm._v("Increase WiFi range from router to device")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Recommended for homes over 2,500 sq. ft.")]), _vm._v(" "), _c('li', [_vm._v("Extend WiFi 6 coverage for harder to reach areas")]), _vm._v(" "), _c('li', [_vm._v("Add one or more, as needed")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pr-3 pl-3 pb-3"
  }, [_vm._v("\n                    Quantity:\n                    "), _c('select', {
    staticClass: "form-control d-inline",
    attrs: {
      "name": "xtndr-qty",
      "id": "xtndr-qty"
    },
    domProps: {
      "value": _vm.meshQuantityDisplay
    },
    on: {
      "change": _vm.setMeshQuantity
    }
  }, _vm._l((_vm.meshQuantitiesAvailable), function(number) {
    return _c('option', {
      domProps: {
        "value": number
      }
    }, [_vm._v(_vm._s(number))])
  }), 0)]), _vm._v(" "), _c('td', {
    staticClass: "pl-3"
  }, [_c('div', {
    staticClass: "faded",
    attrs: {
      "id": "get-xtndr-price"
    }
  }, [_c('b', {
    staticClass: "price"
  }, [_vm._v("$" + _vm._s(_vm.meshMonthlyRate))]), _vm._v("/mo "), _c('span', {
    staticClass: "each"
  }, [_vm._v("each")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('label', {
    staticClass: "mb-3"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "xtndr",
      "id": "no-xtndr-radio"
    },
    domProps: {
      "checked": _vm.isMeshNone
    },
    on: {
      "click": _vm.setMeshNone
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "no-xtndr"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("No thanks")]), _vm._v(" "), _c('div', [_vm._v("I don't need mesh extenders.")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('tr', {
    staticStyle: {
      "color": "#666"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('img', {
    staticClass: "ml-2 mb-2 mr-2",
    staticStyle: {
      "filter": "grayscale(100%)",
      "opacity": "0.5"
    },
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-router-app.png",
      "height": "100"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "pr-3 pl-3 w-100"
  }, [_c('b', {
    staticClass: "d-block mb-2"
  }, [_vm._v("Temporarily Out of Stock")]), _vm._v("\n                New routers arriving soon. "), _c('br'), _vm._v("Please\n                "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "tel:8015390852"
    }
  }, [_c('b', [_vm._v("call (801) 539-0852")])]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#007bff"
    },
    attrs: {
      "href": "https://chat.xmission.com",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("chat")])]), _vm._v(" for exact date.\n                "), _c('br', {
    attrs: {
      "clear": "all"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "get-nothing"
    }
  }, [_c('h4', [_vm._v("No thanks")]), _vm._v(" "), _c('div', [_vm._v("I will provide my own router")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "get-nothing"
    }
  }, [_c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Opt out")]), _vm._v(" "), _c('div', [_vm._v("I will provide my own router")])])
}]}

/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-button', _vm._b({
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clicked()
      }
    }
  }, 'b-button', _vm.$attrs, false), [_c('b-form-checkbox', {
    attrs: {
      "checked": _vm.checked
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1317:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('h4', [_vm._v("1. Select at least 3 words to use in your password")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-light border-dark",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.refreshWordlist()
      }
    }
  }, [_vm._v("Refresh Wordlist")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.wordListFilled) ? _c('table', {
    staticClass: "table table-bordered table-striped hoverPointerTDs"
  }, [_c('tbody', _vm._l((5), function(row) {
    return _c('tr', _vm._l((3), function(col) {
      return _c('td', {
        key: col,
        class: {
          'selected-word': _vm.wordsSelected[row - 1][col - 1]
        },
        on: {
          "click": function($event) {
            return _vm.selectWord(row, col)
          }
        }
      }, [_vm._v(_vm._s(_vm.wordList2D[row - 1][col - 1]))])
    }), 0)
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h4', [_vm._v("2. Generate your password")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-light border-dark",
    attrs: {
      "disabled": _vm.generateButtonDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generatePassword()
      }
    }
  }, [_vm._v("Generate")])]), _vm._v(" "), _c('br'), _vm._v("\n      After you've finished selecting your words, click generate until you find a password you like.\n    "), _vm._l((_vm.generatedPasswords.entries()), function(ref) {
    var index = ref[0];
    var password = ref[1];

    return _c('copy-paste-input', {
      key: index,
      attrs: {
        "text": password,
        "value": password,
        "show-check": _vm.clickedCopyInput === index
      },
      on: {
        "click": function($event) {
          return _vm.passwordSelected(password, index)
        }
      }
    })
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h4', [_vm._v("3. Choose a password")]), _vm._v(" "), (_vm.genericMessage) ? _c('span', [_vm._v("Pick a password from the list above and then either copy or type it in as your new password wherever you would like.")]) : _vm._e(), _vm._v(" "), (!_vm.genericMessage) ? _c('span', [_vm._v("Pick a password from the list above and copy or type it in the \"" + _vm._s(_vm.passwordLabel) + "\" field below.")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1318:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "mt-2"
  }, [_vm._v("Bank account holder")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-success': _vm.bankNameValid, 'has-error': !_vm.bankNamePotentiallyValid
    }
  }, [_vm._v("\n        Account name"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.name),
      expression: "form_data.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.bankNameValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter the name on the bank account")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-success': _vm.bankRoutingValid, 'has-error': !_vm.bankRoutingPotentiallyValid
    }
  }, [_vm._v("\n        Routing number"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.routing),
      expression: "form_data.routing"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "123456789"
    },
    domProps: {
      "value": (_vm.form_data.routing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "routing", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.bankRoutingValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid routing number")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-success': _vm.bankAccountValid, 'has-error': !_vm.bankAccountPotentiallyValid
    }
  }, [_vm._v("\n          Account number"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.account),
      expression: "form_data.account"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "account", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.bankAccountValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid account number")]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "ach-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.account_type),
      expression: "form_data.account_type"
    }],
    attrs: {
      "type": "radio",
      "name": "ach-type"
    },
    domProps: {
      "value": _vm.checking,
      "checked": _vm._q(_vm.form_data.account_type, _vm.checking)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "account_type", _vm.checking)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Checking")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "ach-savings"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.account_type),
      expression: "form_data.account_type"
    }],
    attrs: {
      "type": "radio",
      "name": "ach-type"
    },
    domProps: {
      "value": _vm.savings,
      "checked": _vm._q(_vm.form_data.account_type, _vm.savings)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "account_type", _vm.savings)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Savings")])])])]), _vm._v(" "), (!_vm.bankAccountTypeValid) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', {
    class: [_vm.hasDarkTheme ? 'bg-info' : 'bg-warning'],
    staticStyle: {
      "padding": "10px 15px",
      "margin-top": "10px"
    }
  }, [_c('b', [_vm._v("Please double-check")]), _vm._v(" that the account info entered above is correct. "), _c('br'), _vm._v("Incorrect information will result in a bounced payment fee of $20.\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("\n        Account type\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please select an account type")])])
}]}

/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pt-2",
    attrs: {
      "id": "account-setup"
    }
  }, [_c('h3', {
    staticClass: "mb-2 pb-2"
  }, [_vm._v("Set up your XMission account")]), _vm._v(" "), _c('form-validator', {
    ref: "form",
    model: {
      value: (_vm.customerFormValid),
      callback: function($$v) {
        _vm.customerFormValid = $$v
      },
      expression: "customerFormValid"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('xm-input', {
    ref: "fname",
    staticClass: "signup-input",
    attrs: {
      "name": "fname",
      "label": "First name",
      "required": ""
    },
    model: {
      value: (_vm.fname),
      callback: function($$v) {
        _vm.fname = $$v
      },
      expression: "fname"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('xm-input', {
    ref: "lname",
    staticClass: "signup-input",
    attrs: {
      "name": "lname",
      "label": "Last name",
      "required": ""
    },
    model: {
      value: (_vm.lname),
      callback: function($$v) {
        _vm.lname = $$v
      },
      expression: "lname"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('xm-input', {
    ref: "email",
    staticClass: "signup-input",
    attrs: {
      "name": "email",
      "label": "Email",
      "type": "email",
      "pattern": _vm.regex.email,
      "error": "Please enter a valid email address",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    ref: "phone",
    staticClass: "signup-input",
    attrs: {
      "name": "phone",
      "label": "Phone number",
      "type": "tel",
      "error": "Please enter a valid phone number",
      "pattern": _vm.regex.phone,
      "required": ""
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "col-form-label"
  }, [_vm._v("\n                  Date of birth\n                  "), _c('span', {
    staticClass: "btn-primary qtip",
    attrs: {
      "data-content": "For more secure account verification you can enter a 'security date' instead."
    }
  }, [_vm._v("?")])]), _vm._v(" "), _c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    ref: "dob",
    staticClass: "signup-input",
    attrs: {
      "name": "dob",
      "pattern": _vm.dobPattern,
      "placeholder": "MM/DD/YYYY",
      "error": "Please enter a valid date of birth",
      "required": ""
    },
    model: {
      value: (_vm.dob),
      callback: function($$v) {
        _vm.dob = $$v
      },
      expression: "dob"
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('account-credentials')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customerFormValid),
      expression: "customerFormValid"
    }],
    attrs: {
      "id": "account-credentials"
    }
  }, [_c('h4', {
    staticClass: "mt-3"
  }, [_vm._v("XMission account credentials")]), _vm._v(" "), _c('user-form', {
    on: {
      "form-valid": function($event) {
        _vm.userFormValid = true
      },
      "form-invalid": function($event) {
        _vm.userFormValid = false
      }
    },
    model: {
      value: (_vm.user_form),
      callback: function($$v) {
        _vm.user_form = $$v
      },
      expression: "user_form"
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1320:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    staticClass: "ControlNav",
    attrs: {
      "fixed": "top"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-navbar-nav', [_c('b-nav-item', {
    class: [{
      active: _vm.onAccountTab
    }, 'control-nav-item'],
    attrs: {
      "to": "/account"
    }
  }, [_c('span', {
    staticClass: "hide-mobile"
  }, [_vm._v("Account ")]), _vm._v("Home"), _c('span', {
    staticClass: "nav-info"
  }, [_vm._v("Settings, Billing, Contacts")])]), _vm._v(" "), _c('b-nav-item', {
    class: [{
      disabled: true,
      active: _vm.onServicesTab
    }, 'control-nav-item'],
    attrs: {
      "to": "/services"
    }
  }, [_vm._v("\n        Services"), _c('span', {
    staticClass: "nav-info"
  }, [_vm._v("Servers, Hosting, etc.")])]), _vm._v(" "), _c('b-nav-item', {
    class: [{
      disabled: !_vm.hasPaymentsViewPerm,
      active: _vm.onBillingTab
    }, 'control-nav-item'],
    attrs: {
      "to": "/billing"
    }
  }, [_vm._v("\n        Billing"), _c('span', {
    staticClass: "nav-info"
  }, [_vm._v("Payments, Statements")])])], 1), _vm._v(" "), _c('b-navbar-nav', [_c('b-nav-item', {
    class: ['CtrLogout', 'control-logout'],
    attrs: {
      "right": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('b-icon-box-arrow-right', {
    staticClass: "hide-mobile",
    attrs: {
      "font-scale": "1.25",
      "id": "logout-icon"
    }
  }), _c('span', {
    staticClass: "nav-info logout-button-span"
  }, [_vm._v("Log Out")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1321:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.activeNotices), function(notice) {
    return _c('div', [_c('notice', {
      attrs: {
        "notice": notice
      }
    })], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 1322:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "speed-select"
    }
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("Choose the XMission Fiber speed for this address")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.speedOptions.speed_options), function(option) {
    return _c('label', {
      key: option.speed_id,
      on: {
        "click": function($event) {
          return _vm.setSpeedDetails(option)
        }
      }
    }, [_c('input', {
      staticClass: "speed-radio",
      attrs: {
        "type": "radio",
        "name": "speed"
      }
    }), _vm._v(" "), _c('div', {
      class: ['package', option.speed_color]
    }, [_c('h4', [_vm._v(_vm._s(option.speed_label) + " "), _c('small', [_vm._v("upload and download")])]), _vm._v(" "), _c('div', {
      staticClass: "promo-fmf"
    }, [_vm._v(_vm._s(option.early_net_connectivity_rate_term))]), _vm._v(" "), _c('b', {
      staticClass: "price"
    }, [_vm._v("$" + _vm._s(option.monthly_gross_connectivity_rate))]), _vm._v("/mo\n        "), _c('small', {
      staticClass: "breakdown"
    }, [_vm._v(_vm._s(option.monthly_gross_connectivity_rate_breakdown))]), _vm._v(" "), (option.speed_id !== 'speed_10000_sym') ? _c('span', [_c('div', {
      staticClass: "promo-2dollars xm-g-bg"
    }, [_vm._v("$"), _c('b', [_vm._v(_vm._s(option.monthly_gross_connectivity_router_rate))]), _vm._v("/mo when you add "), _c('b', [_vm._v("XWi Home")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(option.speed_description))])]) : _c('span', [_c('p', {
      staticClass: "mb-0"
    }, [_c('img', {
      staticClass: "float-left mr-2",
      attrs: {
        "src": "https://asset.xmission.com/xwi/xwi-router-white.png",
        "width": "90",
        "alt": "XWi router white"
      }
    }), _vm._v("\n              10Gbps comes bundled with "), _c('img', {
      staticStyle: {
        "height": "20px",
        "vertical-align": "baseline"
      },
      attrs: {
        "src": _vm.xwiLogoUrl,
        "alt": "XWi"
      }
    }), _vm._v(" including router & app.\n            ")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mr-3",
    staticStyle: {
      "line-height": "normal"
    }
  }, _vm._l((_vm.legalDisclaimers), function(promo_legal_disclaimer) {
    return _c('span', [_c('b', [_vm._v(_vm._s(promo_legal_disclaimer.label))]), _vm._v(": "), _c('small', [_vm._v(_vm._s(promo_legal_disclaimer.disclaimer))]), _vm._v(" \n      ")])
  }), 0)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1324:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.paya_url) ? _c('embed', {
    attrs: {
      "id": "payaPaymentAccountIframe",
      "src": _vm.paya_url
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.serviceTypes.length === 1) ? _c('div', [_c(_vm.serviceTypes[0], {
    tag: "component",
    on: {
      "form-state": _vm.setServiceValidity,
      "form-invalid": function($event) {
        return _vm.setServiceValidity(false)
      },
      "form-valid": function($event) {
        return _vm.setServiceValidity(true)
      }
    }
  })], 1) : _c('div')])
},staticRenderFns: []}

/***/ }),

/***/ 1326:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    class: ['btn', _vm.disabled ? 'btn-outline-primary' : 'order-btn-active', 'mb-1'],
    attrs: {
      "type": "button",
      "id": "order-btn",
      "disabled": _vm.disabled,
      "title": _vm.title,
      "value": "Place order"
    },
    on: {
      "click": _vm.handleClick
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form-validator', {
    model: {
      value: (_vm.formValidatorValid),
      callback: function($$v) {
        _vm.formValidatorValid = $$v
      },
      expression: "formValidatorValid"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('xm-input', {
    attrs: {
      "name": "line1",
      "label": "Street Address",
      "required": "",
      "error": "Please enter a valid address",
      "pattern": "[a-zA-Z0-9]+",
      "error-style": "address-name-style text-danger"
    },
    model: {
      value: (_vm.formValues.line1),
      callback: function($$v) {
        _vm.$set(_vm.formValues, "line1", $$v)
      },
      expression: "formValues.line1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('xm-input', {
    attrs: {
      "name": "line2",
      "label": "Address Line 2"
    },
    model: {
      value: (_vm.formValues.line2),
      callback: function($$v) {
        _vm.$set(_vm.formValues, "line2", $$v)
      },
      expression: "formValues.line2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('xm-input', {
    attrs: {
      "name": "city",
      "label": "City",
      "required": "",
      "pattern": "[a-zA-Z0-9]+",
      "error": "Please enter a valid city",
      "error-style": "address-name-style text-danger"
    },
    model: {
      value: (_vm.formValues.city),
      callback: function($$v) {
        _vm.$set(_vm.formValues, "city", $$v)
      },
      expression: "formValues.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "col-form-label",
    attrs: {
      "for": "us-states"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('us-states', {
    attrs: {
      "id": "us-states"
    },
    model: {
      value: (_vm.formValues.state),
      callback: function($$v) {
        _vm.$set(_vm.formValues, "state", $$v)
      },
      expression: "formValues.state"
    }
  }), _vm._v(" "), (!_vm.stateValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid state")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('xm-input', {
    attrs: {
      "name": "zip_code",
      "label": "Zip Code",
      "required": "",
      "error": "Please enter a valid zip code",
      "pattern": "^\\d{5}(?:[-\\s]\\d{4})?$",
      "error-style": "address-name-style text-danger"
    },
    model: {
      value: (_vm.formValues.zip_code),
      callback: function($$v) {
        _vm.$set(_vm.formValues, "zip_code", $$v)
      },
      expression: "formValues.zip_code"
    }
  })], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1328:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xm-top-navbar"
  }, [_c('div', [_c('b-navbar', {
    staticClass: "navbar-dark",
    attrs: {
      "fixed": "top",
      "toggleable": "lg"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": _vm.base
    }
  }, [_c('img', {
    class: {
      'xmBrand': _vm.isSignup
    },
    attrs: {
      "src": _vm.brandUrl,
      "alt": "XMission"
    }
  })]), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "XMMainNav",
      "aria-controls": "XMMainNav",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "XMMainNav",
      "is-nav": ""
    }
  }, [_c('b-navbar-nav', {
    staticClass: "mr-auto"
  }, [_c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-labelledby": "businessMenu",
      "no-caret": "",
      "text": "Business",
      "menu-class": ['submenu-business', 'businessMenu']
    }
  }, [_c('b-dropdown-header', [_vm._v("Internet Connections")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/xmission-business-fiber')
      }
    }
  }, [_vm._v("XMission Business Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_utopia')
      }
    }
  }, [_vm._v("·\t  Business UTOPIA")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_bountiful')
      }
    }
  }, [_vm._v("·\t  Bountiful Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_lehi')
      }
    }
  }, [_vm._v("·\t  Lehi Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_southern_ute')
      }
    }
  }, [_vm._v("·\t  Southern Ute")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "link-class": "subsub"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_yellowstone')
      }
    }
  }, [_vm._v("·\t  Yellowstone")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/xwi-smartsmb')
      }
    }
  }, [_vm._v("XWi Smart SMB")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_connectivity')
      }
    }
  }, [_vm._v("Other Connectivity")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Domain & Hosting Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/domains')
      }
    }
  }, [_vm._v("Domain Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/web_hosting')
      }
    }
  }, [_vm._v("Shared Hosting")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/cloud_hosting')
      }
    }
  }, [_vm._v("Managed Cloud Hosting")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/vps')
      }
    }
  }, [_vm._v("Unmanaged Cloud Hosting")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/colocation')
      }
    }
  }, [_vm._v("Colocation")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/ssl')
      }
    }
  }, [_vm._v("SSL Certificates")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Email & Collaboration Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/email_collaboration')
      }
    }
  }, [_vm._v("Hosted Zimbra Email")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/licensing')
      }
    }
  }, [_vm._v("Zimbra Licensing")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/reseller')
      }
    }
  }, [_vm._v("Private Label & Reseller")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Phone & Professional Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/business_phone')
      }
    }
  }, [_vm._v("Business Phone Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/professional_services')
      }
    }
  }, [_vm._v("Professional Services")])], 1)], 1), _vm._v(" "), _c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-labelledby": "residentialMenu",
      "no-caret": "",
      "text": "Residential",
      "href": "#",
      "menu-class": ['residentialMenu', 'submenu-residential']
    }
  }, [_c('b-dropdown-header', [_vm._v("Internet Connections")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/utopia')
      }
    }
  }, [_vm._v("UTOPIA")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/yellowstone_fiber')
      }
    }
  }, [_vm._v("Yellowstone Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/xmission-fiber-bountiful')
      }
    }
  }, [_vm._v("Bountiful Fiber")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/lehi')
      }
    }
  }, [_vm._v("Lehi Fiber")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Phone Service")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/voice')
      }
    }
  }, [_vm._v("Voice")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Domain & Hosting Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/domains')
      }
    }
  }, [_vm._v("Domain Services")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/web_hosting')
      }
    }
  }, [_vm._v("Shared Hosting")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Email")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/personal_email')
      }
    }
  }, [_vm._v("Personal Premium Email")])], 1)], 1), _vm._v(" "), _c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-labelledby": "aboutMenu",
      "no-caret": "",
      "text": "About",
      "href": "#",
      "menu-class": "aboutMenu"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/contact')
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/blog')
      }
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/our_story')
      }
    }
  }, [_vm._v("Our Story")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/our_network')
      }
    }
  }, [_vm._v("Our Network")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/community')
      }
    }
  }, [_vm._v("Community")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/environment')
      }
    }
  }, [_vm._v("Environment")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/jobs')
      }
    }
  }, [_vm._v("Jobs")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/legal')
      }
    }
  }, [_vm._v("Legal")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/media')
      }
    }
  }, [_vm._v("Media")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/statistics')
      }
    }
  }, [_vm._v("Statistics")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/transparency')
      }
    }
  }, [_vm._v("Transparency")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/privacy-pledge')
      }
    }
  }, [_vm._v("Privacy Pledge")])], 1)], 1), _vm._v(" "), _c('b-nav-item', [_c('b-nav-item-dropdown', {
    attrs: {
      "aria-labelledby": "supportMenu",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "no-caret": "",
      "text": "Support",
      "href": "#",
      "menu-class": "supportMenu"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/support')
      }
    }
  }, [_vm._v("Resource Center")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/contact')
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.navigateTo('/livesupport')
      }
    }
  }, [_vm._v("Live Support")])], 1)], 1)], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.search-xmission-modal",
      modifiers: {
        "search-xmission-modal": true
      }
    }],
    staticClass: "btn btn-outline-success",
    attrs: {
      "type": "button",
      "id": "search-button"
    }
  }, [_c('i', {
    staticClass: "bi bi-search"
  })]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('a', {
    staticClass: "btn btn-outline-danger",
    attrs: {
      "href": "/login"
    }
  }, [_c('b', [_vm._v("login")])]) : _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "/control",
      "id": "CtlUserTab"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.username) + "\n          "), _c('small', [_vm._v("logged in")])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Search XMission",
      "id": "search-xmission-modal",
      "hide-footer": ""
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    model: {
      value: (_vm.search_query),
      callback: function($$v) {
        _vm.search_query = $$v
      },
      expression: "search_query"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("\n            Go\n          ")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flush-left"
  }, [(_vm.label !== '') ? _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v(_vm._s(_vm.label) + ":")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "copy_input",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "copy_input"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), _c('span', {
    staticClass: "input-group-append btn",
    on: {
      "click": function($event) {
        return _vm.copy()
      }
    }
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [(_vm.showCheck) ? _c('i', {
    staticClass: "bi bi-check2 text-success"
  }) : _c('i', {
    staticClass: "bi bi-clipboard"
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1330:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('text-overlay', {
    attrs: {
      "show": _vm.querying_api,
      "text": _vm.overlay_text,
      "no-wrap": "",
      "fixed": ""
    }
  }), _vm._v(" "), _c('div', [(_vm.dropDetails.needs_ont_install) ? _c('div', [_c('br'), _vm._v(" "), _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('google-maps-draggable', {
    attrs: {
      "draggable": true
    },
    model: {
      value: (_vm.location_details),
      callback: function($$v) {
        _vm.location_details = $$v
      },
      expression: "location_details"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('xm-input', {
    attrs: {
      "placeholder": _vm.exterior_notes_placeholder,
      "type": "textarea"
    },
    model: {
      value: (_vm.form_data.drop_details.notes),
      callback: function($$v) {
        _vm.$set(_vm.form_data.drop_details, "notes", $$v)
      },
      expression: "form_data.drop_details.notes"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), _vm._l((_vm.installationOptions), function(installation_option) {
    return _c('div', {
      key: installation_option.installation_type
    }, [_c('div', [_c('label', {
      staticClass: "radio-head"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "install_type_radio"
      },
      on: {
        "click": function($event) {
          return _vm.setInstallType(installation_option)
        }
      }
    }), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(installation_option.label))])])]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(installation_option.billing.fees[0].rate) + " (" + _vm._s(installation_option.sub_description) + ")")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(installation_option.description))])]), _vm._v(" "), _c('br')])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('xm-input', {
    attrs: {
      "placeholder": _vm.interior_notes_placeholder,
      "type": "textarea"
    },
    model: {
      value: (_vm.form_data.install_details.notes),
      callback: function($$v) {
        _vm.$set(_vm.form_data.install_details, "notes", $$v)
      },
      expression: "form_data.install_details.notes"
    }
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('strata-installation-date-details')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.installTypeChosen && !_vm.querying_api),
      expression: "installTypeChosen && !querying_api"
    }],
    attrs: {
      "id": "strata-installation-date-details"
    }
  }, [_c('div', [_c('h5', [_vm._v("Installation date and time")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Pick an install date:")]), _vm._v(" "), _c('b-form-datepicker', {
    attrs: {
      "date-disabled-fn": _vm.dateAvailable,
      "initial-date": _vm.install_start_date,
      "no-highlight-today": ""
    },
    model: {
      value: (_vm.install_date),
      callback: function($$v) {
        _vm.install_date = $$v
      },
      expression: "install_date"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('strata-installation-time-details')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.installDateChosen),
      expression: "installDateChosen"
    }],
    attrs: {
      "id": "strata-installation-time-details"
    }
  }, [_c('label', [_vm._v("Pick an install time:")]), _c('br'), _vm._v(" "), _c('b-dropdown', {
    attrs: {
      "text": _vm.install_time
    }
  }, _vm._l((_vm.install_times), function(installation_item) {
    return _c('b-dropdown-item', {
      key: installation_item.displayTime,
      on: {
        "click": function($event) {
          return _vm.setInstallDate(installation_item)
        }
      }
    }, [_vm._v(" " + _vm._s(installation_item.displayTime + ' (' + installation_item.duration + 'minutes) '))])
  }), 1)], 1)])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Fiber installation: home exterior "), _c('small', [_vm._v("(red pin "), _c('span', {
    staticClass: "red-pin-icon"
  }), _vm._v(" shows where the fiber will attach to your home, typically near other utilities). The red pin marks the pre-engineered fiber location where Lehi City plans to reach your home. Note that adjusting this location will trigger an engineering review, potentially leading to extra charges and installation delays.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Exterior installation notes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Fiber installation: home interior "), _c('small', [_vm._v("(fiber equipment mounted inside the home on an exterior wall)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Interior installation notes")])])
}]}

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "uid-suggestions"
    }
  }, [_c('xm-input', {
    ref: "uid",
    attrs: {
      "name": "uid",
      "id": "uid-input",
      "label": "Username",
      "error": _vm.uidErrorStr,
      "pattern": _vm.uidRegex
    },
    on: {
      "blur": function($event) {
        return _vm.hideSuggestions(100)
      }
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uid-menu"
  }, [(_vm.showDropdown) ? _c('ul', {
    ref: "dropdown",
    attrs: {
      "id": "uid-dropdown"
    }
  }, [_c('li', {
    attrs: {
      "id": "uid-taken-warning"
    }
  }, [_vm._v("That username is taken. Here are some suggestions")]), _vm._v(" "), _vm._l((_vm.uidSuggestions), function(item) {
    return _c('li', {
      staticClass: "suggestion",
      on: {
        "click": function () {
          _vm.choose(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1332:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": _vm.classType,
      "dismissible": ""
    },
    on: {
      "dismissed": function($event) {
        return _vm.closeNotification()
      }
    }
  }, [(_vm.multiMessage) ? _c('ul', _vm._l((_vm.notification.message), function(item) {
    return _c('li', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0) : _c('span', [_vm._v("\n      " + _vm._s(_vm.notification.message) + "\n    ")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-modal', {
    attrs: {
      "open": _vm.refreshPasswordOpened,
      "title": 'Verify Identity',
      "modal-name": _vm.modalName,
      "save": _vm.save,
      "backdrop": false
    },
    on: {
      "closed": function($event) {
        return _vm.closeModal()
      },
      "valid": function($event) {
        return _vm.setFormValid(true)
      },
      "invalid": function($event) {
        return _vm.setFormValid(false)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('xm-input', {
    attrs: {
      "type": "password",
      "label": "Password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1334:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('p', [_vm._v("If you would like XMission to contact you about adding phone services, please check the box below.")]), _vm._v(" "), _c('b-form-checkbox', {
    model: {
      value: (_vm.form_data.contact),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "contact", $$v)
      },
      expression: "form_data.contact"
    }
  }, [_vm._v("Contact me about setting up XMission Voice on my connectivity service")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Additional Voice services")])])
}]}

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isProspect),
      expression: "!isProspect"
    }]
  }, [_c('div', [_vm._v("Installation fees are currently waived.")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('label', [_vm._v("When would you like your installation to occur? Note that Bonfire will call you beforehand to confirm or update your activation time.")]), _vm._v(" "), _c('b-form-datepicker', {
    attrs: {
      "min": _vm.min_date
    },
    model: {
      value: (_vm.form_data.desired_activation_date),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "desired_activation_date", $$v)
      },
      expression: "form_data.desired_activation_date"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Desired activation date")])])
}]}

/***/ }),

/***/ 1336:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alertBox"
  }, _vm._l((_vm.reverseNotifications), function(notification) {
    return _c('notification', {
      key: notification.index,
      attrs: {
        "notification": notification
      }
    })
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('script', {
    attrs: {
      "type": "application/javascript"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.googleMapsLibraryScript)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-overlay', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function() {
        return [_c('div', {
          staticClass: "row"
        }, [_c('b-spinner'), _vm._v("   \n      "), _c('span', {
          attrs: {
            "id": "overlay-text"
          }
        }, [_vm._v(_vm._s(_vm.text))])], 1)]
      },
      proxy: true
    }])
  }, 'b-overlay', _vm.$attrs, false), _vm.$listeners))
},staticRenderFns: []}

/***/ }),

/***/ 1339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xm-modal', {
    attrs: {
      "value": _vm.open,
      "title": _vm.title,
      "size": "lg",
      "id": _vm.modalName,
      "save": _vm.save,
      "save-text": _vm.saveBtnText,
      "save-disabled": !_vm.formValid || !_vm.saveValid,
      "cancel-method": _vm.cancelMethod
    },
    on: {
      "hide": function($event) {
        return _vm.$emit('closed')
      },
      "show": function($event) {
        return _vm.$emit('opened')
      }
    }
  }, [_c('div', [_c('form', [_c('form-validator', {
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_vm._t("default")], 2)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(111);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(42);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueTheMask = __webpack_require__(1354);

var _vueTheMask2 = _interopRequireDefault(_vueTheMask);

var _billing = __webpack_require__(779);

var _billing2 = _interopRequireDefault(_billing);

var _contacts = __webpack_require__(781);

var _contacts2 = _interopRequireDefault(_contacts);

var _dns = __webpack_require__(782);

var _dns2 = _interopRequireDefault(_dns);

var _hosting = __webpack_require__(783);

var _hosting2 = _interopRequireDefault(_hosting);

var _notifications = __webpack_require__(787);

var _notifications2 = _interopRequireDefault(_notifications);

var _modals = __webpack_require__(785);

var _modals2 = _interopRequireDefault(_modals);

var _servers = __webpack_require__(788);

var _servers2 = _interopRequireDefault(_servers);

var _services = __webpack_require__(789);

var _services2 = _interopRequireDefault(_services);

var _user = __webpack_require__(351);

var _user2 = _interopRequireDefault(_user);

var _notices = __webpack_require__(786);

var _notices2 = _interopRequireDefault(_notices);

var _cart = __webpack_require__(780);

var _cart2 = _interopRequireDefault(_cart);

var _ssu = __webpack_require__(790);

var _ssu2 = _interopRequireDefault(_ssu);

var _logging = __webpack_require__(784);

var _logging2 = _interopRequireDefault(_logging);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

_vue2.default.use(_vueTheMask2.default);

var debug = "production" !== 'production';

exports.default = new _vuex2.default.Store({
  modules: {
    billing: _billing2.default,
    contacts: _contacts2.default,
    dns: _dns2.default,
    hosting: _hosting2.default,
    notifications: _notifications2.default,
    servers: _servers2.default,
    services: _services2.default,
    user: _user2.default,
    notices: _notices2.default,
    modals: _modals2.default,
    cart: _cart2.default,
    ssu: _ssu2.default,
    logging: _logging2.default
  },
  strict: debug
});

/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group row password-notifications"
  }, [(!_vm.hidePasswordNotifications) ? _c('p', {
    class: ['bg-danger', 'pppoe-warning', 'col-md-12']
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v(" Customers configured for PPPoE must also update their router password.")]) : _vm._e()]), _vm._v(" "), (_vm.requireOldPassword) ? _c('div', {
    staticClass: "form-group"
  }, [_c('show-password-field', {
    attrs: {
      "label": 'Current password',
      "name": 'password',
      "required": true,
      "maxlength": _vm.passwordMaxLength
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  }), _vm._v(" "), (!_vm.oldPasswordIsValid) ? _c('small', {
    staticClass: "pw-warnings"
  }, [_c('b', {
    staticClass: "text-danger"
  }, [_vm._v("\n          You must enter your current password\n        ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.suggestionsInModal) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-button', {
    attrs: {
      "variant": "light",
      "id": "pw-help"
    },
    on: {
      "click": function($event) {
        _vm.modalVisible = true
      }
    }
  }, [_vm._v("Help me create a secure password")])], 1) : _c('div', {
    class: !_vm.passwordInModal ? 'col-md-6' : 'col-md-12'
  }, [_c('div', [_c('b-card', {
    attrs: {
      "no-body": "",
      "id": "passGen",
      "header-text-variant": "white"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "btn btn-primary btn-block collapsed",
          on: {
            "click": function($event) {
              _vm.collapseVisible = !_vm.collapseVisible
            }
          }
        }, [_vm._v("Help me create a secure password "), _c('span', {
          staticClass: "float-right"
        }, [_c('i', {
          class: ['bi', _vm.collapseVisible ? 'bi-caret-up-fill' : 'bi-caret-down-fill']
        })])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "password-collapse"
    },
    model: {
      value: (_vm.collapseVisible),
      callback: function($$v) {
        _vm.collapseVisible = $$v
      },
      expression: "collapseVisible"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('password-generator', {
    attrs: {
      "password-label": _vm.passwordLabel
    }
  })], 1)])], 1)], 1)])]), _vm._v(" "), _c('form-validator', {
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('show-password-field', {
    ref: "newPassword",
    staticClass: "mb-2",
    attrs: {
      "label": _vm.passwordLabel,
      "help": _vm.passwordHelp,
      "minlength": _vm.passwordMinLength,
      "maxlength": _vm.passwordMaxLength,
      "required": true,
      "name": "new-password"
    },
    on: {
      "toggle": function($event) {
        return _vm.toggleShowNewPass($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "faded"
  }, [_vm._v("Password strength")]), _vm._v(" "), _c('b-progress', {
    attrs: {
      "value": _vm.passwordComplexity,
      "striped": "",
      "height": "10px",
      "variant": "success",
      "animated": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pw-warnings"
  }, [(_vm.dangerSuggestion) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('b', {
    staticClass: "text-danger"
  }, [_c('b-icon-x-lg', {
    attrs: {
      "scale": "0.75"
    }
  }), _vm._v(" " + _vm._s(_vm.dangerSuggestion) + "\n                ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.warningSuggestion) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('b', {
    staticClass: "text-warning"
  }, [_c('b-icon-info-circle-fill'), _vm._v(" " + _vm._s(_vm.warningSuggestion) + "\n                ")], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 form-group"
  }, [_c('xm-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "new-password-confirm",
      "type": _vm.showNewPass ? 'text' : 'password',
      "required": "",
      "maxlength": _vm.passwordMaxLength,
      "label": _vm.passwordConfirmLabel
    },
    model: {
      value: (_vm.newPassConfirm),
      callback: function($$v) {
        _vm.newPassConfirm = $$v
      },
      expression: "newPassConfirm"
    }
  }), _vm._v(" "), (!_vm.passwordsMatch) ? _c('span', {
    staticClass: "text-muted"
  }, [_c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b-icon-x-lg', {
    attrs: {
      "scale": "0.75"
    }
  }), _vm._v(" Passwords do not match.")], 1)]) : _vm._e()], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Generate Password",
      "id": "password-generator-modal",
      "size": "lg"
    },
    model: {
      value: (_vm.modalVisible),
      callback: function($$v) {
        _vm.modalVisible = $$v
      },
      expression: "modalVisible"
    }
  }, [_c('password-generator', {
    attrs: {
      "password-label": _vm.passwordLabel
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1341:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "summary-payment"
    }
  }, [_c('h3', [_vm._v("Order summary")]), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive xm-order-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.getFullCart), function(cart_item) {
    return _c('tr', {
      class: _vm.isPromo(cart_item) ? 'text-success' : ''
    }, [_c('td', [(cart_item.provider.name === 'xmission') ? _c('span', [_vm._v("\n          " + _vm._s(cart_item.description) + " "), (cart_item.quantity > 1) ? _c('span', [_vm._v("(x" + _vm._s(cart_item.quantity) + ")")]) : _vm._e(), _vm._v(" "), (cart_item.rate_mode === 'variable' && cart_item.rate >= cart_item.rate_max) ? _c('span', [_c('br'), _vm._v(" "), _c('small', [_vm._v("Up to $" + _vm._s(cart_item.rate_max) + " value")])]) : _vm._e()]) : _c('span', [_c('b', [_vm._v(_vm._s(_vm.rateString(cart_item.rate, cart_item.quantity, cart_item.rate_type, cart_item.rate_period, cart_item.rate_term, cart_item.rate_mode)))]), _vm._v(_vm._s(_vm.ratePeriodString(cart_item.rate_period, cart_item.rate_term, cart_item.description)) + " "), _c('small', [_vm._v(_vm._s(_vm.taxString(cart_item.rate, cart_item.taxable)))])])]), _vm._v(" "), _c('td', [(cart_item.provider.name === 'xmission') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.rateString(cart_item.rate, cart_item.quantity, cart_item.rate_type, cart_item.rate_period, cart_item.rate_term, cart_item.rate_mode)))]), _vm._v(_vm._s(_vm.ratePeriodString(cart_item.rate_period, cart_item.rate_term, '')) + " "), _c('small', [_vm._v(_vm._s(_vm.taxString(cart_item.rate, cart_item.taxable)))])]) : _c('span', [_c('small', [_vm._v("billed separately "), _c('br'), _vm._v(" by " + _vm._s(cart_item.provider.label))])])])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "total-row"
  }, [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v("$" + _vm._s(_vm.oneTimeXmissionTotalDueNow['total']))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.taxString(_vm.oneTimeXmissionTotalDueNow['total'], _vm.oneTimeXmissionTotalDueNow['taxed'])))])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#f5f5f5"
    }
  }, [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v("$" + _vm._s(_vm.oneTimeXmissionTotalDueLater['total']))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.taxString(_vm.oneTimeXmissionTotalDueLater['total'], _vm.oneTimeXmissionTotalDueLater['taxed'])))])])]), _vm._v(" "), _vm._l((_vm.monthlyTotalsAfterFirstMonth.entries()), function(ref) {
    var ndx = ref[0];
    var total_details = ref[1];

    return _c('tr', {
      key: ndx
    }, [_c('td', [_c('b', [_vm._v("Total ")]), _vm._v("due XMission "), _c('small', [_vm._v(_vm._s(_vm.dueTermString(ndx + 1)))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.rateString(total_details['total'], 1, 'price')))]), _vm._v(_vm._s(_vm.ratePeriodString((total_details['rate_term'] !== 1) ? 'monthly' : 'one-time', total_details['rate_term'], '', true)) + " "), _c('small', [_vm._v(_vm._s(_vm.taxString(total_details['total'], total_details['taxed'])))])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "faded"
  }, [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Price")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Due today")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Total ")]), _vm._v("due XMission "), _c('br'), _vm._v("upon installation and activation"), _c('br')])
}]}

/***/ }),

/***/ 1342:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.apiCallFinished,
    attrs: {
      "id": "signup-component"
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.creatingAccount,
      "no-wrap": "",
      "fixed": ""
    }
  }), _vm._v(" "), _c('form-validator', {
    ref: "form"
  }, [_c('div', {
    attrs: {
      "id": "signup-group"
    }
  }, [_c('div', [_c('add-services', {
    attrs: {
      "serviceTypes": _vm.serviceTypes
    },
    on: {
      "form-state": function (val) { return _vm.servicesValid = val; }
    }
  })], 1), _vm._v(" "), (_vm.displayInline) ? _c('div', [_c('br'), _c('br'), _c('hr'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.servicesValid) ? _c('div', {
    staticClass: "container"
  }, [_c('hr')]) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('attribution-dropdown-su')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.servicesValid && !_vm.skipClicked),
      expression: "servicesValid && !skipClicked"
    }],
    staticClass: "container",
    attrs: {
      "id": "attribution-dropdown-su"
    }
  }, [_c('attribution-dropdown', {
    ref: "attribution",
    on: {
      "input": _vm.setAttributionData,
      "skip-clicked": function($event) {
        _vm.skipClicked = true
      }
    }
  }), _vm._v(" "), _c('br')], 1)]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('customer-signup-form-su')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.servicesValid),
      expression: "servicesValid"
    }],
    staticClass: "container",
    attrs: {
      "id": "customer-signup-form-su"
    }
  }, [_c('customer-signup-form', {
    ref: "customerSignup",
    on: {
      "form-state": function (val) { return _vm.customerValid = val; },
      "input": _vm.setCustomerData
    }
  })], 1)]), _vm._v(" "), (_vm.displayInline) ? _c('div', [_c('br'), _c('br'), _c('hr'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('order-summary-payment-method')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.servicesValid && _vm.customerValid),
      expression: "servicesValid && customerValid"
    }],
    staticClass: "container",
    attrs: {
      "id": "order-summary-payment-method"
    }
  }, [_c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.servicesValid && _vm.customerValid) ? _c('order-summary') : _vm._e(), _c('br'), _vm._v(" "), _c('payment-method', {
    ref: "addPayment",
    attrs: {
      "init-values": _vm.initValues
    },
    on: {
      "input": _vm.setPaymentData,
      "form-state": function (val) { return _vm.paymentValid = val; }
    }
  })], 1)]), _vm._v(" "), (_vm.displayInline) ? _c('div', [_c('br'), _c('br'), _c('hr'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('user-agreement-submit')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.servicesValid && _vm.customerValid && _vm.paymentValid),
      expression: "servicesValid && customerValid && paymentValid"
    }],
    attrs: {
      "id": "user-agreement-submit"
    }
  }, [_c('user-agreement', {
    ref: "userAgreement",
    on: {
      "input": _vm.setAgreementData,
      "form-state": function (val) { return _vm.agreementValid = val; }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "create-container"
    }
  }, [_c('order-button', {
    attrs: {
      "disabled": !_vm.formValid,
      "title": !_vm.formValid ? 'You must check I agree above to continue' : ''
    },
    on: {
      "click": _vm.selfSignup
    }
  }), _vm._v(" "), (!_vm.formValid) ? _c('small', {
    staticClass: "d-block"
  }, [_vm._v("Please check \"I agree\" first")]) : _vm._e()], 1)])], 1)]), _vm._v(" "), (_vm.showFormData) ? _c('div', {
    staticClass: "container"
  }, [_c('br'), _vm._v(" "), _c('h5', [_vm._v("Form data")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showForm = !_vm.showForm
      }
    }
  }, [_vm._v(_vm._s(_vm.showForm ? 'Hide' : 'Show'))]), _vm._v(" "), (_vm.showForm) ? _c('pre', [_vm._v(_vm._s(_vm.formDataString))]) : _vm._e()]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "form",
    staticClass: "form-group",
    class: {
      validate: _vm.canValidate, 'has-feedback': _vm.icon, 'has-error': _vm.canValidate && _vm.valid === false, 'has-success': _vm.canValidate && _vm.valid
    }
  }, [_vm._t("label", function() {
    return [(_vm.label) ? _c('label', {
      staticClass: "col-form-label",
      on: {
        "click": _vm.focus
      }
    }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]
  }), _vm._v(" "), (_vm.$slots.before || _vm.$slots.after) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._t("before"), _vm._v(" "), (_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, null) > -1 : (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        var $$a = _vm.val,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.val = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.val = $$c
        }
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.val, null)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        _vm.val = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }), _vm._v(" "), (_vm.clearButton && _vm.value) ? _c('div', {
    class: {
      icon: _vm.icon
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.value = ''
      }
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('div', {
    staticClass: "icon"
  }, [(_vm.icon && _vm.valid !== null) ? _c('span', {
    class: ['form-control-feedback glyphicon', 'glyphicon-' + (_vm.valid ? 'ok' : 'remove')],
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("after")], 2) : [(_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, null) > -1 : (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        var $$a = _vm.val,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.val = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.val = $$c
        }
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.val, null)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        _vm.val = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }), _vm._v(" "), (_vm.clearButton && _vm.val) ? _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.val = ''
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.valid !== null) ? _c('span', {
    class: ['form-control-feedback glyphicon', 'glyphicon-' + (_vm.valid ? 'ok' : 'remove')],
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()], _vm._v(" "), (_vm.id_datalist) ? _c('datalist', {
    attrs: {
      "id": _vm.id_datalist
    }
  }, _vm._l((_vm.options), function(opc) {
    return _c('option', {
      domProps: {
        "value": opc
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showHelp) ? _c('div', {
    staticClass: "text-muted",
    on: {
      "click": _vm.focus
    }
  }, [_vm._v(_vm._s(_vm.help))]) : _vm._e(), _vm._v(" "), (_vm.showError) ? _c('div', {
    class: _vm.errorStyle,
    on: {
      "click": _vm.focus
    }
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1344:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'alert alert-dismissible ' + _vm.classType,
    attrs: {
      "role": "alert"
    }
  }, [(!_vm.notice['ignorable']) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])]) : _vm._e(), _vm._v(" "), (_vm.notice['ignorable']) ? _c('b-dropdown', {
    staticClass: "pull-right",
    attrs: {
      "id": "ignore-btn",
      "text": "",
      "type": "default",
      "disabled": false
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.ignoreNotice()
      }
    }
  }, [_vm._v("Ignore")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Acknowledge")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.notice['content']))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1345:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('new-payment-method-select', {
    on: {
      "input": _vm.setAccountType
    }
  }), _vm._v(" "), (_vm.accountTypeSelected) ? _c('div', [(_vm.isCard && _vm.card_details_valid) ? _c('div', [_c('span', [_vm._v("Card ending in " + _vm._s(_vm.form_data.card_details.last_four))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary",
    on: {
      "click": function($event) {
        _vm.show_paya_modal = true
      }
    }
  }, [_vm._v("Change")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('new-bank-account-form-pm')
      }
    }
  }, [(!_vm.isCard && !_vm.show_paya_modal) ? _c('div', {
    attrs: {
      "id": "new-bank-account-form-pm"
    }
  }, [_c('new-bank-account-form', {
    attrs: {
      "account-name": _vm.accountName
    },
    on: {
      "input": function (x) { return _vm.form_data.bank_details = x; },
      "form-state": function (x) { return _vm.bank_details_valid = x; }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('new-payment-type-form-pm')
      }
    }
  }, [(_vm.paymentAccountFormValid) ? _c('div', {
    attrs: {
      "id": "new-payment-type-form-pm"
    }
  }, [_c('new-payment-type-form', {
    attrs: {
      "show-billing-address": true,
      "first-name": _vm.initValues.fname,
      "last-name": _vm.initValues.lname,
      "formatted-address": _vm.initValues.formatted_address
    },
    on: {
      "input": _vm.setPaymentAccountType,
      "form-state": function (x) { return _vm.payment_type_valid = x; }
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('new-paya-payment-account-modal', {
    attrs: {
      "id": "new-paya-payment-account-modal-ssu",
      "account-name": _vm.accountName
    },
    on: {
      "card-added": _vm.cardAdded
    },
    model: {
      value: (_vm.show_paya_modal),
      callback: function($$v) {
        _vm.show_paya_modal = $$v
      },
      expression: "show_paya_modal"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1346:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 mb-4 has-feedback",
    class: {
      'has-success': _vm.fnameValid, 'has-error': !_vm.fnamePotentiallyValid
    }
  }, [_vm._v("\n      First name"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.fname),
      expression: "form_data.fname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "fname", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.fnameValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid first name")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 has-feedback",
    class: {
      'has-success': _vm.mnamiValid, 'has-error': !_vm.mnamiPotentiallyValid
    }
  }, [_vm._v("\n        Middle Initial"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.mnami),
      expression: "form_data.mnami"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('A'),
      expression: "'A'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.mnami)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "mnami", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.mnamiValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid initial")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 has-feedback",
    class: {
      'has-success': _vm.lnameValid, 'has-error': !_vm.lnamePotentiallyValid
    }
  }, [_vm._v("\n        Last name"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.lname),
      expression: "form_data.lname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "lname", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.lnameValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid last name")]) : _vm._e()])]), _vm._v(" "), (_vm.is_company) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 has-feedback",
    class: {
      'has-success': _vm.companyNameValid, 'has-error': !_vm.companyNamePotentiallyValid
    }
  }, [_vm._v("\n      Company name"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.cmp_name),
      expression: "form_data.cmp_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form_data.cmp_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form_data, "cmp_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.companyNameValid) ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v("Please enter a valid company name")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('address-form', {
    on: {
      "input": _vm.setAddress,
      "form-state": _vm.setAddressValid
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1347:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mt-4",
    attrs: {
      "id": "billing-pref"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "mt-4 pt-2"
  }, [_vm._v("Billing Preference")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-pref"
    },
    domProps: {
      "checked": _vm.form_data.auto_pay
    },
    on: {
      "input": function($event) {
        return _vm.setAutoPay(true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Auto-bill monthly")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-pref"
    },
    domProps: {
      "checked": !_vm.form_data.auto_pay
    },
    on: {
      "input": function($event) {
        return _vm.setAutoPay(false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Manual payment")])])]), _vm._v(" "), (_vm.showBillingAddress) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "mt-4 pt-2"
  }, [_vm._v("Billing Address")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "billing-addr-same"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-addr-same"
    },
    domProps: {
      "checked": _vm.copyAddress
    },
    on: {
      "input": function($event) {
        return _vm.setCopyAddress(true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addressString))])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "billing-addr-same",
      "id": "different-billing-addr"
    },
    domProps: {
      "checked": _vm.copyAddress === false
    },
    on: {
      "input": function($event) {
        return _vm.setCopyAddress(false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Enter new address")])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('revio-address-nptf')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBillingAddress && (_vm.copyAddress !== null) && !_vm.copyAddress),
      expression: "showBillingAddress && (copyAddress !== null) && !copyAddress"
    }],
    attrs: {
      "id": "revio-address-nptf"
    }
  }, [_c('revio-address', {
    attrs: {
      "company": false
    },
    on: {
      "form-state": function (x) { return _vm.address_valid = x; }
    },
    model: {
      value: (_vm.form_data.billing_address),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "billing_address", $$v)
      },
      expression: "form_data.billing_address"
    }
  })], 1)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1348:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('text-overlay', {
    attrs: {
      "show": _vm.querying_api,
      "text": _vm.overlay_text,
      "no-wrap": "",
      "fixed": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tribal-renter-forms"
    }
  }, [(_vm.needsTribalForm) ? _c('div', [_c('h5', [_vm._v("Are you a Southern Ute Tribal Member, member of another Native American Tribe, or a person of Native American descent?")]), _vm._v(" "), _c('div', [_vm._v("*Installation costs waived for Self-identifying Tribal Members.")]), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "tribal-member-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_tribal),
      expression: "form_data.is_tribal"
    }],
    attrs: {
      "type": "radio",
      "name": "tribal-status"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.form_data.is_tribal, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_tribal", true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Yes")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "not-tribal-member-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_tribal),
      expression: "form_data.is_tribal"
    }],
    attrs: {
      "type": "radio",
      "name": "tribal-status"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.form_data.is_tribal, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_tribal", false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), (_vm.needsRenterForm) ? _c('div', [(_vm.needsTribalForm) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', [_c('h5', [_vm._v("Do you own or rent your home?")]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "owner-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_owner),
      expression: "form_data.is_owner"
    }],
    attrs: {
      "type": "radio",
      "name": "rent-type"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.form_data.is_owner, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_owner", true)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Own")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-head",
    attrs: {
      "id": "renter-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form_data.is_owner),
      expression: "form_data.is_owner"
    }],
    attrs: {
      "type": "radio",
      "name": "rent-type"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.form_data.is_owner, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form_data, "is_owner", false)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Rent")])])])]) : _vm._e(), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('tribal-renter-forms')
      }
    }
  }, [(_vm.isRenter && _vm.needsRenterForm && _vm.rentersAllowed) ? _c('div', [_c('br'), _vm._v(" "), _c('span', [_vm._v("Renters must gain approval from the homeowner. Please enter the owner's contact information.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('xm-input', {
    staticClass: "col-md-5",
    attrs: {
      "name": "name",
      "label": "Owner name",
      "pattern": _vm.regex.name,
      "required": "",
      "error": "Enter owner name"
    },
    model: {
      value: (_vm.form_data.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_name", $$v)
      },
      expression: "form_data.owner_name"
    }
  }), _vm._v(" "), _c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "col-md-3",
    attrs: {
      "name": "phone",
      "label": "Owner phone",
      "pattern": _vm.regex.phone,
      "required": "",
      "error": "Please enter a valid phone number"
    },
    model: {
      value: (_vm.form_data.owner_phone),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_phone", $$v)
      },
      expression: "form_data.owner_phone"
    }
  }), _vm._v(" "), _c('xm-input', {
    staticClass: "col-md-4",
    attrs: {
      "name": "email",
      "label": "Owner email",
      "type": "email",
      "pattern": _vm.regex.email,
      "required": "",
      "error": "Please enter a valid email address"
    },
    model: {
      value: (_vm.form_data.owner_email),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_email", $$v)
      },
      expression: "form_data.owner_email"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('Transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('tribal-renter-forms')
      }
    }
  }, [(_vm.isRenter && _vm.needsRenterForm && !_vm.rentersAllowed) ? _c('div', [_c('br'), _vm._v(" "), _c('h5', [_vm._v("Owner approval form")]), _vm._v(" "), _c('span', [_vm._v("Renters must gain approval from the homeowner. Please download and ask your landlord to complete the approval form. Once completed, please contact XMission sales to complete the signup process.")]), _c('br'), _c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "submit-button",
    attrs: {
      "variant": "primary",
      "href": "https://asset.xmission.com/pdf/lehi-fiber-rental-agreement.pdf",
      "target": "_blank",
      "download": "lehi-fiber-rental-agreement.pdf"
    }
  }, [_vm._v("\n          Download rental approval form\n        ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Your contact information")]), _vm._v(" "), _c('span', [_vm._v("If you would like sales to reach out to you please provide your contact information.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('xm-input', {
    staticClass: "col-md-5",
    attrs: {
      "name": "name",
      "label": "Full Name",
      "pattern": _vm.regex.name,
      "required": "",
      "error": "Enter your name"
    },
    model: {
      value: (_vm.form_data.owner_name),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_name", $$v)
      },
      expression: "form_data.owner_name"
    }
  }), _vm._v(" "), _c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    staticClass: "col-md-3",
    attrs: {
      "name": "phone",
      "label": "Phone Number",
      "pattern": _vm.regex.phone,
      "required": "",
      "error": "Please enter a valid phone number"
    },
    model: {
      value: (_vm.form_data.owner_phone),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_phone", $$v)
      },
      expression: "form_data.owner_phone"
    }
  }), _vm._v(" "), _c('xm-input', {
    staticClass: "col-md-4",
    attrs: {
      "name": "email",
      "label": "Email Address",
      "type": "email",
      "pattern": _vm.regex.email,
      "required": "",
      "error": "Please enter a valid email address"
    },
    model: {
      value: (_vm.form_data.owner_email),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "owner_email", $$v)
      },
      expression: "form_data.owner_email"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "submit-button",
    attrs: {
      "disabled": !_vm.validOwnerContact,
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addRenterContact()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1349:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.searching_address || _vm.adding_to_contact_list,
      "no-wrap": "",
      "fixed": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fiber-search-header"
    }
  }, [_c('div', {
    staticClass: "container pb-5"
  }, [_c('h1', {
    staticClass: "pt-4"
  }, [_vm._v("XMission Fiber for home")]), _vm._v(" "), _c('h5', {
    staticClass: "not-bold"
  }, [_vm._v("Check your address availability")]), _vm._v(" "), _c('address-auto-complete', {
    attrs: {
      "init-display-value": _vm.initialAddressString
    },
    on: {
      "address-selected": _vm.setAddressSelected
    }
  })], 1)]), _vm._v(" "), (_vm.error_message) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.error_message) + "\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.serviceable_address_selected) ? _c('div', {
    staticClass: "container",
    attrs: {
      "id": "whitespace"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    on: {
      "show": function($event) {
        _vm.address_id_selected = ''
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('div', [_c('h4', {
          staticClass: "modal-title"
        }, [_vm._v("Suggested serviceable addresses")]), _vm._v(" "), _c('small', [_vm._v("(if your address is not listed, you may be outside a serviceable area)")])])]
      },
      proxy: true
    }, {
      key: "default",
      fn: function() {
        return _vm._l((_vm.addresses), function(address) {
          return _c('div', {
            key: address.address_id
          }, [_c('div', {
            staticClass: "form-group"
          }, [_c('label', [_c('input', {
            staticClass: "NSradioBtn",
            attrs: {
              "type": "radio",
              "name": "address-radio"
            },
            on: {
              "click": function($event) {
                return _vm.setAddressDetails(address)
              }
            }
          }), _vm._v(" "), _c('span', [_vm._v(_vm._s(address.address.formatted_address))])])])])
        })
      },
      proxy: true
    }, {
      key: "modal-footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn btn-secondary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.show_multi_address_modal = false;
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.show_multi_address_modal = false;
              _vm.setNoAddressFound()
            }
          }
        }, [_vm._v("My address is not listed")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button",
            "disabled": _vm.address_id_selected === ''
          },
          on: {
            "click": function($event) {
              _vm.getServiceabilityDetails();
              _vm.show_multi_address_modal = false;
            }
          }
        }, [_vm._v("Select Address")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.show_multi_address_modal),
      callback: function($$v) {
        _vm.show_multi_address_modal = $$v
      },
      expression: "show_multi_address_modal"
    }
  }), _vm._v(" "), _c('xm-modal', {
    attrs: {
      "title": "Hmm, we couldn't find you.",
      "save": _vm.addToContactList,
      "save-text": "Add me",
      "save-disabled": !_vm.serviceability_notice_form_valid,
      "cancel-method": _vm.cancelAddToContactList
    },
    on: {
      "show": function($event) {
        _vm.address_id_selected = ''
      }
    },
    model: {
      value: (_vm.show_address_unavailable_modal),
      callback: function($$v) {
        _vm.show_address_unavailable_modal = $$v
      },
      expression: "show_address_unavailable_modal"
    }
  }, [_c('div', [_c('b', [_vm._v(_vm._s(_vm.serviceability_notice_form.address))]), _vm._v(" isn’t available... yet"), _c('br'), _c('br'), _vm._v("\n      Did you just receive a card from us in the mail?  Service may be coming very soon. Fill out the form below and we’ll get in touch quickly to complete the process. "), _c('br'), _c('br'), _vm._v("\n      Just interested?  Leave us your contact info below and we will notify you the moment your address becomes serviceable.\n      "), _c('form-validator', {
    model: {
      value: (_vm.serviceability_notice_form_valid),
      callback: function($$v) {
        _vm.serviceability_notice_form_valid = $$v
      },
      expression: "serviceability_notice_form_valid"
    }
  }, [_c('xm-input', {
    attrs: {
      "name": "name",
      "label": "Full Name",
      "required": ""
    },
    model: {
      value: (_vm.serviceability_notice_form.name),
      callback: function($$v) {
        _vm.$set(_vm.serviceability_notice_form, "name", $$v)
      },
      expression: "serviceability_notice_form.name"
    }
  }), _vm._v(" "), _c('xm-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('(###) ###-####'),
      expression: "'(###) ###-####'"
    }],
    attrs: {
      "name": "phone",
      "label": "Phone Number",
      "pattern": _vm.regex.phone,
      "required": ""
    },
    model: {
      value: (_vm.serviceability_notice_form.phone),
      callback: function($$v) {
        _vm.$set(_vm.serviceability_notice_form, "phone", $$v)
      },
      expression: "serviceability_notice_form.phone"
    }
  }), _vm._v(" "), _c('xm-input', {
    attrs: {
      "name": "email",
      "label": "Email Address",
      "type": "email",
      "pattern": _vm.regex.email,
      "required": ""
    },
    model: {
      value: (_vm.serviceability_notice_form.email),
      callback: function($$v) {
        _vm.$set(_vm.serviceability_notice_form, "email", $$v)
      },
      expression: "serviceability_notice_form.email"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-4 pt-3 ml-4 pl-2"
  }, [_c('span', {
    staticClass: "rotated-90",
    staticStyle: {
      "margin-left": "-28px"
    }
  }, [_vm._v("«")]), _vm._v("To get started, enter the address where you would like to have XMission Fiber."), _c('span', {
    staticClass: "d-block mt-2"
  }, [_vm._v("For more information visit "), _c('a', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "href": "https://xmission.com/xmission-fiber",
      "target": "_blank"
    }
  }, [_vm._v("XMission Fiber")]), _vm._v(" or contact "), _c('a', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "href": "https://xmission.com/contact",
      "target": "_blank"
    }
  }, [_vm._v("XMission sales")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "xwi-promo"
    }
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('img', {
    staticClass: "d-none d-md-block",
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-router-app.png",
      "alt": "XWi router app"
    }
  })]), _vm._v(" "), _c('td', [_c('small', [_vm._v("When choosing your connectivity package")]), _vm._v(" "), _c('h4', {
    staticClass: "mb-0 pb-0"
  }, [_vm._v("Insist on "), _c('img', {
    staticStyle: {
      "height": "20px",
      "vertical-align": "baseline"
    },
    attrs: {
      "src": "https://asset.xmission.com/xwi/xwi-logo-white.png",
      "alt": "XWi"
    }
  }), _vm._v(" Home")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "features-box"
  }, [_c('b', [_vm._v("Features include:")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-1"
  }, [_c('li', [_vm._v("Complete home Internet solution with state-of-the-art router")]), _vm._v(" "), _c('li', [_vm._v("Easy-to-use smartphone app to control your settings")]), _vm._v(" "), _c('li', [_vm._v("Hassle-free remote support from XMission techs 24/7")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Save on XMission Fiber")]), _vm._v(" when you use XWi Home")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://xmission.com/xwi",
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-dark"
  }, [_vm._v("Learn more")])])])])])])])])
}]}

/***/ }),

/***/ 1350:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('xm-input', {
    attrs: {
      "id": "password-field",
      "type": _vm.showPass ? 'text' : 'password',
      "autocomplete": "false",
      "maxlength": _vm.maxlength,
      "label": _vm.label
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('span', {
    staticClass: "input-group-append",
    attrs: {
      "slot": "after"
    },
    on: {
      "click": function($event) {
        return _vm.updateShowPass(!_vm.showPass)
      }
    },
    slot: "after"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_c('i', {
    staticClass: "bi icon-sizing",
    class: _vm.showPass ? 'bi-eye-slash-fill' : 'bi-eye-fill'
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1351:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.needsCityAccountForm) ? _c('div', [_c('br'), _vm._v(" "), _c('h4', {
    staticClass: "pt-4"
  }, [_vm._v("Required Bountiful Utility information")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "max-width": "640px"
    }
  }, [_vm._v("\n      Bountiful Fiber customers must enter their Account Number and Customer ID from their "), _vm._m(0), _vm._v(".\n      These numbers can be found on your "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "id": "utility-bill-btn"
    },
    on: {
      "click": function($event) {
        _vm.show_utility_bill = !_vm.show_utility_bill
      }
    }
  }, [_c('b', [_vm._v("utility bill")])]), _vm._v(" "), _c('transition', {
    on: {
      "enter": function($event) {
        return _vm.scrolldown('sample-utility-bill')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_utility_bill),
      expression: "show_utility_bill"
    }],
    attrs: {
      "id": "sample-utility-bill"
    }
  }, [_c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://asset.xmission.com/xmweb3/btfl-utility-sample.png",
      "alt": "Sample Utility Bill"
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n        Bountiful Utility Account Number"), _c('br'), _vm._v(" "), _c('xm-input', {
    staticClass: "mb-3",
    attrs: {
      "pattern": _vm.city_account_id_regex,
      "required": "",
      "error": "Enter account ID",
      "maxlength": 30
    },
    model: {
      value: (_vm.form_data.city_account_id),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "city_account_id", $$v)
      },
      expression: "form_data.city_account_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("\n        Bountiful Utility Customer ID"), _c('br'), _vm._v(" "), _c('xm-input', {
    staticClass: "mb-3",
    attrs: {
      "pattern": _vm.city_customer_id_regex,
      "required": "",
      "error": "Enter a valid integer",
      "maxlength": 10
    },
    model: {
      value: (_vm.form_data.city_customer_id),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "city_customer_id", $$v)
      },
      expression: "form_data.city_customer_id"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.bountifulutah.gov/Utilities1",
      "target": "_blank"
    }
  }, [_c('b', [_vm._v("Bountiful Utility account")])])
}]}

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(135);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(153);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(136);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(155);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(154);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service = __webpack_require__(152);

var _service2 = _interopRequireDefault(_service);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

var _dates = __webpack_require__(224);

var _dates2 = _interopRequireDefault(_dates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectivityService = function (_Service) {
  (0, _inherits3.default)(ConnectivityService, _Service);

  function ConnectivityService(service, address_details) {
    (0, _classCallCheck3.default)(this, ConnectivityService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ConnectivityService.__proto__ || (0, _getPrototypeOf2.default)(ConnectivityService)).call(this, service));

    _this.address_details = address_details;
    _this.speed_info_map = {
      speed_250_sym: {
        label: '250Mbps',
        description: 'Perfect for the individual with average usage.',
        color: 'xm-y-bg'
      },
      speed_1000_sym: {
        label: '1Gbps',
        description: 'All the bandwidth a family needs for streaming, gaming, and more.',
        color: 'xm-b-bg'
      },
      speed_2000_sym: {
        label: '2Gbps',
        description: 'A bigger pipe for a bigger family or work-from-home professional.',
        color: 'xm-g-bg'
      },
      speed_2500_sym: {
        label: '2.5Gbps',
        description: 'A bigger pipe for a bigger family or work-from-home professional.',
        color: 'xm-g-bg'
      },
      speed_10000_sym: {
        label: '10Gbps',
        description: 'Serious users only. Make sure you have a router powerful enough for this much speed.',
        color: 'xm-r-bg'
      }
    };
    _this.active_speed_option = null;
    _this.install_info_map = {
      'basic': {
        'label': 'Standard install',
        'description': 'Cabling run up to 45’ to wireless router, taking up to 2 hours.',
        'sub_description': 'covers most installations' },
      'advanced': {
        'label': 'Advanced install',
        'description': 'Cabling run up to 150’ to wireless router, taking up to 4 hours.',
        'sub_description': 'not common' } };
    _this.setSpeedStrings();
    _this.setOrderSummaryStrings();
    _logger2.default.debug('conn service', _this.service);
    return _this;
  }

  (0, _createClass3.default)(ConnectivityService, [{
    key: "setSpeedStrings",
    value: function setSpeedStrings() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.service.speed_options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var speed_option = _step.value;

          speed_option.label = this.speed_info_map[speed_option.speed_id].label;
          speed_option.description = this.speed_info_map[speed_option.speed_id].description;
          speed_option.color = this.speed_info_map[speed_option.speed_id].color;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "getRateTermString",
    value: function getRateTermString(promo, rate, legal) {
      if (!rate) {}
      if (promo.rate_term === 1) {
        if (legal) {
          return 'one FREE month';
        }
        return "First month " + (rate > 0 ? '$' + rate : 'FREE');
      } else {
        var word_map = { 1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven', 8: 'eight',
          9: 'nine', 10: 'ten', 11: 'eleven', 12: 'twelve' };
        var rate_period_map = { 'monthly': 'month', 'yearly': 'year' };
        var suffix = promo.rate_term > 1 ? 's' : '';
        if (legal) {
          if (!rate) {
            return word_map[promo.rate_term] + " FREE " + rate_period_map[promo.rate_period] + suffix;
          }
          return "$" + rate + " per " + rate_period_map[promo.rate_period] + " for " + word_map[promo.rate_term] + " " + rate_period_map[promo.rate_period] + suffix;
        }
        return "First " + word_map[promo.rate_term] + " " + rate_period_map[promo.rate_period] + suffix + " " + (rate > 0 ? '$' + rate : 'FREE');
      }
    }
  }, {
    key: "setPromoOrderSummaryStrings",
    value: function setPromoOrderSummaryStrings() {
      var _this2 = this;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(this.service.speed_options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var speed_option = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            var _loop = function _loop() {
              var promo = _step3.value;

              promo.legal_label = promo.description;
              var variable_string = promo.rate_mode === 'variable' ? " Up to $" + promo.rate_max + " value." : '';
              var one_time_string = !!promo.rate_term ? ' One-time use only.' : '';
              var expire_string = promo.expiration_date ? " This offer expires on: " + _dates2.default.isoDateStringToReadable(promo.expiration_date) + "." : '';
              var location_string = '';
              if (promo.name.includes('wv_online_promo')) {
                location_string = ' Applies to West Valley City residents only.';
              }
              var promo_couple_string = ' This offer cannot be used in combination with other promotions or discounts.';
              if (speed_option.billing.promos.length > 1) {
                var other_promo_names = speed_option.billing.promos.filter(function (x) {
                  return x.name !== promo.name;
                }).map(function (x) {
                  return x.description;
                });
                var other_promo_string = other_promo_names.length > 1 ? other_promo_names.join(', ') : other_promo_names[0];
                promo_couple_string = " This offer cannot be combined with other promotional offers, with the exception of the " + other_promo_string + " promotion" + (other_promo_names.length > 1 ? 's' : '') + ".";
              }
              promo.legal_description = "XMission will automatically credit " + _this2.getRateTermString(promo, promo.rate === speed_option.billing.prices[0].rate ? null : promo.rate, true) + " of XMission Fiber service to your account upon installation and activation." + variable_string + location_string + " This offer does not include additional service fees or hardware costs." + promo_couple_string + " Limit of one per household. Applies to new XMission customers only." + one_time_string + expire_string;
            };

            for (var _iterator3 = (0, _getIterator3.default)(speed_option.billing.promos), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              _loop();
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "setOrderSummaryStrings",
    value: function setOrderSummaryStrings() {
      this.setPromoOrderSummaryStrings();
    }
  }, {
    key: "speedOptions",
    value: function speedOptions() {
      return this.service.speed_options;
    }
  }, {
    key: "setActiveSpeedOption",
    value: function setActiveSpeedOption(speed_id) {
      var speed_option = this.speedOptions().filter(function (x) {
        return x.speed_id === speed_id;
      });
      this.active_speed_option = speed_option.length === 1 ? speed_option[0] : null;
      _logger2.default.debug('setActiveSpeedOption', speed_id, this.active_speed_option);
    }
  }, {
    key: "getActiveSpeedOption",
    value: function getActiveSpeedOption() {
      return this.active_speed_option;
    }
  }, {
    key: "addActiveSpeedOptionToCart",
    value: function addActiveSpeedOptionToCart() {
      return this.order_summary.addServiceOptionToCart(this.getActiveSpeedOption());
    }
  }, {
    key: "installationOptions",
    value: function installationOptions() {
      var install_options = JSON.parse((0, _stringify2.default)(this.service.installation_options));
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(install_options), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var install_option = _step4.value;

          var install_info = this.install_info_map[install_option.installation_type];
          install_option.label = install_info.label;
          install_option.description = install_info.description;
          install_option.sub_description = install_info.sub_description;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return install_options;
    }
  }, {
    key: "monthlyPriceFeeServiceOptionBreakdownString",
    value: function monthlyPriceFeeServiceOptionBreakdownString(speed_option) {
      var costs_by_provider = this.order_summary.grossCostsPerProvider(speed_option);
      _logger2.default.debug('costs by provider', costs_by_provider);
      var breakdown_string = "$" + costs_by_provider.xmission.cost + " " + costs_by_provider.xmission.provider.label;
      if ((0, _keys2.default)(costs_by_provider).length === 2) {
        for (var key in costs_by_provider) {
          if (key === 'xmission') {
            continue;
          }
          breakdown_string = breakdown_string + " + $" + costs_by_provider[key].cost + " " + costs_by_provider[key].provider.label;
        }
      }
      return breakdown_string;
    }
  }, {
    key: "grossServiceOptionMonthlyCost",
    value: function grossServiceOptionMonthlyCost(speed_option) {
      return this.order_summary.grossServiceOptionXMissionMonthlyCost(speed_option);
    }
  }, {
    key: "onlinePromo",
    value: function onlinePromo(speed_option) {
      var promos = speed_option.billing.promos.filter(function (x) {
        return x.featured;
      });
      if (promos.length === 1) {
        return promos[0];
      }
      return null;
    }
  }, {
    key: "grossOneTimeXMissionCost",
    value: function grossOneTimeXMissionCost(speed_option) {
      var online_promo = this.onlinePromo(speed_option);
      var monthly_cost = this.order_summary.grossServiceXMissionMonthlyCost() + this.order_summary.grossServiceOptionXMissionMonthlyCost(speed_option);

      var online_promo_rate = Boolean(online_promo) ? online_promo.rate : 0;
      return monthly_cost - online_promo_rate;
    }
  }]);
  return ConnectivityService;
}(_service2.default);

exports.default = ConnectivityService;

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(136);

var _createClass3 = _interopRequireDefault(_createClass2);

var _serviceOrderSummary = __webpack_require__(773);

var _serviceOrderSummary2 = _interopRequireDefault(_serviceOrderSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Service = function () {
  function Service(service) {
    (0, _classCallCheck3.default)(this, Service);

    this.reset(service);
  }

  (0, _createClass3.default)(Service, [{
    key: 'reset',
    value: function reset(service) {
      this.service = service;
      this.order_summary = new _serviceOrderSummary2.default(service);
      this.service_class_model = this.service.service_class_model;
      this.provider = this.service_class_model.provider;
    }
  }]);
  return Service;
}();

exports.default = Service;

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1174)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-93073bd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_DATE_FORMAT = 'L';
var DEFAULT_DATETIME_FORMAT = 'L LT';

var ISO_DATE_FORMAT = 'YYYY-MM-DD';

var helpers = {
  checkInvalid: function checkInvalid(res) {
    return res === 'Invalid date' ? '' : res;
  }
};

exports.default = {
  dateFormat: function dateFormat(dateStr) {
    if (dateStr === '0000-00-00') {
      return '01/01/1990';
    }

    var res = (0, _moment2.default)(dateStr).format(DEFAULT_DATE_FORMAT);
    return helpers.checkInvalid(res);
  },
  datetimeFormat: function datetimeFormat(datetimeStr) {
    var res = (0, _moment2.default)(datetimeStr).format(DEFAULT_DATETIME_FORMAT);
    return helpers.checkInvalid(res);
  },
  unixFormat: function unixFormat(unixTime) {
    var res = _moment2.default.unix(unixTime).format(DEFAULT_DATE_FORMAT);
    return helpers.checkInvalid(res);
  },
  unixDatetimeFormat: function unixDatetimeFormat(unixTime) {
    var res = _moment2.default.unix(unixTime).format(DEFAULT_DATETIME_FORMAT);
    return helpers.checkInvalid(res);
  },
  isoFormat: function isoFormat(date) {
    return (0, _moment2.default)(date).format(ISO_DATE_FORMAT);
  },
  isoDatetimeFormat: function isoDatetimeFormat(datetime) {
    return (0, _moment2.default)(datetime).format();
  },
  isDateOfFormat: function isDateOfFormat(date, format) {
    return (0, _moment2.default)(date, format, true).isValid();
  },
  today: function today() {
    return (0, _moment2.default)();
  },
  tomorrow: function tomorrow() {
    return (0, _moment2.default)().add(1, 'days');
  },
  yesterday: function yesterday() {
    return (0, _moment2.default)().add(-1, 'days');
  },
  iso_date_to_card_exp: function iso_date_to_card_exp(date_str, num_digits) {
    var arr = date_str.split('T')[0].split('-');
    return arr[1] + '/' + arr[0].slice(4 - num_digits, 4);
  },
  isoDateStringToReadable: function isoDateStringToReadable(date_str) {
    var components = date_str.split('-');
    var date = new Date(components[0], components[1] - 1, components[2]);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  }
};

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_FOUND_USERNAMES = exports.SET_FOUND_USERNAMES = 'SET_FOUND_USERNAMES';
var SET_USERNAME_SELECTED = exports.SET_USERNAME_SELECTED = 'SET_USERNAME_SELECTED';

var SET_BILLING = exports.SET_BILLING = 'SET_BILLING';
var SET_AMOUNT_DUE = exports.SET_AMOUNT_DUE = 'SET_AMOUNT_DUE';
var SET_DUE_DATE = exports.SET_DUE_DATE = 'SET_DUE_DATE';
var SET_OVERDUE = exports.SET_OVERDUE = 'SET_OVERDUE';
var SET_BILLS = exports.SET_BILLS = 'SET_BILLS';
var SET_BILL_PAGE = exports.SET_BILL_PAGE = 'SET_BILL_PAGE';
var SET_PAYMENTS = exports.SET_PAYMENTS = 'SET_PAYMENTS';
var SET_TEMP_PAYMENT_ID = exports.SET_TEMP_PAYMENT_ID = 'SET_TEMP_PAYMENT_ID';
var SET_PAYMENT_ACCOUNTS = exports.SET_PAYMENT_ACCOUNTS = 'SET_PAYMENT_ACCOUNTS';
var START_PAYMENT_REQUEST = exports.START_PAYMENT_REQUEST = 'START_PAYMENT_REQUEST';
var END_PAYMENT_REQUEST = exports.END_PAYMENT_REQUEST = 'END_PAYMENT_REQUEST';
var SET_BILLING_ADDRESS = exports.SET_BILLING_ADDRESS = 'SET_BILLING_ADDRESS';
var SET_PAYA_URL = exports.SET_PAYA_URL = 'SET_PAYA_URL';

var SET_AUTHORIZED_CONTACTS = exports.SET_AUTHORIZED_CONTACTS = 'SET_AUTHORIZED_CONTACTS';
var SET_EDITING_CONTACT = exports.SET_EDITING_CONTACT = 'SET_EDITING_CONTACT';
var SET_EDITING_LDAP = exports.SET_EDITING_LDAP = 'SET_EDITING_LDAP';
var SET_EDITING_PERMS = exports.SET_EDITING_PERMS = 'SET_EDITING_PERMS';
var BEGIN_EDIT_CONTACT = exports.BEGIN_EDIT_CONTACT = 'BEGIN_EDIT_CONTACT';
var CANCEL_EDIT_CONTACT = exports.CANCEL_EDIT_CONTACT = 'CANCEL_EDIT_CONTACT';
var UPDATE_EDITING_CONTACT = exports.UPDATE_EDITING_CONTACT = 'UPDATE_EDITING_CONTACT';
var UPDATE_NEW_CONTACT = exports.UPDATE_NEW_CONTACT = 'UPDATE_NEW_CONTACT';

var LOGGED_IN = exports.LOGGED_IN = 'LOGGED_IN';
var SET_LOGGED_IN = exports.SET_LOGGED_IN = 'SET_LOGGED_IN';
var LOGGED_OUT = exports.LOGGED_OUT = 'LOGGED_OUT';
var SET_PROFILE = exports.SET_PROFILE = 'SET_PROFILE';
var SET_USER = exports.SET_USER = 'SET_USER';
var SET_PERM_SCHEMA = exports.SET_PERM_SCHEMA = 'SET_PERM_SCHEMA';
var SET_PERM_CATEGORIES = exports.SET_PERM_CATEGORIES = 'SET_PERM_CATEGORIES';
var SAVE_AJAX_REQUEST = exports.SAVE_AJAX_REQUEST = 'SAVE_AJAX_REQUEST';
var CLEAR_AJAX_REQUEST = exports.CLEAR_AJAX_REQUEST = 'CLEAR_AJAX_REQUEST';
var SET_PASSWORD_WORDLIST = exports.SET_PASSWORD_WORDLIST = 'SET_PASSWORD_WORDLIST';
var HAS_DARK_THEME = exports.HAS_DARK_THEME = 'HAS_DARK_THEME';

var GET_ZONES = exports.GET_ZONES = 'GET_ZONES';
var SET_DEFAULT_ACTIVE_ZONE = exports.SET_DEFAULT_ACTIVE_ZONE = 'SET_DEFAULT_ACTIVE_ZONE';
var SET_ACTIVE_ZONE = exports.SET_ACTIVE_ZONE = 'SET_ACTIVE_ZONE';
var SET_EDITING_ZONE_ALIASES = exports.SET_EDITING_ZONE_ALIASES = 'SET_EDITING_ZONE_ALIASES';
var UPDATE_EDITING_ZONE = exports.UPDATE_EDITING_ZONE = 'UPDATE_EDITING_ZONE';
var BEGIN_CREATING_ALIAS = exports.BEGIN_CREATING_ALIAS = 'BEGIN_CREATING_ALIAS';
var END_CREATING_ALIAS = exports.END_CREATING_ALIAS = 'END_CREATING_ALIAS';
var UPDATE_NEW_ZONE = exports.UPDATE_NEW_ZONE = 'UPDATE_NEW_ZONE';
var SET_NEW_ZONE = exports.SET_NEW_ZONE = 'SET_NEW_ZONE';
var SET_RECORDS = exports.SET_RECORDS = 'SET_RECORDS';
var NULL_ACTIVE_ZONE = exports.NULL_ACTIVE_ZONE = 'NULL_ACTIVE_ZONE';
var SET_EDITING_ZONE = exports.SET_EDITING_ZONE = 'SET_EDITING_ZONE';
var NEXT_ZONES_PAGE = exports.NEXT_ZONES_PAGE = 'NEXT_ZONES_PAGE';
var PREV_ZONES_PAGE = exports.PREV_ZONES_PAGE = 'PREV_ZONES_PAGE';
var NEXT_RECORDS_PAGE = exports.NEXT_RECORDS_PAGE = 'NEXT_RECORDS_PAGE';
var PREV_RECORDS_PAGE = exports.PREV_RECORDS_PAGE = 'PREV_RECORDS_PAGE';
var FIRST_RECORDS_PAGE = exports.FIRST_RECORDS_PAGE = 'FIRST_RECORDS_PAGE';
var RESET_DISABLED_ZONE_TIMERS = exports.RESET_DISABLED_ZONE_TIMERS = 'RESET_DISABLED_ZONE_TIMERS';
var ZONE_REFRESH_TIMERS_LOADED = exports.ZONE_REFRESH_TIMERS_LOADED = 'ZONE_REFRESH_TIMERS_LOADED';
var NEW_ZONE_ADDED = exports.NEW_ZONE_ADDED = 'NEW_ZONE_ADDED';
var INCREASE_STARTUP_DISABLED_ZONE = exports.INCREASE_STARTUP_DISABLED_ZONE = 'INCREASE_STARTUP_DISABLED_ZONE';
var REMOVE_DISABLED_ZONE_BY_INDEX = exports.REMOVE_DISABLED_ZONE_BY_INDEX = 'REMOVE_DISABLED_ZONE_BY_INDEX';
var TOGGLE_SHOW_ALL_RECORDS = exports.TOGGLE_SHOW_ALL_RECORDS = 'TOGGLE_SHOW_ALL_RECORDS';
var TOGGLE_SHOW_ALL_ZONES = exports.TOGGLE_SHOW_ALL_ZONES = 'TOGGLE_SHOW_ALL_ZONES';

var ADD_NOTIFICATION = exports.ADD_NOTIFICATION = 'ADD_NOTIFICATION';
var ADD_NOTIFICATION_TIMEOUT = exports.ADD_NOTIFICATION_TIMEOUT = 'ADD_NOTIFICATION_TIMEOUT';
var ADD_NOTIFICATION_FROM_RESULT = exports.ADD_NOTIFICATION_FROM_RESULT = 'ADD_NOTIFICATION_FROM_RESULT';
var UNHANDLED_ERROR_NOTIFICATION = exports.UNHANDLED_ERROR_NOTIFICATION = 'UNHANDLED_ERROR_NOTIFICATION';
var ACCESS_DENIED_NOTIFICATION = exports.ACCESS_DENIED_NOTIFICATION = 'ACCESS_DENIED_NOTIFICATION';
var HIDE_NOTIFICATION = exports.HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
var HIDE_ALL_NOTIFICATIONS = exports.HIDE_ALL_NOTIFICATIONS = 'HIDE_ALL_NOTIFICATIONS';
var ADD_MODAL_NOTIFICATION = exports.ADD_MODAL_NOTIFICATION = 'ADD_MODAL_NOTIFICATION';
var ADD_MODAL_NOTIFICATION_FROM_RESULT = exports.ADD_MODAL_NOTIFICATION_FROM_RESULT = 'ADD_MODAL_NOTIFICATION_FROM_RESULT';
var ADD_UNHANDLED_MODAL_NOTIFICATION = exports.ADD_UNHANDLED_MODAL_NOTIFICATION = 'ADD_UNHANDLED_MODAL_NOTIFICATION';
var HIDE_MODAL_NOTIFICATION = exports.HIDE_MODAL_NOTIFICATION = 'HIDE_MODAL_NOTIFICATION';
var HIDE_ALL_MODAL_NOTIFICATIONS = exports.HIDE_ALL_MODAL_NOTIFICATIONS = 'HIDE_ALL_MODAL_NOTIFICATIONS';
var SHOW_LOGOUT_NOTIFICATION = exports.SHOW_LOGOUT_NOTIFICATION = 'SHOW_LOGOUT_NOTIFICATION';
var HIDE_LOGOUT_NOTIFICATION = exports.HIDE_LOGOUT_NOTIFICATION = 'HIDE_LOGOUT_NOTIFICATION';

var CREATING_HOSTING = exports.CREATING_HOSTING = 'CREATING_HOSTING';
var FINISHED_CREATING_HOSTING = exports.FINISHED_CREATING_HOSTING = 'FINISHED_CREATING_HOSTING';
var DELETING_HOSTING = exports.DELETING_HOSTING = 'DELETING_HOSTING';
var FINISHED_DELETING_HOSTING = exports.FINISHED_DELETING_HOSTING = 'FINISHED_DELETING_HOSTING';

var ADD_SERVER = exports.ADD_SERVER = 'ADD_SERVER';
var SET_SERVERS = exports.SET_SERVERS = 'SET_SERVERS';
var SET_SERVER = exports.SET_SERVER = 'SET_SERVER';
var SET_SERVER_STATUS = exports.SET_SERVER_STATUS = 'SET_SERVER_STATUS';
var INCREASE_LAST_SHUTDOWN = exports.INCREASE_LAST_SHUTDOWN = 'INCREASE_LAST_SHUTDOWN';
var SET_VIEWING_SERVER_IID = exports.SET_VIEWING_SERVER_IID = 'SET_VIEWING_SERVER_IID';
var UPDATE_EDITING_SERVER = exports.UPDATE_EDITING_SERVER = 'UPDATE_EDITING_SERVER';
var SET_SSL_CERTS = exports.SET_SSL_CERTS = 'SET_SSL_CERTS';
var SET_DATABASES = exports.SET_DATABASES = 'SET_DATABASES';
var SET_VHOSTS = exports.SET_VHOSTS = 'SET_VHOSTS';
var SET_FTP_USERS = exports.SET_FTP_USERS = 'SET_FTP_USERS';
var SET_DOMAIN_REDIRECTS = exports.SET_DOMAIN_REDIRECTS = 'SET_DOMAIN_REDIRECTS';
var SET_PHP_SETTINGS = exports.SET_PHP_SETTINGS = 'SET_PHP_SETTINGS';
var SET_NGINX_STATUS = exports.SET_NGINX_STATUS = 'SET_NGINX_STATUS';
var SERVER_REFRESH_TIMERS_LOADED = exports.SERVER_REFRESH_TIMERS_LOADED = 'SERVER_REFRESH_TIMERS_LOADED';
var RESET_SERVER_REFRESH_TIMERS = exports.RESET_SERVER_REFRESH_TIMERS = 'RESET_SERVER_REFRESH_TIMERS';
var SET_EDITING_DB = exports.SET_EDITING_DB = 'SET_EDITING_DB';
var SET_UPDATE_FTP = exports.SET_UPDATE_FTP = 'SET_UPDATE_FTP';
var SET_NEW_FTP_VHOST_ID = exports.SET_NEW_FTP_VHOST_ID = 'SET_NEW_FTP_VHOST_ID';
var SET_EDITING_SERVER = exports.SET_EDITING_SERVER = 'SET_EDITING_SERVER';
var CREATING_SERVER = exports.CREATING_SERVER = 'CREATING_SERVER';
var FINISHED_CREATING_SERVER = exports.FINISHED_CREATING_SERVER = 'FINISHED_CREATING_SERVER';
var UPDATING_SERVER = exports.UPDATING_SERVER = 'UPDATING_SERVER';
var FINISHED_UPDATING_SERVER = exports.FINISHED_UPDATING_SERVER = 'FINISHED_UPDATING_SERVER';
var DELETING_SERVER = exports.DELETING_SERVER = 'DELETING_SERVER';
var FINISHED_DELETING_SERVER = exports.FINISHED_DELETING_SERVER = 'FINISHED_DELETING_SERVER';
var DATABASE_REFRESH_TIMERS_LOADED = exports.DATABASE_REFRESH_TIMERS_LOADED = 'DATABASE_REFRESH_TIMERS_LOADED';
var RESET_DATABASE_TIMERS = exports.RESET_DATABASE_TIMERS = 'RESET_DATABASE_TIMERS';
var NEW_DATABASE_CREATED = exports.NEW_DATABASE_CREATED = 'NEW_DATABASE_CREATED';
var SET_DATABASE_BY_INDEX = exports.SET_DATABASE_BY_INDEX = 'SET_DATABASE_BY_INDEX';
var REMOVE_DATABASE_BY_INDEX = exports.REMOVE_DATABASE_BY_INDEX = 'REMOVE_DATABASE_BY_INDEX';
var VHOST_REFRESH_TIMERS_LOADED = exports.VHOST_REFRESH_TIMERS_LOADED = 'VHOST_REFRESH_TIMERS_LOADED';
var RESET_VHOST_TIMERS = exports.RESET_VHOST_TIMERS = 'RESET_VHOST_TIMERS';
var NEW_VHOST_CREATED = exports.NEW_VHOST_CREATED = 'NEW_VHOST_CREATED';
var SET_NEW_VHOST_BY_INDEX = exports.SET_NEW_VHOST_BY_INDEX = 'SET_NEW_VHOST_BY_INDEX';
var REMOVE_NEW_VHOST_BY_INDEX = exports.REMOVE_NEW_VHOST_BY_INDEX = 'REMOVE_NEW_VHOST_BY_INDEX';
var INCREASE_STARTUP_NEW_VHOST = exports.INCREASE_STARTUP_NEW_VHOST = 'INCREASE_STARTUP_NEW_VHOST';
var INCREASE_STARTUP_NEW_DATABASE = exports.INCREASE_STARTUP_NEW_DATABASE = 'INCREASE_STARTUP_NEW_DATABASE';
var SET_ALL_SERVERS = exports.SET_ALL_SERVERS = 'SET_ALL_SERVERS';
var SET_ALL_SERVERS_COUNT = exports.SET_ALL_SERVERS_COUNT = 'SET_ALL_SERVERS_COUNT';

var ADD_COLOCATIONS = exports.ADD_COLOCATIONS = 'ADD_COLOCATIONS';
var ADD_CONNECTIVITY = exports.ADD_CONNECTIVITY = 'ADD_CONNECTIVITY';
var ADD_EMAILS = exports.ADD_EMAILS = 'ADD_EMAILS';
var ADD_HOSTING = exports.ADD_HOSTING = 'ADD_HOSTING';
var ADD_DOMAINS = exports.ADD_DOMAINS = 'ADD_DOMAINS';
var SET_RESIDENTIAL_EMAILS = exports.SET_RESIDENTIAL_EMAILS = 'SET_RESIDENTIAL_EMAILS';
var SET_BUSINESS_EMAILS = exports.SET_BUSINESS_EMAILS = 'SET_BUSINESS_EMAILS';
var SET_EMAIL_ALIASES = exports.SET_EMAIL_ALIASES = 'SET_EMAIL_ALIASES';
var SET_PLESK_SERVERS = exports.SET_PLESK_SERVERS = 'SET_PLESK_SERVERS';
var SET_SSL = exports.SET_SSL = 'SET_SSL';
var ADD_VOIP = exports.ADD_VOIP = 'ADD_VOIP';
var OPEN_ALL_SERVICE_PANELS = exports.OPEN_ALL_SERVICE_PANELS = 'OPEN_ALL_SERVICE_PANELS';
var CLOSE_ALL_BUT_ONE_SERVICE_PANEL = exports.CLOSE_ALL_BUT_ONE_SERVICE_PANEL = 'CLOSE_ALL_BUT_ONE_SERVICE_PANEL';
var CLOSE_ALL_SERVICE_PANELS = exports.CLOSE_ALL_SERVICE_PANELS = 'CLOSE_ALL_SERVICE_PANELS';
var TOGGLE_SERVICE_PANEL = exports.TOGGLE_SERVICE_PANEL = 'TOGGLE_SERVICE_PANEL';
var OPEN_SERVICE_PANEL = exports.OPEN_SERVICE_PANEL = 'OPEN_SERVICE_PANEL';
var CLOSE_SERVICE_PANEL = exports.CLOSE_SERVICE_PANEL = 'CLOSE_SERVICE_PANEL';
var SET_PROVISION_TASKS = exports.SET_PROVISION_TASKS = 'SET_PROVISION_TASKS';

var SET_NOTICES = exports.SET_NOTICES = 'SET_NOTICES';
var SET_ALL_NOTICES = exports.SET_ALL_NOTICES = 'SET_ALL_NOTICES';
var REMOVE_NOTICE = exports.REMOVE_NOTICE = 'REMOVE_NOTICE';

var OPEN_REFRESH_PASSWORD = exports.OPEN_REFRESH_PASSWORD = 'OPEN_REFRESH_PASSWORD';
var CLOSE_REFRESH_PASSWORD = exports.CLOSE_REFRESH_PASSWORD = 'CLOSE_REFRESH_PASSWORD';

var ADD_TO_CART = exports.ADD_TO_CART = 'ADD_TO_CART';
var REMOVE_FROM_CART = exports.REMOVE_FROM_CART = 'REMOVE_FROM_CART';
var CALCULATE_CART = exports.CALCULATE_CART = 'CALCULATE_CART';
var EMPTY_CART = exports.EMPTY_CART = 'EMPTY_CART';
var SET_PROVIDER_ORDER = exports.SET_PROVIDER_ORDER = 'SET_PROVIDER_ORDER';
var SET_SERVICE_CLASS_ORDER = exports.SET_SERVICE_CLASS_ORDER = 'SET_SERVICE_CLASS_ORDER';
var SET_BILLABLE_ITEM_TYPE_ORDER = exports.SET_BILLABLE_ITEM_TYPE_ORDER = 'SET_BILLABLE_ITEM_TYPE_ORDER';

var SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT = exports.SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT = 'SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT';
var SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER = exports.SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER = 'SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER';
var SELF_SIGNUP_CONNECTIVITY_SET_SPEED = exports.SELF_SIGNUP_CONNECTIVITY_SET_SPEED = 'SELF_SIGNUP_CONNECTIVITY_SET_SPEED';
var SELF_SIGNUP_CONNECTIVITY_SET_ROUTER = exports.SELF_SIGNUP_CONNECTIVITY_SET_ROUTER = 'SELF_SIGNUP_CONNECTIVITY_SET_ROUTER';
var SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA = exports.SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA = 'SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA';
var SELF_SIGNUP_CONNECTIVITY_SET_STRATA = exports.SELF_SIGNUP_CONNECTIVITY_SET_STRATA = 'SELF_SIGNUP_CONNECTIVITY_SET_STRATA';
var SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE = exports.SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE = 'SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE';
var SELF_SIGNUP_CONNECTIVITY_SET_VOICE = exports.SELF_SIGNUP_CONNECTIVITY_SET_VOICE = 'SELF_SIGNUP_CONNECTIVITY_SET_VOICE';
var SELF_SIGNUP_SET_ATTRIBUTION_DATA = exports.SELF_SIGNUP_SET_ATTRIBUTION_DATA = 'SELF_SIGNUP_SET_ATTRIBUTION_DATA';
var SELF_SIGNUP_SET_CUSTOMER_DATA = exports.SELF_SIGNUP_SET_CUSTOMER_DATA = 'SELF_SIGNUP_SET_CUSTOMER_DATA';
var SELF_SIGNUP_SET_PAYMENT_DATA = exports.SELF_SIGNUP_SET_PAYMENT_DATA = 'SELF_SIGNUP_SET_PAYMENT_DATA';
var SELF_SIGNUP_SET_AGREEMENT_DATA = exports.SELF_SIGNUP_SET_AGREEMENT_DATA = 'SELF_SIGNUP_SET_AGREEMENT_DATA';
var SELF_SIGNUP_RESET_OUTPUT_MODELS = exports.SELF_SIGNUP_RESET_OUTPUT_MODELS = 'SELF_SIGNUP_RESET_OUTPUT_MODELS';
var SELF_SIGNUP_SET_INIT_VALUES = exports.SELF_SIGNUP_SET_INIT_VALUES = 'SELF_SIGNUP_SET_INIT_VALUES';

var SET_PRODUCTION_LOG_LEVEL = exports.SET_PRODUCTION_LOG_LEVEL = 'SET_PRODUCTION_LOG_LEVEL';
var SET_DEVELOPMENT_LOG_LEVEL = exports.SET_DEVELOPMENT_LOG_LEVEL = 'SET_DEVELOPMENT_LOG_LEVEL';

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1172)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(810),
  /* template */
  __webpack_require__(1336),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8641c246",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1163)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1323),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cb934e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(135);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(111);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1352);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _index = __webpack_require__(134);

var _index2 = _interopRequireDefault(_index);

var _user = __webpack_require__(351);

var _user2 = _interopRequireDefault(_user);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _no_auth_routes = __webpack_require__(350);

var _no_auth_routes2 = _interopRequireDefault(_no_auth_routes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Signup = function Signup() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 741));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1366));
};
var Manage = function Manage() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1367));
};
var Account = function Account() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1363));
};
var Server = function Server() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1362));
};
var SSLCerts = function SSLCerts() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1372));
};
var DomainRedirects = function DomainRedirects() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1371));
};
var Services = function Services() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1373));
};
var Billing = function Billing() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1364));
};
var PaymentMethods = function PaymentMethods() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1370));
};
var Invoice = function Invoice() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1365));
};
var UsernameRecovery = function UsernameRecovery() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1376));
};
var PasswordUpdate = function PasswordUpdate() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1369));
};
var Status404 = function Status404() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1374));
};

var PasswordGeneratorPage = function PasswordGeneratorPage() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1368));
};

var Test = function Test() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1375));
};

_vue2.default.use(_vueRouter2.default);

var routes = [{ path: '/', redirect: { name: 'login' } }, { path: '/signup/:components?', name: 'signup', component: Signup }, { path: '/login/', name: 'login', component: Login }, { path: '/pw/', redirect: { name: 'password-recovery' } }, { path: '/username-recovery/', name: 'username-recovery', component: UsernameRecovery }, { path: '/password-update/:id', name: 'password-update', component: PasswordUpdate }, { path: '/password-generator/', alias: '/passgen/', name: 'password-generator', component: PasswordGeneratorPage }, { path: '/account/', name: 'account', component: Account }, { path: '/services/', name: 'services', component: Services, meta: { perms: { services: 'view' } } }, { path: '/services/:service', name: 'servicesParam', component: Services, meta: { perms: { services: 'view' } } }, { path: '/servers/:server/manage', name: 'manage-server', component: Manage }, { path: '/server/:iid', name: 'server', component: Server, meta: { perms: { services: 'view' } } }, { path: '/server/:iid/ssl', name: 'ssl', component: SSLCerts, meta: { perms: { services: 'view' } } }, { path: '/server/:iid/domain_redirects', name: 'domain_redirects', component: DomainRedirects, meta: { perms: { services: 'view' } } }, { path: '/billing/', name: 'billing', component: Billing, meta: { perms: { payments: 'view' } } }, { path: '/payment-methods/', name: 'payment-methods', component: PaymentMethods, meta: { perms: { payments: 'manage' } } }, { path: '/invoice/:endpoint/:id', name: 'invoice', component: Invoice }, { path: '*', name: '404', component: Status404 }, { path: '/test/:argument', name: 'test', component: Test }];

var router = new _vueRouter2.default({
  mode: 'history',
  base: '/control/',
  routes: routes
});

var routeHelpers = {
  routeAuthCheck: function routeAuthCheck(to, from) {
    return new _promise2.default(function (resolve, reject) {
      _index2.default.dispatch('getProfile').then(function (result) {
        if (_index2.default.state.user.loggedIn) {
          if ('meta' in to && 'perms' in to.meta && (0, _keys2.default)(to.meta.perms).length > 0) {
            if (_user2.default.helpers.hasOnePermission(_index2.default.state.user.perms, to.meta.perms)) {
              resolve('');
            } else {
              _index2.default.commit(types.ADD_NOTIFICATION, {
                type: 'danger',
                message: 'You do not have permission to view this'
              });
              resolve('account');
            }
          } else {
            resolve('');
          }
        } else {
          resolve('login');
        }
      }, function (errorResult) {
        resolve('login');
      });
    });
  }
};

router.beforeEach(function (to, from, next) {
  if ('name' in to) {
    sessionStorage.setItem('attemptingRoute', to.name);
  }
  if ('name' in to && _no_auth_routes2.default.includes(to.name)) {
    next();
    return;
  } else {
    routeHelpers.routeAuthCheck(to, from).then(function (response) {
      if (response === '') {
        next();
      } else {
        next({ name: response });
      }
    });
  }
});

exports.default = router;

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1156)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(803),
  /* template */
  __webpack_require__(1310),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e800b6c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = __webpack_require__(225);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _iterator = __webpack_require__(352);

var _iterator2 = _interopRequireDefault(_iterator);

var _getOwnPropertyNames = __webpack_require__(846);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(136);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(771);

var ArrayProto = Array.prototype;
var nodeError = new Error('Passed arguments must be of Node');
var blurEvent;
var blurList = [];
var Events = [];

function isNode(val) {
  return val instanceof window.Node;
}
function isNodeList(val) {
  return val instanceof window.NodeList || val instanceof NodeList || val instanceof window.HTMLCollection || val instanceof Array;
}

var NodeList = function () {
  function NodeList(args) {
    (0, _classCallCheck3.default)(this, NodeList);

    var nodes = args;
    if (args[0] === window) {
      nodes = [window];
    } else if (typeof args[0] === 'string') {
      nodes = (args[1] || document).querySelectorAll(args[0]);
      if (args[1]) {
        this.owner = args[1];
      }
    } else if (0 in args && !isNode(args[0]) && args[0] && 'length' in args[0]) {
      nodes = args[0];
      if (args[1]) {
        this.owner = args[1];
      }
    }
    if (nodes) {
      for (var i in nodes) {
        this[i] = nodes[i];
      }
      this.length = nodes.length;
    } else {
      this.length = 0;
    }
    window.prueba = this;
  }

  (0, _createClass3.default)(NodeList, [{
    key: 'concat',
    value: function concat() {
      var nodes = ArrayProto.slice.call(this);
      function flatten(arr) {
        ArrayProto.forEach.call(arr, function (el) {
          if (isNode(el)) {
            if (!~nodes.indexOf(el)) nodes.push(el);
          } else if (isNodeList(el)) {
            flatten(el);
          }
        });
      }

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      ArrayProto.forEach.call(args, function (arg) {
        if (isNode(arg)) {
          if (!~nodes.indexOf(arg)) nodes.push(arg);
        } else if (isNodeList(arg)) {
          flatten(arg);
        } else {
          throw Error('Concat arguments must be of a Node, NodeList, HTMLCollection, or Array of (Node, NodeList, HTMLCollection, Array)');
        }
      });
      return NodeListJS(nodes, this);
    }
  }, {
    key: 'delete',
    value: function _delete() {
      var notRemoved = flatten(this).filter(function (el) {
        if (el.remove) {
          el.remove();
        } else if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
        return document.body.contains(el);
      });
      if (notRemoved.length) console.warn('NodeList: Some nodes could not be deleted.');
      return notRemoved;
    }
  }, {
    key: 'each',
    value: function each() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      ArrayProto.forEach.apply(this, args);
      return this;
    }
  }, {
    key: 'filter',
    value: function filter() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return NodeListJS(ArrayProto.filter.apply(this, args), this);
    }
  }, {
    key: 'find',
    value: function find(element) {
      var nodes = [];
      if (typeof element === 'string') flatten(this).forEach(function (node) {
        nodes.push(node.querySelectorAll(element));
      });
      if (isNode(element)) flatten(this).forEach(function (node) {
        if (node !== element && node.contains(element)) nodes.push(element);
      });
      if (isNodeList(element)) {
        var els = flatten(element);
        flatten(this).forEach(function (node) {
          els.forEach(function (el) {
            if (node !== el && node.contains(el)) nodes.push(el);
          });
        });
      }
      return flatten(nodes, this.owner);
    }
  }, {
    key: 'forEach',
    value: function forEach() {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      ArrayProto.forEach.apply(this, args);
      return this;
    }
  }, {
    key: 'includes',
    value: function includes(element, index) {
      return ~this.indexOf(element, index);
    }
  }, {
    key: 'map',
    value: function map() {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      var mapped = ArrayProto.map.apply(this, args);
      return mapped.some(function (el) {
        return isNode(el) || isNodeList(el);
      }) ? flatten(mapped, this) : mapped;
    }
  }, {
    key: 'parent',
    value: function parent() {
      return flatten(this.map(function (el) {
        return el.parentNode;
      }), this);
    }
  }, {
    key: 'pop',
    value: function pop(amount) {
      if (typeof amount !== 'number') {
        amount = 1;
      }
      var nodes = [];
      var pop = ArrayProto.pop.bind(this);
      while (amount--) {
        nodes.push(pop());
      }return NodeListJS(nodes, this);
    }
  }, {
    key: 'push',
    value: function push() {
      var _this = this;

      for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      ArrayProto.forEach.call(args, function (arg) {
        if (!isNode(arg)) throw nodeError;
        if (!~_this.indexOf(arg)) ArrayProto.push.call(_this, arg);
      });
      return this;
    }
  }, {
    key: 'shift',
    value: function shift(amount) {
      if (typeof amount !== 'number') {
        amount = 1;
      }
      var nodes = [];
      while (amount--) {
        nodes.push(ArrayProto.shift.call(this));
      }return nodes.length == 1 ? nodes[0] : NodeListJS(nodes, this);
    }
  }, {
    key: 'slice',
    value: function slice() {
      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return NodeListJS(ArrayProto.slice.apply(this, args), this);
    }
  }, {
    key: 'splice',
    value: function splice() {
      for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      for (var i = 2, l = args.length; i < l; i++) {
        if (!isNode(args[i])) throw nodeError;
      }
      ArrayProto.splice.apply(this, args);
      return this;
    }
  }, {
    key: 'unshift',
    value: function unshift() {
      var _this2 = this;

      var unshift = ArrayProto.unshift.bind(this);

      for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }

      ArrayProto.forEach.call(args, function (arg) {
        if (!isNode(arg)) throw nodeError;
        if (!~_this2.indexOf(arg)) unshift(arg);
      });
      return this;
    }
  }, {
    key: 'addClass',
    value: function addClass(classes) {
      return this.toggleClass(classes, true);
    }
  }, {
    key: 'removeClass',
    value: function removeClass(classes) {
      return this.toggleClass(classes, false);
    }
  }, {
    key: 'toggleClass',
    value: function toggleClass(classes) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var method = value === undefined || value === null ? 'toggle' : value ? 'add' : 'remove';
      if (typeof classes === 'string') {
        classes = classes.trim().replace(/\s+/, ' ').split(' ');
      }
      return this.each(function (el) {
        return classes.forEach(function (c) {
          return el.classList[method](c);
        });
      });
    }
  }, {
    key: 'get',
    value: function get(prop) {
      var arr = [];
      this.each(function (el) {
        if (el !== null) {
          el = el[prop];
        }
        arr.push(el);
      });
      return flatten(arr, this);
    }
  }, {
    key: 'set',
    value: function set(prop, value) {
      if (prop.constructor === Object) {
        this.each(function (el) {
          if (el) {
            for (var key in prop) {
              if (key in el) {
                el[key] = prop[key];
              }
            }
          }
        });
      } else {
        this.each(function (el) {
          if (prop in el) {
            el[prop] = value;
          }
        });
      }
      return this;
    }
  }, {
    key: 'call',
    value: function call() {
      for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        args[_key10] = arguments[_key10];
      }

      var method = ArrayProto.shift.call(args);
      var arr = [];
      var returnThis = true;
      this.each(function (el) {
        if (el && el[method] instanceof Function) {
          el = el[method].apply(el, args);
          arr.push(el);
          if (returnThis && el !== undefined) {
            returnThis = false;
          }
        } else {
          arr.push(undefined);
        }
      });
      return returnThis ? this : flatten(arr, this);
    }
  }, {
    key: 'item',
    value: function item(index) {
      return NodeListJS([this[index]], this);
    }
  }, {
    key: 'on',
    value: function on(events, selector, callback) {
      if (typeof events === 'string') {
        events = events.trim().replace(/\s+/, ' ').split(' ');
      }
      if (!this || !this.length) return this;
      if (callback === undefined) {
        callback = selector;
        selector = null;
      }
      if (!callback) return this;
      var fn = callback;
      callback = selector ? function (e) {
        var els = NodeListJS(selector, this);
        if (!els.length) {
          return;
        }
        els.some(function (el) {
          var target = el.contains(e.target);
          if (target) fn.call(el, e, el);
          return target;
        });
      } : function (e) {
        fn.apply(this, [e, this]);
      };
      this.each(function (el) {
        events.forEach(function (event) {
          if (el === window || isNode(el)) {
            el.addEventListener(event, callback, false);
            Events.push({
              el: el,
              event: event,
              callback: callback
            });
          }
        });
      });
      return this;
    }
  }, {
    key: 'off',
    value: function off(events, callback) {
      if (events instanceof Function) {
        callback = events;
        events = null;
      }
      events = events instanceof Array ? events : typeof events === 'string' ? events.trim().replace(/\s+/, ' ').split(' ') : null;
      this.each(function (el) {
        Events = Events.filter(function (e) {
          if (e && e.el === el && (!callback || callback === e.callback) && (!events || ~events.indexOf(e.event))) {
            e.el.removeEventListener(e.event, e.callback);
            return false;
          }
          return true;
        });
      });
      return this;
    }
  }, {
    key: 'onBlur',
    value: function onBlur(callback) {
      if (!this || !this.length) return this;
      if (!callback) return this;
      this.each(function (el) {
        blurList.push({ el: el, callback: callback });
      });
      if (!blurEvent) {
        blurEvent = function blurEvent(e) {
          blurList.forEach(function (item) {
            var target = item.el.contains(e.target) || item.el === e.target;
            if (!target) item.callback.call(item.el, e, item.el);
          });
        };
        document.addEventListener('click', blurEvent, false);
        document.addEventListener('touchstart', blurEvent, false);
      }
      return this;
    }
  }, {
    key: 'offBlur',
    value: function offBlur(callback) {
      this.each(function (el) {
        blurList = blurList.filter(function (blur) {
          if (blur && blur.el === el && (!callback || blur.callback === callback)) {
            return false;
          }
          return el;
        });
      });
      return this;
    }
  }, {
    key: 'asArray',
    get: function get() {
      return ArrayProto.slice.call(this);
    }
  }]);
  return NodeList;
}();

var NL = NodeList.prototype;

function flatten(arr, owner) {
  var list = [];
  ArrayProto.forEach.call(arr, function (el) {
    if (isNode(el)) {
      if (!~list.indexOf(el)) list.push(el);
    } else if (isNodeList(el)) {
      for (var id in el) {
        if (!~list.indexOf(el[id])) list.push(el[id]);
      }
    } else if (el !== null) {
      arr.get = NL.get;
      arr.set = NL.set;
      arr.call = NL.call;
      arr.owner = owner;
      return arr;
    }
  });
  return NodeListJS(list, owner);
}

var exceptions = ['join', 'copyWithin', 'fill', 'find', 'forEach'];
(0, _getOwnPropertyNames2.default)(ArrayProto).forEach(function (key) {
  if (!~exceptions.indexOf(key) && NL[key] === undefined) {
    NL[key] = ArrayProto[key];
  }
});
if (window.Symbol && _iterator2.default) {
  NL[_iterator2.default] = NL.values = ArrayProto[_iterator2.default];
}
var div = document.createElement('div');
function setterGetter(prop) {
  var _this3 = this;

  if (NL[prop]) return;
  if (div[prop] instanceof Function) {
    NL[prop] = function () {
      for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }

      var arr = [];
      var returnThis = true;
      for (var i in NL) {
        var el = NL[i];
        if (el && el[prop] instanceof Function) {
          el = el[prop].apply(el, args);
          arr.push(el);
          if (returnThis && el !== undefined) {
            returnThis = false;
          }
        } else {
          arr.push(undefined);
        }
      }
      return returnThis ? _this3 : flatten(arr, _this3);
    };
  } else {
    (0, _defineProperty2.default)(NL, prop, {
      get: function get() {
        var arr = [];
        this.each(function (el) {
          if (el !== null) {
            el = el[prop];
          }
          arr.push(el);
        });
        return flatten(arr, this);
      },
      set: function set(value) {
        this.each(function (el) {
          if (el && prop in el) {
            el[prop] = value;
          }
        });
      }
    });
  }
}
for (var prop in div) {
  setterGetter(prop);
}function NodeListJS() {
  for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }

  return new NodeList(args);
}
window.NL = NodeListJS;

exports.default = NodeListJS;

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(136);

var _createClass3 = _interopRequireDefault(_createClass2);

var _connectivityService = __webpack_require__(151);

var _connectivityService2 = _interopRequireDefault(_connectivityService);

var _routerService = __webpack_require__(348);

var _routerService2 = _interopRequireDefault(_routerService);

var _staticIpService = __webpack_require__(774);

var _staticIpService2 = _interopRequireDefault(_staticIpService);

var _subnetService = __webpack_require__(775);

var _subnetService2 = _interopRequireDefault(_subnetService);

var _voiceService = __webpack_require__(349);

var _voiceService2 = _interopRequireDefault(_voiceService);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectivityClotService = function () {
  function ConnectivityClotService(service_details) {
    (0, _classCallCheck3.default)(this, ConnectivityClotService);

    _logger2.default.debug('service_details', service_details);
    _logger2.default.debug('THIS SHOULD ONLY BE CALLED TWICE');
    service_details = JSON.parse((0, _stringify2.default)(service_details));
    this.address_details = service_details.address_details;
    this.is_available = this.address_details.available;
    this.speed_options = [];
    if (this.isAvailable()) {
      this.service_details = service_details.service;
      this.service_class_model = this.service_details.service_class_model;

      this.connectivity = new _connectivityService2.default(this.service_details.connectivity, this.address_details);
      this.router = new _routerService2.default(this.service_details.router, this.address_details);
      this.voice = new _voiceService2.default(this.service_details.voice, this.address_details);
      this.static_ip = new _staticIpService2.default(this.service_details.static_ip);
      this.subnet = new _subnetService2.default(this.service_details.subnet);
    }
  }

  (0, _createClass3.default)(ConnectivityClotService, [{
    key: "isAvailable",
    value: function isAvailable() {
      return this.is_available;
    }
  }, {
    key: "setSpeedOptionsForSelect",
    value: function setSpeedOptionsForSelect() {
      var _this = this;

      _logger2.default.debug('setSpeedOptionsForSelect', this);
      var promo_labels = [];
      var speed_options = { speed_options: [], promo_legal_disclaimers: [] };
      var router_legal_disclaimers = [];
      if (!this.isAvailable) {
        return;
      }
      var total_speed_options = this.connectivity.speedOptions();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var speed_option = _step.value;

          var router_option = _this.router.routerOptions().filter(function (x) {
            return x.speed_id === speed_option.speed_id;
          });
          var connectivity_promo = _this.connectivity.onlinePromo(speed_option);
          var connectivity_promos = speed_option.billing.promos;
          var router_promo = null;
          var router_promo_rate = 0.;

          if (router_option.length === 1) {
            router_option = router_option[0];
            router_promo = _this.router.onlinePromo(router_option);
            if (router_promo) {
              router_promo_rate = router_promo.rate;
            }
          }
          var router_promos = router_option.billing.promos;
          var monthly_gross_connectivity_rate = _this.connectivity.grossServiceOptionMonthlyCost(speed_option);
          var early_net_connectivity_rate = _this.connectivity.grossOneTimeXMissionCost(speed_option);
          var monthly_gross_connectivity_router_rate = monthly_gross_connectivity_rate - router_promo_rate;
          speed_options.speed_options.push({ download_speed: speed_option.download_speed,
            speed_id: speed_option.speed_id,
            external_soid: speed_option.external_soid,
            speed_label: speed_option.label,
            speed_description: speed_option.description,
            speed_color: speed_option.color,
            symmetric: speed_option.symmetric,
            monthly_gross_connectivity_rate: monthly_gross_connectivity_rate,
            monthly_gross_connectivity_rate_breakdown: _this.connectivity.monthlyPriceFeeServiceOptionBreakdownString(speed_option),
            has_connectivity_promo: Boolean(connectivity_promos),
            early_net_connectivity_rate_term: _this.connectivity.getRateTermString(connectivity_promo, early_net_connectivity_rate, false),
            has_router_promo: Boolean(router_promo),
            monthly_gross_connectivity_router_rate: monthly_gross_connectivity_router_rate });
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(connectivity_promos), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var promo = _step2.value;

              if (!promo_labels.includes(connectivity_promo.legal_label)) {
                promo_labels.push(connectivity_promo.legal_label);
                speed_options.promo_legal_disclaimers.push({ label: connectivity_promo.legal_label, disclaimer: connectivity_promo.legal_description });
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(router_promos), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _promo = _step3.value;

              if (!promo_labels.includes(_promo.legal_label)) {
                promo_labels.push(_promo.legal_label);

                router_legal_disclaimers.push({ label: _promo.legal_label, disclaimer: _promo.legal_description });
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        };

        for (var _iterator = (0, _getIterator3.default)(total_speed_options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      speed_options.promo_legal_disclaimers = speed_options.promo_legal_disclaimers.concat(router_legal_disclaimers);

      speed_options.speed_options = speed_options.speed_options.sort(function (a, b) {
        return Number(a.download_speed) - Number(b.download_speed);
      });
      this.speed_options = speed_options;
    }
  }]);
  return ConnectivityClotService;
}();

exports.default = ConnectivityClotService;

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(153);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(136);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(155);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(154);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service = __webpack_require__(152);

var _service2 = _interopRequireDefault(_service);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouterService = function (_Service) {
  (0, _inherits3.default)(RouterService, _Service);

  function RouterService(service, address_details) {
    (0, _classCallCheck3.default)(this, RouterService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RouterService.__proto__ || (0, _getPrototypeOf2.default)(RouterService)).call(this, service));

    _this.address_details = address_details;
    _this.active_router_option = null;
    _this.setPromoOrderSummaryStrings();
    _logger2.default.debug('router service', _this.service);
    return _this;
  }

  (0, _createClass3.default)(RouterService, [{
    key: 'setPromoOrderSummaryStrings',
    value: function setPromoOrderSummaryStrings() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.service.router_options), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var router_option = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(router_option.billing.promos), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var promo = _step2.value;

              promo.legal_label = promo.description;
              if (promo.name.includes('_first_month_discount')) {
                promo.legal_description = 'XMission will automatically credit one FREE month of XMission XWi service ($12-15) to your account upon installation and activation. Limit of one per household. Applies to new XMission XWi customers only. One-time use only.';
              } else if (promo.name.includes('_xwi_discount')) {
                promo.legal_description = 'XMission will automatically credit $' + promo.rate + ' per month of XMission XWi service to your account upon installation and activation. Limit of one per household. Applies to new XMission customers only.';
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'routerOptions',
    value: function routerOptions() {
      return this.service.router_options;
    }
  }, {
    key: 'onlinePromo',
    value: function onlinePromo(router_option) {
      var promos = router_option.billing.promos.filter(function (x) {
        return x.featured;
      });
      if (promos.length === 1) {
        return promos[0];
      }
      return null;
    }
  }, {
    key: 'setActiveRouterOption',
    value: function setActiveRouterOption(speed_id) {
      var router_option = this.routerOptions().filter(function (x) {
        return x.speed_id === speed_id;
      });
      this.active_router_option = router_option.length === 1 ? router_option[0] : null;
      _logger2.default.debug('router options', this.routerOptions());
    }
  }, {
    key: 'getActiveRouterOption',
    value: function getActiveRouterOption() {
      return this.active_router_option;
    }
  }, {
    key: 'grossMonthlyRate',
    value: function grossMonthlyRate() {
      return this.active_router_option.billing.prices[0].rate;
    }
  }, {
    key: 'addActiveRouterOptionToCart',
    value: function addActiveRouterOptionToCart() {
      this.order_summary.addServiceOptionToCart(this.active_router_option);
    }
  }, {
    key: 'addMeshOptionToCart',
    value: function addMeshOptionToCart() {
      this.order_summary.addServiceOptionToCart(this.service.mesh_option);
    }
  }, {
    key: 'removeRouterOptionFromCart',
    value: function removeRouterOptionFromCart() {
      this.order_summary.removeServiceOptionFromCart(this.active_router_option);
    }
  }, {
    key: 'removeMeshOptionFromCart',
    value: function removeMeshOptionFromCart() {
      _logger2.default.debug('removeMeshOptionFromCart', this.service.mesh_option);
      this.order_summary.removeServiceOptionFromCart(this.service.mesh_option);
    }
  }, {
    key: 'activeRouterAvailable',
    value: function activeRouterAvailable() {
      if (this.active_router_option === null) {
        return false;
      }
      return this.active_router_option.router_available;
    }
  }, {
    key: 'meshesAvailable',
    value: function meshesAvailable() {
      _logger2.default.debug('router service asdf', this.service);
      return this.service.mesh_option.quantity_available;
    }
  }, {
    key: 'meshMonthlyRate',
    value: function meshMonthlyRate() {
      return this.service.mesh_option.billing.prices[0].rate;
    }
  }]);
  return RouterService;
}(_service2.default);

exports.default = RouterService;

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(153);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(155);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(154);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service = __webpack_require__(152);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoiceService = function (_Service) {
  (0, _inherits3.default)(VoiceService, _Service);

  function VoiceService(service, address_details) {
    (0, _classCallCheck3.default)(this, VoiceService);
    return (0, _possibleConstructorReturn3.default)(this, (VoiceService.__proto__ || (0, _getPrototypeOf2.default)(VoiceService)).call(this, service));
  }

  return VoiceService;
}(_service2.default);

exports.default = VoiceService;

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var NO_AUTH_ROUTES = ['password-recovery', 'username-recovery', 'password-update', 'login', 'signup', '404', 'password-generator', 'unsubscribe', 'test'];
exports.default = NO_AUTH_ROUTES;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _jquery = __webpack_require__(110);

var _jquery2 = _interopRequireDefault(_jquery);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _jsCookie = __webpack_require__(551);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _underscore = __webpack_require__(1215);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  username: '',
  cid: '',
  perms: {},
  siteAdmin: false,
  loggedIn: undefined,
  info: {
    name: '',
    first_name: '',
    middle_initial: '',
    last_name: '',
    business: false,
    dob: '',
    phone: '',
    email: ''
  },
  user_loaded: false,
  connected_users: [],
  editing_user: {
    created: '',
    username: ''
  },
  editing_user_permissions: {},
  perm_categories: {},
  perm_schema: {},

  ajaxCallback: undefined,
  ajaxOptions: {},
  passwordWordList: [],
  primary_admin: false,
  hasDarkTheme: localStorage.getItem('xm-theme') ? localStorage.getItem('xm-theme') === 'dark' : null,
  service_address: { line1: '', line2: '', city: '', state: '', zip_code: '', fname: '', lname: '', mnami: '' }
};

var helpers = {
  hasPermission: function hasPermission(perms, category, permission) {
    if ('admin' in perms && perms['admin']['has_manage']) {
      return true;
    }

    if (!(category in perms)) {
      return false;
    }

    if (permission === 'view' && perms[category]['has_manage']) {
      return true;
    }
    var permissionName = 'has_' + permission;

    if (!(permissionName in perms[category])) {
      return false;
    }
    return perms[category][permissionName];
  },
  hasOnePermission: function hasOnePermission(perms, permsRequired) {
    if ('admin' in perms && perms['admin']['has_manage']) {
      return true;
    }

    for (var category in permsRequired) {
      var perm = permsRequired[category];
      if (helpers.hasPermission(perms, category, perm)) {
        return true;
      }
    }
    return false;
  }
};

var getters = {
  hasViewAccountPerm: function hasViewAccountPerm(state) {
    return helpers.hasPermission(state.perms, 'account', 'view');
  },
  hasAdminPerm: function hasAdminPerm(state) {
    return helpers.hasPermission(state.perms, 'admin', 'manage');
  },
  hasViewContactPerm: function hasViewContactPerm(state) {
    return helpers.hasPermission(state.perms, 'contacts', 'view');
  },
  hasManageContactPerm: function hasManageContactPerm(state) {
    return helpers.hasPermission(state.perms, 'contacts', 'manage');
  },
  hasInvoiceViewPerm: function hasInvoiceViewPerm(state) {
    return helpers.hasPermission(state.perms, 'invoices', 'view');
  },
  hasPaymentsViewPerm: function hasPaymentsViewPerm(state) {
    return helpers.hasPermission(state.perms, 'payments', 'view');
  },
  hasPaymentsManagePerm: function hasPaymentsManagePerm(state) {
    return helpers.hasPermission(state.perms, 'payments', 'manage');
  },
  hasServicesViewPerm: function hasServicesViewPerm(state) {
    return helpers.hasPermission(state.perms, 'services', 'view');
  },
  hasServicesManagePerm: function hasServicesManagePerm(state) {
    return helpers.hasPermission(state.perms, 'services', 'manage');
  },
  hasTicketsViewPerm: function hasTicketsViewPerm(state) {
    return helpers.hasPermission(state.perms, 'tickets', 'view');
  },
  hasTicketsManagePerm: function hasTicketsManagePerm(state) {
    return helpers.hasPermission(state.perms, 'tickets', 'manage');
  },
  isPrimaryAdmin: function isPrimaryAdmin(state) {
    return state.primary_admin;
  },
  isSiteAdmin: function isSiteAdmin(state) {
    return state.siteAdmin;
  },
  isPBAUser: function isPBAUser(state) {
    return state.cid >= 1000000;
  },
  username: function username(state) {
    return state.username;
  },
  isLoggedIn: function isLoggedIn(state) {
    return state.loggedIn;
  },
  hasDarkTheme: function hasDarkTheme(state) {
    return state.hasDarkTheme;
  } };

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.LOGGED_IN, function (state, _ref) {
  var username = _ref.username,
      cid = _ref.cid,
      perms = _ref.perms,
      site_admin = _ref.site_admin;

  state.username = username;
  state.cid = cid;
  state.perms = perms;
  state.loggedIn = true;

  state.siteAdmin = site_admin;
}), (0, _defineProperty3.default)(_mutations, types.SET_LOGGED_IN, function (state) {
  state.loggedIn = true;
}), (0, _defineProperty3.default)(_mutations, types.LOGGED_OUT, function (state) {
  state.username = '';
  state.roles = [];
  state.loggedIn = false;
  state.siteAdmin = false;
}), (0, _defineProperty3.default)(_mutations, types.SET_PROFILE, function (state, _ref2) {
  var username = _ref2.username,
      cid = _ref2.cid,
      perms = _ref2.perms,
      site_admin = _ref2.site_admin;

  state.username = username;
  state.cid = cid;
  state.perms = perms;

  state.siteAdmin = site_admin;
}), (0, _defineProperty3.default)(_mutations, types.SET_USER, function (state, input) {
  state.info.name = input['name'];
  state.info.dob = input['dob'];
  state.info.email = input['email'];
  state.info.phone = input['phone'];
  state.info.business = input['business'];
  state.info.first_name = input['first_name'];
  state.info.middle_initial = input['middle_initial'];
  state.info.last_name = input['last_name'];
  state.primary_admin = input['primary_admin'];
  state.service_address = input['service_address'];
  state.user_loaded = true;
}), (0, _defineProperty3.default)(_mutations, types.SET_PERM_SCHEMA, function (state, permSchema) {
  state.perm_schema = permSchema;
}), (0, _defineProperty3.default)(_mutations, types.SET_PERM_CATEGORIES, function (state, permCategories) {
  state.perm_categories = permCategories;
}), (0, _defineProperty3.default)(_mutations, types.SAVE_AJAX_REQUEST, function (state, _ref3) {
  var ajaxCallback = _ref3.ajaxCallback,
      ajaxOptions = _ref3.ajaxOptions;

  state.ajaxCallback = ajaxCallback;
  state.ajaxOptions = ajaxOptions;
}), (0, _defineProperty3.default)(_mutations, types.CLEAR_AJAX_REQUEST, function (state) {
  state.ajaxCallback = undefined;
  state.ajaxOptions = undefined;
}), (0, _defineProperty3.default)(_mutations, types.SET_PASSWORD_WORDLIST, function (state, passwordWordList) {
  state.passwordWordList = passwordWordList;
}), (0, _defineProperty3.default)(_mutations, types.HAS_DARK_THEME, function (state, hasTheme) {
  state.hasDarkTheme = hasTheme;
}), _mutations);

var actions = {
  login: function login(_ref4, payload) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        keepNotifications = _ref4.keepNotifications;

    return new _promise2.default(function (resolve, reject) {
      _jquery2.default.ajax({
        type: 'POST',
        data: (0, _stringify2.default)({
          username: payload.username,
          password: payload.password,
          store_in_cookies: true
        }),
        tryCount: 0,
        url: '/manage/api/v1.0/auth/tokens',
        contentType: 'application/json',
        success: function success(result) {
          commit(types.LOGGED_IN, {
            username: result.username,
            cid: result.cid,
            perms: result.perms,
            siteAdmin: result.site_admin
          });

          if (keepNotifications !== true) {
            commit(types.HIDE_ALL_NOTIFICATIONS);
          }
          localStorage.setItem('xm_username', result.username);
          resolve();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          if (_authRequest2.default.handleTimeout(jqXHR, textStatus, this)) {
            return;
          } else if (jqXHR.status === 401) {
            commit(types.LOGGED_OUT);
            reject(jqXHR.responseJSON.title);
          } else {
            console.log('Error logging in: ' + textStatus + ' ' + errorThrown, jqXHR);
            reject(jqXHR.responseJSON.title);
          }
        }
      });
    });
  },
  logout: function logout(_ref5, router) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        disableApiUrl: true,
        url: '/manage/api/v1.0/auth/tokens',
        success: function success(result) {
          commit(types.LOGGED_OUT);
          commit(types.SET_NOTICES, []);
          commit(types.SHOW_LOGOUT_NOTIFICATION);
          if (result.proxy_logout === true) {
            commit(types.LOGGED_IN, {
              username: result.username,
              cid: result.cid,
              perms: result.perms,
              siteAdmin: result.site_admin
            });

            dispatch('getProfile');

            dispatch('getNotices');
            router.push({ name: 'admin-proxy' });
          } else {
            router.push({ name: 'login' });
          }
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  updatePassword: function updatePassword(_ref6, _ref7) {
    var commit = _ref6.commit;
    var username = _ref7.username,
        password = _ref7.password,
        url = _ref7.url;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/token/update_password/' + url,
        data: {
          username: username,
          password: password
        },
        success: function success(result) {
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  changePassword: function changePassword(_ref8, _ref9) {
    var commit = _ref8.commit;
    var currentPass = _ref9.currentPass,
        newPass = _ref9.newPass;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        disableApiUrl: true,
        url: '/manage/api/v1.0/token/password_reset',
        data: {
          old_password: currentPass,
          new_password: newPass
        },
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          return resolve(result);
        },
        error: function error(result) {
          return reject(result);
        }
      });
    });
  },
  getProfile: function getProfile(_ref10) {
    var commit = _ref10.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/user/profile',
        success: function success(result) {
          commit(types.SET_PROFILE, result);
          commit(types.SET_LOGGED_IN);
          resolve(result);
        },
        error: function error(result) {
          commit(types.LOGGED_OUT);
          reject(result);
        }
      });
    });
  },
  getInfo: function getInfo(_ref11) {
    var commit = _ref11.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/user/info',
        success: function success(result) {
          commit(types.SET_USER, result);
          if (result.billing) {
            commit(types.SET_BILLING_ADDRESS, result.billing.billing_address);
            commit(types.SET_BILLING, result.billing);
          }
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  saveProfile: function saveProfile(_ref12, profile) {
    var commit = _ref12.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.put({
        url: '/user/info',
        data: profile,
        success: function success(result) {
          return resolve(result);
        },
        error: function error(result) {
          return reject(result);
        }
      });
    });
  },
  getPermSchema: function getPermSchema(_ref13) {
    var commit = _ref13.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/perms/schema',
        success: function success(result) {
          commit(types.SET_PERM_CATEGORIES, result);
          return resolve();
        },
        error: function error(result) {
          return reject(result);
        }
      });
    });
  },
  updatePasswordWordList: function updatePasswordWordList(_ref14) {
    var commit = _ref14.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/passgen/15',
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          commit(types.SET_PASSWORD_WORDLIST, result['words']);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  setDarkTheme: function setDarkTheme(_ref15) {
    var commit = _ref15.commit;
    var setLocalStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return new _promise2.default(function (resolve, reject) {
      (0, _jquery2.default)("body").addClass("darkMode").removeClass("liteMode");
      if (setLocalStorage) {
        localStorage.setItem('xm-theme', 'dark');
      }
      commit(types.HAS_DARK_THEME, true);
    });
  },
  setLightTheme: function setLightTheme(_ref16) {
    var commit = _ref16.commit;
    var setLocalStorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return new _promise2.default(function (resolve, reject) {
      (0, _jquery2.default)("body").removeClass("darkMode").addClass("liteMode");
      if (setLocalStorage) {
        localStorage.setItem('xm-theme', 'light');
      }
      commit(types.HAS_DARK_THEME, false);
    });
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  helpers: helpers
};

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(134);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function callLogger(level, args) {
  _store2.default.dispatch('logAction', { level: level, args: args }).then(function () {});
}

var logger = {
  debug: function debug() {
    callLogger('debug', arguments);
  },
  info: function info() {
    callLogger('info', arguments);
  },
  log: function log() {
    callLogger('info', arguments);
  },
  warn: function warn() {
    callLogger('warn', arguments);
  },
  error: function error() {
    callLogger('error', arguments);
  }
};

exports.default = logger;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery = __webpack_require__(110);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(551);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _index = __webpack_require__(344);

var _index2 = _interopRequireDefault(_index);

var _no_auth_routes = __webpack_require__(350);

var _no_auth_routes2 = _interopRequireDefault(_no_auth_routes);

var _index3 = __webpack_require__(134);

var _index4 = _interopRequireDefault(_index3);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiURL = '/manage/api/v1.0';

var refreshTokenURL = '/manage/api/v1.0/auth/refresh_token';

var accessTokenURL = '/manage/api/v1.0/auth/access_token';

var RETRY_LIMIT = 1;

var RETRY_DELAY = 800;

var FRESH_TOKEN_REQUIRED_TITLE = 'Fresh Access Token Required';

exports.default = {
  get: function get(options) {
    var self = this;
    options = this.setDefaultOptions(options);
    return _jquery2.default.ajax({
      method: 'GET',
      headers: {
        'X-CSRF-TOKEN': _jsCookie2.default.get('csrf_access_token')
      },
      tryCount: 0,
      url: self.urlHelper(options),
      async: options.async,
      success: function success(result, statusText) {
        self.reqSuccess(result, options);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        self.reqError(jqXHR, textStatus, errorThrown, options, this, self.get, options);
      }
    });
  },
  post: function post(options) {
    var self = this;
    options = this.setDefaultOptions(options);
    return _jquery2.default.ajax({
      method: 'POST',
      headers: {
        'X-CSRF-TOKEN': _jsCookie2.default.get('csrf_access_token'),
        'Content-Type': 'application/json'
      },
      tryCount: 0,
      url: self.urlHelper(options),
      contentType: 'application/json',
      data: (0, _stringify2.default)(options.data),
      async: options.async,
      success: function success(result, textStatus) {
        self.reqSuccess(result, options);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        self.reqError(jqXHR, textStatus, errorThrown, options, this, self.post, options);
      }
    });
  },
  put: function put(options) {
    var self = this;
    options = this.setDefaultOptions(options);
    return _jquery2.default.ajax({
      method: 'PUT',
      headers: {
        'X-CSRF-TOKEN': _jsCookie2.default.get('csrf_access_token'),
        'Content-Type': 'application/json'
      },
      url: self.urlHelper(options),
      tryCount: 0,
      contentType: 'application/json',
      data: (0, _stringify2.default)(options.data),
      dataType: 'json',
      async: options.async,
      success: function success(result, textStatus) {
        self.reqSuccess(result, options);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        self.reqError(jqXHR, textStatus, errorThrown, options, this, self.put, options);
      }
    });
  },
  patch: function patch(options) {
    var self = this;
    options = this.setDefaultOptions(options);
    return _jquery2.default.ajax({
      method: 'PATCH',
      headers: {
        'X-CSRF-TOKEN': _jsCookie2.default.get('csrf_access_token'),
        'Content-Type': 'application/json'
      },
      url: self.urlHelper(options),
      tryCount: 0,
      contentType: 'application/json',
      data: (0, _stringify2.default)(options.data),
      dataType: 'json',
      async: options.async,
      success: function success(result, textStatus) {
        self.reqSuccess(result, options);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        self.reqError(jqXHR, textStatus, errorThrown, options, this, self.put, options);
      }
    });
  },
  delete: function _delete(options) {
    var self = this;
    options = this.setDefaultOptions(options);

    return _jquery2.default.ajax({
      method: 'DELETE',
      headers: {
        'X-CSRF-TOKEN': _jsCookie2.default.get('csrf_access_token'),
        'Content-Type': 'application/json'
      },
      tryCount: 0,
      url: self.urlHelper(options),
      data: (0, _stringify2.default)(options.data),
      dataType: 'json',
      async: options.async,
      success: function success(result, textStatus) {
        self.reqSuccess(result, options);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        self.reqError(jqXHR, textStatus, errorThrown, options, this, self.delete, options);
      }
    });
  },
  setDefaultOptions: function setDefaultOptions(options) {
    if (!('modalNotifications' in options)) {
      options['modalNotifications'] = false;
    }
    if (!('notifications' in options)) {
      options['notifications'] = true;
    }
    if (!('async' in options)) {
      options['async'] = true;
    }
    return options;
  },
  addNotifications: function addNotifications(responseJSON, ajaxOptions) {
    if (typeof responseJSON === 'string') {
      try {
        responseJSON = JSON.parse(responseJSON);
      } catch (e) {
        return;
      }
    }
    if (ajaxOptions.notifications) {
      _index4.default.commit(types.ADD_NOTIFICATION_FROM_RESULT, responseJSON);
    }
    if (ajaxOptions.modalNotifications) {
      _index4.default.commit(types.ADD_MODAL_NOTIFICATION_FROM_RESULT, responseJSON);
    }
  },
  reqSuccess: function reqSuccess(result, ajaxOptions) {
    this.addNotifications(result, ajaxOptions);

    ajaxOptions.success(result);
  },
  reqError: function reqError(jqXHR, textStatus, errorThrown, ajaxOptions, ajaxRequest, httpMethod, httpOptions) {
    if (this.handleTimeout(jqXHR, textStatus, ajaxRequest)) {
      return;
    } else if (typeof jqXHR.responseJSON === 'undefined' && errorThrown !== 'abort') {
      this.unhandledException();
    } else if (jqXHR.status !== 401) {
      this.addNotifications(jqXHR.responseJSON, ajaxOptions);

      if ('error' in ajaxOptions) {
        ajaxOptions.error(jqXHR, textStatus, errorThrown);
      }
    } else if (jqXHR.responseJSON.title === FRESH_TOKEN_REQUIRED_TITLE) {
      this.promptRefreshAccessToken(httpMethod, httpOptions);
    } else {
      this.refreshToken(httpMethod, httpOptions);
    }
  },
  refreshToken: function refreshToken(ajaxCallback, options) {
    var _this = this;

    this.refreshTokenRequest().then(function (result) {
      var boundAjax = ajaxCallback.bind(_this);

      boundAjax(options);
    });
  },
  refreshTokenRequest: function refreshTokenRequest() {
    var _this2 = this;

    return new _promise2.default(function (resolve, reject) {
      _jquery2.default.ajax({
        context: _this2,
        type: 'POST',
        data: (0, _stringify2.default)({ store_in_cookies: true }),
        dataType: 'json',
        tryCount: 0,
        headers: {
          'X-CSRF-TOKEN': _jsCookie2.default.get('csrf_refresh_token'),
          'Content-Type': 'application/json'
        },
        url: refreshTokenURL,
        success: function success(result) {
          resolve(result);
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          if (this.handleTimeout(jqXHR, textStatus, this)) {
            return;
          } else if (jqXHR.status === 401) {
            _index4.default.commit(types.LOGGED_OUT);
            _index4.default.commit(types.SET_NOTICES, []);

            if (!_no_auth_routes2.default.includes(_index2.default.currentRoute.name)) {
              var redirect = sessionStorage.getItem('attemptingRoute');
              if (!redirect) {
                redirect = _index2.default.currentRoute.name;
              }
              sessionStorage.removeItem('attemptingRoute');
              _index2.default.push({ name: 'login', query: { timeout: 'true', redirect: redirect } });
            }
          } else {
            this.unhandledException();
          }
        }
      });
    });
  },
  promptRefreshAccessToken: function promptRefreshAccessToken(ajaxCallback, options) {
    _index4.default.commit(types.SAVE_AJAX_REQUEST, {
      ajaxCallback: ajaxCallback,
      ajaxOptions: options
    });

    _index4.default.commit(types.OPEN_REFRESH_PASSWORD);
  },
  refreshAccessToken: function refreshAccessToken(_ref) {
    var username = _ref.username,
        password = _ref.password;

    var self = this;
    return _jquery2.default.ajax({
      method: 'POST',
      context: this,
      headers: {
        'Content-Type': 'application/json'
      },
      tryCount: 0,
      url: accessTokenURL,
      contentType: 'application/json',
      data: (0, _stringify2.default)({
        username: username,
        password: password,
        store_in_cookies: true
      }),
      dataType: 'json',
      success: function success(result, textStatus) {
        var ajaxCallback = _index4.default.state.user.ajaxCallback;
        var options = _index4.default.state.user.ajaxOptions;

        var boundAjax = ajaxCallback.bind(this);

        boundAjax(options);

        _index4.default.commit(types.CLEAR_AJAX_REQUEST);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        var options = {
          test: 'test'
        };
        self.reqError(jqXHR, textStatus, errorThrown, options, this, self.post, options);
      }
    });
  },
  urlHelper: function urlHelper(options) {
    if (options.disableApiUrl) {
      return options.url;
    } else if (options.params) {
      return apiURL + options.url + '?' + _jquery2.default.param(options.params);
    } else {
      return apiURL + options.url;
    }
  },
  handleTimeout: function handleTimeout(jqXHR, textStatus, ajaxCallback) {
    if (textStatus === 'timeout' || 'responseText' in jqXHR && jqXHR.responseText.includes('Error occurred while trying to proxy to:')) {
      ajaxCallback.tryCount++;
      if (ajaxCallback.tryCount <= RETRY_LIMIT) {
        window.setTimeout(_jquery2.default.ajax, RETRY_DELAY, ajaxCallback);
      } else {
        this.addErrorNotification('Timed out when trying to contact server');
      }
      return true;
    } else {
      return false;
    }
  },
  unhandledException: function unhandledException() {
    this.addErrorNotification('An internal server error occurred during the last request');
  },
  addSuccessNotification: function addSuccessNotification(message) {
    _index4.default.commit(types.ADD_NOTIFICATION, {
      type: 'success',
      message: message
    });
  },
  addErrorNotification: function addErrorNotification(message) {
    _index4.default.commit(types.ADD_NOTIFICATION, {
      type: 'error',
      message: message
    });
  },
  addWarningNotification: function addWarningNotification(message) {
    _index4.default.commit(types.ADD_NOTIFICATION, {
      type: 'warning',
      message: message
    });
  },
  param: function param(url, obj) {
    return '' + url + (url.endsWith('?') ? '' : '?') + _jquery2.default.param(obj);
  }
};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  debounce: function debounce(fn, wait) {
    var timer = void 0;
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer) clearTimeout(timer);
      var context = this;
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  },
  pluralize: function pluralize(word) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';

    return count === 1 ? word : word + suffix;
  },
  scrolldown: function scrolldown() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var height = $(document).height();
    if (typeof name === 'string') {
      var element = document.getElementById(name);
      if (element) {
        height = window.scrollY + element.getBoundingClientRect().top - 132;
      } else {
        return;
      }
    }

    $("html, body").animate({ scrollTop: height }, 1000);
  },
  sleep: function sleep(time) {
    return new _promise2.default(function (resolve) {
      return setTimeout(resolve, time);
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)))

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1178)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1343),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a34481ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(809),
  /* template */
  __webpack_require__(1332),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-782e39f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1152)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1304),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08d88a60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1166)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1327),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1170)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1331),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-730e2312",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1177)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1342),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a0eadb9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 745:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 749:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 750:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 751:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1155)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1308),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16940fba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(800),
  /* template */
  __webpack_require__(1339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(796),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(811),
  /* template */
  __webpack_require__(1340),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9cdfb3cc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1316),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1158)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1314),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33c621d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(1318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(1303),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0741c2fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1179)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(807),
  /* template */
  __webpack_require__(1344),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a7c81e9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1160)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(1317),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37e609ed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1164)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(813),
  /* template */
  __webpack_require__(1324),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4ed3808a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(1346),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1305),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1326),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5718c664",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1176)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1341),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9f361638",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    'use strict';

    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

if ("document" in self) {
  if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {

    (function (view) {

      "use strict";

      if (!('Element' in view)) return;

      var classListProp = "classList",
          protoProp = "prototype",
          elemCtrProto = view.Element[protoProp],
          objCtr = Object,
          strTrim = String[protoProp].trim || function () {
        return this.replace(/^\s+|\s+$/g, "");
      },
          arrIndexOf = Array[protoProp].indexOf || function (item) {
        var i = 0,
            len = this.length;
        for (; i < len; i++) {
          if (i in this && this[i] === item) {
            return i;
          }
        }
        return -1;
      },
          DOMEx = function DOMEx(type, message) {
        this.name = type;
        this.code = DOMException[type];
        this.message = message;
      },
          checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
        if (token === "") {
          throw new DOMEx("SYNTAX_ERR", "An invalid or illegal string was specified");
        }
        if (/\s/.test(token)) {
          throw new DOMEx("INVALID_CHARACTER_ERR", "String contains an invalid character");
        }
        return arrIndexOf.call(classList, token);
      },
          ClassList = function ClassList(elem) {
        var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
            classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
            i = 0,
            len = classes.length;
        for (; i < len; i++) {
          this.push(classes[i]);
        }
        this._updateClassName = function () {
          elem.setAttribute("class", this.toString());
        };
      },
          classListProto = ClassList[protoProp] = [],
          classListGetter = function classListGetter() {
        return new ClassList(this);
      };

      DOMEx[protoProp] = Error[protoProp];
      classListProto.item = function (i) {
        return this[i] || null;
      };
      classListProto.contains = function (token) {
        token += "";
        return checkTokenAndGetIndex(this, token) !== -1;
      };
      classListProto.add = function () {
        var tokens = arguments,
            i = 0,
            l = tokens.length,
            token,
            updated = false;
        do {
          token = tokens[i] + "";
          if (checkTokenAndGetIndex(this, token) === -1) {
            this.push(token);
            updated = true;
          }
        } while (++i < l);

        if (updated) {
          this._updateClassName();
        }
      };
      classListProto.remove = function () {
        var tokens = arguments,
            i = 0,
            l = tokens.length,
            token,
            updated = false,
            index;
        do {
          token = tokens[i] + "";
          index = checkTokenAndGetIndex(this, token);
          while (index !== -1) {
            this.splice(index, 1);
            updated = true;
            index = checkTokenAndGetIndex(this, token);
          }
        } while (++i < l);

        if (updated) {
          this._updateClassName();
        }
      };
      classListProto.toggle = function (token, force) {
        token += "";

        var result = this.contains(token),
            method = result ? force !== true && "remove" : force !== false && "add";

        if (method) {
          this[method](token);
        }

        if (force === true || force === false) {
          return force;
        } else {
          return !result;
        }
      };
      classListProto.toString = function () {
        return this.join(" ");
      };

      if (objCtr.defineProperty) {
        var classListPropDesc = {
          get: classListGetter,
          enumerable: true,
          configurable: true
        };
        try {
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        } catch (ex) {
          if (ex.number === -0x7FF5EC54) {
            classListPropDesc.enumerable = false;
            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
          }
        }
      } else if (objCtr[protoProp].__defineGetter__) {
        elemCtrProto.__defineGetter__(classListProp, classListGetter);
      }
    })(self);
  } else {

    (function () {
      "use strict";

      var testElement = document.createElement("_");

      testElement.classList.add("c1", "c2");

      if (!testElement.classList.contains("c2")) {
        var createMethod = function createMethod(method) {
          var original = DOMTokenList.prototype[method];

          DOMTokenList.prototype[method] = function (token) {
            var i,
                len = arguments.length;

            for (i = 0; i < len; i++) {
              token = arguments[i];
              original.call(this, token);
            }
          };
        };
        createMethod('add');
        createMethod('remove');
      }

      testElement.classList.toggle("c3", false);

      if (testElement.classList.contains("c3")) {
        var _toggle = DOMTokenList.prototype.toggle;

        DOMTokenList.prototype.toggle = function (token, force) {
          if (1 in arguments && !this.contains(token) === !force) {
            return force;
          } else {
            return _toggle.call(this, token);
          }
        };
      }

      testElement = null;
    })();
  }
}

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJSON = getJSON;
exports.getScrollBarWidth = getScrollBarWidth;
exports.translations = translations;
exports.delayer = delayer;
exports.VueFixer = VueFixer;
var coerce = exports.coerce = {
  boolean: function boolean(val) {
    return typeof val === 'string' ? val === '' || val === 'true' ? true : val === 'false' || val === 'null' || val === 'undefined' ? false : val : val;
  },

  number: function number(val) {
    var alt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return typeof val === 'number' ? val : val === undefined || val === null || isNaN(Number(val)) ? alt : Number(val);
  },

  string: function string(val) {
    return val === undefined || val === null ? '' : val + '';
  },

  pattern: function pattern(val) {
    return val instanceof Function || val instanceof RegExp ? val : typeof val === 'string' ? new RegExp(val) : null;
  }
};

function getJSON(url) {
  var request = new window.XMLHttpRequest();
  var data = {};

  var p = {
    then: function then(fn1, fn2) {
      return p.done(fn1).fail(fn2);
    },
    catch: function _catch(fn) {
      return p.fail(fn);
    },
    always: function always(fn) {
      return p.done(fn).fail(fn);
    }
  };
  ['done', 'fail'].forEach(function (name) {
    data[name] = [];
    p[name] = function (fn) {
      if (fn instanceof Function) data[name].push(fn);
      return p;
    };
  });
  p.done(JSON.parse);
  request.onreadystatechange = function () {
    if (request.readyState === 4) {
      var e = { status: request.status };
      if (request.status === 200) {
        try {
          var response = request.responseText;
          for (var i in data.done) {
            var value = data.done[i](response);
            if (value !== undefined) {
              response = value;
            }
          }
        } catch (err) {
          data.fail.forEach(function (fail) {
            return fail(err);
          });
        }
      } else {
        data.fail.forEach(function (fail) {
          return fail(e);
        });
      }
    }
  };
  request.open('GET', url);
  request.setRequestHeader('Accept', 'application/json');
  request.send();
  return p;
}

function getScrollBarWidth() {
  if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) {
    return 0;
  }
  var inner = document.createElement('p');
  inner.style.width = '100%';
  inner.style.height = '200px';

  var outer = document.createElement('div');
  outer.style.position = 'absolute';
  outer.style.top = '0px';
  outer.style.left = '0px';
  outer.style.visibility = 'hidden';
  outer.style.width = '200px';
  outer.style.height = '150px';
  outer.style.overflow = 'hidden';
  outer.appendChild(inner);

  document.body.appendChild(outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 === w2) w2 = outer.clientWidth;

  document.body.removeChild(outer);

  return w1 - w2;
}

function translations() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  var text = {
    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    limit: 'Limit reached ({{limit}} items max).',
    loading: 'Loading...',
    minLength: 'Min. Length',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    notSelected: 'Nothing Selected',
    required: 'Required',
    search: 'Search',
    selected: '{{count}} selected'
  };
  return window.VueStrapLang ? window.VueStrapLang(lang) : text;
}

function delayer(fn, varTimer) {
  var ifNaN = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

  function toInt(el) {
    return (/^[0-9]+$/.test(el) ? Number(el) || 1 : null
    );
  }
  var timerId;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timerId) clearTimeout(timerId);
    timerId = setTimeout(function () {
      fn.apply(_this, args);
    }, toInt(varTimer) || toInt(this[varTimer]) || ifNaN);
  };
}

function VueFixer(vue) {
  var vue2 = !window.Vue || !window.Vue.partial;
  var mixin = {
    computed: {
      vue2: function vue2() {
        return !this.$dispatch;
      }
    }
  };
  if (!vue2) {
    if (vue.beforeCreate) {
      mixin.create = vue.beforeCreate;
      delete vue.beforeCreate;
    }
    if (vue.beforeMount) {
      vue.beforeCompile = vue.beforeMount;
      delete vue.beforeMount;
    }
    if (vue.mounted) {
      vue.ready = vue.mounted;
      delete vue.mounted;
    }
  } else {
    if (vue.beforeCompile) {
      vue.beforeMount = vue.beforeCompile;
      delete vue.beforeCompile;
    }
    if (vue.compiled) {
      mixin.compiled = vue.compiled;
      delete vue.compiled;
    }
    if (vue.ready) {
      vue.mounted = vue.ready;
      delete vue.ready;
    }
  }
  if (!vue.mixins) {
    vue.mixins = [];
  }
  vue.mixins.unshift(mixin);
  return vue;
}

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(136);

var _createClass3 = _interopRequireDefault(_createClass2);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _store = __webpack_require__(134);

var _store2 = _interopRequireDefault(_store);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderSummary = function () {
  function ServiceOrderSummary(service) {
    (0, _classCallCheck3.default)(this, ServiceOrderSummary);

    this.monthly = 'monthly';
    this.service = service;
    this.service_class_name = service.service_class_model.name;
  }

  (0, _createClass3.default)(ServiceOrderSummary, [{
    key: '_sum',
    value: function _sum(array) {
      var total = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          total += Number(item);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return total;
    }
  }, {
    key: 'getMonthlyRate',
    value: function getMonthlyRate(billing_item) {
      return billing_item.rate_period === this.monthly ? billing_item.rate : 0.;
    }
  }, {
    key: 'serviceOptionMonthlyXMissionFeesTotal',
    value: function serviceOptionMonthlyXMissionFeesTotal(service_option) {
      var _this = this;

      var fees = service_option.billing.fees.filter(function (x) {
        return x.provider.name === 'xmission';
      });
      return this._sum(fees.map(function (x) {
        return _this.getMonthlyRate(x);
      }));
    }
  }, {
    key: 'serviceMonthlyXMissionFeesTotal',
    value: function serviceMonthlyXMissionFeesTotal() {
      var _this2 = this;

      var fees = this.service.billing.fees.filter(function (x) {
        return x.provider.name === 'xmission';
      });
      return this._sum(fees.map(function (x) {
        return _this2.getMonthlyRate(x);
      }));
    }
  }, {
    key: 'serviceOptionMonthlyXMissionPricesTotal',
    value: function serviceOptionMonthlyXMissionPricesTotal(service_option) {
      var _this3 = this;

      var prices = service_option.billing.prices.filter(function (x) {
        return x.provider.name === 'xmission';
      });
      return this._sum(prices.map(function (x) {
        return _this3.getMonthlyRate(x);
      }));
    }
  }, {
    key: 'serviceMonthlyXMissionPricesTotal',
    value: function serviceMonthlyXMissionPricesTotal() {
      var _this4 = this;

      var prices = this.service.billing.prices.filter(function (x) {
        return x.provider.name === 'xmission';
      });
      return this._sum(prices.map(function (x) {
        return _this4.getMonthlyRate(x);
      }));
    }
  }, {
    key: 'serviceOptionMonthlyPromosTotal',
    value: function serviceOptionMonthlyPromosTotal(service_option) {
      var _this5 = this;

      return this._sum(service_option.billing.promos.map(function (x) {
        return _this5.getMonthlyRate(x);
      }));
    }
  }, {
    key: 'grossServiceOptionXMissionMonthlyCost',
    value: function grossServiceOptionXMissionMonthlyCost(service_option) {
      return this.serviceOptionMonthlyXMissionFeesTotal(service_option) + this.serviceOptionMonthlyXMissionPricesTotal(service_option);
    }
  }, {
    key: 'grossServiceXMissionMonthlyCost',
    value: function grossServiceXMissionMonthlyCost() {
      return this.serviceMonthlyXMissionFeesTotal() + this.serviceMonthlyXMissionPricesTotal();
    }
  }, {
    key: 'grossCostsPerProvider',
    value: function grossCostsPerProvider(service_option) {
      var costs_by_provider = {};
      var items = this.service.billing.prices.concat(this.service.billing.fees).concat(service_option.billing.prices).concat(service_option.billing.fees);
      _logger2.default.debug('items: ', items);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (!(item.provider.name in costs_by_provider)) {
            costs_by_provider[item.provider.name] = { cost: 0, provider: item.provider };
          }
          costs_by_provider[item.provider.name].cost += item.rate;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return costs_by_provider;
    }
  }, {
    key: 'emptyCart',
    value: function emptyCart() {
      _store2.default.commit(types.EMPTY_CART);
    }
  }, {
    key: '_getBillableItemDetails',
    value: function _getBillableItemDetails(item) {
      return (0, _extends3.default)({}, item, { service_class: this.service_class_name });
    }
  }, {
    key: 'addToCart',
    value: function addToCart(item) {
      _store2.default.commit(types.ADD_TO_CART, this._getBillableItemDetails(item));
    }
  }, {
    key: '_addBillingItemsToContainer',
    value: function _addBillingItemsToContainer(billing_items, adder) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(billing_items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var billing_item = _step3.value;

          adder(billing_item);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'addServiceToCart',
    value: function addServiceToCart() {
      var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (fresh) {
        this.emptyCart();
      }
      this._addBillingItemsToContainer(this.service.billing.prices, this.addToCart.bind(this));
      this._addBillingItemsToContainer(this.service.billing.fees, this.addToCart.bind(this));
      this._addBillingItemsToContainer(this.service.billing.promos, this.addToCart.bind(this));
      _store2.default.commit(types.CALCULATE_CART);
    }
  }, {
    key: 'addServiceOptionToCart',
    value: function addServiceOptionToCart(service_option) {
      this._addBillingItemsToContainer(service_option.billing.prices, this.addToCart.bind(this));
      this._addBillingItemsToContainer(service_option.billing.fees, this.addToCart.bind(this));
      this._addBillingItemsToContainer(service_option.billing.promos, this.addToCart.bind(this));
      _store2.default.commit(types.CALCULATE_CART);
    }
  }, {
    key: 'removeServiceFromCart',
    value: function removeServiceFromCart() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = (0, _getIterator3.default)(this.service.billing.prices.concat(this.service.billing.fees).concat(this.service.billing.promos)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          _store2.default.commit(types.REMOVE_FROM_CART, item.item_type);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      _store2.default.commit(types.CALCULATE_CART);
    }
  }, {
    key: 'removeServiceOptionFromCart',
    value: function removeServiceOptionFromCart(service_option) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = (0, _getIterator3.default)(service_option.billing.prices.concat(service_option.billing.fees).concat(service_option.billing.promos)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          _store2.default.commit(types.REMOVE_FROM_CART, item.item_type);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      _store2.default.commit(types.CALCULATE_CART);
    }
  }]);
  return ServiceOrderSummary;
}();

exports.default = ServiceOrderSummary;

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(153);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(155);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(154);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service = __webpack_require__(152);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticIPService = function (_Service) {
  (0, _inherits3.default)(StaticIPService, _Service);

  function StaticIPService(service) {
    (0, _classCallCheck3.default)(this, StaticIPService);
    return (0, _possibleConstructorReturn3.default)(this, (StaticIPService.__proto__ || (0, _getPrototypeOf2.default)(StaticIPService)).call(this, service));
  }

  return StaticIPService;
}(_service2.default);

exports.default = StaticIPService;

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(153);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(92);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(155);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(154);

var _inherits3 = _interopRequireDefault(_inherits2);

var _service = __webpack_require__(152);

var _service2 = _interopRequireDefault(_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubnetService = function (_Service) {
  (0, _inherits3.default)(SubnetService, _Service);

  function SubnetService(service) {
    (0, _classCallCheck3.default)(this, SubnetService);
    return (0, _possibleConstructorReturn3.default)(this, (SubnetService.__proto__ || (0, _getPrototypeOf2.default)(SubnetService)).call(this, service));
  }

  return SubnetService;
}(_service2.default);

exports.default = SubnetService;

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(226);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var states = [{ "title": "Alaska", "abbr": "AK" }, { "title": "Alabama", "abbr": "AL" }, { "title": "Arkansas", "abbr": "AR" }, { "title": "American Samoa", "abbr": "AS" }, { "title": "Arizona", "abbr": "AZ" }, { "title": "California", "abbr": "CA" }, { "title": "Colorado", "abbr": "CO" }, { "title": "Connecticut", "abbr": "CT" }, { "title": "District of Colombia", "abbr": "DC" }, { "title": "Delaware", "abbr": "DE" }, { "title": "Florida", "abbr": "FL" }, { "title": "Georgia", "abbr": "GA" }, { "title": "Guam", "abbr": "GU" }, { "title": "Hawaii", "abbr": "HI" }, { "title": "Iowa", "abbr": "IA" }, { "title": "Idaho", "abbr": "ID" }, { "title": "Illinois", "abbr": "IL" }, { "title": "Indiana", "abbr": "IN" }, { "title": "Kansas", "abbr": "KS" }, { "title": "Kentucky", "abbr": "KY" }, { "title": "Louisiana", "abbr": "LA" }, { "title": "Massachusetts", "abbr": "MA" }, { "title": "Maryland", "abbr": "MD" }, { "title": "Maine", "abbr": "ME" }, { "title": "Michigan", "abbr": "MI" }, { "title": "Minnesota", "abbr": "MN" }, { "title": "Missouri", "abbr": "MO" }, { "title": "Northern Mariana Islands", "abbr": "MP" }, { "title": "Mississippi", "abbr": "MS" }, { "title": "Montana", "abbr": "MT" }, { "title": "North Carolina", "abbr": "NC" }, { "title": "North Dakota", "abbr": "ND" }, { "title": "Nebraska", "abbr": "NE" }, { "title": "New Hampshire", "abbr": "NH" }, { "title": "New Jersey", "abbr": "NJ" }, { "title": "New Mexico", "abbr": "NM" }, { "title": "Nevada", "abbr": "NV" }, { "title": "New York", "abbr": "NY" }, { "title": "Ohio", "abbr": "OH" }, { "title": "Oklahoma", "abbr": "OK" }, { "title": "Oregon", "abbr": "OR" }, { "title": "Pennsylvania", "abbr": "PA" }, { "title": "Puerto Rico", "abbr": "PR" }, { "title": "Rhode Island", "abbr": "RI" }, { "title": "South Carolina", "abbr": "SC" }, { "title": "South Dakota", "abbr": "SD" }, { "title": "Tennessee", "abbr": "TN" }, { "title": "Trust Territories", "abbr": "TT" }, { "title": "Texas", "abbr": "TX" }, { "title": "Utah", "abbr": "UT" }, { "title": "Virginia", "abbr": "VA" }, { "title": "Virgin Islands", "abbr": "VI" }, { "title": "Vermont", "abbr": "VT" }, { "title": "Washington", "abbr": "WA" }, { "title": "Wisconsin", "abbr": "WI" }, { "title": "West Virginia", "abbr": "WV" }, { "title": "Wyoming", "abbr": "WY" }];
var abbrs = [];
var titles = [];
var lowers = [];

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = (0, _getIterator3.default)(states), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var s = _step.value;

    s.lower = s.title.toLowerCase();
    abbrs.push(s.abbr);
    titles.push(s.title);
    lowers.push(s.lower);
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

function search(term, attr) {
  attr = attr ? attr : 'lower';
  if (attr === 'lower') {
    term = term.toLowerCase();
  }
  var ret = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(states), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var s = _step2.value;

      if (s[attr].startsWith(term)) {
        ret = [s].concat((0, _toConsumableArray3.default)(ret));
      } else if (s[attr].includes(term)) {
        ret = [].concat((0, _toConsumableArray3.default)(ret), [s]);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return ret;
}

exports.default = {
  states: states,
  abbrs: abbrs,
  titles: titles,
  lowers: lowers,
  search: search
};

/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regex = __webpack_require__(112);

var _regex2 = _interopRequireDefault(_regex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  username: function username(uid) {
    var suggestion = '';
    if (!uid.charAt(0).match(/[a-z]/)) {
      suggestion = 'Usernames must begin with a lowercase letter';
    } else if (uid.length < 3) {
      suggestion = 'Usernames must be at least 3 characters long';
    } else if (uid.length > 48) {
      suggestion = 'Usernames cannot be longer than 48 characters';
    } else if (!uid.match(_regex2.default.uid)) {
      suggestion = 'Usernames can only contain lowercase letters, numbers, dashes, and underscores';
    }
    return { valid: typeof uid === 'string' && uid.length > 0 && _regex2.default.uid.test(uid),
      suggestion: suggestion, regex: _regex2.default.uid };
  }
};

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(743);

__webpack_require__(744);

__webpack_require__(746);

__webpack_require__(745);

__webpack_require__(748);

__webpack_require__(752);

__webpack_require__(751);

__webpack_require__(749);

__webpack_require__(750);

__webpack_require__(747);

var _vue = __webpack_require__(111);

var _vue2 = _interopRequireDefault(_vue);

var _vuexRouterSync = __webpack_require__(754);

var _index = __webpack_require__(134);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(344);

var _index4 = _interopRequireDefault(_index3);

var _App = __webpack_require__(753);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _vuexRouterSync.sync)(_index2.default, _index4.default);

new _vue2.default({
  el: '#app',
  router: _index4.default,
  store: _index2.default,
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _dates = __webpack_require__(224);

var _dates2 = _interopRequireDefault(_dates);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  amount_due: 0.00,
  balance: 0.00,
  due_date: '',
  payment_amount: 0.00,
  overdue: false,
  payment_type: '',
  card_type: '',
  default_payment_account_id: '',
  temp_payment_id: '',
  paya_url: '',
  payment_accounts: [],

  bills: [],
  billing_page: 0,
  payments: [],
  domains_payment: [],
  payment_processing: false,
  automatic: false,
  billing_address: { line1: '', line2: '', city: '', state: '', zip_code: '', fname: '', lname: '', mnami: '', formatted_address: '' }
};

var getters = {
  payment_type_opposite: function payment_type_opposite(state) {
    var temp = state.payment_type.toLowerCase() === 'manual' ? 'automatic' : 'manual';
    return temp.toUpperCase();
  },
  formatted_payment_type: function formatted_payment_type(state) {
    return state.payment_type.toUpperCase();
  },
  formatted_opposite_payment_type: function formatted_opposite_payment_type(state) {
    if (state.payment_type.toUpperCase() === 'MANUAL') {
      return 'AUTOMATIC';
    } else {
      return 'MANUAL';
    }
  },
  formatted_due_date: function formatted_due_date(state) {
    return _dates2.default.dateFormat(state.due_date);
  },
  formatted_amount_due: function formatted_amount_due(state) {
    return parseFloat(state.amount_due).toFixed(2);
  },
  formatted_balance: function formatted_balance(state) {
    return parseFloat(state.balance).toFixed(2);
  },
  has_payment_accounts: function has_payment_accounts(state) {
    return state.payment_accounts.length !== 0;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_BILLING, function (state, _ref) {
  var amount_due = _ref.amount_due,
      balance = _ref.balance,
      due_date = _ref.due_date,
      overdue = _ref.overdue,
      automatic = _ref.automatic,
      default_payment_account_id = _ref.default_payment_account_id;

  state.amount_due = amount_due;
  state.balance = balance;
  state.payment_amount = amount_due;
  state.due_date = due_date;
  state.overdue = overdue;
  state.automatic = automatic;
  if (automatic) {
    state.payment_type = 'AUTOMATIC';
  } else {
    state.payment_type = 'MANUAL';
  }
  state.default_payment_account_id = default_payment_account_id;
  if (!state.temp_payment_id) {
    state.temp_payment_id = default_payment_account_id;
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_TEMP_PAYMENT_ID, function (state, result) {
  state.temp_payment_id = result;
}), (0, _defineProperty3.default)(_mutations, types.SET_PAYMENT_ACCOUNTS, function (state, _ref2) {
  var records = _ref2.records;

  records.sort(function (a, b) {
    if (a.payment_account_id === state.default_payment_account_id) {
      return -1;
    } else if (b.payment_account_id === state.default_payment_account_id) {
      return 1;
    } else if (!a.is_bank_account && !b.is_bank_account) {
      return a.credit_card.expiration_date.localeCompare(b.credit_card.expiration_date);
    } else if (a.is_bank_account && b.is_bank_account) {
      return a.bank_account.bank_name.localeCompare(b.bank_account.bank_name);
    } else if (a.is_bank_account && !b.is_bank_account) {
      return 1;
    } else {
      return -1;
    }
  });
  state.payment_accounts = records;
  if (state.payment_accounts.length === 1) {
    state.temp_payment_id = state.payment_accounts[0].payment_account_id;
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_PAYA_URL, function (state, url) {
  state.paya_url = url;
}), (0, _defineProperty3.default)(_mutations, types.SET_AMOUNT_DUE, function (state, amountDue) {
  state.amount_due = amountDue;
}), (0, _defineProperty3.default)(_mutations, types.SET_DUE_DATE, function (state, dueDate) {
  state.due_date = dueDate;
}), (0, _defineProperty3.default)(_mutations, types.SET_OVERDUE, function (state, overdue) {
  state.overdue = overdue;
}), (0, _defineProperty3.default)(_mutations, types.SET_BILLS, function (state, _ref3) {
  var records = _ref3.records;

  state.bills = records;
}), (0, _defineProperty3.default)(_mutations, types.SET_BILL_PAGE, function (state, page) {
  state.billing_page = page;
}), (0, _defineProperty3.default)(_mutations, types.SET_PAYMENTS, function (state, _ref4) {
  var records = _ref4.records;

  state.payments = records;
}), (0, _defineProperty3.default)(_mutations, types.START_PAYMENT_REQUEST, function (state) {
  state.payment_processing = true;
}), (0, _defineProperty3.default)(_mutations, types.END_PAYMENT_REQUEST, function (state) {
  state.payment_processing = false;
}), (0, _defineProperty3.default)(_mutations, types.SET_BILLING_ADDRESS, function (state, address) {
  state.billing_address = address;
}), _mutations);

var actions = {
  getPaymentAccounts: function getPaymentAccounts(_ref5, params) {
    var commit = _ref5.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/billing/payment_accounts',
        success: function success(result) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(result.records), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var record = _step.value;

              record.is_bank_account = record.method === 'ACH' ? true : false;
              if (!record.is_bank_account) {
                record.credit_card.exp_mm_yy = _dates2.default.iso_date_to_card_exp(record.credit_card.expiration_date, 2);
                record.credit_card.exp_mm_yyyy = _dates2.default.iso_date_to_card_exp(record.credit_card.expiration_date, 4);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          commit(types.SET_PAYMENT_ACCOUNTS, result);
          resolve();
        }
      });
    });
  },
  getPayaUrl: function getPayaUrl(_ref6, account_name) {
    var commit = _ref6.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/billing/payment_account_url',
        params: { 'account_name': account_name },
        success: function success(result) {
          commit(types.SET_PAYA_URL, result.url);
          _logger2.default.debug('paya url result', result);
        }
      });
    });
  },
  addCard: function addCard(_ref7, cardDetails) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        notifications: false,
        modalNotifications: true,
        url: '/billing/payment_accounts/card',
        data: cardDetails,
        success: function success(result) {
          dispatch('getPaymentAccounts').then(function (response) {
            dispatch('getInfo');
          });
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  addACH: function addACH(_ref8, bankDetails) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        notifications: false,
        modalNotifications: true,
        url: '/billing/payment_accounts/ach',
        data: bankDetails,
        success: function success(result) {
          dispatch('getPaymentAccounts').then(function (response) {
            dispatch('getInfo');
          });
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  alterPaymentAccount: function alterPaymentAccount(_ref9, input) {
    var dispatch = _ref9.dispatch,
        commit = _ref9.commit;

    var payment_account_id = input.payment_account_id;
    delete input.payment_account_id;
    var notifications = true;
    var modalNotifications = false;
    if ('notifications' in input) {
      notifications = input.notifications;
      delete input.notifications;
    }
    if ('modalNotifications' in input) {
      modalNotifications = input.modalNotifications;
      delete input.modalNotifications;
    }
    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.put({
        url: '/billing/payment_accounts/' + payment_account_id,
        data: input,
        notifications: notifications,
        modalNotifications: modalNotifications,
        success: function success(result) {
          commit(types.SET_TEMP_PAYMENT_ID, '');
          dispatch('getInfo');
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  removePaymentAccount: function removePaymentAccount(_ref10, input) {
    var dispatch = _ref10.dispatch;

    var notifications = true;
    var modalNotifications = false;
    if ('notifications' in input) {
      notifications = input.notifications;
    }
    if ('modalNotifications' in input) {
      modalNotifications = input.modalNotifications;
    }
    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/billing/payment_accounts/' + input.payment_account_id,
        notifications: notifications,
        modalNotifications: modalNotifications,
        success: function success(result) {
          dispatch('getPaymentAccounts').then(function (response) {
            dispatch('getInfo');
          });
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getPayments: function getPayments(_ref11, _ref12) {
    var commit = _ref11.commit;
    var page = _ref12.page,
        limit = _ref12.limit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/billing/payments', success: function success(result) {
          if (result.length === 0) {
            reject();
            return;
          }
          commit(types.SET_PAYMENTS, result);
          resolve();
        }
      });
    });
  },
  makePayment: function makePayment(_ref13, paymentAmount) {
    var getters = _ref13.getters,
        commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    var data = {
      amount: parseFloat(paymentAmount),
      payment_account_id: state.temp_payment_id
    };
    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/billing/payments',
        data: data,
        success: function success(result) {
          commit(types.END_PAYMENT_REQUEST);
          resolve();
        },
        error: function error(result) {
          commit(types.END_PAYMENT_REQUEST);
          reject(result);
        }
      });
    });
  },
  getBills: function getBills(_ref14, _ref15) {
    var commit = _ref14.commit;
    var page = _ref15.page,
        limit = _ref15.limit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/billing/bills', success: function success(result) {
          if (result.length === 0) {
            reject();
            return;
          }
          commit(types.SET_BILLS, result);
          resolve();
        }
      });
    });
  },
  updateBillingAddress: function updateBillingAddress(_ref16, address) {
    var dispatch = _ref16.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/billing/address',
        data: address,
        notifications: true,
        modalNotifications: false,
        success: function success(result) {
          dispatch('getInfo');
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _set = __webpack_require__(848);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(226);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(135);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  items: [],
  full_cart: [],
  provider_order: null,
  service_class_order: null,
  billable_rate_type_order: null
};

var helpers = {
  monthly: 'monthly',
  rate_total: function rate_total(rate_period, xmission_only, rate_deferred) {
    var rate_terms = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ['all'];

    var items = state.items;
    if (rate_period !== null) {
      items = state.items.filter(function (x) {
        return x.rate_period === rate_period;
      });
    }
    if (!rate_terms.includes('all')) {
      items = items.filter(function (x) {
        return rate_terms.includes(x.rate_term);
      });
    }

    items = xmission_only ? items.filter(function (x) {
      return x.provider.name === 'xmission';
    }) : items;

    if (rate_deferred !== null) {
      items = items.filter(function (x) {
        return x.rate_deferred === rate_deferred;
      });
    }

    var item_groups = {};
    var total_has_taxes = false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (item.taxable) {
          total_has_taxes = true;
        }
        if (!(item.item_group in item_groups)) {
          item_groups[item.item_group] = [];
        }
        item_groups[item.item_group].push(item);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var total = 0.;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)((0, _keys2.default)(item_groups)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var item_group = _step2.value;

        var group_total = item_groups[item_group].reduce(function (partialSum, item) {
          return partialSum + Number(item.rate * item.quantity) * (item.rate_type === 'promo' ? -1 : 1);
        }, 0);

        group_total = Math.max(group_total, 0);
        total += group_total;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return { 'total': total, 'taxed': total_has_taxes };
  },
  all_providers: function all_providers() {
    var providers = [].concat((0, _toConsumableArray3.default)(new _set2.default(state.items.map(function (x) {
      return x.provider.name;
    })))).sort();
    _logger2.default.debug('providers', providers);
    if (providers.includes('xmission')) {
      providers = ['xmission'].concat(providers.filter(function (x) {
        return x !== 'xmission';
      }));
    }
    _logger2.default.debug('providers after reorder', providers);
    return providers;
  },
  all_service_classes: function all_service_classes() {
    return [].concat((0, _toConsumableArray3.default)(new _set2.default(state.items.map(function (x) {
      return x.service_class;
    })))).sort();
  },
  sort_by_index: function sort_by_index(item_a, item_b, order, key) {
    return order.indexOf(item_a[key]) - order.indexOf(item_b[key]);
  },
  sort_billable_items: function sort_billable_items(item_a, item_b, provider_order, service_class_order, billable_rate_type_order) {
    var provider_sort = helpers.sort_by_index(item_a.provider, item_b.provider, provider_order, 'name');
    if (provider_sort !== 0) {
      return provider_sort;
    }

    var service_class_sort = helpers.sort_by_index(item_a, item_b, service_class_order, 'service_class');
    if (service_class_sort !== 0) {
      return service_class_sort;
    }

    var billable_rate_type_sort = helpers.sort_by_index(item_a, item_b, billable_rate_type_order, 'rate_type');
    if (billable_rate_type_sort !== 0) {
      return billable_rate_type_sort;
    }

    return item_a.description.localeCompare(item_b.description);
  },
  getCleanCart: function getCleanCart(item_type) {
    var item_names_to_remove = [];
    var item_name_map = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(state.items), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var billable_item = _step3.value;

        item_name_map[billable_item.name] = billable_item;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    function findRootItemType(item, height) {
      if (item.item_type === item_type) {
        item_names_to_remove.push(item.name);
      }
      if (item.related_item === '') {
        return { has_root_item_type: item.item_type === item_type, height: height };
      }
      if (height > 10) {
        _logger2.default.error('circular reference detected', item);
        return { has_root_item_type: item.item_type === item_type, height: height };
      }
      var root_item_type = findRootItemType(item_name_map[item.related_item], height + 1);
      if (root_item_type.has_root_item_type) {
        item_names_to_remove.push(item.name);
      }
      return { has_root_item_type: root_item_type.has_root_item_type, height: root_item_type.height + 1 };
    }

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = (0, _getIterator3.default)(state.items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var item = _step4.value;

        findRootItemType(item, 0);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return state.items.filter(function (x) {
      return !item_names_to_remove.includes(x.name);
    });
  },
  getFullCart: function getFullCart(state) {
    var all_billable_items = state.items;
    var item_name_map = {};
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = (0, _getIterator3.default)(all_billable_items), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var billable_item = _step5.value;

        item_name_map[billable_item.name] = billable_item;
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    var related_items = all_billable_items.filter(function (x) {
      return x.related_item !== '';
    });
    var unrelated_items = all_billable_items.filter(function (x) {
      return x.related_item === '';
    });

    var provider_order = state.provider_order !== null ? state.provider_order : helpers.all_providers();
    var service_class_order = state.service_class_order !== null ? state.service_class_order : helpers.all_service_classes();
    var billable_rate_type_order = state.billable_rate_type_order !== null ? state.billable_rate_type_order : ['price', 'promo', 'fee'];

    unrelated_items = unrelated_items.sort(function (a, b) {
      return helpers.sort_billable_items(a, b, provider_order, service_class_order, billable_rate_type_order);
    });

    function findDistanceToRootItem(item, height) {
      if (item.related_item === '') {
        return 0;
      }
      if (height > 10) {
        _logger2.default.error('circular reference detected', item);
        return 0;
      }
      return 1 + findDistanceToRootItem(item_name_map[item.related_item], height + 1);
    }

    var distance_map = {};
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = (0, _getIterator3.default)(related_items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var related_item = _step6.value;

        var item_distance = String(findDistanceToRootItem(related_item, 0));
        _logger2.default.debug('item distance', item_distance, related_item);
        if (!(item_distance in distance_map)) {
          distance_map[item_distance] = [];
        }
        distance_map[item_distance].push(related_item);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = (0, _getIterator3.default)((0, _keys2.default)(distance_map).sort(function (a, b) {
        return Number(a) - Number(b);
      })), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var distance = _step7.value;
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          var _loop = function _loop() {
            var related_item = _step8.value;

            var inject_ndx = unrelated_items.findIndex(function (x) {
              return x.name === related_item.related_item;
            });
            _logger2.default.debug('inject_ndx', inject_ndx, related_item);

            unrelated_items.splice(inject_ndx + 1, 0, related_item);
          };

          for (var _iterator8 = (0, _getIterator3.default)(distance_map[distance]), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    _logger2.default.debug('all billable items', all_billable_items);
    _logger2.default.debug('full cart', unrelated_items);
    return unrelated_items;
  }
};

var getters = {
  getFullCart: function getFullCart() {
    return state.full_cart;
  },
  oneTimeXmissionTotalDueNow: function oneTimeXmissionTotalDueNow() {
    return helpers.rate_total(null, true, false);
  },
  oneTimeXmissionTotalDueLater: function oneTimeXmissionTotalDueLater() {
    return helpers.rate_total(null, true, true);
  },
  monthlyXmissionTotals: function monthlyXmissionTotals() {
    var rate_terms = [].concat((0, _toConsumableArray3.default)(new _set2.default(state.items.map(function (x) {
      return x.rate_term;
    })))).sort();
    var totals = [];
    for (var i = 0; i < rate_terms.length; i++) {
      var total_details = helpers.rate_total(null, true, null, rate_terms.slice(i, rate_terms.length));
      totals.push({ rate_term: rate_terms[i], total: total_details['total'], taxed: total_details['taxed'] });
    }
    return totals;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.ADD_TO_CART, function (state, _ref) {
  var name = _ref.name,
      description = _ref.description,
      item_type = _ref.item_type,
      item_group = _ref.item_group,
      provider = _ref.provider,
      rate = _ref.rate,
      rate_type = _ref.rate_type,
      rate_period = _ref.rate_period,
      rate_term = _ref.rate_term,
      rate_mode = _ref.rate_mode,
      rate_min = _ref.rate_min,
      rate_max = _ref.rate_max,
      rate_deferred = _ref.rate_deferred,
      quantity = _ref.quantity,
      related_item = _ref.related_item,
      service_class = _ref.service_class,
      taxable = _ref.taxable;

  state.items = helpers.getCleanCart(item_type);

  state.items.push({
    name: name, description: description, item_type: item_type, item_group: item_group, provider: provider,
    rate: rate, rate_type: rate_type, rate_period: rate_period, rate_term: rate_term, rate_mode: rate_mode, rate_min: rate_min, rate_max: rate_max,
    rate_deferred: rate_deferred, quantity: quantity, related_item: related_item, service_class: service_class, taxable: taxable });
}), (0, _defineProperty3.default)(_mutations, types.REMOVE_FROM_CART, function (state, item_type) {
  state.items = helpers.getCleanCart(item_type);
}), (0, _defineProperty3.default)(_mutations, types.CALCULATE_CART, function (state) {
  state.full_cart = helpers.getFullCart(state);
}), (0, _defineProperty3.default)(_mutations, types.EMPTY_CART, function (state) {
  state.items = [];
}), (0, _defineProperty3.default)(_mutations, types.SET_PROVIDER_ORDER, function (state, provider_order) {
  state.provider_order = provider_order;
}), (0, _defineProperty3.default)(_mutations, types.SET_SERVICE_CLASS_ORDER, function (state, service_class_order) {
  state.service_class_order = service_class_order;
}), (0, _defineProperty3.default)(_mutations, types.SET_BILLABLE_ITEM_TYPE_ORDER, function (state, billable_rate_type_order) {
  state.billable_rate_type_order = billable_rate_type_order;
}), _mutations);

var actions = {};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(135);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _index = __webpack_require__(134);

var _index2 = _interopRequireDefault(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  authorized_contacts: [],
  temp_contact: {},
  editing_contact: {
    city: '',
    cmp_name: '',
    comments: '',
    cntid: '0',
    dob: '',
    email: '',
    fax: '',
    line1: '',
    line2: '',
    mobile: '',
    name: '',
    phone: '',
    position: '',
    state: '',
    title: '',
    zip_code: '',
    zip_ext: ''
  },
  editing_ldap: { uid: '', password: '' },
  editing_perms: {
    account: { 'has_manage': false, 'has_view': false },
    admin: { 'has_manage': false, 'has_view': false },
    contacts: { 'has_manage': false, 'has_view': false },
    invoices: { 'has_manage': false, 'has_view': false },
    payments: { 'has_manage': false, 'has_view': false },
    services: { 'has_manage': false, 'has_view': false }
  },
  edit_mode: false,

  address_types: [{ label: 'Business', value: '1' }, { label: 'Home', value: '2' }],
  reminder_types: [{ label: 'Fax', value: '3' }, { label: 'E-Mail', value: '1' }, { label: 'CC Auto', value: '4' }, { label: 'Snail Mail', value: '2' }]
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_AUTHORIZED_CONTACTS, function (state, authorizedContacts) {
  state.authorized_contacts = authorizedContacts;
}), (0, _defineProperty3.default)(_mutations, types.BEGIN_EDIT_CONTACT, function (state) {
  state.temp_contact = JSON.parse((0, _stringify2.default)(state.editing_contact));
  state.edit_mode = true;
}), (0, _defineProperty3.default)(_mutations, types.CANCEL_EDIT_CONTACT, function (state) {
  state.edit_mode = false;
  if ((0, _keys2.default)(state.temp_contact).length > 0) {
    state.editing_contact = JSON.parse((0, _stringify2.default)(state.temp_contact));
    state.temp_contact = {};
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_EDITING_CONTACT, function (state, contact) {
  state.editing_contact = contact;
}), (0, _defineProperty3.default)(_mutations, types.SET_EDITING_LDAP, function (state, ldap_data) {
  state.editing_ldap = ldap_data;
}), (0, _defineProperty3.default)(_mutations, types.SET_EDITING_PERMS, function (state, perms_data) {
  state.editing_perms = perms_data;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_EDITING_CONTACT, function (state, _ref) {
  var name = _ref.name,
      value = _ref.value;

  var temp = state.editing_contact;
  temp[name] = value;
  state.editing_contact = temp;
}), _mutations);

var actions = {
  getAuthorizedContacts: function getAuthorizedContacts(_ref2) {
    var commit = _ref2.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/user/authorized_contacts',
        success: function success(result) {
          commit(types.SET_AUTHORIZED_CONTACTS, result);
          resolve();
        }
      });
    });
  },
  createNewContact: function createNewContact(_ref3, newContact) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_contacts',
        data: newContact,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getAuthorizedContacts');
          resolve();
        },
        error: function error(result) {
          resolve();
        }
      });
    });
  },
  createNewUser: function createNewUser(_ref4, newContact) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users',
        data: newContact,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getAuthorizedContacts');
          resolve(result);
        },
        error: function error(result) {
          resolve(result);
        }
      });
    });
  },
  getEditingContact: function getEditingContact(_ref5, contact_id) {
    var commit = _ref5.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/user/authorized_contact?contact_id=' + contact_id,
        success: function success(result) {
          result.billing['contact_id'] = contact_id;
          commit(types.SET_EDITING_CONTACT, result.billing);
          resolve();
        }
      });
    });
  },
  getEditingUser: function getEditingUser(_ref6, _ref7) {
    var commit = _ref6.commit;
    var contact_id = _ref7.contact_id,
        uid = _ref7.uid;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/user/authorized_users?contact_id=' + contact_id + '&uid=' + uid,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          result.billing['contact_id'] = contact_id;
          commit(types.SET_EDITING_CONTACT, result.billing);
          commit(types.SET_EDITING_LDAP, result.ldap);
          commit(types.SET_EDITING_PERMS, result.db);
          resolve();
        }
      });
    });
  },
  saveEditingContact: function saveEditingContact(_ref8, contact) {
    var commit = _ref8.commit,
        state = _ref8.state,
        dispatch = _ref8.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.patch({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_contacts/' + contact.contact_id,
        data: contact,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getAuthorizedContacts');
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  saveEditingUser: function saveEditingUser(_ref9, contact) {
    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.patch({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users/' + contact.contact_data.contact_id,
        data: contact,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getAuthorizedContacts');
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  convertContactToUser: function convertContactToUser(_ref10, contact) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    return new _promise2.default(function (resolve, reject) {
      contact['add_perms'] = true;
      _authRequest2.default.put({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users/' + contact.contact_id,
        data: contact,
        notifications: true,
        modalNotifications: false,
        success: function success(result) {
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  convertUserToContact: function convertUserToContact(_ref11, contact) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    return new _promise2.default(function (resolve, reject) {
      contact['add_perms'] = false;
      _authRequest2.default.put({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users/' + contact.contact_id,
        data: contact,
        notifications: true,
        modalNotifications: false,
        success: function success(result) {
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteContact: function deleteContact(_ref12, contact) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_contacts/' + contact.contact_id,
        success: function success(result) {
          dispatch('getAuthorizedContacts');
          resolve();
        },
        error: function error(result) {
          reject();
        }
      });
    });
  },
  deleteUser: function deleteUser(_ref13, contact) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/user/' + (_index2.default.getters.hasAdminPerm ? 'admin_' : '') + 'authorized_users/' + contact.contact_id + '?uid=' + contact.uid,
        notifications: true,
        modalNotifications: false,
        success: function success(result) {
          dispatch('getAuthorizedContacts');
          resolve();
        },
        error: function error(result) {
          reject();
        }
      });
    });
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(222);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(135);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _jquery = __webpack_require__(110);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_NEW_ZONE = {
  name: '',
  ttl: '3600'
};

var state = {
  total_zones: 0,
  zones: [],
  editing_zone: {
    zone_name: '',
    ttl: ''
  },
  active_zone_id: -1,
  new_zone: DEFAULT_NEW_ZONE,
  zone_timers_loaded: false,
  disabled_zones: [],
  creating_alias: false,

  zoneOffset: 0,
  zoneLimit: 10,
  zonePage: 0,
  showAllZones: false,
  records: [],
  total_records: 0,
  recordsOffset: 0,
  recordsLimit: 10,
  recordsPage: 0,
  showAllRecords: false,
  record_types: [{
    name: 'A',
    description: 'An IPv4 address, used to map hostnames to an IP address',
    options: [{
      name: 'ipv4_address',
      label: 'IP Address',
      type: 'text'
    }]
  }, {
    name: 'TXT',
    description: 'Arbitrary text in a DNS record',
    options: [{
      name: 'text',
      label: 'Text',
      type: 'text'
    }]
  }, {
    name: 'AAAA',
    description: 'An IPv6 address, used to map hostnames to an IP address',
    options: [{
      name: 'ipv6_address',
      label: 'IPv6 Address',
      type: 'text'
    }]
  }, {
    name: 'CNAME',
    description: 'Alias of one name to another',
    options: [{
      name: 'canonical_name',
      label: 'Aliased Domain',
      type: 'text'
    }]
  }, {
    name: 'SRV',
    description: 'Generalized service location record',
    options: [{
      name: 'priority',
      label: 'Priority',
      type: 'number'
    }, {
      name: 'weight',
      label: 'Weight',
      type: 'number'
    }, {
      name: 'port',
      label: 'Port',
      type: 'number'
    }, {
      name: 'target',
      label: 'Target Host',
      type: 'text'
    }]
  }, {
    name: 'NS',
    description: 'Delegates a DNS zone to use the given authoritative name servers',
    options: [{
      name: 'nameserver',
      label: 'Nameserver',
      type: 'text'
    }]
  }, {
    name: 'MX',
    description: 'Maps a zone name to a list of message transfer agents',
    options: [{
      name: 'target',
      label: 'Target',
      type: 'text'
    }, {
      name: 'priority',
      label: 'Priority',
      type: 'number'
    }]
  }]
};

var getters = {
  active_zone: function active_zone(state) {
    return state.zones.filter(function (zone) {
      return zone.zone_id === state.active_zone_id;
    })[0];
  },
  zonesCount: function zonesCount(state) {
    return state.zones.length;
  },
  hasZones: function hasZones(state, getters) {
    return getters.zonesCount > 0;
  },
  getDisabledZoneById: function getDisabledZoneById(state) {
    return function (id) {
      return state.disabled_zones.find(function (zone) {
        return zone.zone_id === id;
      });
    };
  },
  getDisabledZoneDeleteText: function getDisabledZoneDeleteText(state, getters) {
    return function (id) {
      var zone = getters.getDisabledZoneById(id);
      if (zone === undefined) {
        return 'Delete';
      } else {
        return 'Delete (Disabled for ' + zone.last_start.toString() + 's)';
      }
    };
  },
  getDisabledZoneEditText: function getDisabledZoneEditText(state, getters) {
    return function (id) {
      var zone = getters.getDisabledZoneById(id);
      if (zone === undefined) {
        return 'Edit';
      } else {
        return 'Edit (Disabled for ' + zone.last_start.toString() + 's)';
      }
    };
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.GET_ZONES, function (state, result) {
  state.total_zones = result.total_zones;
  state.zones = result.zones;

  if (state.zones !== undefined && state.zones.length > 0 && state.active_zone_id === -1) {
    state.active_zone_id = state.zones[0].zone_id;
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_DEFAULT_ACTIVE_ZONE, function (state) {
  if (state.zones.length > 0) {
    state.active_zone_id = state.zones[0].zone_id;
  } else {
    state.active_zone_id = -1;
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_ACTIVE_ZONE, function (state, activeZone) {
  state.active_zone_id = activeZone.zone_id;
}), (0, _defineProperty3.default)(_mutations, types.NULL_ACTIVE_ZONE, function (state) {
  state.active_zone_id = -1;
}), (0, _defineProperty3.default)(_mutations, types.SET_EDITING_ZONE_ALIASES, function (state, _ref) {
  var zoneAliases = _ref.zoneAliases;

  state.editing_zone.aliases = zoneAliases;
}), (0, _defineProperty3.default)(_mutations, types.SET_EDITING_ZONE, function (state, zone) {
  state.editing_zone = _jquery2.default.extend(true, {}, zone);
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_EDITING_ZONE, function (state, _ref2) {
  var name = _ref2.name,
      value = _ref2.value;

  state.editing_zone[name] = value;
}), (0, _defineProperty3.default)(_mutations, types.BEGIN_CREATING_ALIAS, function (state) {
  state.creating_alias = true;
}), (0, _defineProperty3.default)(_mutations, types.END_CREATING_ALIAS, function (state) {
  state.creating_alias = false;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_NEW_ZONE, function (state, _ref3) {
  var name = _ref3.name,
      value = _ref3.value;

  state.new_zone[name] = value;
}), (0, _defineProperty3.default)(_mutations, types.SET_NEW_ZONE, function (state, zone) {
  state.new_zone = _jquery2.default.extend(true, {}, zone);
}), (0, _defineProperty3.default)(_mutations, types.SET_RECORDS, function (state, result) {
  state.records = result.records;
  state.total_records = result.total_records;
}), (0, _defineProperty3.default)(_mutations, types.NEXT_ZONES_PAGE, function (state) {
  state.zoneOffset += state.zoneLimit;
}), (0, _defineProperty3.default)(_mutations, types.PREV_ZONES_PAGE, function (state) {
  state.zoneOffset -= state.zoneLimit;
  if (state.zoneOffset < 0) {
    state.zoneOffset = 0;
  }
}), (0, _defineProperty3.default)(_mutations, types.TOGGLE_SHOW_ALL_ZONES, function (state) {
  state.showAllZones = !state.showAllZones;
  state.zoneOffset = 0;
  state.zonePage = 0;
  if (state.showAllZones) {
    state.zoneLimit = state.total_zones;
  } else {
    state.zoneLimit = 10;
  }
}), (0, _defineProperty3.default)(_mutations, types.FIRST_RECORDS_PAGE, function (state) {
  state.recordsOffset = 0;
  state.recordsPage = 0;
}), (0, _defineProperty3.default)(_mutations, types.NEXT_RECORDS_PAGE, function (state) {
  state.recordsOffset += state.recordsLimit;
}), (0, _defineProperty3.default)(_mutations, types.PREV_RECORDS_PAGE, function (state) {
  state.recordsOffset -= state.recordsLimit;
  if (state.recordsOffset < 0) {
    state.recordsOffset = 0;
  }
}), (0, _defineProperty3.default)(_mutations, types.TOGGLE_SHOW_ALL_RECORDS, function (state) {
  state.showAllRecords = !state.showAllRecords;
  state.recordsOffset = 0;
  state.recordsPage = 0;
  if (state.showAllRecords) {
    state.recordsLimit = state.total_records;
  } else {
    state.recordsLimit = 10;
  }
}), (0, _defineProperty3.default)(_mutations, types.RESET_DISABLED_ZONE_TIMERS, function (state) {
  state.zone_timers_loaded = false;
}), (0, _defineProperty3.default)(_mutations, types.ZONE_REFRESH_TIMERS_LOADED, function (state) {
  state.zone_timers_loaded = true;
  state.disabled_zones = [];
}), (0, _defineProperty3.default)(_mutations, types.NEW_ZONE_ADDED, function (state, zone) {
  zone.last_start = 60;
  state.disabled_zones.push(zone);
}), (0, _defineProperty3.default)(_mutations, types.INCREASE_STARTUP_DISABLED_ZONE, function (state, index) {
  var zone = state.disabled_zones[index];
  zone.last_start -= 1;
  state.disabled_zones[index] = zone;
}), (0, _defineProperty3.default)(_mutations, types.REMOVE_DISABLED_ZONE_BY_INDEX, function (state, index) {
  state.disabled_zones.splice(index, 1);
}), _mutations);

var actions = {
  getZones: function getZones(_ref4, payload) {
    var state = _ref4.state,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/dns?limit=' + state.zoneLimit + '&offset=' + state.zoneOffset,
        success: function success(result) {
          commit(types.GET_ZONES, result);
          if (result.total_zones === 0) {
            commit(types.NULL_ACTIVE_ZONE);
          } else {
            dispatch('getActiveZoneRecords');
          }
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  nextZonesPage: function nextZonesPage(_ref5) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new _promise2.default(function (resolve, reject) {
      commit(types.NEXT_ZONES_PAGE);
      dispatch('getZones').then(function (result) {
        commit(types.FIRST_RECORDS_PAGE);
        commit(types.SET_DEFAULT_ACTIVE_ZONE);
      });
    });
  },
  prevZonesPage: function prevZonesPage(_ref6) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    return new _promise2.default(function (resolve, reject) {
      commit(types.PREV_ZONES_PAGE);
      dispatch('getZones').then(function (result) {
        commit(types.FIRST_RECORDS_PAGE);
        commit(types.SET_DEFAULT_ACTIVE_ZONE);
      });
    });
  },
  toggleShowAllZones: function toggleShowAllZones(_ref7) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    return new _promise2.default(function (resolve, reject) {
      commit(types.TOGGLE_SHOW_ALL_ZONES);
      dispatch('getZones');
      resolve();
    });
  },
  findZone: function findZone(_ref8, _ref9) {
    var state = _ref8.state;
    var id = _ref9.id;

    return new _promise2.default(function (resolve, reject) {
      var zone = state.zones.filter(function (zone) {
        return zone.zone_id === id;
      })[0];
      if (zone === 'undefined') {
        reject(zone);
      } else {
        resolve(zone);
      }
    });
  },
  refreshEditingZoneAliases: function refreshEditingZoneAliases(_ref10) {
    var state = _ref10.state,
        dispatch = _ref10.dispatch,
        commit = _ref10.commit;

    if (state.editing_zone === 'undefined') {
      return;
    }
    dispatch('findZone', { id: state.editing_zone.zone_id }).then(function (zone) {
      commit(types.SET_EDITING_ZONE_ALIASES, { zoneAliases: zone.aliases });
    });
  },
  getPreviousRecordsPage: function getPreviousRecordsPage(_ref11) {
    var dispatch = _ref11.dispatch,
        commit = _ref11.commit;

    return new _promise2.default(function (resolve, reject) {
      commit(types.PREV_RECORDS_PAGE);
      dispatch('getActiveZoneRecords');
    });
  },
  getNextRecordsPage: function getNextRecordsPage(_ref12) {
    var dispatch = _ref12.dispatch,
        commit = _ref12.commit;

    return new _promise2.default(function (resolve, reject) {
      commit(types.NEXT_RECORDS_PAGE);
      dispatch('getActiveZoneRecords');
    });
  },
  toggleShowAllRecords: function toggleShowAllRecords(_ref13) {
    var dispatch = _ref13.dispatch,
        commit = _ref13.commit;

    return new _promise2.default(function (resolve, reject) {
      commit(types.TOGGLE_SHOW_ALL_RECORDS);
      dispatch('getActiveZoneRecords');
      resolve();
    });
  },
  getActiveZoneRecords: function getActiveZoneRecords(_ref14) {
    var getters = _ref14.getters,
        state = _ref14.state,
        commit = _ref14.commit;

    return new _promise2.default(function (resolve, reject) {
      if (typeof getters.active_zone === 'undefined' || (0, _keys2.default)(getters.active_zone).length === 0) {
        commit(types.SET_RECORDS, { records: [] });
        return resolve();
      }

      _authRequest2.default.get({
        url: '/dns/' + getters.active_zone.zone_id + '/records?limit=' + state.recordsLimit + '&offset=' + state.recordsOffset,
        success: function success(result) {
          commit(types.SET_RECORDS, result);
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  createDNSRecord: function createDNSRecord(_ref15, newRecord) {
    var getters = _ref15.getters,
        dispatch = _ref15.dispatch,
        commit = _ref15.commit;

    return new _promise2.default(function (resolve, reject) {
      if (newRecord.record_type === 'MX' && newRecord.target !== '@' && newRecord.target.slice(-1) !== '.') {
        newRecord.target = newRecord.target + '.';
      }
      _authRequest2.default.post({
        data: newRecord,
        notifications: false,
        modalNotifications: true,
        url: '/dns/' + getters.active_zone.zone_id + '/records/' + newRecord.record_type,
        success: function success(result) {
          dispatch('getZones');
          resolve();
        },
        error: function error(result) {
          commit(types.ADD_NOTIFICATION, { type: 'error', message: result.responseJSON.detail });
          reject();
        }
      });
    });
  },
  updateDNSRecord: function updateDNSRecord(_ref16, _ref17) {
    var dispatch = _ref16.dispatch,
        commit = _ref16.commit;
    var zoneId = _ref17.zoneId,
        record = _ref17.record;

    return new _promise2.default(function (resolve, reject) {
      for (var i in record.record_data) {
        record[i] = record.record_data[i];
      }

      if (record.record_type === 'MX' && record.target.slice(-1) !== '.') {
        record.target = record.target + '.';
      }
      delete record['record_data'];
      _authRequest2.default.put({
        data: record,
        url: '/dns/' + zoneId + '/records/' + record.record_type + '/' + record.record_id,
        success: function success(result) {
          dispatch('getActiveZoneRecords');
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteDNSRecord: function deleteDNSRecord(_ref18, _ref19) {
    var dispatch = _ref18.dispatch,
        commit = _ref18.commit;
    var zoneId = _ref19.zoneId,
        record = _ref19.record;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/dns/' + zoneId + '/records/' + record.record_type + '/' + record.record_id,
        success: function success(result) {
          dispatch('getActiveZoneRecords');
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  createZone: function createZone(_ref20, _ref21) {
    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;
    var zone_name = _ref21.zone_name,
        ttl = _ref21.ttl;

    return new _promise2.default(function (resolve, reject) {
      var newZone = {
        zone_name: zone_name,
        ttl: parseInt(ttl)
      };
      _authRequest2.default.post({
        data: newZone,
        url: '/dns',
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getZones');
          commit(types.NEW_ZONE_ADDED, result);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  saveEditingZone: function saveEditingZone(_ref22) {
    var dispatch = _ref22.dispatch,
        commit = _ref22.commit,
        state = _ref22.state;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.put({
        data: state.editing_zone,
        url: '/dns/' + state.editing_zone.zone_id,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getZones');
          resolve();
        },
        error: function error(result) {
          if (result.status === 422) {
            if ((0, _typeof3.default)(result.responseJSON.msg) === 'object') {
              reject(result.responseJSON.msg);
            }
          } else {
            commit(types.UNHANDLED_ERROR_NOTIFICATION);
            reject();
          }
        }
      });
    });
  },
  deleteZone: function deleteZone(_ref23, zoneId) {
    var state = _ref23.state,
        dispatch = _ref23.dispatch,
        commit = _ref23.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/dns/' + zoneId,
        success: function success(result) {
          dispatch('getZones').then(function (response) {
            if (typeof state.active_zone === 'undefined' || state.active_zone.id === zoneId) {
              commit(types.SET_DEFAULT_ACTIVE_ZONE);
            }
            resolve();
          }, function (response) {
            reject(response);
          });
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteAlias: function deleteAlias(_ref24, _ref25) {
    var dispatch = _ref24.dispatch;
    var zoneId = _ref25.zoneId,
        aliasId = _ref25.aliasId;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/dns/' + zoneId + '/aliases/' + aliasId,
        notifications: false,
        modalNotifications: true,
        success: function success() {
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  createNewAlias: function createNewAlias(_ref26, _ref27) {
    var dispatch = _ref26.dispatch;
    var zoneId = _ref27.zoneId,
        alias_name = _ref27.alias_name;

    return new _promise2.default(function (resolve, reject) {
      var newAlias = {
        alias_name: alias_name
      };
      _authRequest2.default.post({
        url: '/dns/' + zoneId + '/aliases',
        data: newAlias,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getZones').then(function () {
            dispatch('refreshEditingZoneAliases');
          });
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  }
};

exports.default = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  creating_hosting: false,
  deleting_hosting: false
};

var getters = {};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.CREATING_HOSTING, function (state) {
  state.creating_hosting = true;
}), (0, _defineProperty3.default)(_mutations, types.FINISHED_CREATING_HOSTING, function (state) {
  state.creating_hosting = false;
}), (0, _defineProperty3.default)(_mutations, types.DELETING_HOSTING, function (state) {
  state.deleting_hosting = true;
}), (0, _defineProperty3.default)(_mutations, types.FINISHED_DELETING_HOSTING, function (state) {
  state.deleting_hosting = false;
}), _mutations);

var actions = {
  createHosting: function createHosting(_ref, newHosting) {
    var commit = _ref.commit;

    return new _promise2.default(function (resolve, reject) {
      commit(types.CREATING_HOSTING);
      _authRequest2.default.post({
        url: '/plesk_servers',
        data: newHosting,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          commit(types.FINISHED_CREATING_HOSTING);
          resolve(result);
        },
        error: function error(result) {
          commit(types.FINISHED_CREATING_HOSTING);
          reject(result);
        }
      });
    });
  },
  deleteHosting: function deleteHosting(_ref2, data) {
    var commit = _ref2.commit;

    return new _promise2.default(function (resolve, reject) {
      commit(types.DELETING_HOSTING);
      _authRequest2.default.post({
        url: '/plesk_servers/delete',
        data: data,
        success: function success(result) {
          commit(types.FINISHED_DELETING_HOSTING);
          resolve(result);
        },
        error: function error(result) {
          commit(types.FINISHED_DELETING_HOSTING);
          reject(result);
        }
      });
    });
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(226);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  environment: "production",
  production: "production" === 'production',
  production_log_level: 'info',
  development_log_level: 'debug',
  log_levels: ['debug', 'info', 'warn', 'error']
};

var helpers = {
  canLog: function canLog(state, level) {
    if (state.production) {
      return state.log_levels.indexOf(level) >= state.log_levels.indexOf(state.production_log_level);
    } else {
      return state.log_levels.indexOf(level) >= state.log_levels.indexOf(state.development_log_level);
    }
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_PRODUCTION_LOG_LEVEL, function (state, level) {
  if (state.log_levels.includes(level)) {
    state.production_log_level = level;
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_DEVELOPMENT_LOG_LEVEL, function (state, level) {
  if (state.log_levels.includes(level)) {
    state.development_log_level = level;
  }
}), _mutations);

var actions = {
  logAction: function logAction(_ref, _ref2) {
    var state = _ref.state;
    var level = _ref2.level,
        args = _ref2.args;

    if (helpers.canLog(state, level)) {
      var _console;

      (_console = console)[level].apply(_console, (0, _toConsumableArray3.default)(args));
    }
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  refresh_password_modal_opened: false
};

var getters = {
  refreshPasswordOpened: function refreshPasswordOpened(state, getters) {
    return function () {
      return state.refresh_password_modal_opened;
    };
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.OPEN_REFRESH_PASSWORD, function (state) {
  state.refresh_password_modal_opened = true;
}), (0, _defineProperty3.default)(_mutations, types.CLOSE_REFRESH_PASSWORD, function (state) {
  state.refresh_password_modal_opened = false;
}), _mutations);

exports.default = {
  state: state,
  getters: getters,
  mutations: mutations
};

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  notices: [],
  allNotices: []
};

var getters = {
  activeNotices: function activeNotices(state) {
    return state.notices;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_NOTICES, function (state, notices) {
  state.notices = notices;
}), (0, _defineProperty3.default)(_mutations, types.SET_ALL_NOTICES, function (state, allNotices) {
  state.allNotices = allNotices;
}), (0, _defineProperty3.default)(_mutations, types.REMOVE_NOTICE, function (state, noticeId) {
  state.notices = state.notices.filter(function (notice) {
    return notice.id !== noticeId;
  });
}), _mutations);

var actions = {
  getNotices: function getNotices(_ref) {
    var commit = _ref.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/notices',
        success: function success(result) {
          commit(types.SET_NOTICES, result);
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getAllNotices: function getAllNotices(_ref2) {
    var commit = _ref2.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/notices/all',
        success: function success(result) {
          commit(types.SET_ALL_NOTICES, result);
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  createNotice: function createNotice(_ref3, data) {
    var dispatch = _ref3.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/notices',
        data: data,
        success: function success(result) {
          dispatch('getAllNotices');
          dispatch('getNotices');
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteNotice: function deleteNotice(_ref4, noticeId) {
    var dispatch = _ref4.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/notices/' + noticeId,
        success: function success(result) {
          dispatch('getAllNotices');
          dispatch('getNotices');
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  acknowledgeNotice: function acknowledgeNotice(_ref5, noticeId) {
    var dispatch = _ref5.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/notices/' + noticeId + '/ack',
        success: function success(result) {
          dispatch('getNotices');
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  messages: [],
  modalMessages: [],
  showLogoutNotification: false,
  notification_id: 0
};

var getters = {
  reverseNotifications: function reverseNotifications(state) {
    return state.messages.slice().reverse();
  },

  reverseModalNotifications: function reverseModalNotifications(state) {
    return state.modalMessages.slice().reverse();
  }
};

var NOTIFICATION_TITLE_EXCLUSION_LIST = ['Access denied'];

var helpers = {
  getNotificationFromResult: function getNotificationFromResult(responseJSON) {
    if (responseJSON === undefined) {
      return null;
    }

    if (Array.isArray(responseJSON)) {
      return null;
    }

    if ('title' in responseJSON && NOTIFICATION_TITLE_EXCLUSION_LIST.includes(responseJSON['title'])) {
      return null;
    }

    if ('msg' in responseJSON && responseJSON['msg'] === 'Logout complete') {
      return null;
    }

    var msg = '';
    if ('msg' in responseJSON) {
      msg = responseJSON['msg'];
    } else if ('detail' in responseJSON) {
      msg = responseJSON['detail'];
    } else {
      return null;
    }

    var type = 'info';
    if ('error' in responseJSON && responseJSON['error'] || helpers.isErrorStatus(responseJSON['status'])) {
      type = 'danger';
    } else if ('success' in responseJSON || helpers.isSuccessStatus(responseJSON['status'])) {
      type = 'success';
    }
    return { msg: msg, type: type };
  },
  pushNotifications: function pushNotifications(messages, msg, type) {
    if (typeof msg === 'string' && msg.length > 0) {
      messages.push({
        message: msg,
        type: type,
        index: state.notification_id
      });
      state.notification_id++;
    }
    return messages;
  },
  addUnhandledError: function addUnhandledError(messages) {
    messages.push({
      type: 'error',
      message: 'An internal server error occured',
      index: state.notification_id
    });
    state.notification_id++;
    return messages;
  },
  isErrorStatus: function isErrorStatus(status) {
    var topLevelNum = status / 100;
    return topLevelNum === 4 || topLevelNum === 5;
  },
  isSuccessStatus: function isSuccessStatus(status) {
    var topLevelNum = status / 100;
    return topLevelNum === 2;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.ADD_NOTIFICATION, function (state, _ref) {
  var type = _ref.type,
      message = _ref.message;

  state.messages.push({
    type: type,
    message: message,
    timeout: false,
    delay: 0,
    index: state.notification_id
  });
  state.notification_id++;
}), (0, _defineProperty3.default)(_mutations, types.ADD_NOTIFICATION_TIMEOUT, function (state, _ref2) {
  var type = _ref2.type,
      message = _ref2.message,
      delay = _ref2.delay;

  state.messages.push({
    type: type,
    message: message,
    timeout: true,
    delay: delay,
    index: state.notification_id
  });
  state.notification_id++;
}), (0, _defineProperty3.default)(_mutations, types.UNHANDLED_ERROR_NOTIFICATION, function (state) {
  state.messages = helpers.addUnhandledError(state.messages);
}), (0, _defineProperty3.default)(_mutations, types.ACCESS_DENIED_NOTIFICATION, function (state) {
  state.messages.push({
    type: 'danger',
    message: 'You do not have the necessary permissions to perform this action',
    timeout: false,
    delay: 0,
    index: state.notification_id
  });
  state.notification_id++;
}), (0, _defineProperty3.default)(_mutations, types.ADD_NOTIFICATION_FROM_RESULT, function (state, responseJSON) {
  var message = helpers.getNotificationFromResult(responseJSON);
  if (!message) {
    return;
  }
  state.messages = helpers.pushNotifications(state.messages, message.msg, message.type);
  state.notification_id++;
}), (0, _defineProperty3.default)(_mutations, types.HIDE_NOTIFICATION, function (state, index) {
  var pos = state.messages.map(function (obj) {
    return obj.index;
  }).indexOf(index);
  state.messages.splice(pos, 1);
}), (0, _defineProperty3.default)(_mutations, types.HIDE_ALL_NOTIFICATIONS, function (state) {
  state.messages = [];
}), (0, _defineProperty3.default)(_mutations, types.ADD_MODAL_NOTIFICATION, function (state, _ref3) {
  var type = _ref3.type,
      message = _ref3.message;

  var notification = {
    message: message,
    type: type
  };
  state.modalMessages.push(notification);
}), (0, _defineProperty3.default)(_mutations, types.ADD_MODAL_NOTIFICATION_FROM_RESULT, function (state, responseJSON) {
  var message = helpers.getNotificationFromResult(responseJSON);
  if (!message) {
    return;
  }

  if (message.type === 'error') {
    state.modalMessages = helpers.pushNotifications(state.modalMessages, message.msg, message.type);
  } else {
    state.messages = helpers.pushNotifications(state.messages, message.msg, message.type);
  }
}), (0, _defineProperty3.default)(_mutations, types.ADD_UNHANDLED_MODAL_NOTIFICATION, function (state) {
  state.modalMessages = helpers.addUnhandledError(state.modalMessages);
}), (0, _defineProperty3.default)(_mutations, types.HIDE_MODAL_NOTIFICATION, function (state, index) {
  state.modalMessages.splice(index, 1);
}), (0, _defineProperty3.default)(_mutations, types.HIDE_ALL_MODAL_NOTIFICATIONS, function (state) {
  state.modalMessages = [];
}), (0, _defineProperty3.default)(_mutations, types.SHOW_LOGOUT_NOTIFICATION, function (state) {
  state.showLogoutNotification = true;
}), (0, _defineProperty3.default)(_mutations, types.HIDE_LOGOUT_NOTIFICATION, function (state) {
  state.showLogoutNotification = false;
}), _mutations);

var actions = {
  addNotificationTimeout: function addNotificationTimeout(_ref4, _ref5) {
    var commit = _ref4.commit;
    var type = _ref5.type,
        message = _ref5.message,
        delay = _ref5.delay;

    commit(types.ADD_NOTIFICATION_TIMEOUT, {
      type: type,
      message: message,
      delay: delay
    });
    setTimeout(function () {
      commit(types.HIDE_NOTIFICATION, state.notification_id - 1);
    }, delay);
  }
};

exports.default = {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  allServers: [],
  allServersCount: 0,
  servers: [],

  refresh_timers_loaded: false,
  database_timers_loaded: false,
  vhost_timers_loaded: false,
  new_databases: [],
  new_vhosts: [],
  ssl_certs: [],
  databases: [],
  editing_db_id: -1,
  editing_db_name: '',
  vhosts: [],
  ftp_users: [],
  new_ftp_user_vhost_id: -1,
  editing_ftp_id: -1,
  editing_ftp_username: '',
  update_ftp_user_vhost_id: -1,
  update_vhost_ftp_open: false,
  domain_redirects: [],
  php_settings: [],
  nginx_status: '',

  viewing_server_iid: -1,

  editing_server: {},
  cpu_min: 1,
  cpu_max: 8,
  cpu_cost_each: 8,
  memory_min: 1,
  memory_max: 16,
  memory_cost_each: 15,
  storage_min: 8,
  storage_max: 1024,
  storage_cost_each: 0.5,

  creating_server: false,

  updating_server: false,
  deleting_server: false
};

var getters = {
  serversCount: function serversCount(state) {
    return state.servers.length;
  },
  hasServers: function hasServers(state, getters) {
    return getters.serversCount > 0;
  },
  viewingServer: function viewingServer(state) {
    if (state.servers.length === 0) {
      return {
        cpus: 1,
        memory: 1024,
        disk: 10
      };
    }
    return state.servers.find(function (server) {
      return server.iid.toString() === state.viewing_server_iid.toString();
    });
  },
  sslCertsCount: function sslCertsCount(state) {
    return state.ssl_certs.length;
  },
  hasSslCerts: function hasSslCerts(state, getters) {
    return getters.sslCertsCount > 0;
  },
  ftpUsersCount: function ftpUsersCount(state) {
    return state.ftp_users.length;
  },
  domainRedirectsCount: function domainRedirectsCount(state) {
    return state.domain_redirects.length;
  },
  newDatabaseById: function newDatabaseById(state) {
    return function (id) {
      return state.new_databases.find(function (database) {
        return database.database_id === id;
      });
    };
  },
  newDatabaseButtonText: function newDatabaseButtonText(state, getters) {
    return function (id) {
      var db = getters.newDatabaseById(id);
      if (db === undefined) {
        return 'Delete';
      } else {
        return 'Delete (Disabled for ' + db.last_start.toString() + 's)';
      }
    };
  },
  newVhostById: function newVhostById(state) {
    return function (id) {
      return state.new_vhosts.find(function (vhost) {
        return vhost.vhost_id === id;
      });
    };
  },
  newVhostDeleteText: function newVhostDeleteText(state, getters) {
    return function (id) {
      var vhost = getters.newVhostById(id);
      if (vhost === undefined) {
        return 'Delete';
      } else {
        return 'Delete (Disabled for ' + vhost.last_start.toString() + 's)';
      }
    };
  },
  vhostsAlphabetical: function vhostsAlphabetical(state) {
    var vhostsAlphabetical = JSON.parse((0, _stringify2.default)(state.vhosts));
    vhostsAlphabetical.sort(function (a, b) {
      return a.vhost.localeCompare(b.vhost);
    });
    return vhostsAlphabetical;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SET_SERVERS, function (state, servers) {
  state.servers = servers;
}), (0, _defineProperty3.default)(_mutations, types.ADD_SERVER, function (state, server) {
  state.servers.push(server);
}), (0, _defineProperty3.default)(_mutations, types.SET_SERVER, function (state, _ref) {
  var iid = _ref.iid,
      server = _ref.server;

  var pos = state.servers.map(function (server) {
    return server.iid;
  }).indexOf(iid);
  if (pos !== -1) {
    state.servers[pos] = server;
  } else {
    state.servers.push(server);
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_SERVER_STATUS, function (state, _ref2) {
  var iid = _ref2.iid,
      power = _ref2.power,
      time = _ref2.time;

  var pos = state.servers.map(function (server) {
    return server.iid;
  }).indexOf(iid);
  if (pos !== -1) {
    state.servers[pos]['power'] = power;
    state.servers[pos]['time_since_shutdown_issued'] = time;
  }
}), (0, _defineProperty3.default)(_mutations, types.INCREASE_LAST_SHUTDOWN, function (state, iid) {
  var pos = state.servers.map(function (server) {
    return server.iid;
  }).indexOf(iid);
  if (pos !== -1) {
    state.servers[pos]['time_since_shutdown_issued'] += 1;
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_VIEWING_SERVER_IID, function (state, serverIid) {
  state.viewing_server_iid = serverIid;
}), (0, _defineProperty3.default)(_mutations, types.SET_EDITING_SERVER, function (state, server) {
  state.editing_server = JSON.parse((0, _stringify2.default)(server));

  state.editing_server.mem_gb = state.editing_server.mem / 1024;
}), (0, _defineProperty3.default)(_mutations, types.UPDATE_EDITING_SERVER, function (state, _ref3) {
  var name = _ref3.name,
      value = _ref3.value;

  state.editing_server[name] = value;
}), (0, _defineProperty3.default)(_mutations, types.SET_SSL_CERTS, function (state, sslCerts) {
  state.ssl_certs = sslCerts;
}), (0, _defineProperty3.default)(_mutations, types.SET_DATABASES, function (state, databases) {
  state.databases = databases;
}), (0, _defineProperty3.default)(_mutations, types.SET_EDITING_DB, function (state, _ref4) {
  var databaseName = _ref4.databaseName,
      databaseId = _ref4.databaseId;

  state.editing_db_name = databaseName;
  state.editing_db_id = databaseId;
}), (0, _defineProperty3.default)(_mutations, types.SET_VHOSTS, function (state, vhosts) {
  state.vhosts = vhosts;
}), (0, _defineProperty3.default)(_mutations, types.SET_FTP_USERS, function (state, ftpUsers) {
  state.ftp_users = ftpUsers;
}), (0, _defineProperty3.default)(_mutations, types.SET_NEW_FTP_VHOST_ID, function (state, vhostId) {
  state.new_ftp_user_vhost_id = vhostId;
}), (0, _defineProperty3.default)(_mutations, types.SET_UPDATE_FTP, function (state, _ref5) {
  var vhostId = _ref5.vhostId,
      ftpId = _ref5.ftpId,
      ftpUsername = _ref5.ftpUsername;

  state.update_ftp_user_vhost_id = vhostId;
  state.editing_ftp_id = ftpId;
  state.editing_ftp_username = ftpUsername;
}), (0, _defineProperty3.default)(_mutations, types.SET_DOMAIN_REDIRECTS, function (state, domainRedirects) {
  state.domain_redirects = domainRedirects;
}), (0, _defineProperty3.default)(_mutations, types.SET_PHP_SETTINGS, function (state, phpSettings) {
  state.php_settings = phpSettings;
}), (0, _defineProperty3.default)(_mutations, types.SET_NGINX_STATUS, function (state, nginxStatus) {
  state.nginx_status = nginxStatus;
}), (0, _defineProperty3.default)(_mutations, types.SERVER_REFRESH_TIMERS_LOADED, function (state) {
  state.refresh_timers_loaded = true;
}), (0, _defineProperty3.default)(_mutations, types.RESET_SERVER_REFRESH_TIMERS, function (state) {
  state.refresh_timers_loaded = false;
}), (0, _defineProperty3.default)(_mutations, types.DATABASE_REFRESH_TIMERS_LOADED, function (state) {
  state.database_timers_loaded = true;
  state.new_databases = [];
}), (0, _defineProperty3.default)(_mutations, types.RESET_DATABASE_TIMERS, function (state) {
  state.database_timers_loaded = false;
  state.new_databases = [];
}), (0, _defineProperty3.default)(_mutations, types.NEW_DATABASE_CREATED, function (state, database) {
  database.last_start = 60;
  state.new_databases.push(database);
}), (0, _defineProperty3.default)(_mutations, types.INCREASE_STARTUP_NEW_DATABASE, function (state, index) {
  var db = state.new_databases[index];
  db.last_start -= 1;
  state.new_databases[index] = db;
}), (0, _defineProperty3.default)(_mutations, types.SET_DATABASE_BY_INDEX, function (state, _ref6) {
  var database = _ref6.database,
      index = _ref6.index;

  state.new_databases[index] = database;
}), (0, _defineProperty3.default)(_mutations, types.REMOVE_DATABASE_BY_INDEX, function (state, index) {
  state.new_databases.splice(index, 1);
}), (0, _defineProperty3.default)(_mutations, types.VHOST_REFRESH_TIMERS_LOADED, function (state) {
  state.vhost_timers_loaded = true;
  state.new_vhosts = [];
}), (0, _defineProperty3.default)(_mutations, types.RESET_VHOST_TIMERS, function (state) {
  state.vhost_timers_loaded = false;
  state.new_vhosts = [];
}), (0, _defineProperty3.default)(_mutations, types.NEW_VHOST_CREATED, function (state, vhost) {
  vhost.last_start = 60;
  state.new_vhosts.push(vhost);
}), (0, _defineProperty3.default)(_mutations, types.INCREASE_STARTUP_NEW_VHOST, function (state, index) {
  var vhost = state.new_vhosts[index];
  vhost.last_start -= 1;
  state.new_vhosts[index] = vhost;
}), (0, _defineProperty3.default)(_mutations, types.SET_NEW_VHOST_BY_INDEX, function (state, _ref7) {
  var vhost = _ref7.vhost,
      index = _ref7.index;

  state.new_vhosts[index] = vhost;
}), (0, _defineProperty3.default)(_mutations, types.REMOVE_NEW_VHOST_BY_INDEX, function (state, index) {
  state.new_vhosts.splice(index, 1);
}), (0, _defineProperty3.default)(_mutations, types.CREATING_SERVER, function (state) {
  state.creating_server = true;
}), (0, _defineProperty3.default)(_mutations, types.FINISHED_CREATING_SERVER, function (state) {
  state.creating_server = false;
}), (0, _defineProperty3.default)(_mutations, types.UPDATING_SERVER, function (state) {
  state.updating_server = true;
}), (0, _defineProperty3.default)(_mutations, types.FINISHED_UPDATING_SERVER, function (state) {
  state.updating_server = false;
}), (0, _defineProperty3.default)(_mutations, types.DELETING_SERVER, function (state) {
  state.deleting_server = true;
}), (0, _defineProperty3.default)(_mutations, types.FINISHED_DELETING_SERVER, function (state) {
  state.deleting_server = false;
}), (0, _defineProperty3.default)(_mutations, types.SET_ALL_SERVERS, function (state, servers) {
  state.allServers = servers;
}), (0, _defineProperty3.default)(_mutations, types.SET_ALL_SERVERS_COUNT, function (state, count) {
  state.allServersCount = count;
}), _mutations);

var actions = {
  getAllServers: function getAllServers(_ref8, _ref9) {
    var commit = _ref8.commit;
    var sortedColumn = _ref9.sortedColumn,
        sortUp = _ref9.sortUp;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/servers/all/' + sortedColumn + '/' + sortUp,
        success: function success(result) {
          commit(types.SET_ALL_SERVERS, result);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getAllServersCount: function getAllServersCount(_ref10) {
    var commit = _ref10.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/servers/all/count',
        success: function success(result) {
          commit(types.SET_ALL_SERVERS_COUNT, result.count);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getServers: function getServers(_ref11) {
    var commit = _ref11.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/servers',
        success: function success(result) {
          commit(types.SET_SERVERS, result);
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getServerStatus: function getServerStatus(_ref12, iid) {
    var commit = _ref12.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/servers/' + iid + '/power_status',
        success: function success(result) {
          commit(types.SET_SERVER_STATUS, {
            iid: iid,
            power: result.power,
            time: result.time_since_shutdown_issued });
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getServer: function getServer(_ref13, iid) {
    var commit = _ref13.commit,
        state = _ref13.state;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/servers/' + iid,
        success: function success(result) {
          commit(types.SET_SERVER, { iid: iid, server: result });
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  createServer: function createServer(_ref14, newServer) {
    var commit = _ref14.commit;

    return new _promise2.default(function (resolve, reject) {
      commit(types.CREATING_SERVER);
      _authRequest2.default.post({
        url: '/servers/',
        data: newServer,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          commit(types.SET_SERVER, {
            iid: newServer.iid,
            server: result.server
          });
          commit(types.FINISHED_CREATING_SERVER);
          resolve(result);
        },
        error: function error(result) {
          commit(types.FINISHED_CREATING_SERVER);
          reject(result);
        }
      });
    });
  },
  updateServer: function updateServer(_ref15, editingServer) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    return new _promise2.default(function (resolve, reject) {
      commit(types.UPDATING_SERVER);

      editingServer.mem = editingServer.mem_gb * 1024;
      var putData = {
        cpus: Number(editingServer.cpus),
        mem: Number(editingServer.mem),
        disk: Number(editingServer.disk)
      };
      _authRequest2.default.put({
        url: '/servers/' + editingServer.iid,
        data: putData,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getServers');
          commit(types.FINISHED_UPDATING_SERVER);
          resolve(result);
        },
        error: function error(result) {
          commit(types.FINISHED_UPDATING_SERVER);
          reject(result);
        }
      });
    });
  },
  deleteServer: function deleteServer(_ref16, serverIid) {
    var commit = _ref16.commit;

    return new _promise2.default(function (resolve, reject) {
      commit(types.DELETING_SERVER);
      _authRequest2.default.delete({
        url: '/servers/' + serverIid,
        success: function success(result) {
          commit(types.FINISHED_DELETING_SERVER);
          resolve(result);
        },
        error: function error(result) {
          commit(types.FINISHED_DELETING_SERVER);
          reject(result);
        }
      });
    });
  },
  startServer: function startServer(_ref17, serverIid) {
    var dispatch = _ref17.dispatch,
        commit = _ref17.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/servers/' + serverIid + '/start',
        success: function success(result) {
          dispatch('getServer', serverIid);
          resolve();
        },
        error: function error(result) {
          reject();
        }
      });
    });
  },
  stopServer: function stopServer(_ref18, serverIid) {
    var dispatch = _ref18.dispatch,
        commit = _ref18.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/servers/' + serverIid + '/stop',
        success: function success(result) {
          dispatch('getServer', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  forceStopServer: function forceStopServer(_ref19, serverIid) {
    var dispatch = _ref19.dispatch,
        commit = _ref19.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/servers/' + serverIid + '/force_stop',
        success: function success(result) {
          dispatch('getServer', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  setNewStatus: function setNewStatus(_ref20, _ref21) {
    var commit = _ref20.commit;
    var serverIid = _ref21.serverIid,
        newStatus = _ref21.newStatus;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.post({
        url: '/servers/' + serverIid + '/' + newStatus,
        success: function success(result) {
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  setViewingServer: function setViewingServer(_ref22, serverIid) {
    var commit = _ref22.commit,
        dispatch = _ref22.dispatch,
        getters = _ref22.getters,
        state = _ref22.state;

    return new _promise2.default(function (resolve, reject) {
      if (!serverIid) {
        return;
      }
      commit(types.SET_VIEWING_SERVER_IID, serverIid);
      dispatch('getServer', serverIid).then(function (response) {
        if (getters.viewingServer === undefined) {
          commit(types.ADD_NOTIFICATION, {
            type: 'warning',
            message: 'Server not found'
          });
          reject();
        } else if (getters.viewingServer.managed) {
          dispatch('getManagedServer', serverIid).then(function (response) {
            resolve();
          });
        }
      });
    });
  },
  getManagedServer: function getManagedServer(_ref23, serverIid) {
    var dispatch = _ref23.dispatch;

    return new _promise2.default(function (resolve, reject) {
      dispatch('getSslCerts', serverIid);
      dispatch('getDatabases', serverIid);
      dispatch('getVhosts', serverIid);
      dispatch('getFtpUsers', serverIid);
      dispatch('getDomainRedirects', serverIid);
      dispatch('getPhpSettings', serverIid);

      dispatch('getNginxStatus', serverIid);
      resolve();
    });
  },
  getSslCerts: function getSslCerts(_ref24, serverIid) {
    var commit = _ref24.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/managed_vm/' + serverIid + '/ssl_certs',
        success: function success(result) {
          commit(types.SET_SSL_CERTS, result);
          resolve();
        },
        error: function error() {
          reject();
        }
      });
    });
  },
  createSSLCert: function createSSLCert(_ref25, _ref26) {
    var dispatch = _ref25.dispatch;
    var serverIid = _ref26.serverIid,
        name = _ref26.name,
        cert = _ref26.cert,
        key = _ref26.key,
        ca = _ref26.ca;

    return new _promise2.default(function (resolve, reject) {
      var sslCert = {
        name: name,
        cert: cert,
        key: key,
        ca: ca
      };
      _authRequest2.default.post({
        url: '/managed_vm/' + serverIid + '/ssl_certs',
        data: sslCert,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getSslCerts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteSSLCert: function deleteSSLCert(_ref27, _ref28) {
    var dispatch = _ref27.dispatch;
    var serverIid = _ref28.serverIid,
        certId = _ref28.certId;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/managed_vm/' + serverIid + '/ssl_certs/' + certId,
        success: function success(result) {
          dispatch('getSslCerts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getDatabases: function getDatabases(_ref29, serverIid) {
    var commit = _ref29.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/managed_vm/' + serverIid + '/mysql_database',
        success: function success(result) {
          commit(types.SET_DATABASES, result);
          resolve();
        },
        error: function error() {
          reject();
        }
      });
    });
  },
  createDatabase: function createDatabase(_ref30, _ref31) {
    var commit = _ref30.commit,
        dispatch = _ref30.dispatch;
    var serverIid = _ref31.serverIid,
        name = _ref31.name,
        db_username = _ref31.db_username,
        db_password = _ref31.db_password;

    return new _promise2.default(function (resolve, reject) {
      var database = {
        database_name: name,
        username: db_username,
        password: db_password
      };
      _authRequest2.default.post({
        url: '/managed_vm/' + serverIid + '/mysql_database',
        data: database,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          commit(types.NEW_DATABASE_CREATED, result);
          dispatch('getDatabases', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  updateDbPass: function updateDbPass(_ref32, _ref33) {
    var dispatch = _ref32.dispatch;
    var serverIid = _ref33.serverIid,
        databaseId = _ref33.databaseId,
        password = _ref33.password;

    return new _promise2.default(function (resolve, reject) {
      var putData = { password: password };
      _authRequest2.default.put({
        url: '/managed_vm/' + serverIid + '/mysql_database/' + databaseId,
        data: putData,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getDatabases', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getVhosts: function getVhosts(_ref34, serverIid) {
    var commit = _ref34.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/managed_vm/' + serverIid + '/vhosts',
        success: function success(result) {
          commit(types.SET_VHOSTS, result);
          resolve();
        },
        error: function error() {
          reject();
        }
      });
    });
  },
  createVhost: function createVhost(_ref35, _ref36) {
    var commit = _ref35.commit,
        dispatch = _ref35.dispatch;
    var serverIid = _ref36.serverIid,
        domain = _ref36.domain,
        aliases = _ref36.aliases,
        ssl_enabled = _ref36.ssl_enabled,
        ssl_id = _ref36.ssl_id,
        ssl_only = _ref36.ssl_only;

    return new _promise2.default(function (resolve, reject) {
      var vhost = {
        domain: domain,
        aliases: aliases.filter(function (n) {
          return n !== '';
        }),
        ssl_enabled: ssl_enabled,
        ssl_id: ssl_id,
        ssl_only: ssl_only
      };
      _authRequest2.default.post({
        url: '/managed_vm/' + serverIid + '/vhosts',
        data: vhost,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          commit(types.NEW_VHOST_CREATED, result);
          dispatch('getVhosts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteVhost: function deleteVhost(_ref37, _ref38) {
    var dispatch = _ref37.dispatch;
    var serverIid = _ref38.serverIid,
        vhostId = _ref38.vhostId;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/managed_vm/' + serverIid + '/vhosts/' + vhostId,
        success: function success(result) {
          dispatch('getVhosts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  updateVhostAliases: function updateVhostAliases(_ref39, _ref40) {
    var dispatch = _ref39.dispatch;
    var serverIid = _ref40.serverIid,
        vhostId = _ref40.vhostId,
        aliases = _ref40.aliases;

    return new _promise2.default(function (resolve, reject) {
      var putData = {
        aliases: aliases.filter(function (n) {
          return n !== '';
        })
      };
      _authRequest2.default.put({
        url: '/managed_vm/' + serverIid + '/vhosts/' + vhostId + '/domain_aliases',
        data: putData,
        success: function success(result) {
          dispatch('getVhosts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  updateVhostFtp: function updateVhostFtp(_ref41, _ref42) {
    var dispatch = _ref41.dispatch;
    var serverIid = _ref42.serverIid,
        ftpId = _ref42.ftpId,
        password = _ref42.password;

    return new _promise2.default(function (resolve, reject) {
      var postData = {
        password: password
      };
      _authRequest2.default.put({
        url: '/managed_vm/' + serverIid + '/ftp_users/' + ftpId,
        data: postData,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getVhosts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  addVhostFtp: function addVhostFtp(_ref43, _ref44) {
    var dispatch = _ref43.dispatch;
    var serverIid = _ref44.serverIid,
        username = _ref44.username,
        password = _ref44.password,
        vhostId = _ref44.vhostId;

    return new _promise2.default(function (resolve, reject) {
      var postData = {
        username: username,
        password: password,
        vhost_id: vhostId
      };
      _authRequest2.default.post({
        url: '/managed_vm/' + serverIid + '/ftp_users',
        data: postData,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getVhosts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteFtpUser: function deleteFtpUser(_ref45, _ref46) {
    var dispatch = _ref45.dispatch;
    var serverIid = _ref46.serverIid,
        ftpId = _ref46.ftpId;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/managed_vm/' + serverIid + '/ftp_users/' + ftpId,
        success: function success(result) {
          dispatch('getVhosts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  updateVhostHttps: function updateVhostHttps(_ref47, _ref48) {
    var dispatch = _ref47.dispatch;
    var serverIid = _ref48.serverIid,
        vhostId = _ref48.vhostId,
        sslOnly = _ref48.sslOnly,
        sslEnabled = _ref48.sslEnabled,
        sslId = _ref48.sslId;

    return new _promise2.default(function (resolve, reject) {
      var postData = {
        ssl_only: sslOnly,
        ssl_enabled: sslEnabled,
        ssl_id: sslId
      };
      _authRequest2.default.put({
        url: '/managed_vm/' + serverIid + '/vhosts/' + vhostId,
        data: postData,
        success: function success(result) {
          dispatch('getVhosts', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getFtpUsers: function getFtpUsers(_ref49, serverIid) {
    var commit = _ref49.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/managed_vm/' + serverIid + '/ftp_users',
        success: function success(result) {
          commit(types.SET_FTP_USERS, result);
          resolve();
        },
        error: function error() {
          reject();
        }
      });
    });
  },
  getDomainRedirects: function getDomainRedirects(_ref50, serverIid) {
    var commit = _ref50.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/managed_vm/' + serverIid + '/domain_redirects',
        success: function success(result) {
          commit(types.SET_DOMAIN_REDIRECTS, result);
          resolve();
        },
        error: function error() {
          reject();
        }
      });
    });
  },
  createDomainRedirect: function createDomainRedirect(_ref51, _ref52) {
    var dispatch = _ref51.dispatch;
    var serverIid = _ref52.serverIid,
        redirect_from = _ref52.redirect_from,
        redirect_to = _ref52.redirect_to;

    return new _promise2.default(function (resolve, reject) {
      var redirect = {
        redirect_from: redirect_from,
        redirect_to: redirect_to
      };
      _authRequest2.default.post({
        url: '/managed_vm/' + serverIid + '/domain_redirects',
        data: redirect,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getDomainRedirects', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteDomainRedirect: function deleteDomainRedirect(_ref53, _ref54) {
    var dispatch = _ref53.dispatch;
    var serverIid = _ref54.serverIid,
        redirectId = _ref54.redirectId;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/managed_vm/' + serverIid + '/domain_redirects/' + redirectId,
        success: function success(result) {
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getPhpSettings: function getPhpSettings(_ref55, serverIid) {
    var commit = _ref55.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/managed_vm/' + serverIid + '/php_settings',
        success: function success(result) {
          commit(types.SET_PHP_SETTINGS, result);
          resolve();
        },
        error: function error() {
          reject();
        }
      });
    });
  },
  createPhpSetting: function createPhpSetting(_ref56, _ref57) {
    var dispatch = _ref56.dispatch;
    var serverIid = _ref57.serverIid,
        key = _ref57.key,
        value = _ref57.value;

    return new _promise2.default(function (resolve, reject) {
      var phpSetting = {
        key: key,
        value: value
      };
      _authRequest2.default.post({
        url: '/managed_vm/' + serverIid + '/php_settings',
        data: phpSetting,
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          dispatch('getPhpSettings', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deletePhpSetting: function deletePhpSetting(_ref58, _ref59) {
    var commit = _ref58.commit,
        dispatch = _ref58.dispatch;
    var serverIid = _ref59.serverIid,
        phpKey = _ref59.phpKey;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/managed_vm/' + serverIid + '/php_settings/' + phpKey,
        success: function success(result) {
          dispatch('getPhpSettings', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  deleteDatabase: function deleteDatabase(_ref60, _ref61) {
    var commit = _ref60.commit,
        dispatch = _ref60.dispatch;
    var serverIid = _ref61.serverIid,
        databaseId = _ref61.databaseId;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.delete({
        url: '/managed_vm/' + serverIid + '/mysql_database/' + databaseId,
        success: function success(result) {
          dispatch('getDatabases', serverIid);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getNginxStatus: function getNginxStatus(_ref62, serverIid) {
    var commit = _ref62.commit;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/managed_vm/' + serverIid + '/nginx',
        success: function success(result) {
          commit(types.SET_NGINX_STATUS, result.status);
          resolve();
        },
        error: function error() {
          reject();
        }
      });
    });
  },
  toggleNginxStatus: function toggleNginxStatus(_ref63, serverIid) {
    var state = _ref63.state,
        dispatch = _ref63.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.put({
        url: '/managed_vm/' + serverIid + '/nginx',
        data: {
          enable: !state.nginx_status
        },
        success: function success(result) {
          dispatch('getNginxStatus', serverIid);
          resolve();
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  changeWebsitesPassword: function changeWebsitesPassword(_ref64, _ref65) {
    var commit = _ref64.commit;
    var serverIid = _ref65.serverIid,
        password = _ref65.password;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.put({
        url: '/managed_vm/' + serverIid + '/websites_user',
        data: {
          password: password
        },
        notifications: false,
        modalNotifications: true,
        success: function success(result) {
          commit(types.ADD_NOTIFICATION_FROM_RESULT, result);
          resolve(result);
        },
        error: function error() {
          reject();
        }
      });
    });
  }
};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _mutations;

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _dates = __webpack_require__(224);

var _dates2 = _interopRequireDefault(_dates);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  'Business Connectivity': 2,
  'Residential Connectivity': 17,
  'Colocation': 19,
  'Domains': 23,
  'Email': 21,
  'Hosting': 20,
  'Miscellaneous': 22,
  'Professional Services': 18,
  'SSL Certificates': 24,
  'Voice Services': 1,
  allServices: [],
  allProducts: [],
  colocations: [],
  emails: [],
  hosting: [],
  emailAliases: [],
  pleskServers: [],
  connectivity: [],
  domains: [],
  ssl: [],
  voip: [],
  tasks: [],
  servicePanelsOpen: {
    summary: false,
    colocations: false,
    domains: false,
    emails: false,
    hosting: false,
    connectivity: false,
    dnspanel: false,
    servers: false,
    ssl: false,
    voip: false
  }
};

var getters = {
  servicesCount: function servicesCount(state) {
    return state.allProducts.length;
  },
  dateFormat: function dateFormat(state) {
    return function (str) {
      return _dates2.default.dateFormat(str);
    };
  },
  colocationsCount: function colocationsCount(state) {
    return state.colocations.length;
  },
  domainsCount: function domainsCount(state) {
    return state.domains.length;
  },
  emailsCount: function emailsCount(state) {
    return state.emails.length;
  },
  hostingCount: function hostingCount(state) {
    return state.hosting.length;
  },
  connectivityCount: function connectivityCount(state) {
    return state.connectivity.length;
  },
  sslCount: function sslCount(state) {
    return state.ssl.length;
  },
  voipCount: function voipCount(state) {
    return state.voip.length;
  },
  hasColocations: function hasColocations(state, getters) {
    return getters.colocationsCount > 0;
  },
  hasEmails: function hasEmails(state, getters) {
    return getters.emailsCount > 0;
  },
  hasDomains: function hasDomains(state, getters) {
    return getters.domainsCount > 0;
  },
  hasHosting: function hasHosting(state, getters) {
    return getters.hostingCount > 0;
  },
  hasConnectivity: function hasConnectivity(state, getters) {
    return getters.connectivityCount > 0;
  },
  hasSSL: function hasSSL(state, getters) {
    return getters.sslCount > 0;
  },
  hasVoip: function hasVoip(state, getters) {
    return getters.voipCount > 0;
  },
  allPanelsOpen: function allPanelsOpen(state) {
    for (var i in state.servicePanelsOpen) {
      if (state.servicePanelsOpen[i]) {
        return false;
      }
    }
    return true;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.ADD_CONNECTIVITY, function (state, _ref) {
  var reset = _ref.reset,
      result = _ref.result;

  if (reset) {
    state.connectivity = [];
  }

  if (result[state['Business Connectivity']] !== undefined) {
    for (var i = 0; i < result[state['Business Connectivity']].length; i++) {
      state.connectivity = state.connectivity.concat(result[state['Business Connectivity']][i].products);
    }
  }
  if (result[state['Residential Connectivity']] !== undefined) {
    for (i = 0; i < result[state['Residential Connectivity']].length; i++) {
      state.connectivity = state.connectivity.concat(result[state['Residential Connectivity']][i].products);
    }
  }
}), (0, _defineProperty3.default)(_mutations, types.ADD_COLOCATIONS, function (state, _ref2) {
  var reset = _ref2.reset,
      colocations = _ref2.colocations;

  if (reset) {
    state.colocations = [];
  }
  if (colocations !== undefined) {
    for (var i = 0; i < colocations.length; i++) {
      state.colocations = state.colocations.concat(colocations[i].products);
    }
  }
}), (0, _defineProperty3.default)(_mutations, types.ADD_EMAILS, function (state, _ref3) {
  var reset = _ref3.reset,
      emails = _ref3.emails;

  if (reset) {
    state.emails = [];
  }
  if (emails !== undefined) {
    state.emails = emails;
  }
}), (0, _defineProperty3.default)(_mutations, types.ADD_HOSTING, function (state, _ref4) {
  var reset = _ref4.reset,
      hosting = _ref4.hosting;

  if (reset) {
    state.hosting = [];
  }

  if (hosting !== undefined) {
    state.hosting = hosting;
  }
}), (0, _defineProperty3.default)(_mutations, types.ADD_DOMAINS, function (state, _ref5) {
  var reset = _ref5.reset,
      domains = _ref5.domains;

  if (reset) {
    state.domains = [];
  }

  if (domains !== undefined) {
    state.domains = domains;
  }
}), (0, _defineProperty3.default)(_mutations, types.SET_PLESK_SERVERS, function (state, pleskServers) {
  state.pleskServers = pleskServers;
}), (0, _defineProperty3.default)(_mutations, types.SET_SSL, function (state, ssl) {
  state.ssl = [];
  if (ssl !== undefined) {
    for (var i = 0; i < ssl.length; i++) {
      state.ssl = state.ssl.concat(ssl[i].products);
    }
  }
}), (0, _defineProperty3.default)(_mutations, types.ADD_VOIP, function (state, _ref6) {
  var reset = _ref6.reset,
      voip = _ref6.voip;

  if (reset) {
    state.voip = [];
  }
  if (voip !== undefined) {
    for (var i = 0; i < voip.length; i++) {
      state.voip = state.voip.concat(voip[i].products);
    }
  }
}), (0, _defineProperty3.default)(_mutations, types.OPEN_ALL_SERVICE_PANELS, function (state) {
  for (var panel in state.servicePanelsOpen) {
    state.servicePanelsOpen[panel] = true;
  }
}), (0, _defineProperty3.default)(_mutations, types.CLOSE_ALL_BUT_ONE_SERVICE_PANEL, function (state, service) {
  for (var panel in state.servicePanelsOpen) {
    if (panel === service) {
      state.servicePanelsOpen[panel] = true;
    } else {
      state.servicePanelsOpen[panel] = false;
    }
  }
}), (0, _defineProperty3.default)(_mutations, types.CLOSE_ALL_SERVICE_PANELS, function (state) {
  for (var panel in state.servicePanelsOpen) {
    state.servicePanelsOpen[panel] = false;
  }
}), (0, _defineProperty3.default)(_mutations, types.TOGGLE_SERVICE_PANEL, function (state, service) {
  state.servicePanelsOpen[service] = !state.servicePanelsOpen[service];
}), (0, _defineProperty3.default)(_mutations, types.OPEN_SERVICE_PANEL, function (state, service) {
  state.servicePanelsOpen[service] = true;
}), (0, _defineProperty3.default)(_mutations, types.CLOSE_SERVICE_PANEL, function (state, service) {
  state.servicePanelsOpen[service] = false;
}), (0, _defineProperty3.default)(_mutations, types.SET_PROVISION_TASKS, function (state, tasks) {
  state.tasks = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(tasks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var task = _step.value;

      if (['complete', 'error'].includes(task.status)) {
        continue;
      }
      state.tasks.push(task);
      if (task.service_class_id === 14) {
        task.status = task.status.toUpperCase();
        task.created_date = task.creation_dt;
        task.activated_date = null;
        var duplicate = false;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(state.connectivity), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var connection = _step2.value;

            if (connection.number2 === task.service_display_id) {
              duplicate = true;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (!duplicate) {
          state.connectivity.push(task);
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}), _mutations);

var actions = {
  getAllServices: function getAllServices(_ref7) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    return new _promise2.default(function (resolve, reject) {
      dispatch('getZones');
      dispatch('getServers');
      dispatch('getPleskServers');

      _authRequest2.default.get({
        url: '/services',
        success: function success(result) {
          var reset = true;

          commit(types.ADD_DOMAINS, { 'reset': reset, 'domains': result.services[state['Domains']] });
          commit(types.ADD_CONNECTIVITY, { 'reset': reset, 'result': result.services });
          commit(types.ADD_HOSTING, { 'reset': reset, 'hosting': result.services[state['Hosting']] });
          commit(types.ADD_COLOCATIONS, { 'reset': reset, 'colocations': result.services[state.Colocation] });
          commit(types.ADD_EMAILS, { 'reset': reset, 'emails': result.services[state.Email] });
          commit(types.ADD_VOIP, { 'reset': reset, 'voip': result.services[state['Voice Services']] });

          if (result['has_more'] === true) {
            commit(types.ADD_NOTIFICATION, { 'type': 'danger', 'message': 'Not all products were fetched' });
          }
          dispatch('getProvisionTasks');
          resolve();
        }
      });
    });
  },
  getPleskServers: function getPleskServers(_ref8) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/plesk_servers',
        success: function success(result) {
          commit(types.SET_PLESK_SERVERS, result);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  },
  getProvisionTasks: function getProvisionTasks(_ref9) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    return new _promise2.default(function (resolve, reject) {
      _authRequest2.default.get({
        url: '/services/provisioning/tasks',
        success: function success(result) {
          commit(types.SET_PROVISION_TASKS, result);
          resolve(result);
        },
        error: function error(result) {
          reject(result);
        }
      });
    });
  }
};

exports.default = {
  actions: actions,
  getters: getters,
  state: state,
  mutations: mutations
};

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(57);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _mutations;

var _connectivityClotService = __webpack_require__(347);

var _connectivityClotService2 = _interopRequireDefault(_connectivityClotService);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clot_action = 'clot_action';
var new_action = 'new';
var none_action = 'none';

var getDefaultOutputClotModel = function getDefaultOutputClotModel() {
  return {
    service_class_id: '',
    service_action_type: clot_action,
    connectivity: {
      service_class_id: -1,
      service_action_type: none_action,
      speed_id: '',
      external_adid: '',
      external_soid: '',
      early_signup: false,
      customer_details: {
        is_owner: true,
        is_tribal: false,
        owner_name: '',
        owner_phone: '',
        owner_email: '',
        city_customer_id: '',
        city_account_id: ''
      },
      drop_details: {
        accepted: true,
        latitude: '',
        longitude: '',
        notes: '',
        needs_ont_install: false
      },
      install_details: {
        date: '',
        display_time: '',
        duration: 0,
        end_datetime: '',
        external_install_id: '',
        installation_type: '',
        notes: '',
        start_datetime: '',
        time: 0
      }
    },
    router: {
      service_class_id: -1,
      service_action_type: none_action,
      external_soid: '',
      router_model: '',
      mesh_quantity: 0,
      mesh_type: 'mesh_none'
    },
    voice: {
      service_class_id: -1,
      service_action_type: none_action
    },
    static_ip: {
      service_class_id: -1,
      service_action_type: none_action
    },
    subnet: {
      service_class_id: -1,
      service_action_type: none_action
    }
  };
};

var getDefaultOutputModel = function getDefaultOutputModel() {
  return {
    services: [],
    customer: {
      email: '',
      fname: '',
      lname: '',
      name: '',
      uid: '',
      password: '',
      line1: '',
      line2: '',
      zip_code: '',
      city: '',
      phone: '',
      state: '',
      dob: '',
      attribution: ''
    },
    payment: {
      account_type: '',
      auto_pay: true,
      alternate_billing_address: null,
      card_details: {
        internal_token: '',
        token: '',
        fname: '',
        lname: '',
        exp_month: 0,
        exp_year: 0,
        last_four: '',
        brand: ''
      },
      bank_details: {
        name: '',
        routing: '',
        account: '',
        account_type: ''
      },
      billing_address: {
        fname: '',
        lname: '',
        mnami: '',
        cmp_name: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip_code: '',
        zip_ext: ''
      }
    },
    agreement: {
      time: ''
    },
    metadata: {
      signup_hash: ''
    }
  };
};

var state = {
  address_details: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zip_code: '',
    address_id: '',
    drop_latitude: '',
    drop_longitude: '',
    needs_ont_install: true,
    formatted_address: '',
    early_signup: false,
    in_service: false,
    is_business: false,
    orderable: false,
    disabled: false,
    available: false
  },

  init_values: {
    signup_hash: '',
    google_address_id: '',
    formatted_address: '',
    fname: '',
    mname: '',
    lname: '' },

  connectivity_clot_input_model: null,
  connectivity_clot_output_model: getDefaultOutputClotModel(),
  ssu_output_model: getDefaultOutputModel()
};

var helpers = {
  triggerConnectivityClotUpdate: function triggerConnectivityClotUpdate(state) {
    state.connectivity_clot_output_model = (0, _extends3.default)({}, state.connectivity_clot_output_model);
  },
  getInitialValue: function getInitialValue(key, obj, default_val) {
    if (key in obj) {
      try {
        return obj[key];
      } catch (error) {
        return default_val;
      }
    }
    return default_val;
  },
  setInitialValues: function setInitialValues(state) {
    state.init_values.formatted_address = state.address_details.formatted_address;
    state.init_values.fname = state.ssu_output_model.customer.fname;
    state.init_values.mname = state.ssu_output_model.customer.mname;
    state.init_values.lname = state.ssu_output_model.customer.lname;
  }
};

var getters = {
  ssuInitDetails: function ssuInitDetails(state) {
    return state.init_values;
  },
  ssuInitGoogleAddressId: function ssuInitGoogleAddressId(state) {
    return state.init_values.google_address_id;
  },
  ssuSelectedSpeedId: function ssuSelectedSpeedId(state) {
    return state.connectivity_clot_output_model.connectivity.speed_id;
  },
  ssuServiceDetails: function ssuServiceDetails(state) {
    return state.connectivity_clot_input_model;
  },
  ssuOutputModel: function ssuOutputModel(state) {
    var output_model = JSON.parse((0, _stringify2.default)(state.ssu_output_model));
    output_model.services = [state.connectivity_clot_output_model];
    output_model.metadata.signup_hash = state.init_values.signup_hash;
    return output_model;
  },
  existingConnectivityClotOutputModel: function existingConnectivityClotOutputModel(state) {
    return state.connectivity_clot_output_model;
  },
  ssuLoginDetails: function ssuLoginDetails(state) {
    return { uid: state.ssu_output_model.customer.uid, password: state.ssu_output_model.customer.password };
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT, function (state, _ref) {
  var service = _ref.service;

  state.connectivity_clot_input_model = new _connectivityClotService2.default(service);
  state.address_details = (0, _extends3.default)({}, service.address_details);
  helpers.setInitialValues(state);

  state.ssu_output_model.customer.line1 = state.address_details.line1;
  state.ssu_output_model.customer.line2 = state.address_details.line2;
  state.ssu_output_model.customer.city = state.address_details.city;
  state.ssu_output_model.customer.state = state.address_details.state;
  state.ssu_output_model.customer.zip_code = state.address_details.zip_code;
  if (state.address_details.available) {
    state.connectivity_clot_output_model.service_action_type = clot_action;
    state.connectivity_clot_output_model.connectivity.service_action_type = new_action;
    state.connectivity_clot_output_model.connectivity.external_adid = state.address_details.address_id;
    state.connectivity_clot_output_model.connectivity.early_signup = state.address_details.early_signup;
    state.connectivity_clot_output_model.connectivity.drop_details.needs_ont_install = state.address_details.needs_ont_install;

    state.connectivity_clot_output_model.service_class_id = state.connectivity_clot_input_model.service_class_model.service_class_id;
    state.connectivity_clot_output_model.connectivity.service_class_id = state.connectivity_clot_input_model.connectivity.service_class_model.service_class_id;
    state.connectivity_clot_output_model.router.service_class_id = state.connectivity_clot_input_model.router.service_class_model.service_class_id;
    state.connectivity_clot_output_model.voice.service_class_id = state.connectivity_clot_input_model.voice.service_class_model.service_class_id;
    state.connectivity_clot_output_model.static_ip.service_class_id = state.connectivity_clot_input_model.static_ip.service_class_model.service_class_id;
    state.connectivity_clot_output_model.subnet.service_class_id = state.connectivity_clot_input_model.subnet.service_class_model.service_class_id;
    state.connectivity_clot_input_model.connectivity.order_summary.addServiceToCart(true);

    helpers.triggerConnectivityClotUpdate(state);
  }
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER, function (state, _ref2) {
  var is_owner = _ref2.is_owner,
      is_tribal = _ref2.is_tribal,
      owner_phone = _ref2.owner_phone,
      owner_email = _ref2.owner_email,
      owner_name = _ref2.owner_name;

  state.connectivity_clot_output_model.connectivity.customer_details.is_owner = is_owner === null ? true : is_owner;
  state.connectivity_clot_output_model.connectivity.customer_details.is_tribal = !!is_tribal;
  state.connectivity_clot_output_model.connectivity.customer_details.owner_phone = owner_phone;
  state.connectivity_clot_output_model.connectivity.customer_details.owner_email = owner_email;
  state.connectivity_clot_output_model.connectivity.customer_details.owner_name = owner_name;
  helpers.triggerConnectivityClotUpdate(state);
  state.connectivity_clot_input_model.setSpeedOptionsForSelect();
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_CONNECTIVITY_SET_SPEED, function (state, _ref3) {
  var speed_id = _ref3.speed_id,
      external_soid = _ref3.external_soid;

  state.connectivity_clot_output_model.connectivity.speed_id = speed_id;
  state.connectivity_clot_output_model.connectivity.external_soid = external_soid;
  helpers.triggerConnectivityClotUpdate(state);

  state.connectivity_clot_input_model.connectivity.setActiveSpeedOption(speed_id);
  state.connectivity_clot_input_model.router.setActiveRouterOption(speed_id);
  state.connectivity_clot_output_model.router.external_soid = state.connectivity_clot_input_model.router.getActiveRouterOption().external_soid;
  state.connectivity_clot_input_model.connectivity.addActiveSpeedOptionToCart();

  if (state.connectivity_clot_output_model.router.service_action_type === new_action) {
    state.connectivity_clot_input_model.router.addActiveRouterOptionToCart();
  }
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_CONNECTIVITY_SET_ROUTER, function (state, _ref4) {
  var needs_router = _ref4.needs_router,
      router_model = _ref4.router_model,
      external_soid = _ref4.external_soid,
      mesh_quantity = _ref4.mesh_quantity,
      mesh_type = _ref4.mesh_type;

  state.connectivity_clot_output_model.router.service_action_type = needs_router ? new_action : none_action;
  state.connectivity_clot_output_model.router.router_model = router_model;
  state.connectivity_clot_output_model.router.external_soid = external_soid;
  state.connectivity_clot_output_model.router.mesh_quantity = mesh_quantity;
  state.connectivity_clot_output_model.router.mesh_type = mesh_type;
  helpers.triggerConnectivityClotUpdate(state);
  state.connectivity_clot_input_model.router.service.mesh_option.billing.prices[0].quantity = mesh_quantity;
  if (needs_router) {
    _logger2.default.debug('connectivity clot input', state.connectivity_clot_input_model);
    state.connectivity_clot_input_model.router.order_summary.addServiceToCart();
    state.connectivity_clot_input_model.router.addActiveRouterOptionToCart();
    if (mesh_quantity > 0) {
      state.connectivity_clot_input_model.router.addMeshOptionToCart();
    } else if (mesh_quantity === 0) {
      state.connectivity_clot_input_model.router.removeMeshOptionFromCart();
    }
  } else if (needs_router === false) {
    state.connectivity_clot_input_model.router.order_summary.removeServiceFromCart();
    state.connectivity_clot_input_model.router.removeRouterOptionFromCart();
    state.connectivity_clot_input_model.router.removeMeshOptionFromCart();
  }
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA, function (state, _ref5) {
  var city_customer_id = _ref5.city_customer_id,
      city_account_id = _ref5.city_account_id;

  state.connectivity_clot_output_model.connectivity.customer_details.city_customer_id = city_customer_id;
  state.connectivity_clot_output_model.connectivity.customer_details.city_account_id = city_account_id;
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_CONNECTIVITY_SET_STRATA, function (state, _ref6) {
  var install_details = _ref6.install_details,
      drop_details = _ref6.drop_details;

  state.connectivity_clot_output_model.connectivity.install_details = (0, _extends3.default)({}, state.connectivity_clot_output_model.connectivity.install_details, install_details);
  state.connectivity_clot_output_model.connectivity.drop_details = (0, _extends3.default)({}, state.connectivity_clot_output_model.connectivity.drop_details, drop_details);
  state.connectivity_clot_output_model.connectivity.drop_details.latitude = String(state.connectivity_clot_output_model.connectivity.drop_details.latitude);
  state.connectivity_clot_output_model.connectivity.drop_details.longitude = String(state.connectivity_clot_output_model.connectivity.drop_details.longitude);
  helpers.triggerConnectivityClotUpdate(state);
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE, function (state, _ref7) {
  var desired_activation_date = _ref7.desired_activation_date;

  state.connectivity_clot_output_model.connectivity.install_details.date = desired_activation_date;
  helpers.triggerConnectivityClotUpdate(state);
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_CONNECTIVITY_SET_VOICE, function (state, _ref8) {
  var contact = _ref8.contact;

  state.connectivity_clot_output_model.voice.service_action_type = contact ? new_action : none_action;
  helpers.triggerConnectivityClotUpdate(state);
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_SET_ATTRIBUTION_DATA, function (state, attribution) {
  state.ssu_output_model.customer.attribution = attribution;
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_SET_CUSTOMER_DATA, function (state, payload) {
  state.ssu_output_model.customer.name = payload.fname + " " + payload.lname;
  state.ssu_output_model.customer = (0, _extends3.default)({}, state.ssu_output_model.customer, payload);
  helpers.setInitialValues(state);
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_SET_PAYMENT_DATA, function (state, payload) {
  state.ssu_output_model.payment = (0, _extends3.default)({}, state.ssu_output_model.payment, payload);
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_SET_AGREEMENT_DATA, function (state, payload) {
  state.ssu_output_model.agreement = (0, _extends3.default)({}, state.ssu_output_model.agreement, payload);
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_RESET_OUTPUT_MODELS, function (state) {
  state.ssu_output_model = getDefaultOutputModel();
  state.connectivity_clot_output_model = getDefaultOutputClotModel();
}), (0, _defineProperty3.default)(_mutations, types.SELF_SIGNUP_SET_INIT_VALUES, function (state, _ref9) {
  var signup_hash = _ref9.signup_hash,
      data = _ref9.data;

  _logger2.default.debug('setting init values', data);
  state.init_values.signup_hash = signup_hash;
  state.init_values.google_address_id = helpers.getInitialValue('google_address_id', data.service[0], '');
}), _mutations);

var actions = {};

exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _TopNavbar = __webpack_require__(1301);

var _TopNavbar2 = _interopRequireDefault(_TopNavbar);

var _BottomNavbar = __webpack_require__(1277);

var _BottomNavbar2 = _interopRequireDefault(_BottomNavbar);

var _Foot = __webpack_require__(1280);

var _Foot2 = _interopRequireDefault(_Foot);

var _Notifications = __webpack_require__(341);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _vuex = __webpack_require__(42);

var _Notices = __webpack_require__(1284);

var _Notices2 = _interopRequireDefault(_Notices);

var _RefreshPasswordModal = __webpack_require__(1282);

var _RefreshPasswordModal2 = _interopRequireDefault(_RefreshPasswordModal);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _Signup = __webpack_require__(741);

var _Signup2 = _interopRequireDefault(_Signup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    this.checkTheme();
  },


  computed: (0, _extends3.default)({
    isSignup: function isSignup() {
      return this.$route.name === 'signup';
    },
    subNavbarVisible: function subNavbarVisible() {
      return this.loggedIn;
    },
    visibilityClass: function visibilityClass() {
      return this.subNavbarVisible ? 'visible-subnav' : 'invisible-subnav';
    }
  }, (0, _vuex.mapGetters)(['hasDarkTheme']), (0, _vuex.mapState)({
    notifications: function notifications(state) {
      return state.notifications.messages;
    },
    loggedIn: function loggedIn(state) {
      return state.user.loggedIn;
    }
  })),

  methods: {
    checkTheme: function checkTheme() {
      if (this.hasDarkTheme !== null) {
        this.hasDarkTheme ? this.$store.dispatch('setDarkTheme') : this.$store.dispatch('setLightTheme');
      } else if (this.hasDarkTheme === null && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.$store.dispatch('setDarkTheme');
      } else {
        this.$store.dispatch('setLightTheme');
      }
    }
  },

  components: {
    TopNavbar: _TopNavbar2.default,
    BottomNavbar: _BottomNavbar2.default,
    Foot: _Foot2.default,
    Notifications: _Notifications2.default,
    Notices: _Notices2.default,
    RefreshPasswordModal: _RefreshPasswordModal2.default,
    Signup: _Signup2.default
  }
};

/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(42);

var _bootstrapVue = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      servicesNav: [{ param: 'connectivity', label: 'Connectivity' }, { param: 'emails', label: 'Email' }, { param: 'servers', label: 'Servers' }, { param: 'hosting', label: 'Hosting' }, { param: 'domains', label: 'Domains' }, { param: 'dnspanel', label: 'DNS' }, { param: 'colocations', label: 'Colocation' }, { param: 'ssl', label: 'SSL' }, { param: 'voip', label: 'VoIP' }]
    };
  },


  computed: (0, _extends3.default)({
    hasRouteName: function hasRouteName() {
      return 'name' in this.$store.state.route && this.$store.state.route.name !== undefined;
    },
    onAccountTab: function onAccountTab() {
      return this.hasRouteName && ['account'].includes(this.$store.state.route.name);
    },
    onAdminTab: function onAdminTab() {
      return this.hasRouteName && ['admin'].includes(this.$store.state.route.name);
    },
    onServicesTab: function onServicesTab() {
      return this.hasRouteName && ['services', 'servicesParam', 'manage-server', 'server', 'ssl', 'domain_redirects'].includes(this.$store.state.route.name);
    },
    onBillingTab: function onBillingTab() {
      return this.hasRouteName && ['billing', 'payment', 'invoice'].includes(this.$store.state.route.name);
    }
  }, (0, _vuex.mapGetters)(['hasPaymentsViewPerm', 'hasServicesViewPerm', 'isSiteAdmin'])),

  methods: {
    logout: function logout() {
      this.$store.dispatch('logout', this.$router);
    }
  },

  components: {
    BNavbar: _bootstrapVue.BNavbar,
    BNavItem: _bootstrapVue.BNavItem,
    BNavbarBrand: _bootstrapVue.BNavbarBrand,
    BNavbarToggle: _bootstrapVue.BNavbarToggle,
    BCollapse: _bootstrapVue.BCollapse,
    BNavbarNav: _bootstrapVue.BNavbarNav,
    BIconBoxArrowRight: _bootstrapVue.BIconBoxArrowRight
  }
};

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrapVue = __webpack_require__(31);

exports.default = {
  data: function data() {
    return {
      checked: false
    };
  },
  mounted: function mounted() {
    this.checked = this.value;
  },


  computed: {
    isChecked: function isChecked() {
      return this.checked;
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    clicked: function clicked() {
      this.$emit('click');
      this.checked = !this.checked;
    }
  },

  watch: {
    value: function value(new_val, old_val) {
      this.checked = new_val;
    },
    isChecked: function isChecked(new_val, old_val) {
      this.$emit('input', new_val);
    }
  },

  components: {
    BButton: _bootstrapVue.BButton,
    BFormCheckbox: _bootstrapVue.BFormCheckbox
  }
};

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrapVue = __webpack_require__(31);

exports.default = {
  props: {
    buttonText: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    },
    buttonType: {
      type: String,
      required: false,
      default: 'default'
    },
    dropup: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    }
  },

  computed: {
    dropClass: function dropClass() {
      return this.dropup ? 'dropup' : 'dropdown';
    }
  },

  components: {
    BDropdown: _bootstrapVue.BDropdown,
    BDropdownItem: _bootstrapVue.BDropdownItem
  }
};

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  methods: {
    copy: function copy() {
      navigator.clipboard.writeText(this.text);
      this.$emit('click');
    }
  },
  props: {
    text: {
      required: true,
      type: String
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    showCheck: {
      required: false,
      type: Boolean,
      default: false
    }
  }
};

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ConfirmButton = __webpack_require__(1278);

var _ConfirmButton2 = _interopRequireDefault(_ConfirmButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_ConfirmButton2.default],

  props: {
    buttonType: {
      type: String,
      required: false,
      default: 'danger'
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Delete'
    },
    confirmText: {
      type: String,
      required: false,
      default: 'Confirm Deletion'
    },
    dropup: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    this.setButtonToggle();
  },

  computed: (0, _extends3.default)({
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  }, (0, _vuex.mapGetters)(['hasDarkTheme'])),
  methods: {
    setButtonToggle: function setButtonToggle() {
      if (this.hasDarkTheme) {
        $("#modeSwitch").prop('checked', true);
        $("#modeSwitchLabel").html("Dark mode");
      } else {
        $("#modeSwitch").prop('checked', false);
        $("#modeSwitchLabel").html("Light mode");
      }
    },
    darkmodeToggle: function darkmodeToggle() {
      if ($("#modeSwitch").prop('checked') === true) {
        this.$store.dispatch('setDarkTheme');
        $("#modeSwitchLabel").html("Dark mode");
      } else {
        this.$store.dispatch('setLightTheme');
        $("#modeSwitchLabel").html("Light mode");
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)))

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NodeList = __webpack_require__(346);

var _NodeList2 = _interopRequireDefault(_NodeList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    enterSubmit: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    lang: { type: String, default: navigator.language },
    value: null
  },
  data: function data() {
    return {
      children: [],
      valid: null,
      timeout: null
    };
  },

  watch: {
    valid: function valid(val, old) {
      this.$emit('isvalid', val);
      this.$emit('input', val);
      this.$emit(!val ? 'invalid' : 'valid');
      if (val !== old && this._parent) this._parent.validate();
    }
  },
  methods: {
    validate: function validate() {
      var invalid = !this.children.every(function (el) {
        return el.validate ? el.validate() : el.valid !== undefined ? el.valid : el.required && !~['', null, undefined].indexOf(el.value);
      });
      this.valid = !invalid;
      return !invalid;
    }
  },
  created: function created() {
    this._formValidator = true;
    var parent = this.$parent;
    while (parent && !parent._formValidator) {
      parent = parent.$parent;
    }
    if (parent && parent._formValidator) {
      parent.children.push(this);
      this._parent = parent;
    }
  },
  mounted: function mounted() {
    this.validate();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._parent) {
      var index = this._parent.children.indexOf(this);
      this._parent.children.splice(index, 1);
    }
  }
};

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(42);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _Notification = __webpack_require__(737);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['reverseModalNotifications'])),

  methods: {
    closeNotification: function closeNotification(index) {
      this.$store.commit(types.HIDE_MODAL_NOTIFICATION, index);
    }
  },

  components: {
    Notification: _Notification2.default
  }
};

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _XmModal = __webpack_require__(345);

var _XmModal2 = _interopRequireDefault(_XmModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    open: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    saveBtnText: {
      type: String,
      required: false,
      default: 'Submit'
    },
    modalName: {
      type: String,
      required: true
    },
    backdrop: {
      type: Boolean,
      required: false,
      default: true
    },
    save: {
      required: false,
      default: null
    },
    cancelMethod: {
      required: false,
      default: null
    },
    saveValid: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data: function data() {
    return {
      formValid: false
    };
  },


  methods: {
    setFormValid: function setFormValid(valid) {
      if (valid) {
        this.$emit('valid');
      } else {
        this.$emit('invalid');
      }
    }
  },

  components: {
    FormValidator: _FormValidator2.default,
    XmModal: _XmModal2.default
  },

  watch: {
    'formValid': 'setFormValid'
  }
};

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PayaPaymentAccount = __webpack_require__(766);

var _PayaPaymentAccount2 = _interopRequireDefault(_PayaPaymentAccount);

var _bootstrapVue = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    BModal: _bootstrapVue.BModal,
    PayaPaymentAccount: _PayaPaymentAccount2.default },

  data: function data() {
    return {
      title: "Add credit card",
      form_data: null
    };
  },


  props: {
    id: {
      required: true,
      type: String
    },
    accountName: {
      required: false,
      type: String,
      default: ''
    },
    value: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
        if (!val) {
          this.$emit('hide');
        }
      }
    }
  },

  methods: {
    getPayaUrl: function getPayaUrl() {
      this.$store.dispatch('getPayaUrl', this.accountName);
    },
    cardAdded: function cardAdded(card_data) {
      this.form_data = card_data;
      this.$emit('card-added', this.form_data);
      this.$root.$emit('bv::hide::modal', this.id);
    }
  }
};

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _FormModal = __webpack_require__(755);

var _FormModal2 = _interopRequireDefault(_FormModal);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _vuex = __webpack_require__(42);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      modalName: 'refresh-password',
      formValid: false,
      password: ''
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    username: function username(state) {
      return state.user.username;
    },
    refreshPasswordOpened: function refreshPasswordOpened(state) {
      return state.modals.refresh_password_modal_opened;
    }
  })),

  methods: {
    closeModal: function closeModal() {
      this.resetForm();
      this.$store.commit(types.CLOSE_REFRESH_PASSWORD);
    },
    resetForm: function resetForm() {
      this.password = '';
    },
    save: function save() {
      var _this = this;

      return _authRequest2.default.refreshAccessToken({
        username: this.username,
        password: this.password
      }).then(function () {
        _this.closeModal();
      });
    },
    setFormValid: function setFormValid(valid) {
      this.formValid = valid;
    }
  },
  components: {
    XmInput: _XmInput2.default,
    FormModal: _FormModal2.default
  }
};

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _ModalNotifications = __webpack_require__(761);

var _ModalNotifications2 = _interopRequireDefault(_ModalNotifications);

var _bootstrapVue = __webpack_require__(31);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _TextOverlay = __webpack_require__(223);

var _TextOverlay2 = _interopRequireDefault(_TextOverlay);

var _DeleteButton = __webpack_require__(756);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      saving: false,
      deleting: false
    };
  },


  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },

    save: {
      required: false,
      default: null
    },
    saveDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    saveText: {
      type: String,
      required: false,
      default: 'Save'
    },
    savingText: {
      type: String,
      required: false,
      default: ''
    },

    cancelMethod: {
      required: false,
      default: null
    },
    cancelDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    cancelText: {
      type: String,
      required: false,
      default: 'Cancel'
    },

    deleteMethod: {
      required: false,
      default: null
    },
    deleteDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    deletingText: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {
    saveClicked: function saveClicked() {
      if (this.save === null) {
        return _promise2.default.resolve();
      };
      this.saving = true;
      var self = this;

      return this.save().then(function () {
        self.saving = false;
      }).catch(function (exception) {
        self.saving = false;throw exception;
      });
    },
    cancelClicked: function cancelClicked() {
      if (this.cancelMethod === null) {
        return _promise2.default.resolve();
      };
      return this.cancelMethod();
    },
    deleteClicked: function deleteClicked() {
      this.deleting = true;
      var self = this;
      return this.deleteMethod().then(function () {
        self.deleting = false;
      }).catch(function () {
        self.deleting = false;
      });
    },
    closeModalNotifications: function closeModalNotifications() {
      this.$store.commit(types.HIDE_ALL_MODAL_NOTIFICATIONS);
      this.$emit('hide');
      this.saving = false;
      this.deleting = false;
      this.$emit('input', false);
    }
  },

  components: {
    ModalNotifications: _ModalNotifications2.default,
    BModal: _bootstrapVue.BModal,
    BOverlay: _bootstrapVue.BOverlay,
    TextOverlay: _TextOverlay2.default,
    DeleteButton: _DeleteButton2.default,
    BButton: _bootstrapVue.BButton
  }
};

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _bootstrapVue = __webpack_require__(31);

var _vuex = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bankValid = __webpack_require__(1272);

exports.default = {
  emits: ['form-invalid', 'form-state', 'form-valid', 'input'],
  props: {
    accountName: {
      required: false,
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      checking: 'CHECKING',
      savings: 'SAVINGS',
      extra_routing_numbers: ['124003284', '031101334'],
      form_data: {
        name: this.accountName.trim(),
        routing: '',
        account: '',
        account_type: ''
      }
    };
  },


  computed: (0, _extends3.default)({
    bankNameValid: function bankNameValid() {
      if (this.form_data.name === '') {
        return false;
      }
      return (/^[a-z A-Z]+$/.test(this.form_data.name)
      );
    },
    bankNamePotentiallyValid: function bankNamePotentiallyValid() {
      if (this.form_data.name === '') {
        return true;
      }
      return (/^[a-z A-Z]+$/.test(this.form_data.name)
      );
    },
    bankRoutingValid: function bankRoutingValid() {
      var routingNum = this.form_data.routing;
      return Boolean(bankValid.routingNumber(routingNum).isValid | this.extra_routing_numbers.includes(routingNum));
    },
    bankRoutingPotentiallyValid: function bankRoutingPotentiallyValid() {
      var validation = bankValid.routingNumber(this.form_data.routing);
      return validation.isPotentiallyValid;
    },
    bankAccountValid: function bankAccountValid() {
      var validation = bankValid.accountNumber(this.form_data.account);
      return validation.isValid;
    },
    bankAccountPotentiallyValid: function bankAccountPotentiallyValid() {
      var validation = bankValid.accountNumber(this.form_data.account);
      return validation.isPotentiallyValid;
    },
    bankAccountTypeValid: function bankAccountTypeValid() {
      return [this.checking, this.savings].includes(this.form_data.account_type);
    },
    bankIsValid: function bankIsValid() {
      return !!(this.bankNameValid && this.bankRoutingValid && this.bankAccountValid);
    },
    formDataValid: function formDataValid() {
      return this.bankIsValid && this.bankAccountTypeValid;
    },
    formData: function formData() {
      return this.form_data;
    }
  }, (0, _vuex.mapGetters)(['hasDarkTheme'])),

  methods: {
    resetForm: function resetForm() {
      this.form_data = {
        name: this.accountName.trim(),
        routing: '',
        account: '',
        account_type: ''
      };
    }
  },

  watch: {
    formData: {
      handler: function handler(new_val) {
        this.$emit('input', new_val);
      },

      deep: true
    },
    formDataValid: function formDataValid(new_val) {
      this.$emit('form-state', new_val);
      this.$emit(new_val ? 'form-valid' : 'form-invalid');
    }
  },

  components: {
    BFormInput: _bootstrapVue.BFormInput
  }
};

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      credit_card: 'CREDIT_CARD',
      ach: 'ACH',
      account_type: this.value
    };
  },

  props: {
    value: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    setAccountType: function setAccountType(account_type) {
      this.account_type = account_type;
      this.$emit('input', this.account_type);
    }
  }
};

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

var _RevioAddress = __webpack_require__(767);

var _RevioAddress2 = _interopRequireDefault(_RevioAddress);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { RevioAddress: _RevioAddress2.default },
  data: function data() {
    return {
      scrolldown: _helpers2.default.scrolldown,
      address_valid: false,
      address_string_length: 20,
      form_data: {
        alternate_billing_address: null,
        auto_pay: true,
        billing_address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip_code: '',
          zip_ext: '',
          fname: this.firstName,
          lname: this.lastName,
          mnami: '',
          cmp_name: ''
        }
      }
    };
  },


  props: {
    showBillingAddress: {
      type: Boolean,
      required: false,
      default: false
    },
    firstName: {
      type: String,
      required: false,
      default: ''
    },
    lastName: {
      type: String,
      required: false,
      default: ''
    },
    formattedAddress: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    copyAddress: function copyAddress() {
      if (this.form_data.alternate_billing_address === null) {
        return null;
      }
      return !this.form_data.alternate_billing_address;
    },
    addressString: function addressString() {
      var address_string = this.formattedAddress;
      return address_string.length <= this.address_string_length ? address_string : address_string.substring(0, this.address_string_length) + '...';
    },
    addressIsValid: function addressIsValid() {
      return this.address_valid;
    },
    formDataValid: function formDataValid() {
      return this.copyAddress !== null && (this.copyAddress || this.addressIsValid);
    },
    formData: function formData() {
      return this.form_data;
    }
  },

  methods: {
    setAutoPay: function setAutoPay(auto_pay) {
      this.form_data.auto_pay = auto_pay;
    },
    setCopyAddress: function setCopyAddress(value) {
      _logger2.default.debug('set copy address', value);
      this.form_data.alternate_billing_address = !value;
    }
  },

  watch: {
    formData: {
      handler: function handler(new_val) {
        this.$emit('input', new_val);
      },

      deep: true
    },
    formDataValid: function formDataValid(new_val) {
      this.$emit('form-state', new_val);
      this.$emit(new_val ? 'form-valid' : 'form-invalid');
    }
  }
};

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _bootstrapVue = __webpack_require__(31);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  name: 'Notice',
  props: {
    notice: {
      required: true,
      type: Object
    }
  },
  computed: {
    classType: function classType() {
      return 'alert-info';
    }
  },
  methods: {
    close: function close() {
      this.$store.dispatch('acknowledgeNotice', this.notice['id']);
    },
    ignoreNotice: function ignoreNotice() {
      this.$store.commit(types.REMOVE_NOTICE, this.notice['id']);
    }
  },
  components: {
    BDropdown: _bootstrapVue.BDropdown,
    BDropdownItem: _bootstrapVue.BDropdownItem
  }
};

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _Notice = __webpack_require__(764);

var _Notice2 = _interopRequireDefault(_Notice);

var _vuex = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Notices',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    loggedIn: function loggedIn(state) {
      return state.user.loggedIn;
    }
  }), (0, _vuex.mapGetters)(['activeNotices'])),
  watch: {
    loggedIn: function loggedIn(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.$store.dispatch('getNotices');
      }
    }
  },
  components: {
    Notice: _Notice2.default
  }
};

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrapVue = __webpack_require__(31);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {};
  },


  computed: {
    classType: function classType() {
      if (this.notification.type === 'error') {
        return 'danger';
      }
      return this.notification.type;
    },
    multiMessage: function multiMessage() {
      return Array.isArray(this.notification.message);
    }
  },

  methods: {
    closeNotification: function closeNotification() {
      this.$store.commit(types.HIDE_NOTIFICATION, this.notification.index);
    }
  },

  props: {
    notification: {
      required: true,
      type: Object
    }
  },
  components: {
    BAlert: _bootstrapVue.BAlert
  }
};

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(42);

var _Notification = __webpack_require__(737);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['reverseNotifications'])),

  components: {
    Notification: _Notification2.default
  }
};

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _bootstrapVue = __webpack_require__(31);

var _ShowPasswordField = __webpack_require__(1291);

var _ShowPasswordField2 = _interopRequireDefault(_ShowPasswordField);

var _PasswordGenerator = __webpack_require__(765);

var _PasswordGenerator2 = _interopRequireDefault(_PasswordGenerator);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var zxcvbn = __webpack_require__(759);

exports.default = {
  emits: ['form-state', 'input'],
  data: function data() {
    return {
      newPassConfirm: '',
      showNewPass: false,
      formValid: false,
      showSuggestions: false,
      passwordMinLength: 12,
      passwordMaxLength: 127,
      passwordMinComplexity: 100,
      passwordGeneratorOpen: false,
      password: this.value,
      oldPassword: '',
      collapseVisible: false,
      modalVisible: false,
      dangerSuggestion: '',
      warningSuggestion: ''
    };
  },

  props: {
    value: {
      default: '',
      type: String
    },
    suggestionsInModal: {
      default: false,
      type: Boolean
    },
    requireOldPassword: {
      default: false,
      type: Boolean
    },
    isNewPassword: {
      default: true,
      type: Boolean
    },
    passwordInModal: {
      default: false,
      type: Boolean
    },
    hidePasswordNotifications: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    formData: function formData() {
      return {
        old_password: this.oldPassword,
        password: this.password
      };
    },
    passwordLabel: function passwordLabel() {
      return this.isNewPassword ? 'New password' : 'Password';
    },
    passwordConfirmLabel: function passwordConfirmLabel() {
      return this.isNewPassword ? 'Confirm new password' : 'Confirm password';
    },
    passwordHelp: function passwordHelp() {
      return 'Enter a password from ' + this.passwordMinLength + ' to ' + this.passwordMaxLength + ' characters';
    },
    passwordsMatch: function passwordsMatch() {
      return this.password === this.newPassConfirm;
    },
    newOldPasswordsMatch: function newOldPasswordsMatch() {
      if (!this.requireOldPassword) {
        return false;
      }
      return this.password === this.oldPassword;
    },
    passwordLength: function passwordLength() {
      return this.password.length;
    },
    passwordShort: function passwordShort() {
      if (this.passwordLength === 0 || this.newPassConfirm === 0) {
        return false;
      }
      return this.passwordLength < this.passwordMinLength;
    },
    passwordLong: function passwordLong() {
      return this.passwordLength > this.passwordMaxLength;
    },
    passwordLengthOk: function passwordLengthOk() {
      return this.passwordLength >= this.passwordMinLength && this.passwordLength <= this.passwordMaxLength;
    },
    passwordStats: function passwordStats() {
      return zxcvbn(this.password);
    },
    passwordComplexity: function passwordComplexity() {
      return this.passwordStats.score * 25;
    },
    passwordComplexityPassed: function passwordComplexityPassed() {
      if (this.passwordLength === 0 || this.newPassConfirm === 0) {
        return true;
      }
      return this.passwordComplexity >= this.passwordMinComplexity;
    },
    passwordIsValid: function passwordIsValid() {
      return this.passwordsMatch && this.passwordComplexityPassed && this.passwordLengthOk;
    },
    oldPasswordIsValid: function oldPasswordIsValid() {
      return this.oldPassword.length > 0;
    },
    formIsValid: function formIsValid() {
      if (this.requireOldPassword && (!this.oldPasswordIsValid || this.newOldPasswordsMatch)) {
        return false;
      }
      return this.passwordIsValid && this.formValid;
    }
  },
  methods: {
    toggleShowNewPass: function toggleShowNewPass(val) {
      this.showNewPass = val;
    },
    setDangerSuggestion: function setDangerSuggestion() {
      if (!this.showSuggestions) {
        return '';
      }
      var danger_suggestions = [];

      if (!this.passwordComplexityPassed) {
        danger_suggestions.push('Password score too low.');
      }
      if (this.passwordShort) {
        danger_suggestions.push('Password too short.');
      }
      if (this.passwordLong) {
        danger_suggestions.push('Password too long.');
      }
      if (this.requireOldPassword && this.newOldPasswordsMatch) {
        danger_suggestions.push('New password must be different from current password.');
      }
      this.dangerSuggestion = danger_suggestions.join(' ').trim();
    },
    setWarningSuggestion: function setWarningSuggestion() {
      if (!this.showSuggestions) {
        return '';
      }
      var warning_suggestion = '';
      var warning_suggestions = [];
      if (!this.passwordComplexityPassed && this.passwordStats.feedback.warning) {
        warning_suggestions.push(this.passwordStats.feedback.warning);
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.passwordStats.feedback.suggestions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var suggestion = _step.value;

          warning_suggestions.push(suggestion);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(warning_suggestions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _suggestion = _step2.value;

          if (_suggestion.slice(-1) !== '.') {
            _suggestion += '.';
          }
          warning_suggestion += _suggestion + ' ';
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.warningSuggestion = warning_suggestion.trim();
    },
    generatedPasswordSelected: function generatedPasswordSelected(password) {
      this.password = password;
      if (this.suggestionsInModal) {
        this.modalVisible = false;
      } else {
        this.collapseVisible = false;
      }
    }
  },
  watch: {
    passwordLength: function passwordLength(new_val) {
      if (!this.showSuggestions) {
        if (new_val > 0) {
          this.showSuggestions = true;
        }
      }
    },
    formIsValid: function formIsValid(new_val) {
      this.$emit('form-state', new_val);
    },

    formData: {
      handler: function handler(new_val, old_val) {
        this.$emit('input', new_val);
      },

      deep: true
    },
    password: function password(new_val, old_val) {
      _helpers2.default.debounce(this.setDangerSuggestion, 750)();
      _helpers2.default.debounce(this.setWarningSuggestion, 750)();
    },
    oldPassword: function oldPassword(new_val, old_val) {
      _helpers2.default.debounce(this.setDangerSuggestion, 750)();
      _helpers2.default.debounce(this.setWarningSuggestion, 750)();
    }
  },
  components: {
    BCard: _bootstrapVue.BCard,
    BCollapse: _bootstrapVue.BCollapse,
    BProgress: _bootstrapVue.BProgress,
    FormValidator: _FormValidator2.default,
    ShowPasswordField: _ShowPasswordField2.default,
    PasswordGenerator: _PasswordGenerator2.default,
    BIconXLg: _bootstrapVue.BIconXLg,
    BIconInfoCircleFill: _bootstrapVue.BIconInfoCircleFill,
    BIconCaretDownFill: _bootstrapVue.BIconCaretDownFill,
    BModal: _bootstrapVue.BModal,
    BButton: _bootstrapVue.BButton,
    XmInput: _XmInput2.default,
    BFormInput: _bootstrapVue.BFormInput
  }

};

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(42);

var _CopyPasteInput = __webpack_require__(1279);

var _CopyPasteInput2 = _interopRequireDefault(_CopyPasteInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PasswordGenerator',
  components: { CopyPasteInput: _CopyPasteInput2.default },

  props: {
    genericMessage: {
      default: false,
      type: Boolean
    },
    passwordLabel: {
      default: 'New password',
      type: String
    }
  },

  data: function data() {
    return {
      minNumbers: 2,
      symbolList: ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '-', '_', '+', '=', '/', '[', ']', '{', '}', '<', '>', ',', '.', '?'],
      generatedPasswords: [],
      clickedCopyInput: null,
      wordsSelected: [[false, false, false], [false, false, false], [false, false, false], [false, false, false], [false, false, false]]

    };
  },


  computed: (0, _extends3.default)({
    wordListFilled: function wordListFilled() {
      return this.passwordWordList.length === 15;
    },
    generateButtonDisabled: function generateButtonDisabled() {
      return this.wordsSelectedList.length < 3;
    },
    wordList2D: function wordList2D() {
      if (!this.wordListFilled) {
        return [];
      }
      var wordList = [];
      var passwordWordListCopy = this.passwordWordList.slice();

      for (var row = 0; row < 5; row++) {
        var rowList = [];
        for (var column = 0; column < 3; column++) {
          rowList.push(passwordWordListCopy.pop());
        }
        wordList.push(rowList);
      }
      return wordList;
    },
    wordsSelectedList: function wordsSelectedList() {
      var selectedList = [];
      for (var row = 0; row < 5; row++) {
        for (var col = 0; col < 3; col++) {
          if (this.wordsSelected[row][col]) {
            selectedList.push(this.wordList2D[row][col]);
          }
        }
      }
      return selectedList;
    }
  }, (0, _vuex.mapState)({
    passwordWordList: function passwordWordList(state) {
      return state.user.passwordWordList;
    }
  })),

  mounted: function mounted() {
    this.refreshWordlist();
  },


  methods: {
    refreshWordlist: function refreshWordlist() {
      var _this = this;

      this.$store.dispatch('updatePasswordWordList').then(function (result) {
        _this.resetWordsSelected();
      });
    },
    resetWordsSelected: function resetWordsSelected() {
      this.wordsSelected = [];
      for (var row = 0; row < 5; row++) {
        var rowArray = [];
        for (var col = 0; col < 5; col++) {
          rowArray.push(false);
        }
        this.wordsSelected.push(rowArray);
      }
    },
    selectWord: function selectWord(row, col) {
      row -= 1;
      col -= 1;

      var newRowArr = this.wordsSelected[row];
      newRowArr[col] = !this.wordsSelected[row][col];
      this.wordsSelected.splice(row, 1, newRowArr);
    },
    getRandomInt: function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);

      return Math.floor(Math.random() * (max - min)) + min;
    },
    getRandomBoolean: function getRandomBoolean() {
      return Math.random() >= 0.5;
    },
    getRandomSymbol: function getRandomSymbol() {
      return this.symbolList[this.getRandomInt(0, this.symbolList.length)];
    },
    capitalize: function capitalize(word) {
      if (typeof word !== 'string') return '';
      return word.charAt(0).toUpperCase() + word.slice(1);
    },
    isNumeric: function isNumeric(char) {
      return !isNaN(parseInt(char, 10));
    },
    includesMinNumbers: function includesMinNumbers(symbolNumList) {
      var numNumbers = 0;
      for (var index in symbolNumList) {
        var cur = symbolNumList[index];
        if (this.isNumeric(cur)) {
          numNumbers += 1;
        }
      }
      return numNumbers >= this.minNumbers;
    },
    includesSymbol: function includesSymbol(symbolNumList) {
      for (var index in symbolNumList) {
        var cur = symbolNumList[index];
        if (this.symbolList.includes(cur)) {
          return true;
        }
      }
      return false;
    },
    generatePassword: function generatePassword() {
      var newPassword = '';

      var symbolNumList = [];
      while (!this.includesMinNumbers(symbolNumList) || !this.includesSymbol(symbolNumList)) {
        symbolNumList = [];
        for (var count = 0; count < 4; count++) {
          if (this.getRandomBoolean()) {
            symbolNumList.push(this.getRandomSymbol());
          } else {
            symbolNumList.push(this.getRandomInt(0, 10).toString());
          }
        }
      }

      newPassword = newPassword.concat(symbolNumList[0]);

      var wordsList = this.wordsSelectedList.slice();

      for (var i = 0; i < 3; i++) {
        var selectedWordIndex = this.getRandomInt(0, wordsList.length);
        var selectedWord = this.capitalize(wordsList[selectedWordIndex]);
        wordsList.splice(selectedWordIndex, 1);
        newPassword = newPassword.concat(selectedWord);
        newPassword = newPassword.concat(symbolNumList[i + 1]);
      }

      this.generatedPasswords.push(newPassword);
    },
    passwordSelected: function passwordSelected(password, index) {
      this.clickedCopyInput = index;
      this.$emit('password-selected', password);
    }
  }
};

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

var _vuex = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      allowed_urls: ["https://api.sandbox.payaconnect.com", "https://api.payaconnect.com"],
      response_received: false,
      form_data: {
        internal_token: '',
        token: '',
        fname: '',
        lname: '',
        exp_month: 0,
        exp_year: 0,
        last_four: '',
        brand: ''
      }
    };
  },
  mounted: function mounted() {
    window.addEventListener("message", this.receiveMessage, false);
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    paya_url: function paya_url(state) {
      return state.billing.paya_url;
    }
  })),

  methods: {
    receiveMessage: function receiveMessage(event) {
      if (!this.allowed_urls.includes(event.origin)) {
        return;
      }
      var data = void 0;
      try {
        data = JSON.parse(event.data);
      } catch (error) {
        _logger2.default.info('invalid data: ', event.data);
        _logger2.default.info('error: ', error);
        return;
      }
      try {
        this.form_data.internal_token = data.account_vault_api_id;
        this.form_data.token = data.id;
        this.form_data.last_four = data.last_four;
        this.form_data.brand = String(data.account_type).toUpperCase();
        var split_name = data.account_holder_name.split(' ');
        this.form_data.fname = split_name[0];

        if (split_name.length > 1) {
          this.form_data.lname = split_name.slice(1).join(' ');
        }
        this.form_data.exp_month = Number(data.exp_date.substring(0, 2));
        this.form_data.exp_year = Number('20' + data.exp_date.substring(2));
      } catch (error) {
        _logger2.default.info('Receive Error: ', error);
      }
      this.$emit('card-added', this.form_data);
    }
  }
};

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _AddressForm = __webpack_require__(739);

var _AddressForm2 = _interopRequireDefault(_AddressForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      addressValid: false,
      revio_address: {},
      is_company: this.company,
      form_data: {
        fname: '',
        mnami: '',
        lname: '',
        cmp_name: '' }
    };
  },


  props: {
    'value': {
      required: false,
      default: null
    },
    'company': {
      required: false,
      default: false
    }
  },

  computed: {
    companyNameValid: function companyNameValid() {
      if (this.form_data.cmp_name === '') {
        return false;
      }
      return (/^[a-zA-Z]+$/.test(this.form_data.cmp_name)
      );
    },
    companyNamePotentiallyValid: function companyNamePotentiallyValid() {
      if (this.form_data.cmp_name === '') {
        return true;
      }
      return (/^[a-zA-Z]+$/.test(this.form_data.cmp_name)
      );
    },
    fnameValid: function fnameValid() {
      if (this.form_data.fname === '') {
        return false;
      }
      return (/^[a-zA-Z]+$/.test(this.form_data.fname) || this.is_company
      );
    },
    fnamePotentiallyValid: function fnamePotentiallyValid() {
      if (this.form_data.fname === '') {
        return true;
      }
      return (/^[a-zA-Z]+$/.test(this.form_data.fname)
      );
    },
    mnamiValid: function mnamiValid() {
      if (this.form_data.mnami === '') {
        return true;
      }
      return (/^[a-zA-Z]+$/.test(this.form_data.mnami) || this.is_company
      );
    },
    mnamiPotentiallyValid: function mnamiPotentiallyValid() {
      if (this.form_data.mnami === '') {
        return true;
      }
      return (/^[a-zA-Z]+$/.test(this.form_data.mnami)
      );
    },
    lnameValid: function lnameValid() {
      if (this.form_data.lname === '') {
        return false;
      }
      return (/^[a-zA-Z ]+$/.test(this.form_data.lname) || this.is_company
      );
    },
    lnamePotentiallyValid: function lnamePotentiallyValid() {
      if (this.form_data.lname === '') {
        return true;
      }
      return (/^[a-zA-Z ]+$/.test(this.form_data.lname)
      );
    },
    addressIsValid: function addressIsValid() {
      return this.addressValid;
    },
    formValid: function formValid() {
      return this.fnameValid && this.lnameValid && this.mnamiValid && this.addressValid;
    },
    formData: function formData() {
      return (0, _extends3.default)({}, this.form_data, this.revio_address);
    }
  },

  methods: {
    setAddressValid: function setAddressValid(value) {
      this.addressValid = value;
    },
    setAddress: function setAddress(address) {
      this.revio_address = address;
    }
  },

  components: {
    AddressForm: _AddressForm2.default
  },

  watch: {
    formData: {
      handler: function handler(new_value, old_value) {
        this.$emit('input', new_value);
      },

      deep: true
    },
    formValid: function formValid(new_value, old_value) {
      this.$emit('form-state', new_value);
      this.$emit(new_value ? 'form-valid' : 'form-invalid');
    }
  }
};

/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrapVue = __webpack_require__(31);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _regex = __webpack_require__(112);

var _regex2 = _interopRequireDefault(_regex);

var _connectivityService = __webpack_require__(151);

var _connectivityService2 = _interopRequireDefault(_connectivityService);

var _SpeedSelect = __webpack_require__(342);

var _SpeedSelect2 = _interopRequireDefault(_SpeedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form_data: { desired_activation_date: '' },
      regex: _regex2.default,
      overlay_text: '',
      min_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000) };
  },
  mounted: function mounted() {
    this.$emit('form-state', this.serviceValid);
  },


  props: {
    value: {
      required: false,
      default: function _default() {}
    },

    service: {
      required: true,
      type: _connectivityService2.default
    }
  },

  computed: {
    activationDateChosen: function activationDateChosen() {
      return this.form_data.desired_activation_date !== '';
    },
    isProspect: function isProspect() {
      return this.service.address_details.early_signup;
    },
    serviceValid: function serviceValid() {
      if (!this.isProspect) {
        return this.activationDateChosen;
      }
      return true;
    },
    serviceSubmissionData: function serviceSubmissionData() {
      return this.form_data;
    }
  },

  methods: {
    resetForm: function resetForm() {
      this.form_data = { is_tribal: null,
        desired_activation_date: '' };
    }
  },

  watch: {
    serviceValid: function serviceValid(new_val, old_val) {
      this.$emit('form-state', new_val);
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
    },

    serviceSubmissionData: {
      handler: function handler(new_val, old_val) {
        this.$emit('input', new_val);
      },

      deep: true
    }
  },

  components: {
    XmInput: _XmInput2.default,
    FormValidator: _FormValidator2.default,
    SpeedSelect: _SpeedSelect2.default,
    BFormDatepicker: _bootstrapVue.BFormDatepicker
  }

};

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextOverlay = __webpack_require__(223);

var _TextOverlay2 = _interopRequireDefault(_TextOverlay);

var _bootstrapVue = __webpack_require__(31);

var _connectivityService = __webpack_require__(151);

var _connectivityService2 = _interopRequireDefault(_connectivityService);

var _regex = __webpack_require__(112);

var _regex2 = _interopRequireDefault(_regex);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      regex: _regex2.default,
      scrolldown: _helpers2.default.scrolldown,
      querying_api: false,
      overlay_text: '',
      form_data: {
        is_owner: null,
        is_tribal: null,
        owner_phone: '',
        owner_email: '',
        owner_name: ''
      }
    };
  },


  emits: ['form-state', 'form-valid', 'form-invalid', 'input'],
  props: {
    service: {
      required: true,
      type: _connectivityService2.default
    }
  },

  mounted: function mounted() {
    _logger2.default.debug('customer details mounted');
    this.$emit('form-state', this.formValid);
    this.$emit('input', this.formData);
  },


  computed: {
    rentersAllowed: function rentersAllowed() {
      return this.service.service.renters_allowed;
    },
    needsRenterForm: function needsRenterForm() {
      _logger2.default.debug('owner data required', this.service.service.owner_data_required);
      return this.service.service.owner_data_required;
    },
    needsTribalForm: function needsTribalForm() {
      return this.service.service.tribal_data_required;
    },
    isOwner: function isOwner() {
      return this.form_data.is_owner === true;
    },
    isRenter: function isRenter() {
      return this.form_data.is_owner === false;
    },
    validOwnerName: function validOwnerName() {
      return !!this.form_data.owner_name.match(this.regex.name);
    },
    validOwnerEmail: function validOwnerEmail() {
      return !!this.form_data.owner_email.match(this.regex.email);
    },
    validOwnerPhone: function validOwnerPhone() {
      return !!this.form_data.owner_phone.match(this.regex.phone);
    },
    validOwnerContact: function validOwnerContact() {
      return this.validOwnerName && this.validOwnerEmail && this.validOwnerPhone;
    },
    renterFormValid: function renterFormValid() {
      if (this.needsRenterForm) {
        if (this.form_data.is_owner === null) {
          return false;
        }
        if (!this.rentersAllowed) {
          return this.isOwner;
        }
        if (this.isRenter) {
          return this.validOwnerContact;
        }
      }
      return true;
    },
    tribalFormValid: function tribalFormValid() {
      if (this.needsTribalForm) {
        return this.form_data.is_tribal !== null;
      }
      return true;
    },
    signupAllowed: function signupAllowed() {
      if (!this.rentersAllowed) {
        return this.isOwner;
      }
      return true;
    },
    formValid: function formValid() {
      _logger2.default.debug('customer details formValid', this.renterFormValid, this.tribalFormValid, this.signupAllowed);
      return this.renterFormValid && this.tribalFormValid && this.signupAllowed;
    },
    formData: function formData() {
      return this.form_data;
    }
  },

  methods: {
    addRenterContact: function addRenterContact() {
      this.querying_api = true;
      var self = this;
      this.overlay_text = "Saving contact information...";
      var data = { address_id: this.service.address_details.address_id,
        email: this.form_data.owner_email,
        phone: this.form_data.owner_phone,
        name: this.form_data.owner_name,
        provider_id: this.service.provider.provider_id };
      _authRequest2.default.post({
        url: '/connectivity_clots/renter',
        data: data,
        success: function success(res) {
          self.$emit('contact-added');
          self.querying_api = false;
        },
        error: function error() {
          self.querying_api = false;
        }
      });
    }
  },

  watch: {
    formValid: function formValid(new_val, old_val) {
      this.$emit('form-state', new_val);
      this.$emit(new_val ? 'form-valid' : 'form-invalid');
    },

    formData: {
      handler: function handler(new_val, old_val) {
        if (new_val.is_tribal === null) {
          new_val.is_tribal = false;
        }
        this.$emit('input', new_val);
      },

      deep: true
    }
  },

  components: {
    TextOverlay: _TextOverlay2.default,
    BButton: _bootstrapVue.BButton,
    XmInput: _XmInput2.default
  }

};

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _ServiceableAddressSearch = __webpack_require__(1297);

var _ServiceableAddressSearch2 = _interopRequireDefault(_ServiceableAddressSearch);

var _UtopiaResidential = __webpack_require__(1288);

var _UtopiaResidential2 = _interopRequireDefault(_UtopiaResidential);

var _StrataResidential = __webpack_require__(1287);

var _StrataResidential2 = _interopRequireDefault(_StrataResidential);

var _BonfireResidential = __webpack_require__(1285);

var _BonfireResidential2 = _interopRequireDefault(_BonfireResidential);

var _VoiceService = __webpack_require__(1289);

var _VoiceService2 = _interopRequireDefault(_VoiceService);

var _SpeedSelect = __webpack_require__(342);

var _SpeedSelect2 = _interopRequireDefault(_SpeedSelect);

var _XWiService = __webpack_require__(1290);

var _XWiService2 = _interopRequireDefault(_XWiService);

var _CustomerDetails = __webpack_require__(1286);

var _CustomerDetails2 = _interopRequireDefault(_CustomerDetails);

var _Notifications = __webpack_require__(341);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _vuex = __webpack_require__(42);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "ResidentialConnection",
  components: {
    ServiceableAddressSearch: _ServiceableAddressSearch2.default,
    UtopiaResidential: _UtopiaResidential2.default,
    StrataResidential: _StrataResidential2.default,
    BonfireResidential: _BonfireResidential2.default,
    VoiceService: _VoiceService2.default,
    SpeedSelect: _SpeedSelect2.default,
    'xwi-service': _XWiService2.default,
    CustomerDetails: _CustomerDetails2.default,
    Notifications: _Notifications2.default
  },
  emits: ['form-state', 'form-invalid', 'form-valid', 'input'],
  props: ['value', 'initial_data'],
  data: function data() {
    return {
      scrolldown: _helpers2.default.scrolldown,
      set_address: false,
      address_potentially_serviceable: false,
      speed_details_valid: false,
      router_valid: false,
      customer_details_valid: false,
      connectivity_valid: false
    };
  },


  computed: (0, _extends3.default)({
    serviceDetails: function serviceDetails() {
      return this.ssuServiceDetails;
    },
    provider: function provider() {
      if (this.serviceDetails) {
        return this.serviceDetails.connectivity.service_class_model.provider;
      }
      return { 'name': '' };
    },
    addressPotentiallyServiceable: function addressPotentiallyServiceable() {
      _logger2.default.debug('address potentially serviceable', this.address_potentially_serviceable && this.serviceDetails !== null);
      return this.address_potentially_serviceable && this.serviceDetails !== null;
    },
    customerDetailsValid: function customerDetailsValid() {
      return this.customer_details_valid;
    },
    speedValid: function speedValid() {
      return this.customerDetailsValid && this.addressPotentiallyServiceable && this.speed_details_valid;
    },
    routerValid: function routerValid() {
      return this.speedValid && this.router_valid;
    },
    connectivityValid: function connectivityValid() {
      return this.routerValid && this.connectivity_valid;
    },
    needsVoiceOption: function needsVoiceOption() {
      _logger2.default.debug('provider', this.provider);
      return this.connectivityValid && ['utopia', 'yellowstone_fiber', 'bountiful_fiber', 'lehi_fiber'].includes(this.provider.name);
    },
    serviceValid: function serviceValid() {
      return this.connectivityValid;
    }
  }, (0, _vuex.mapGetters)(['ssuServiceDetails'])),

  methods: {
    setAddressPotentiallyServiceable: function setAddressPotentiallyServiceable(address_potentially_serviceable) {
      _logger2.default.debug('set address potentially serviceable', address_potentially_serviceable);
      this.address_potentially_serviceable = address_potentially_serviceable;
    },
    setPotentialServiceableAddressData: function setPotentialServiceableAddressData(details) {
      var _this = this;

      _logger2.default.debug('set potential serviceable address data', details);
      if (this.address_potentially_serviceable) {
        this.$store.commit(types.SELF_SIGNUP_INITIALIZE_CONNECTIVITY_CLOT, details);
        if (!this.set_address) {
          this.set_address = true;
        } else {
          this.$emit('form-invalid');
          this.$emit('form-state', false);
          this.resetAfterAddressForm();

          _logger2.default.debug('resetting address form');
          this.address_potentially_serviceable = false;
          _helpers2.default.sleep(100).then(function () {
            _this.address_potentially_serviceable = true;
          });
        }
      }
    },
    setCustomerDetailsValid: function setCustomerDetailsValid(customer_details_valid) {
      _logger2.default.debug('customer details valid', customer_details_valid);
      this.customer_details_valid = customer_details_valid;
    },
    setCustomerData: function setCustomerData(details) {
      if (this.customerDetailsValid) {
        _logger2.default.debug('customer details updated', details);
        this.$store.commit(types.SELF_SIGNUP_CONNECTIVITY_SET_CUSTOMER, details);
      }
    },
    setSpeedDetailsValid: function setSpeedDetailsValid(speed_details_valid) {
      this.speed_details_valid = speed_details_valid;
    },
    setSpeedData: function setSpeedData(details) {
      _logger2.default.debug('speed details updated', details);
      this.$store.commit(types.SELF_SIGNUP_CONNECTIVITY_SET_SPEED, details);
    },
    setRouterValid: function setRouterValid(router_valid) {
      _logger2.default.debug('router valid:', router_valid);
      this.router_valid = router_valid;
    },
    setRouterData: function setRouterData(details) {
      _logger2.default.debug('router details updated', details);
      this.$store.commit(types.SELF_SIGNUP_CONNECTIVITY_SET_ROUTER, details);
    },
    setConnectivityValid: function setConnectivityValid(connectivity_valid) {
      _logger2.default.debug('connectivity valid:', connectivity_valid);
      this.connectivity_valid = connectivity_valid;
    },
    setUtopiaDetails: function setUtopiaDetails(details) {
      _logger2.default.debug('utopia details updated', details);
      this.$store.commit(types.SELF_SIGNUP_CONNECTIVITY_SET_UTOPIA, details);
    },
    setStrataData: function setStrataData(details) {
      _logger2.default.debug('strata details updated', details);
      this.$store.commit(types.SELF_SIGNUP_CONNECTIVITY_SET_STRATA, details);
    },
    setSouthernUteData: function setSouthernUteData(details) {
      _logger2.default.debug('southern ute details updated', details);
      this.$store.commit(types.SELF_SIGNUP_CONNECTIVITY_SET_SOUTHERN_UTE, details);
    },
    setVoiceData: function setVoiceData(details) {
      _logger2.default.debug('voice details updated', details);
      this.$store.commit(types.SELF_SIGNUP_CONNECTIVITY_SET_VOICE, details);
    },
    resetAfterAddressForm: function resetAfterAddressForm() {
      this.speed_details_valid = false;
      this.router_valid = false;
      this.customer_details_valid = false;
      this.connectivity_valid = false;
      this.$store.commit(types.SET_SERVICE_CLASS_ORDER, ['connectivity', 'xwi', 'voice', 'subnet', 'static_ip']);
    },
    resetBeforeAddressForm: function resetBeforeAddressForm() {
      this.address_potentially_serviceable = false;
      this.resetAfterAddressForm();
    }
  },

  watch: {
    serviceValid: function serviceValid(new_val) {
      this.$emit('form-state', new_val);
      this.$emit(new_val ? 'form-valid' : 'form-invalid');
    },
    initial_data: function initial_data() {
      this.initFromAddress();
    },
    addressPotentiallyServiceable: function addressPotentiallyServiceable(new_val) {
      new_val ? this.resetAfterAddressForm() : this.resetBeforeAddressForm();
    }
  }
};

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _keys = __webpack_require__(135);

var _keys2 = _interopRequireDefault(_keys);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _bootstrapVue = __webpack_require__(31);

var _TextOverlay = __webpack_require__(223);

var _TextOverlay2 = _interopRequireDefault(_TextOverlay);

var _SpeedSelect = __webpack_require__(342);

var _SpeedSelect2 = _interopRequireDefault(_SpeedSelect);

var _GoogleMapsDraggable = __webpack_require__(1295);

var _GoogleMapsDraggable2 = _interopRequireDefault(_GoogleMapsDraggable);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _regex = __webpack_require__(112);

var _regex2 = _interopRequireDefault(_regex);

var _connectivityService = __webpack_require__(151);

var _connectivityService2 = _interopRequireDefault(_connectivityService);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      scrolldown: _helpers2.default.scrolldown,
      regex: _regex2.default,
      overlay_text: '',
      form_data: { drop_details: { latitude: '', longitude: '', notes: '', accepted: true },
        install_details: { installation_type: '', start_datetime: '', end_datetime: '', date: '', time: 0,
          display_time: '', duration: 0, notes: '', external_install_id: '' } },
      service_type: 'strata-residential',
      exterior_notes_placeholder: 'Provide any details you would like the installer to know regarding the outside portion of your fiber installation.',
      interior_notes_placeholder: 'Provide any details you would like the installer to know regarding the inside portion of your fiber installation. For example, do you have internal network wiring you want the fiber connected to? Where do you want your wireless router?',
      renter_contact_form: { email: '', name: '', phone: '' },
      renter_contact_form_valid: false,
      location_details: { lat: '', lon: '' },
      install_dates: [],
      install_start_date: null,
      dates_by_date: {},
      only_dates: [],
      querying_api: false,
      install_date: null,
      install_time: 'Choose an install time',
      install_times: []

    };
  },


  props: {
    value: {
      required: false,
      default: function _default() {}
    },

    service: {
      required: true,
      type: _connectivityService2.default
    }
  },

  mounted: function mounted() {
    this.location_details.lat = this.dropDetails.drop_latitude;
    this.location_details.lon = this.dropDetails.drop_longitude;
    this.$emit('form-state', this.serviceValid);
  },


  computed: {
    installationTypeSelected: function installationTypeSelected() {
      return this.form_data.install_details.installation_type !== '';
    },
    installType: function installType() {
      return this.form_data.install_details.installation_type;
    },
    installationOptions: function installationOptions() {
      _logger2.default.debug('installation types', this.service.installationOptions());
      return this.service.installationOptions();
    },
    installTypeChosen: function installTypeChosen() {
      return this.installType !== '';
    },
    installDateChosen: function installDateChosen() {
      return this.install_date !== null;
    },
    installTimeChosen: function installTimeChosen() {
      return this.install_time !== 'Choose an install time';
    },
    installationRequiredDetailsValid: function installationRequiredDetailsValid() {
      return this.dropDetails.needs_ont_install && this.installationTypeSelected && this.installDateChosen && this.installTimeChosen;
    },
    dropDetails: function dropDetails() {
      _logger2.default.debug('this service, strata', this.service);
      if ('address_details' in this.service) {
        return this.service.address_details;
      }
      return {};
    },
    locationDetails: function locationDetails() {
      return this.location_details;
    },
    locationChanged: function locationChanged() {
      return !(this.form_data.drop_details.latitude === this.dropDetails.drop_latitude && this.form_data.drop_details.longitude === this.dropDetails.drop_longitude);
    },
    serviceValid: function serviceValid() {
      return !this.dropDetails.needs_ont_install || this.installationRequiredDetailsValid;
    },
    serviceSubmissionData: function serviceSubmissionData() {
      return this.form_data;
    }
  },

  methods: {
    getInstallDates: function getInstallDates() {
      this.querying_api = true;
      this.overlay_text = "Searching Available Installation Dates...";
      var self = this;
      _authRequest2.default.get({
        url: '/connectivity_clots/installation',
        params: { install_type: this.form_data.install_details.installation_type,
          provider_id: this.service.provider.provider_id,
          address_id: this.dropDetails.address_id },
        success: function success(response) {
          self.querying_api = false;
          self.install_start_date = response.startDate;
          self.install_dates = response;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(response['availableTimes']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var datum = _step.value;

              if (!(datum['date'] in self.dates_by_date)) {
                self.dates_by_date[datum['date']] = [];
              }
              self.dates_by_date[datum['date']].push(datum);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          self.only_dates = (0, _keys2.default)(self.dates_by_date);
        },
        error: function error() {
          self.querying_api = false;
        }
      });
    },
    setInstallType: function setInstallType(installation_option) {
      _logger2.default.debug('installation option selected', installation_option);
      this.form_data.install_details.installation_type = installation_option.installation_type;
    },
    setInstallDate: function setInstallDate(installation_data) {
      this.install_time = installation_data.displayTime;
      this.form_data.install_details.external_install_id = installation_data.resourceId;
      this.form_data.install_details.start_datetime = installation_data.startDateTime;
      this.form_data.install_details.end_datetime = installation_data.endDateTime;
      this.form_data.install_details.date = installation_data.date;
      this.form_data.install_details.time = installation_data.time;
      this.form_data.install_details.display_time = installation_data.displayTime;
      this.form_data.install_details.duration = installation_data.duration;
    },
    dateAvailable: function dateAvailable(ymd) {
      return !this.only_dates.includes(ymd);
    },
    resetInstallForm: function resetInstallForm() {
      this.install_dates = [];
      this.dates_by_date = {};
      this.only_dates = [];
      this.querying_api = false;
      this.install_date = null;
      this.install_time = 'Choose an install time';
      this.install_times = [];
    }
  },

  watch: {
    serviceValid: function serviceValid(new_val) {
      this.$emit('form-state', new_val);
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
    },

    serviceSubmissionData: {
      handler: function handler(new_val) {
        new_val.drop_details.accepted = !this.locationChanged;
        this.$emit('input', new_val);
      },

      deep: true
    },
    locationDetails: {
      handler: function handler(new_val) {
        this.form_data.drop_details.latitude = new_val.lat;
        this.form_data.drop_details.longitude = new_val.lon;
      },

      deep: true
    },
    installType: function installType(new_val, old_val) {
      if (new_val !== old_val) {
        this.resetInstallForm();
        this.getInstallDates();
      }
    },
    install_date: function install_date() {
      this.install_times = this.dates_by_date[this.install_date];
    }
  },

  components: {
    GoogleMapsDraggable: _GoogleMapsDraggable2.default,
    XmInput: _XmInput2.default,
    FormValidator: _FormValidator2.default,
    SpeedSelect: _SpeedSelect2.default,
    BFormDatepicker: _bootstrapVue.BFormDatepicker,
    BDropdown: _bootstrapVue.BDropdown,
    BDropdownItem: _bootstrapVue.BDropdownItem,
    TextOverlay: _TextOverlay2.default
  }

};

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectivityService = __webpack_require__(151);

var _connectivityService2 = _interopRequireDefault(_connectivityService);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    XmInput: _XmInput2.default
  },

  data: function data() {
    return {
      form_data: {
        city_customer_id: '',
        city_account_id: ''
      },
      city_customer_id_regex: /^[1-9][0-9]{1,10}$/,
      city_account_id_regex: /^[0-9]{1,30}$/,
      show_utility_bill: false,
      scrolldown: _helpers2.default.scrolldown
    };
  },
  mounted: function mounted() {
    this.$emit('form-state', this.serviceReady);
  },


  props: {
    value: {
      required: false,
      default: function _default() {}
    },

    service: {
      required: true,
      type: _connectivityService2.default
    }
  },

  computed: {
    needsCityAccountForm: function needsCityAccountForm() {
      return this.service.service_class_model.service_class_id === 8;
    },
    serviceSubmissionData: function serviceSubmissionData() {
      return this.form_data;
    },
    serviceReady: function serviceReady() {
      if (!this.needsCityAccountForm) {
        return true;
      }

      return this.form_data.city_customer_id.match(this.city_customer_id_regex) && this.form_data.city_account_id.match(this.city_account_id_regex);
    }
  },

  watch: {
    serviceSubmissionData: {
      handler: function handler(new_val) {
        this.$emit('input', new_val);
      },

      deep: true
    },
    serviceReady: function serviceReady(new_val) {
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
      this.$emit('form-state', new_val);
    }
  }
};

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrapVue = __webpack_require__(31);

var _voiceService = __webpack_require__(349);

var _voiceService2 = _interopRequireDefault(_voiceService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form_data: { contact: false }
    };
  },


  props: {
    value: {
      required: false,
      default: function _default() {}
    },

    service: {
      required: true,
      type: _voiceService2.default
    }
  },

  computed: {
    serviceSubmissionData: function serviceSubmissionData() {
      return this.form_data;
    },
    serviceReady: function serviceReady() {
      return true;
    }
  },

  watch: {
    serviceSubmissionData: {
      handler: function handler(new_val, old_val) {
        this.$emit('input', new_val);
      },

      deep: true
    },
    serviceReady: function serviceReady(new_val, old_val) {
      if (new_val) {
        this.$emit('form-valid');
      } else {
        this.$emit('form-invalid');
      }
    }
  },

  components: {
    BFormCheckbox: _bootstrapVue.BFormCheckbox
  }
};

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _routerService = __webpack_require__(348);

var _routerService2 = _interopRequireDefault(_routerService);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _vuex = __webpack_require__(42);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  emits: ['form-state', 'form-invalid', 'form-valid', 'input'],
  props: {
    service: {
      required: true,
      type: _routerService2.default
    }
  },

  data: function data() {
    return {
      scrolldown: _helpers2.default.scrolldown,
      ten_g_button_clicked: false,
      mesh_purchase: 'mesh_purchase',
      mesh_lease: 'mesh_lease',
      mesh_none: 'mesh_none',
      form_data: {
        needs_router: null,
        external_soid: null,
        router_model: null,
        mesh_quantity: null,
        mesh_type: null
      }
    };
  },


  computed: (0, _extends3.default)({
    meshQuantityDisplay: function meshQuantityDisplay() {
      if (!this.form_data.mesh_quantity) {
        return 0;
      }
      return this.form_data.mesh_quantity;
    },
    activeRouterAvailable: function activeRouterAvailable() {
      return this.service.activeRouterAvailable();
    },
    activeRouterOption: function activeRouterOption() {
      return this.service.getActiveRouterOption();
    },
    meshesAvailable: function meshesAvailable() {
      return this.service.meshesAvailable();
    },
    meshQuantitiesAvailable: function meshQuantitiesAvailable() {
      var quantities = [];
      for (var i = 0; i <= this.meshesAvailable; i++) {
        quantities.push(i);
      }
      return quantities;
    },
    meshMonthlyRate: function meshMonthlyRate() {
      return this.service.meshMonthlyRate();
    },
    grossMonthlyRateReady: function grossMonthlyRateReady() {
      return this.service.getActiveRouterOption() !== null;
    },
    grossMonthlyRate: function grossMonthlyRate() {
      return this.service.grossMonthlyRate();
    },
    isTenG: function isTenG() {
      return this.ssuSelectedSpeedId === 'speed_10000_sym';
    },
    isTenGRouter: function isTenGRouter() {
      return ['speed_2000_sym', 'speed_2500_sym', 'speed_10000_sym'].includes(this.ssuSelectedSpeedId);
    },
    routerImageLink: function routerImageLink() {
      if (this.isTenGRouter) {
        return 'https://asset.xmission.com/xwi/gigaspire+app.png';
      }
      return 'https://asset.xmission.com/xwi/xwi-router-app.png';
    },
    routerSelected: function routerSelected() {
      if (this.isTenG) {
        return this.ten_g_button_clicked;
      }
      return this.form_data.needs_router !== null;
    },
    needsRouter: function needsRouter() {
      return this.form_data.needs_router;
    },
    meshExtendersSelected: function meshExtendersSelected() {
      _logger2.default.debug('mesh extender selected', this.form_data.mesh_quantity, this.form_data.mesh_type);
      return this.form_data.mesh_quantity !== null && this.form_data.mesh_type !== null;
    },
    isMeshLease: function isMeshLease() {
      _logger2.default.debug('isMeshLease', this.form_data.mesh_type, this.mesh_lease);
      return this.form_data.mesh_type === this.mesh_lease;
    },
    isMeshNone: function isMeshNone() {
      return this.form_data.mesh_type === this.mesh_none;
    },
    serviceReady: function serviceReady() {
      return this.routerSelected && (this.needsRouter && this.meshExtendersSelected || !this.needsRouter);
    },
    formData: function formData() {
      return this.form_data;
    }
  }, (0, _vuex.mapGetters)(['ssuSelectedSpeedId'])),

  methods: {
    setNeedsRouter: function setNeedsRouter(needs_router) {
      _logger2.default.debug('setNeedsRouter', needs_router);
      this.form_data.needs_router = needs_router;
      this.form_data.router_model = this.activeRouterOption.router_model;
      this.form_data.external_soid = this.activeRouterOption.external_soid;
      if (!needs_router) {
        this.removeRouter();
      }
    },
    removeRouter: function removeRouter() {
      this.form_data.mesh_quantity = 0;
      this.form_data.mesh_type = this.mesh_none;
      this.form_data.router_model = null;
      this.form_data.external_soid = null;
      this.form_data.needs_router = false;
    },
    setMeshQuantity: function setMeshQuantity(event) {
      var quantity = event.target.value;
      if (quantity > 0) {
        this.form_data.mesh_quantity = quantity;
        this.form_data.mesh_type = this.mesh_lease;
      } else {
        this.setMeshNone();
      }
    },
    setMeshNone: function setMeshNone() {
      this.form_data.mesh_quantity = 0;
      this.form_data.mesh_type = this.mesh_none;
    },
    setMeshNull: function setMeshNull() {
      this.form_data.mesh_quantity = null;
      this.form_data.mesh_type = null;
    }
  },

  watch: {
    isTenG: function isTenG(new_val, old_val) {
      if (new_val && !old_val) {
        this.form_data.needs_router = true;
        this.setMeshNull();
        _logger2.default.debug('10G selected', this.form_data);
      } else if (old_val && !new_val) {
          this.form_data.needs_router = null;
          this.setMeshNull();
          _logger2.default.debug('10G unselected', this.form_data);
        }
    },
    serviceReady: function serviceReady(new_val, old_val) {
      this.$emit('form-state', new_val);
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
    },

    formData: {
      handler: function handler(new_val, old_val) {
        this.$emit('input', new_val);
      },

      deep: true
    }
  }
};

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      showPass: false,
      val: this.value
    };
  },


  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    help: {
      type: String,
      required: false,
      default: ''
    },
    minlength: {
      type: Number,
      required: false,
      default: 0
    },
    maxlength: {
      type: Number,
      required: false,
      default: null
    }
  },

  methods: {
    updateShowPass: function updateShowPass(val) {
      this.showPass = val;
      this.$emit('toggle', val);
    }
  },
  watch: {
    val: function val(_val) {
      this.$emit('input', _val);
    },
    value: function value(val) {
      this.val = val;
    }
  },
  components: {
    XmInput: _XmInput2.default
  }
};

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResidentialConnection = __webpack_require__(768);

var _ResidentialConnection2 = _interopRequireDefault(_ResidentialConnection);

var _vue = __webpack_require__(111);

var _vue2 = _interopRequireDefault(_vue);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "AddServices",
  components: {
    residentialConnection: _ResidentialConnection2.default
  },

  props: {
    serviceTypes: { type: Array, default: function _default() {
        return [];
      }, required: false }
  },

  data: function data() {
    return {
      services: [],
      servicesValid: false
    };
  },


  computed: {
    servicesAreValid: function servicesAreValid() {
      return this.servicesValid;
    }
  },

  methods: {
    setServiceValidity: function setServiceValidity(value) {
      this.servicesValid = value;
    }
  },

  watch: {
    servicesAreValid: {
      handler: function handler(newv, oldv) {
        _logger2.default.debug('services are valid: ', newv);
        this.$emit(newv ? 'form-valid' : 'form-invalid');
        this.$emit('form-state', newv);
      }
    }
  }
};

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _vuex = __webpack_require__(42);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "AddressAutoComplete",
  components: {
    XmInput: _XmInput2.default
  },
  data: function data() {
    return {
      val: '',
      suggestions: [],
      choice: undefined,
      choice_address: undefined,
      clicked: false
    };
  },

  props: ['value', 'initDisplayValue'],
  created: function created() {
    this.debouncedSuggestions = _helpers2.default.debounce(this.getSuggestions, 750);
  },
  mounted: function mounted() {
    this.val = this.value;
    this.initializeFromHash();
    if (this.initDisplayValue !== undefined && this.initDisplayValue !== null && this.initDisplayValue !== '') {
      this.val = this.initDisplayValue;
    }
  },

  computed: (0, _extends3.default)({
    isValid: function isValid() {
      return true;
    },
    showDropdown: function showDropdown() {
      return this.suggestions.length > 0;
    },
    hasWarning: function hasWarning() {
      return false;
    },
    hasError: function hasError() {
      return this.isValid === false;
    },
    hasSuccess: function hasSuccess() {
      return this.isValid === true;
    }
  }, (0, _vuex.mapGetters)(['ssuInitGoogleAddressId'])),
  watch: {
    hasWarning: function hasWarning(newv) {
      this.formClasses(newv, 'has-warning');
    },
    hasSuccess: function hasSuccess(newv) {
      this.formClasses(newv, 'has-success');
    },
    hasError: function hasError(newv) {
      this.formClasses(newv, 'has-error');
    },
    initDisplayValue: function initDisplayValue(newv) {
      this.val = this.initDisplayValue;
    },
    val: function val(newv) {
      if (newv) {
        if (!this.clicked && this.initDisplayValue !== newv) {
          this.debouncedSuggestions(newv);
        } else {
          this.clicked = false;
        }
      }
    },
    choice: function choice(newv) {
      var val2 = newv;
      var self = this;
      setTimeout(function () {
        self.clicked = true;
        self.val = val2.formatted;
        self.suggestions = [];
        self.$emit('input', val2);
        self.getAddressDetails().then(function () {
          val2.address = self.choice_address.address;
          self.$emit('address-selected', val2);
        });
      }, 50);
    },
    showDropdown: function showDropdown(newv) {
      var style = this.$refs.search.$refs.input.style;
      var px = newv ? '0px' : '4px';
      style.borderBottomLeftRadius = px;
      style.borderBottomRightRadius = px;
    },

    ssuInitGoogleAddressId: {
      handler: function handler(new_val, old_val) {
        if (new_val !== old_val) {
          this.initializeFromHash();
        } else {
          _logger2.default.debug('old google address: ', old_val.google_address_id);
          _logger2.default.debug('new google address: ', new_val.google_address_id);
        }
      },
      deep: true
    }
  },
  methods: {
    formClasses: function formClasses(newv, cls) {
      this.$refs.uid.$refs.form.classList[newv ? 'add' : 'remove'](cls);
    },
    hideSuggestions: function hideSuggestions(ms) {
      var self = this;
      setTimeout(function () {
        self.suggestions = [];
      }, ms);
    },
    getSuggestions: function getSuggestions(search) {
      var self = this;
      return _authRequest2.default.post({
        url: '/self_signup/address/suggestions',
        data: { search: search },
        success: function success(data) {
          self.suggestions = data;
        },
        error: function error(result) {
          self.suggestions = [];
          console.log('error getting address suggestions ', result);
        }
      });
    },
    getAddressDetails: function getAddressDetails() {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        _authRequest2.default.post({
          url: '/self_signup/address/details',
          data: { addr_id: self.choice.addr_id },
          success: function success(data) {
            self.choice_address = data;
            return resolve(data);
          },
          error: function error(result) {
            self.suggestions = [];
            console.log('error getting address suggestions ', result);
            return reject(result);
          }
        });
      });
    },
    initializeFromHash: function initializeFromHash() {
      if (this.ssuInitGoogleAddressId) {
        var self = this;
        this.choice = { 'addr_id': this.ssuInitGoogleAddressId };
        this.getAddressDetails().then(function () {
          self.choice.address = self.choice_address.address;
          self.choice.formatted = self.choice_address.formatted;
          self.$emit('address-selected', self.choice);
        });
      } else {
        _logger2.default.debug('no google address id found', this.ssuInitGoogleAddressId);
      }
    }
  }
};

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _AddressAutoComplete = __webpack_require__(738);

var _AddressAutoComplete2 = _interopRequireDefault(_AddressAutoComplete);

var _UsStates = __webpack_require__(1298);

var _UsStates2 = _interopRequireDefault(_UsStates);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "AddressForm",
  components: {
    FormValidator: _FormValidator2.default,
    XmInput: _XmInput2.default,
    AddressAutoComplete: _AddressAutoComplete2.default,
    usStates: _UsStates2.default
  },
  props: {
    value: {
      required: false
    },
    initValues: {
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted: function mounted() {
    var iv = this.initValues || {};
    var v = this.value || {};
    iv = iv.hasOwnProperty('address') ? iv.address : iv;
    this.formValues.line1 = iv.line1 || v.line1 || '';
    this.formValues.line2 = iv.line2 || v.line2 || '';
    this.formValues.city = iv.city || v.city || '';
    this.formValues.state = iv.state || v.state || '';
    this.formValues.zip_code = iv.zip_code || v.zip_code || '';
    this.formValues.zip_ext = iv.zip_ext || v.zip_ext || '';
  },
  data: function data() {
    return {
      formValidatorValid: false,
      placeid: '',
      formValues: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zip_code: '',
        zip_ext: ''
      }
    };
  },

  watch: {
    formValid: function formValid(newv) {
      this.$emit('form-state', newv);
    },


    formValues: {
      handler: function handler(newv) {
        this.$emit('input', newv);
        var addr = { line1: newv.line1, line2: newv.line2, city: newv.city, state: newv.state, zip_code: newv.zip_code };
        if (newv.zip_ext) {
          addr.zip_code = this.formValues.zip_code + '-' + this.formValues.zip_ext;
        }
        this.validateAddress(addr);
      },
      deep: true
    },
    initValues: {
      handler: function handler(newv) {
        var iv = newv || {};
        iv = iv.hasOwnProperty('address') ? iv.address : iv;
        this.formValues.line1 = iv.line1 || '';
        this.formValues.line2 = iv.line2 || '';
        this.formValues.city = iv.city || '';
        this.formValues.state = iv.state || '';
        this.formValues.zip_code = iv.zip_code || '';
        this.formValues.zip_ext = iv.zip_ext || '';
      },
      deep: true
    }
  },

  computed: {
    stateValid: function stateValid() {
      return this.formValues.state.trim().length >= 2;
    },
    formValid: function formValid() {
      return this.formValidatorValid && this.stateValid;
    }
  },

  methods: {
    getPlaceDetails: function getPlaceDetails(placeid) {
      var addr_id = placeid.addr_id;
      var self = this;
      $.ajax({
        type: 'post',
        url: '/manage/api/v1.0/self_signup/address/details',
        contentType: 'application/json',
        data: (0, _stringify2.default)({ addr_id: addr_id }),
        success: function success(result) {
          var addr = result.address;
          var zip_split = addr.zip_code.split('-');
          self.formValues.line1 = addr.line1;
          if (addr.line2) {
            self.formValues.line2 = addr.line2;
          }
          self.formValues.city = addr.city;
          self.formValues.state = addr.state;
          self.formValues.zip_code = zip_split[0];
          self.formValues.zip_ext = zip_split[1] || '';
        }
      });
    },
    validateAddress: function validateAddress(addr) {
      var self = this;
      $.ajax({
        type: 'post',
        url: '/manage/api/v1.0/self_signup/address/validate',
        contentType: 'application/json',
        data: (0, _stringify2.default)(addr),
        success: function success(result) {}
      });
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)))

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      attribution: 0,
      attribution_types: [{ value: '', label: '-- select --', id: 0 }, { value: 'Postal mail', label: 'Postal mail', id: 1 }, { value: 'Search engine', label: 'Search engine', id: 2 }, { value: 'Social media', label: 'Social media', id: 3 }, { value: 'Word of mouth', label: 'Word of mouth', id: 4 }, { value: 'Radio', label: 'Radio', id: 5 }, { value: 'News coverage', label: 'News coverage', id: 6 }, { value: 'Event', label: 'Event', id: 7 }, { value: 'Other', label: 'Other', id: 8 }],
      other_text: ''
    };
  },


  computed: {
    isNullAttribution: function isNullAttribution() {
      return this.attribution === 0;
    },
    isOtherAttribution: function isOtherAttribution() {
      if (this.isNullAttribution) {
        return false;
      }
      return this.attribution === 8;
    },
    formData: function formData() {
      var _this = this;

      var attribution_type = this.attribution_types.filter(function (x) {
        return x.id === _this.attribution;
      })[0].value;
      if (this.isOtherAttribution && this.other_text) {
        return attribution_type + ': ' + this.other_text;
      }
      return attribution_type;
    }
  },

  methods: {
    skipClicked: function skipClicked() {
      this.$emit('skip-clicked');
    }
  },

  watch: {
    formData: function formData(new_val) {
      this.$emit('input', new_val);
    }
  }
};

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _bootstrapVue = __webpack_require__(31);

var _UsernameSuggest = __webpack_require__(740);

var _UsernameSuggest2 = _interopRequireDefault(_UsernameSuggest);

var _AddressForm = __webpack_require__(739);

var _AddressForm2 = _interopRequireDefault(_AddressForm);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _UserForm = __webpack_require__(1300);

var _UserForm2 = _interopRequireDefault(_UserForm);

var _regex = __webpack_require__(112);

var _regex2 = _interopRequireDefault(_regex);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "CustomerSignupForm",
  emits: ['form-state', 'form-valid', 'form-invalid', 'input'],
  components: {
    XmInput: _XmInput2.default,
    usernameSuggest: _UsernameSuggest2.default,
    FormValidator: _FormValidator2.default,
    addressForm: _AddressForm2.default,
    BFormCheckbox: _bootstrapVue.BFormCheckbox,
    UserForm: _UserForm2.default
  },
  props: {
    value: {
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      scrolldown: _helpers2.default.scrolldown,
      customerFormValid: false,
      userFormValid: false,
      regex: _regex2.default,
      fname: '',
      mnami: '',
      lname: '',
      email: '',
      phone: '',
      dob: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      zip_code: '',
      nameRegex: /^[a-zA-Z]+$/,
      user_form: { uid: '', password: '' }
    };
  },

  computed: {
    formValid: function formValid() {
      return this.customerFormValid && this.userFormValid;
    },
    formValues: function formValues() {
      return {
        fname: this.fname,
        mnami: this.mnami,
        lname: this.lname,
        email: this.email,
        uid: this.user_form.uid,
        phone: this.phone,
        dob: this.dob,
        password: this.user_form.password
      };
    }
  },
  methods: {
    dobPattern: function dobPattern(dob) {
      var date = new Date(dob);
      if (isNaN(date.getTime())) {
        return false;
      }
      var mdy = dob.split('/');
      if (mdy.length !== 3) {
        return false;
      }
      if (mdy[2].length !== 4) {
        return false;
      }
      if (Number(mdy[2]) < 1900) {
        return false;
      }
      return date < new Date();
    }
  },
  watch: {
    formValues: {
      handler: function handler(newv) {
        this.$emit('input', newv);
      },

      deep: true
    },
    formValid: function formValid(newv) {
      this.$emit('form-state', newv);
      this.$emit(newv ? 'form-valid' : 'form-invalid');
    }
  }
};

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(854);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(850);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      mapId: '5405b356d1bcb251',
      map_data: { lat: this.value.lat, lon: this.value.lon },
      api_key: "AIzaSyD6rTSjT_i8XaHcWGqgZ1U5g6hxQM-EwQw"
    };
  },

  props: {
    zoom: {
      required: false,
      type: Number,
      default: 20
    },
    map_type: {
      required: false,
      default: 'roadmap'
    },
    draggable: {
      required: false,
      default: false
    },
    value: {
      required: false,
      default: { lat: null, lon: null }
    }
  },

  mounted: function mounted() {
    var _this = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var _ref, Map, _ref2, AdvancedMarkerElement, map, draggableMarker, self;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _logger2.default.debug('GoogleMapsDraggable mounted', _this.value);

              _context.next = 3;
              return google.maps.importLibrary("maps");

            case 3:
              _ref = _context.sent;
              Map = _ref.Map;
              _context.next = 7;
              return google.maps.importLibrary("marker");

            case 7:
              _ref2 = _context.sent;
              AdvancedMarkerElement = _ref2.AdvancedMarkerElement;
              map = new Map(document.getElementById("map"), {
                center: { lat: Number(_this.value.lat), lng: Number(_this.value.lon) },
                zoom: _this.zoom,
                mapId: _this.mapId,
                mapTypeId: _this.map_type
              });
              draggableMarker = new AdvancedMarkerElement({
                map: map,
                position: { lat: Number(_this.value.lat), lng: Number(_this.value.lon) },
                gmpDraggable: _this.draggable,
                title: "This marker is draggable."
              });

              if (_this.draggable) {
                self = _this;

                draggableMarker.addListener("dragend", function (event) {
                  var position = draggableMarker.position;
                  self.map_data.lat = String(position.lat);
                  self.map_data.lon = String(position.lng);
                });
              }

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  computed: {
    googleMapsLibraryScript: function googleMapsLibraryScript() {
      return '\n      (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({\n        key: "' + this.api_key + '",\n        v: "weekly",\n        // Use the \'v\' parameter to indicate the version to use (weekly, beta, alpha, etc.).\n        // Add other bootstrap parameters as needed, using camel case.\n      });';
    },
    mapData: function mapData() {
      return this.map_data;
    }
  },

  watch: {
    mapData: {
      handler: function handler(new_val, old_val) {
        this.$emit('input', new_val);
      },

      deep: true
    }
  }
};

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },

  emits: ['click'],

  methods: {
    handleClick: function handleClick() {
      this.$emit('click');
    }
  }
};

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(851);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(42);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getFullCart', 'oneTimeXmissionTotalDueNow', 'oneTimeXmissionTotalDueLater', 'monthlyXmissionTotals']), {
    monthlyTotalsAfterFirstMonth: function monthlyTotalsAfterFirstMonth() {
      return this.monthlyXmissionTotals.filter(function (x) {
        return x.rate_term !== 1;
      });
    },
    monthlyTotalGroupChangeIndex: function monthlyTotalGroupChangeIndex() {
      _logger2.default.debug('monthlyXmissionTotals', this.monthlyXmissionTotals);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.monthlyXmissionTotals.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
              ndx = _step$value[0],
              item = _step$value[1];

          if (item.rate_term === null) {
            continue;
          }
          if (item.rate_term > ndx + 1) {
            return ndx;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
  }),

  methods: {
    isPromo: function isPromo(cart_item) {
      return cart_item.rate_type === 'promo';
    },
    rateString: function rateString(rate, quantity, rate_type) {
      var rate_period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var rate_term = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var rate_mode = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'fixed';

      if (rate_type === 'promo' && rate_period === 'monthly' && rate_term !== null && rate_mode === 'variable') {
        rate = rate * rate_term;
      }
      rate = rate * quantity;
      var rate_string = '$' + rate;
      if (rate_type === 'promo') {
        return '-' + rate_string;
      }
      return rate_string;
    },
    ratePeriodString: function ratePeriodString(rate_period, rate_term, description) {
      var is_a_total = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var rate_period_string = is_a_total ? '' : ' one-time';
      if (rate_period === 'monthly' && rate_term !== 1) {
        rate_period_string = '/month';
      }
      if (description) {
        rate_period_string += ' ' + description;
      }
      return rate_period_string;
    },
    taxString: function taxString(rate, taxable) {
      if (taxable && rate > 0) {
        return '+ tax';
      }
      return '';
    },
    monthsString: function monthsString(rate_term) {
      var rate_term_map = { 1: 'one', 2: 'two', 3: 'three', 4: 'four', 5: 'five', 6: 'six', 7: 'seven',
        8: 'eight', 9: 'nine', 10: 'ten', 11: 'eleven', 12: 'twelve' };
      if (rate_term === 1) {
        return 'one month';
      }
      return rate_term_map[rate_term] + ' months';
    },
    dueTermString: function dueTermString(total_details_index) {
      var total_details = this.monthlyXmissionTotals[total_details_index];
      var is_final_month = total_details_index === this.monthlyXmissionTotals.length - 1;

      if (!is_final_month) {
        if (total_details['rate_term'] > total_details_index + 1 || this.monthlyTotalGroupChangeIndex !== null && this.monthlyTotalGroupChangeIndex <= total_details_index) {
          return 'after ' + this.monthsString(this.monthlyXmissionTotals[total_details_index - 1]['rate_term']);
        } else {
          return 'for ' + this.monthsString(this.monthlyXmissionTotals[total_details_index]['rate_term']);
        }
      }
      return 'after ' + this.monthsString(this.monthlyXmissionTotals[total_details_index - 1]['rate_term']);
    }
  }
};

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NewBankAccountForm = __webpack_require__(762);

var _NewBankAccountForm2 = _interopRequireDefault(_NewBankAccountForm);

var _NewPaymentMethodSelect = __webpack_require__(763);

var _NewPaymentMethodSelect2 = _interopRequireDefault(_NewPaymentMethodSelect);

var _NewPayaPaymentAccountModal = __webpack_require__(1281);

var _NewPayaPaymentAccountModal2 = _interopRequireDefault(_NewPayaPaymentAccountModal);

var _bootstrapVue = __webpack_require__(31);

var _NewPaymentTypeForm = __webpack_require__(1283);

var _NewPaymentTypeForm2 = _interopRequireDefault(_NewPaymentTypeForm);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      scrolldown: _helpers2.default.scrolldown,
      show_paya_modal: false,
      card_details_valid: false,
      bank_details_valid: false,
      payment_type_valid: false,
      form_data: {
        alternate_billing_address: null,
        auto_pay: true,
        account_type: '',
        card_details: {
          internal_token: '',
          token: '',
          fname: '',
          lname: '',
          exp_month: 0,
          exp_year: 0,
          last_four: '',
          brand: ''
        },
        bank_details: {
          name: '',
          routing: '',
          account: '',
          account_type: ''
        },
        billing_address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip_code: '',
          zip_ext: '',
          fname: '',
          lname: '',
          mnami: '',
          cmp_name: ''
        }
      }
    };
  },


  props: {
    initValues: {
      required: false
    }
  },

  mounted: function mounted() {
    this.resetForm();
  },


  computed: {
    accountTypeSelected: function accountTypeSelected() {
      return !!this.form_data.account_type;
    },
    isCard: function isCard() {
      return this.form_data.account_type === 'CREDIT_CARD';
    },
    modalTitle: function modalTitle() {
      return 'Add payment method';
    },
    accountName: function accountName() {
      if (this.initValues) {
        return ((this.initValues.fname || '') + " " + (this.initValues.lname || '')).trim();
      }
      return '';
    },
    paymentAccountFormValid: function paymentAccountFormValid() {
      return this.isCard && this.card_details_valid || !this.isCard && this.bank_details_valid;
    },
    formDataValid: function formDataValid() {
      if (!this.accountTypeSelected) {
        return false;
      }
      if (!this.paymentAccountFormValid) {
        return false;
      }
      return this.payment_type_valid;
    },
    formData: function formData() {
      return this.form_data;
    }
  },

  methods: {
    setAccountType: function setAccountType(account_type) {
      this.form_data.account_type = account_type;
      if (account_type === 'ACH') {
        this.show_paya_modal = false;
      }
      if (!this.card_details_valid) {
        this.show_paya_modal = account_type === 'CREDIT_CARD';
      }
    },
    cardAdded: function cardAdded(card_details) {
      this.card_details_valid = true;
      this.form_data.card_details = card_details;
    },
    setPaymentAccountType: function setPaymentAccountType(data) {
      this.form_data.alternate_billing_address = data.alternate_billing_address;
      this.form_data.auto_pay = data.auto_pay;
      this.form_data.billing_address = data.billing_address;
    },
    resetForm: function resetForm() {
      this.card_details_valid = false;
      this.bank_details_valid = false;
      this.payment_account_valid = false;
      this.form_data = {
        alternate_billing_address: null,
        auto_pay: true,
        account_type: '',
        card_details: {
          internal_token: '',
          token: '',
          fname: '',
          lname: '',
          exp_month: 0,
          exp_year: 0,
          last_four: '',
          brand: ''
        },
        bank_details: {
          name: '',
          routing: '',
          account: '',
          account_type: ''
        },
        billing_address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip_code: '',
          zip_ext: '',
          fname: '',
          lname: '',
          mnami: '',
          cmp_name: ''
        }
      };
    }
  },

  watch: {
    formData: {
      handler: function handler(new_val) {
        this.$emit('input', new_val);
      },

      deep: true
    },
    formDataValid: function formDataValid(new_val) {
      this.$emit('form-state', new_val);
      this.$emit(new_val ? 'form-valid' : 'form-invalid');
    }
  },

  components: {
    NewPaymentTypeForm: _NewPaymentTypeForm2.default,
    NewBankAccountForm: _NewBankAccountForm2.default,
    NewPaymentMethodSelect: _NewPaymentMethodSelect2.default,
    NewPayaPaymentAccountModal: _NewPayaPaymentAccountModal2.default
  },

  directives: {
    'b-modal': _bootstrapVue.VBModal
  }
};

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

var _AddressAutoComplete = __webpack_require__(738);

var _AddressAutoComplete2 = _interopRequireDefault(_AddressAutoComplete);

var _bootstrapVue = __webpack_require__(31);

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _XmModal = __webpack_require__(345);

var _XmModal2 = _interopRequireDefault(_XmModal);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _regex = __webpack_require__(112);

var _regex2 = _interopRequireDefault(_regex);

var _connectivityClotService = __webpack_require__(347);

var _connectivityClotService2 = _interopRequireDefault(_connectivityClotService);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      regex: _regex2.default,
      searching_address: false,
      serviceable_address_selected: false,
      addresses: [],
      show_multi_address_modal: false,
      show_address_unavailable_modal: false,
      address_id_selected: '',
      address_prevalidated: true,
      serviceability_notice_form: { name: '', address: '', email: '', phone: '' },
      serviceability_notice_form_valid: false,
      adding_to_contact_list: false,
      recatpcha_site_key: '6Le3_GEmAAAAALmjy7zJ1OluUj5NeIBuX_uRNJsM',
      address_potentially_serviceable: false,
      error_message: '',
      line1: '',
      line2: '',
      city: '',
      state: '',
      zip_code: '',
      formatted_address: '',
      pre_validated: false,
      form_data: {
        service: null
      }
    };
  },


  emits: ['form-state', 'form-invalid', 'form-valid', 'input'],
  props: ['initial_data'],

  components: {
    AddressAutoComplete: _AddressAutoComplete2.default,
    BOverlay: _bootstrapVue.BOverlay,
    BModal: _bootstrapVue.BModal,
    FormValidator: _FormValidator2.default,
    XmInput: _XmInput2.default,
    XmModal: _XmModal2.default
  },

  computed: {
    addressPotentiallyServiceable: function addressPotentiallyServiceable() {
      return this.address_potentially_serviceable;
    },
    formData: function formData() {
      return this.form_data;
    },
    initialAddressString: function initialAddressString() {
      return this.formatted_address;
    },
    addressIdSelected: function addressIdSelected() {
      return this.address_id_selected;
    }
  },

  mounted: function mounted() {
    this.initFromAddress();
  },


  methods: {
    initFromAddress: function initFromAddress() {
      if (this.initial_data === undefined || this.initial_data === null) {
        return;
      }
      this.setAddressDetails(this.initial_data);
      this.addresses = [this.initial_data.address];
      this.getServiceabilityDetails();
    },
    addToContactList: function addToContactList() {
      this.adding_to_contact_list = true;
      var self = this;
      return new _promise2.default(function () {
        grecaptcha.ready(function () {
          grecaptcha.execute(self.recatpcha_site_key, { action: 'submit' }).then(function (token) {
            self.serviceability_notice_form['recaptcha_token'] = token;
            _authRequest2.default.post({
              url: '/connectivity_clots/availability',
              data: self.serviceability_notice_form,
              success: function success() {
                self.resetForm();
                self.adding_to_contact_list = false;
              },
              error: function error(err) {
                self.resetForm();
                self.adding_to_contact_list = false;
                _logger2.default.debug(err);
              }
            });
          });
        });
      });
    },
    cancelAddToContactList: function cancelAddToContactList() {
      var self = this;
      return new _promise2.default(function (resolve, reject) {
        self.show_address_unavailable_modal = false;
      });
    },
    setNoAddressFound: function setNoAddressFound() {
      this.address_id_selected = '';
      this.show_address_unavailable_modal = true;
      this.serviceability_notice_form.address = this.formatted_address;
    },
    setAddressSelected: function setAddressSelected(address_data_selected) {
      _logger2.default.debug('address selected', address_data_selected);
      this.setAddressDetails(address_data_selected);
      this.searchServiceableAddress();
    },
    getAddressDetailsForSearch: function getAddressDetailsForSearch() {
      return {
        line1: this.line1,
        line2: this.line2,
        city: this.city,
        state: this.state,
        zip_code: this.zip_code,
        pre_validated: this.pre_validated
      };
    },
    searchServiceableAddress: function searchServiceableAddress() {
      this.address_prevalidated = false;
      this.searching_address = true;

      this.error_message = '';
      var self = this;
      _authRequest2.default.get({
        url: '/connectivity_clots/addresses',
        params: this.getAddressDetailsForSearch(),
        success: function success(result) {
          self.addresses = result.addresses;
          if (result.addresses.length === 0) {
            self.setNoAddressFound();
            self.searching_address = false;
          } else if (result.addresses.length === 1 && result.addresses[0].matches_search_address) {
            _logger2.default.debug('single address found', result.addresses[0]);
            self.setAddressDetails(self.addresses[0]);
            self.getServiceabilityDetails();
          } else {
            self.show_multi_address_modal = true;
            self.searching_address = false;
          }
        },
        error: function error(err) {
          self.searching_address = false;
        }
      });
    },
    setAddressDetails: function setAddressDetails(address_details) {
      _logger2.default.debug('setAddressDetails', address_details);
      this.address_id_selected = address_details.address.address_id.trim();
      this.line1 = address_details.address.line1.trim();
      this.line2 = address_details.address.line2.trim();
      this.city = address_details.address.city.trim();
      this.state = address_details.address.state.trim();
      this.zip_code = address_details.address.zip_code.trim();
      this.formatted_address = address_details.address.formatted_address.trim();
    },
    getAvailabilityMessage: function getAvailabilityMessage(address_details) {
      var sales_email = 'sales@xmission.com';
      var sales_phone = '877.964.7746';
      var formatted_address = address_details.formatted_address;
      var message_end = 'please contact XMission sales Toll-Free at ' + sales_phone + ', through online chat via the blue icon in the lower right corner, or email ' + sales_email + '.';
      if (address_details.disabled) {
        return 'There was an error checking the availability of the address ' + formatted_address + '. To order service, ' + message_end;
      } else if (address_details.is_business) {
        return 'The address ' + formatted_address + ' appears to be for a business. For assistance, ' + message_end;
      } else if (address_details.in_service) {
        return 'The address ' + formatted_address + ' appears to already be in service but through a different provider. If you would like to switch to XMission, or have any other questions, ' + message_end;
      } else if (!address_details.orderable && !address_details.early_signup) {
        return 'The address ' + formatted_address + ' does not appear to be currently available. For assistance, ' + message_end;
      }
      return '';
    },
    getServiceabilityDetails: function getServiceabilityDetails() {
      var _this = this;

      _logger2.default.debug('searching serviceability details for addresses', this.addresses);
      var address_details = this.addresses.filter(function (x) {
        return x.address.address_id === _this.address_id_selected;
      })[0];
      this.searching_address = true;
      var self = this;
      _authRequest2.default.get({
        url: '/connectivity_clots/details',
        params: { service_class_id: address_details.service_class_id, address_id: address_details.address.address_id },
        success: function success(service_details) {
          self.setAddressDetails(address_details);
          var connectivity_clot = new _connectivityClotService2.default(service_details);
          if (!connectivity_clot.isAvailable()) {
            self.resetForm();
            self.error_message = self.getAvailabilityMessage(service_details.address_details);
            return;
          }
          self.form_data.service = service_details;
          self.serviceable_address_selected = true;
          self.searching_address = false;
          self.address_potentially_serviceable = true;
        },
        error: function error(err) {
          self.searching_address = false;
        }
      });
    },
    resetForm: function resetForm() {
      this.address_id_selected = '';
      this.address_prevalidated = true;
      this.error_message = '';
      this.serviceability_notice_form_valid = false;
      this.serviceability_notice_form = { name: '', address: '', email: '', phone: '' };
      this.show_address_unavailable_modal = false;
      this.show_multi_address_modal = false;
      this.searching_address = false;
      this.address_potentially_serviceable = false;
      this.addresses = [];
      this.adding_to_contact_list = false;
      this.line1 = '';
      this.line2 = '';
      this.city = '';
      this.state = '';
      this.zip_code = '';
      this.form_data = {
        service: null
      };
      this.$store.commit(types.SET_SERVICE_CLASS_ORDER, ['connectivity', 'xwi', 'voice', 'subnet', 'static_ip']);
    }
  },

  watch: {
    addressPotentiallyServiceable: function addressPotentiallyServiceable(new_val) {
      this.$emit('form-state', new_val);
      new_val ? this.$emit('form-valid') : this.$emit('form-invalid');
    },

    formData: {
      handler: function handler(new_val) {
        this.$emit('input', new_val);
      },

      deep: true
    },
    addressIdSelected: function addressIdSelected() {
      this.$store.commit(types.SELF_SIGNUP_RESET_OUTPUT_MODELS);
    }
  }

};

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

var _vuex = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form_data: {
        speed_id: '',
        external_soid: ''
      }
    };
  },


  props: {
    serviceDetails: {
      required: true
    }
  },

  computed: (0, _extends3.default)({
    speedOptions: function speedOptions() {
      if (!this.serviceDetails) {
        return [];
      }
      return this.serviceDetails.speed_options;
    },
    legalDisclaimers: function legalDisclaimers() {
      return this.speedOptions.promo_legal_disclaimers;
    },
    formValid: function formValid() {
      return this.form_data.speed_id !== '';
    },
    formData: function formData() {
      return this.form_data;
    },
    xwiLogoUrl: function xwiLogoUrl() {
      if (this.hasDarkTheme) {
        return 'https://asset.xmission.com/xwi/xwi-logo-black.png';
      }
      return 'https://asset.xmission.com/xwi/xwi-logo-white.png';
    }
  }, (0, _vuex.mapGetters)(['hasDarkTheme'])),
  methods: {
    setSpeedDetails: function setSpeedDetails(details) {
      _logger2.default.debug('setSpeedDetails', details);
      this.form_data.speed_id = details.speed_id;
      this.form_data.external_soid = details.external_soid;
    }
  },

  watch: {
    formValid: function formValid(new_val) {
      this.$emit('form-state', new_val);
      this.$emit(new_val ? 'form-valid' : 'form-invalid');
    },

    formData: {
      handler: function handler(new_val) {
        if (new_val) {
          this.$emit('input', new_val);
        }
      },

      deep: true
    }
  }
};

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(56);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _bootstrapVue = __webpack_require__(31);

var _usStates = __webpack_require__(776);

var _usStates2 = _interopRequireDefault(_usStates);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "UsStates",
  components: {
    BFormInput: _bootstrapVue.BFormInput,
    BDropdown: _bootstrapVue.BDropdown,
    BDropdownItem: _bootstrapVue.BDropdownItem,
    BInputGroup: _bootstrapVue.BInputGroup,
    BInputGroupPrepend: _bootstrapVue.BInputGroupPrepend,
    BDropdownForm: _bootstrapVue.BDropdownForm
  },
  props: {
    attr: { type: String, default: 'abbr' },
    value: { type: String }
  },
  created: function created() {
    this.debouncedSuggestions = _helpers2.default.debounce(this.getSuggestions, 0);
  },
  mounted: function mounted() {
    var state = this.findState(this.value);
    if (state) {
      this.choice = state;
    }

    var self = this;
    document.body.addEventListener('click', function (event) {
      if (document.getElementById('us-states') !== null) {
        if (!document.getElementById('us-states').contains(event.target)) {
          self.suggestions = [];
        }
      }
    });
  },
  data: function data() {
    return {
      val: '',
      states: _usStates2.default,
      choice: {},
      suggestions: []
    };
  },

  computed: {
    showDropdown: function showDropdown() {
      return this.suggestions.length > 0;
    }
  },
  watch: {
    choice: function choice(newv) {
      var newv2 = newv;
      this.val = newv2.title;
      this.suggestions = [];
      this.$emit('input', newv2[this.attr]);
    },
    val: function val(newv) {
      if (newv) {
        var state = this.findState(newv);
        if (state) {
          this.choice = state;
        } else {
          this.getSuggestions(newv);
        }
      } else {
        this.suggestions = [];
      }
    },
    value: function value(newv) {
      var state = this.findState(newv);
      if (state) {
        this.choice = state;
        return;
      }
      this.val = newv;
    }
  },
  methods: {
    getSuggestions: function getSuggestions(newv) {
      if (this.states.lowers.includes(newv) || this.states.titles.includes(newv)) {
        this.suggestions = [];
      } else {
        this.suggestions = this.states.search(newv);
      }
    },
    findState: function findState(newv) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(this.states.states), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var state = _step.value;

          if (state.abbr === newv || state.title === newv || state.lower === newv) {
            return state;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
};

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrapVue = __webpack_require__(31);

var _ButtonCheckbox = __webpack_require__(760);

var _ButtonCheckbox2 = _interopRequireDefault(_ButtonCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "UserAgreement",
  components: {
    BFormCheckbox: _bootstrapVue.BFormCheckbox,
    'button-checkbox': _ButtonCheckbox2.default
  },
  data: function data() {
    return {
      agreement: '',
      agreed: false,
      form_data: {
        time: null
      }
    };
  },


  computed: {
    formData: function formData() {
      return this.form_data;
    }
  },

  methods: {
    getCurrentTime: function getCurrentTime() {
      var today = new Date();
      var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return date + ' ' + time;
    },
    setCurrentTime: function setCurrentTime() {
      this.agreed = !this.agreed;
      if (this.agreed) {
        this.form_data.time = this.getCurrentTime();
      }
    }
  },

  watch: {
    agreed: function agreed(new_val) {
      this.$emit('form-state', new_val);
      this.$emit(new_val ? 'form-valid' : 'form-invalid');
    },

    formData: {
      handler: function handler(new_val) {
        this.$emit('input', new_val);
      },

      deep: true
    }
  }

};

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _UsernameSuggest = __webpack_require__(740);

var _UsernameSuggest2 = _interopRequireDefault(_UsernameSuggest);

var _PasswordForm = __webpack_require__(757);

var _PasswordForm2 = _interopRequireDefault(_PasswordForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  emits: ['form-state', 'form-invalid', 'form-valid', 'input'],
  data: function data() {
    return {
      name: 'validate-new-password',
      formValid: false,
      form_data: {
        uid: '',
        password: ''
      },
      uidValid: false,
      passwordValid: false
    };
  },

  props: ['value', 'fname', 'lname'],
  computed: {
    formData: function formData() {
      return this.form_data;
    },
    formIsValid: function formIsValid() {
      return this.uidValid && this.passwordValid;
    }
  },
  methods: {
    updateUid: function updateUid(val) {
      this.form_data.uid = val;
    },
    updateUidValid: function updateUidValid(val) {
      this.uidValid = val;
    },
    updatePassword: function updatePassword(data) {
      this.form_data.password = data.password;
    },
    updatePasswordValid: function updatePasswordValid(val) {
      this.passwordValid = val;
    }
  },
  watch: {
    formIsValid: function formIsValid(newv) {
      this.$emit(newv ? 'form-valid' : 'form-invalid');
    },

    formData: {
      handler: function handler(new_val) {
        this.$emit('input', new_val);
      },

      deep: true
    }

  },
  components: {
    FormValidator: _FormValidator2.default,
    UsernameSuggest: _UsernameSuggest2.default,
    PasswordForm: _PasswordForm2.default
  }
};

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _authRequest = __webpack_require__(53);

var _authRequest2 = _interopRequireDefault(_authRequest);

var _regex = __webpack_require__(112);

var _regex2 = _interopRequireDefault(_regex);

var _XmInput = __webpack_require__(65);

var _XmInput2 = _interopRequireDefault(_XmInput);

var _validators = __webpack_require__(777);

var _validators2 = _interopRequireDefault(_validators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "UsernameSuggest",
  components: {
    XmInput: _XmInput2.default
  },
  data: function data() {
    return {
      val: '',
      uidSuggestions: [],
      unusedUid: undefined,
      uidRegex: _regex2.default.uid
    };
  },

  props: {
    value: { type: String },
    fname: { type: String },
    lname: { type: String }
  },
  created: function created() {
    this.debouncedSuggestions = _helpers2.default.debounce(this.usernameSuggestions, 300);
  },
  mounted: function mounted() {
    this.val = this.value;
  },

  computed: {
    uidValidityDetails: function uidValidityDetails() {
      return _validators2.default.username(this.val);
    },
    uidValid: function uidValid() {
      return this.uidValidityDetails.valid;
    },
    uidErrorStr: function uidErrorStr() {
      return this.uidValidityDetails.suggestion;
    },
    uid: function uid() {
      return this.$refs.uid.$refs.input;
    },
    uidFormClasses: function uidFormClasses() {
      return this.$refs.uid.$refs.form.classList;
    },
    showDropdown: function showDropdown() {
      return this.uidSuggestions.length > 0;
    }
  },
  watch: {
    val: function val(newval) {
      this.$emit('input', newval);
      this.$emit('form-state', this.uidValid);
      if (!this.uidValid) {
        this.$refs.uid.$data.valid = false;
      }
      this.debouncedSuggestions(newval);
    },
    uidSuggestions: function uidSuggestions(newval) {},
    showDropdown: function showDropdown(newval) {
      if (newval) {
        this.uid.style.borderBottomLeftRadius = '0px';
        this.uid.style.borderBottomRightRadius = '0px';
      } else {
        this.uid.style.borderBottomLeftRadius = '4px';
        this.uid.style.borderBottomRightRadius = '4px';
      }
    },
    canUse: function canUse() {
      var rem = void 0;
      var add = void 0;
      if (this.uidValid && this.unusedUid) {
        rem = ['has-error', 'has-warning'];
        add = ['has-success'];
      } else if (this.uidValid === false) {
        rem = ['has-success', 'has-warning'];
        add = ['has-error'];
      } else if (this.unusedUid === false) {
        rem = ['has-success', 'has-error'];
        add = ['has-warning'];
      }
      this.uidFormClasses.remove(rem);
      this.uidFormClasses.add(add);
    }
  },
  methods: {
    hideSuggestions: function hideSuggestions(ms) {
      var self = this;
      setTimeout(function () {
        self.uidSuggestions = [];
      }, ms);
    },
    usernameSuggestions: function usernameSuggestions(uid) {
      var self = this;
      if (!this.uidValid) return;
      return _authRequest2.default.get({
        url: _authRequest2.default.param('/self_signup/usernames', { uid: uid, name: self.fname + ' ' + self.lname }),
        success: function success(data) {
          self.uidSuggestions = data['suggestions'];
          self.unusedUid = !data['in_use'];
        },
        error: function error(result) {
          self.unusedUid = true;
          self.uidSuggestions = [];
        }
      });
    },
    choose: function choose(val) {
      this.val = val;
    }
  }
};

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bootstrapVue = __webpack_require__(31);

exports.default = {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    }
  },

  components: {
    BOverlay: _bootstrapVue.BOverlay,
    BSpinner: _bootstrapVue.BSpinner
  }
};

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _bootstrapVue = __webpack_require__(31);

var _vuex = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('keydown', function (e) {
      if (e.key === 'Control') {
        _this.control = true;
      }
    });
    window.addEventListener('keyup', function (e) {
      if (e.key === 'Control') {
        _this.control = false;
      }
    });
  },
  data: function data() {
    return {
      base: 'https://xmission.com',
      control: false,
      search_query: ''
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['isLoggedIn', 'username']), {
    isSignup: function isSignup() {
      return this.$route.name === 'signup';
    },
    brandUrl: function brandUrl() {
      if (this.isSignup) {
        return 'https://asset.xmission.com/xmweb3/XMission-logo.png';
      }
      return 'https://asset.xmission.com/xmweb3/xm-control-panel-logo.png';
    }
  }),

  methods: {
    navigateTo: function navigateTo(page) {
      if (this.control) {
        window.open(this.base + page, '_blank');
      } else {
        window.location.href = this.base + page;
      }
    },
    search: function search() {
      window.location.href = this.base + '?s=' + this.search_query;
    }
  },

  components: {
    BNavbar: _bootstrapVue.BNavbar,
    BNavbarBrand: _bootstrapVue.BNavbarBrand,
    BNavbarToggle: _bootstrapVue.BNavbarToggle,
    BNavbarNav: _bootstrapVue.BNavbarNav,
    BNavItem: _bootstrapVue.BNavItem,
    BDropdown: _bootstrapVue.BDropdown,
    BDropdownItem: _bootstrapVue.BDropdownItem,
    BDropdownHeader: _bootstrapVue.BDropdownHeader,
    BDropdownDivider: _bootstrapVue.BDropdownDivider,
    BCollapse: _bootstrapVue.BCollapse,
    BNavItemDropdown: _bootstrapVue.BNavItemDropdown,
    BModal: _bootstrapVue.BModal,
    BFormInput: _bootstrapVue.BFormInput,
    BInputGroup: _bootstrapVue.BInputGroup,
    BInputGroupAppend: _bootstrapVue.BInputGroupAppend,
    BButton: _bootstrapVue.BButton
  },
  directives: {
    'b-toggle': _bootstrapVue.VBToggle,
    'b-modal': _bootstrapVue.VBModal
  }
};

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(772);

var _NodeList = __webpack_require__(346);

var _NodeList2 = _interopRequireDefault(_NodeList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELAY = 300;

exports.default = {
  props: {
    clearButton: { type: Boolean, default: false },
    cols: { type: Number, default: null },
    datalist: { type: Array, default: null },
    disabled: { type: Boolean, default: false },
    enterSubmit: { type: Boolean, default: false },
    error: { type: String, default: null },
    errorStyle: { type: String, default: 'error-feedback' },
    help: { type: String, default: null },
    hideHelp: { type: Boolean, default: true },
    icon: { type: Boolean, default: false },
    id: { type: String, default: null },
    label: { type: String, default: null },
    lang: { type: String, default: navigator.language },
    mask: null,
    maskDelay: { type: Number, default: 100 },
    match: { type: String, default: null },
    max: { type: String, default: null },
    maxlength: { type: Number, default: null },
    min: { type: String, default: null },
    minlength: { type: Number, default: 0 },
    name: { type: String, default: null },
    pattern: { default: null },
    placeholder: { type: String, default: null },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    rows: { type: Number, default: 3 },
    step: { type: Number, default: null },
    type: { type: String, default: 'text' },
    url: { type: String, default: null },
    urlMap: { type: Function, default: null },
    validationDelay: { type: Number, default: 250 },
    value: { default: null }
  },
  data: function data() {
    var val = this.value;
    return {
      options: this.datalist,
      val: val,
      valid: null,
      timeout: null
    };
  },

  computed: {
    canValidate: function canValidate() {
      return !this.disabled && !this.readonly && (this.required || this.regex || this.nativeValidate || this.match !== null);
    },
    errorText: function errorText() {
      var value = this.value;
      var error = [this.error];
      if (!value && this.required) error.push('(' + this.text.required.toLowerCase() + ')');
      if (value && value.length < this.minlength) error.push('(' + this.text.minLength.toLowerCase() + ': ' + this.minlength + ')');
      return error.join(' ');
    },
    id_datalist: function id_datalist() {
      if (this.type !== 'textarea' && this.datalist instanceof Array) {
        if (!this._id_datalist) {
          if (!this.$root.id_datalist) {
            this.$root.id_datalist = 0;
          }
          this._id_datalist = 'input-datalist' + this.$root.id_datalist++;
        }
        return this._id_datalist;
      }
      return null;
    },
    input: function input() {
      return this.$refs.input;
    },
    nativeValidate: function nativeValidate() {
      return (this.input || {}).checkValidity && (~['url', 'email'].indexOf(this.type.toLowerCase()) || this.min || this.max);
    },
    regex: function regex() {
      return _utils.coerce.pattern(this.pattern);
    },
    showError: function showError() {
      return this.error && this.valid === false;
    },
    showHelp: function showHelp() {
      return this.help && (!this.showError || !this.hideHelp);
    },
    text: function text() {
      return (0, _utils.translations)(this.lang);
    },
    title: function title() {
      return this.errorText || this.help || '';
    }
  },
  watch: {
    datalist: function datalist(val, old) {
      if (val !== old && val instanceof Array) {
        this.options = val;
      }
    },
    match: function match(val) {
      this.eval();
    },
    options: function options(val, old) {
      if (val !== old) this.$emit('options', val);
    },
    url: function url(val) {
      this._url();
    },
    val: function val(_val, old) {
      var _this = this;

      this.$emit('input', _val);
      if (_val !== old) {
        if (this.mask instanceof Function) {
          _val = this.mask(_val || '');
          if (this.val !== _val) {
            if (this._timeout.mask) clearTimeout(this._timeout.mask);
            this._timeout.mask = setTimeout(function () {
              _this.val = _val;
            }, isNaN(this.maskDelay) ? 0 : this.maskDelay);
          }
        }
        this.eval();
      }
    },
    valid: function valid(val, old) {
      this.$emit('isvalid', val);
      this.$emit(!val ? 'invalid' : 'valid');
      if (this._parent) this._parent.validate();
    },
    value: function value(val) {
      if (this.val !== val) {
        this.val = val;
      }
    }
  },
  methods: {
    attr: function attr(value) {
      return ~['', null, undefined].indexOf(value) || value instanceof Function ? null : value;
    },
    emit: function emit(e) {
      this.$emit(e.type, e.type == 'input' ? e.target.value : e);
      if (e.type === 'blur' && this.canValidate) {
        this.valid = this.validate();
      }
    },
    eval: function _eval() {
      var _this2 = this;

      if (this._timeout.eval) clearTimeout(this._timeout.eval);
      if (!this.canValidate) {
        this.valid = true;
      } else {
        this._timeout.eval = setTimeout(function () {
          _this2.valid = _this2.validate();
          _this2._timeout.eval = null;
        }, this.validationDelay);
      }
    },
    focus: function focus() {
      this.input.focus();
    },
    submit: function submit() {
      if (this.$parent._formValidator) {
        return this.$parent.validate();
      }
      if (this.input.form) {
        var invalids = (0, _NodeList2.default)('.form-group.validate:not(.has-success)', this.input.form);
        if (invalids.length) {
          invalids.find('input,textarea,select')[0].focus();
        } else {
          this.input.form.submit();
        }
      }
    },
    validate: function validate() {
      if (!this.canValidate) {
        return true;
      }
      var value = typeof this.val === 'number' ? this.val : (this.val || '').trim();
      if (!value && this.value !== 0) {
        return !this.required;
      }
      if (this.match !== null) {
        return this.match === value;
      }
      if (value.length < this.minlength) {
        return false;
      }
      if (this.nativeValidate && !this.input.checkValidity()) {
        return false;
      }
      if (this.regex) {
        if (!(this.regex instanceof Function ? this.regex(this.val) : this.regex.test(this.val))) {
          return false;
        }
      }
      return true;
    },
    reset: function reset() {
      this.value = '';
      this.valid = null;
      if (this._timeout.mask) clearTimeout(this._timeout.mask);
      if (this._timeout.eval) clearTimeout(this._timeout.eval);
    }
  },
  created: function created() {
    this._input = true;
    this._timeout = {};
    var parent = this.$parent;
    while (parent && !parent._formValidator) {
      parent = parent.$parent;
    }
    if (parent && parent._formValidator) {
      parent.children.push(this);
      this._parent = parent;
    }
    this._url = (0, _utils.delayer)(function () {
      var _this3 = this;

      if (!this.url || !this.$http || this._loading) {
        return;
      }
      this._loading = true;
      this.$http.get(this.url).then(function (response) {
        var data = response.data instanceof Array ? response.data : [];
        try {
          data = JSON.parse(data);
        } catch (e) {}
        if (_this3.urlMap) {
          data = data.map(_this3.urlMap);
        }
        _this3.options = data;
        _this3.loading = false;
      }, function (response) {
        _this3.loading = false;
      });
    }, DELAY);
    if (this.url) this._url();
  },
  mounted: function mounted() {
    this.$refs.input.value = this.value;
  },
  beforeDestroy: function beforeDestroy() {
    if (this._parent) {
      var index = this._parent.children.indexOf(this);
      this._parent.children.splice(index, 1);
    }
  }
};

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(91);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(35);

var _extends3 = _interopRequireDefault(_extends2);

var _CustomerSignupForm = __webpack_require__(1294);

var _CustomerSignupForm2 = _interopRequireDefault(_CustomerSignupForm);

var _UserAgreement = __webpack_require__(1299);

var _UserAgreement2 = _interopRequireDefault(_UserAgreement);

var _AddServices = __webpack_require__(1292);

var _AddServices2 = _interopRequireDefault(_AddServices);

var _FormValidator = __webpack_require__(90);

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _bootstrapVue = __webpack_require__(31);

var _OrderSummary = __webpack_require__(770);

var _OrderSummary2 = _interopRequireDefault(_OrderSummary);

var _mutationTypes = __webpack_require__(24);

var types = _interopRequireWildcard(_mutationTypes);

var _helpers = __webpack_require__(55);

var _helpers2 = _interopRequireDefault(_helpers);

var _vuex = __webpack_require__(42);

var _logger = __webpack_require__(36);

var _logger2 = _interopRequireDefault(_logger);

var _Notifications = __webpack_require__(341);

var _Notifications2 = _interopRequireDefault(_Notifications);

var _PaymentMethod = __webpack_require__(1296);

var _PaymentMethod2 = _interopRequireDefault(_PaymentMethod);

var _AttributionDropdown = __webpack_require__(1293);

var _AttributionDropdown2 = _interopRequireDefault(_AttributionDropdown);

var _OrderButton = __webpack_require__(769);

var _OrderButton2 = _interopRequireDefault(_OrderButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "signup",
  components: {
    OrderButton: _OrderButton2.default,
    Notifications: _Notifications2.default,
    FormValidator: _FormValidator2.default,
    AttributionDropdown: _AttributionDropdown2.default,
    CustomerSignupForm: _CustomerSignupForm2.default,
    AddServices: _AddServices2.default,
    PaymentMethod: _PaymentMethod2.default,
    UserAgreement: _UserAgreement2.default,
    BOverlay: _bootstrapVue.BOverlay,
    BImg: _bootstrapVue.BImg,
    BSpinner: _bootstrapVue.BSpinner,
    BDropdown: _bootstrapVue.BDropdown,
    BDropdownItemButton: _bootstrapVue.BDropdownItemButton,
    BIconCheck: _bootstrapVue.BIconCheck,
    OrderSummary: _OrderSummary2.default
  },
  created: function created() {
    var recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=" + this.recatpchaSiteKey);
    document.head.appendChild(recaptchaScript);

    var self = this;
    if (this.signupHash !== undefined) {
      $.ajax({
        type: 'GET',
        tryCount: 0,
        url: "/manage/api/v1.0/self_signup/pre_signup/" + this.signupHash,
        contentType: 'application/json',
        success: function success(result) {
          self.$store.commit(types.SELF_SIGNUP_SET_INIT_VALUES, { signup_hash: self.signupHash, data: result });
        },
        error: function error(jqXHR, textStatus, errorThrown) {}
      });
    }

    if (this.hasDarkTheme) {
      this.hadDarktheme = true;
      this.$store.dispatch('setLightTheme', false);
    }
  },
  data: function data() {
    return {
      scrolldown: _helpers2.default.scrolldown,
      servicesValid: false,
      skipClicked: false,
      customerValid: false,
      paymentValid: false,
      agreementValid: false,

      signupHash: this.$route.query.signupHash,
      displayInline: this.$route.query.displayInline === 'true',
      apiCallFinished: false,
      creatingAccount: false,
      recatpchaSiteKey: '6Le3_GEmAAAAALmjy7zJ1OluUj5NeIBuX_uRNJsM',
      hadDarktheme: false,
      showForm: false
    };
  },


  computed: (0, _extends3.default)({
    serviceTypes: function serviceTypes() {
      var st = this.$route.params.components || this.$route.query.components;
      return st ? st.split(',') : [];
    },
    initValues: function initValues() {
      var init_values = JSON.parse((0, _stringify2.default)(this.ssuInitDetails));
      _logger2.default.debug('initValues', init_values);
      return init_values;
    },
    formValid: function formValid() {
      return this.servicesValid && this.customerValid && this.paymentValid && this.agreementValid;
    },
    formData: function formData() {
      return this.ssuOutputModel;
    },
    formDataString: function formDataString() {
      return (0, _stringify2.default)(this.formData, null, 2);
    },
    showFormData: function showFormData() {
      _logger2.default.debug('showFormData', "production", this.$route.query.showFormData);
      if (true) {
        return false;
      }
      if (!this.$route.query.showFormData) {
        return false;
      }
      return this.$route.query.showFormData.toLowerCase() === 'true';
    }
  }, (0, _vuex.mapGetters)(['hasDarkTheme', 'ssuInitDetails', 'ssuOutputModel', 'ssuLoginDetails'])),
  methods: {
    setAttributionData: function setAttributionData(attribution) {
      _logger2.default.debug('set attribution data', attribution);
      this.$store.commit(types.SELF_SIGNUP_SET_ATTRIBUTION_DATA, attribution);
    },
    setCustomerData: function setCustomerData(customer) {
      this.$store.commit(types.SELF_SIGNUP_SET_CUSTOMER_DATA, customer);
    },
    setPaymentData: function setPaymentData(payment) {
      _logger2.default.debug('set payment data', payment);
      this.$store.commit(types.SELF_SIGNUP_SET_PAYMENT_DATA, JSON.parse((0, _stringify2.default)(payment)));
    },
    setAgreementData: function setAgreementData(agreement) {
      this.$store.commit(types.SELF_SIGNUP_SET_AGREEMENT_DATA, agreement);
    },
    selfSignup: function selfSignup() {
      this.creatingAccount = true;
      this.$store.commit(types.HIDE_ALL_NOTIFICATIONS);
      var self = this;
      var data = this.formData;
      var alert_payload = { 'type': 'error', 'message': "We\'re having difficulty processing your request. Please try again, or contact XMission Customer Service at (801) 539-0852 or sales@xmission.com" };
      try {
        grecaptcha.ready(function () {
          grecaptcha.execute(self.recatpchaSiteKey, { action: 'submit' }).then(function (token) {
            data['recaptcha_token'] = token;
            $.ajax({
              type: 'POST',
              tryCount: 0,
              url: '/manage/api/v1.0/self_signup',
              contentType: 'application/json',
              data: (0, _stringify2.default)(data),
              success: function success(result) {
                self.selfSignupSuccess(result);
              },
              error: function error(jqXHR, textStatus, errorThrown) {
                self.selfSignupError(jqXHR, textStatus, errorThrown);
              },
              complete: function complete() {
                setTimeout(function () {
                  self.creatingAccount = false;
                }, 30000);
              }
            });
          }).catch(function (e) {
            _logger2.default.error('Error checking recaptcha', e);
            self.$store.commit(types.ADD_NOTIFICATION, alert_payload);
            self.creatingAccount = false;
          });
        });
      } catch (e) {
        _logger2.default.error('Error readying recaptcha', e);
        this.$store.commit(types.ADD_NOTIFICATION, alert_payload);
        this.creatingAccount = false;
      }
    },
    selfSignupSuccess: function selfSignupSuccess(result) {
      this.firstLogin();
    },
    selfSignupError: function selfSignupError(jqXHR, textStatus, errorThrown) {
      var response = jqXHR.responseJSON;
      this.$store.commit(types.ADD_NOTIFICATION, { 'type': 'error', 'message': response.msg });
      if (response.status < 400) {
        this.firstLogin();
      } else {
        this.creatingAccount = false;
      }
    },
    firstLogin: function firstLogin() {
      if (this.hadDarktheme) {
        this.$store.dispatch('setDarkTheme', false);
      }
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('login', {
          username: self.ssuLoginDetails.uid,
          password: self.ssuLoginDetails.password,
          keepNotifications: true
        }).then(function () {
          self.$store.commit(types.ADD_NOTIFICATION, { 'type': 'success', 'message': 'You have succeeded in creating an account and signing up for services with XMission. You\'ll receive an email with more details soon.' });
          self.creatingAccount = false;
          self.$router.push({ name: 'account' });

          document.body.scrollTop = document.documentElement.scrollTop = 0;
        }, function (errorMessage) {
          self.$store.commit(types.ADD_NOTIFICATION, { 'type': 'error', 'message': 'Automatic login failed. Please login manually.' });
          self.creatingAccount = false;
          self.$router.push({ name: 'login' });
        });
      }, 4000);
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(110)))

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1322),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[778]);


// WEBPACK FOOTER //
// static/js/app.06d09192ce07ce6fd0e1.js